function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
            return;
        }
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("ciDU2", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$e0b3e8db087d3d6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $dAfqg;
    var $OxJd1;
    var $iBwzF;
    const $e0b3e8db087d3d6a$var$ProformaProjectFormsSettingsPage = ()=>{
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        if (!projectContextData) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("OxJd1")).ProjectSettingsController), {
            projectKey: projectContextData.projectKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
            theme: {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBwzF")).default), {
            projectContext: projectContextData
        })));
    };
    var $e0b3e8db087d3d6a$export$2e2bcd8739ae039 = $e0b3e8db087d3d6a$var$ProformaProjectFormsSettingsPage;
});
parcelRegister("OxJd1", function(module, exports) {
    $parcel$export(module.exports, "ProjectSettingsController", ()=>$3be22f45e427033f$export$9e38610dc1164d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $9QpK7;
    var $cSD7y;
    var $3mYHL;
    var $9NiTW;
    var $9OXo1;
    var $7tQej;
    var $lADEy;
    const $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
    const $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
    const $3be22f45e427033f$export$2164d5fb3f070c32 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID,
            teamName: "morphinecake",
            packageName: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME,
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement($3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects, {
            projectKey: projectKey,
            isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
        }, children)));
    const $3be22f45e427033f$export$6d6f90026f9508a7 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children, packageId: packageId = $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID, packageName: packageName = $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME, teamName: teamName = 'morphinecake' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_ID,
            teamName: "morphinecake",
            packageName: $3be22f45e427033f$var$ERROR_REPORTING_PACKAGE_NAME,
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement($3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects, {
            projectKey: projectKey,
            isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: packageId,
            teamName: teamName,
            packageName: packageName,
            sendToPrivacyUnsafeSplunk: true
        }, children))));
    const $3be22f45e427033f$export$9e38610dc1164d7d = (0, (0, parcelRequire("cSD7y")).componentWithFG)('projectsettingscontroller_error_boundary', $3be22f45e427033f$export$6d6f90026f9508a7, $3be22f45e427033f$export$2164d5fb3f070c32);
    const $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjectsNew = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            if (!projectKey) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: "/jira/projects"
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lADEy")).ProjectContextSubscriber), null, (projectContext)=>{
                if (projectContext.isProjectArchived) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3mYHL")).RedirectToArchivedPage), null);
                if (tenantContext.isAdmin || projectContext.isProjectAdmin || isRouteAllowedForNonAdmins && isRouteAllowedForNonAdmins()) return children;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                    to: `/projects/${projectContext.projectKey}`
                });
            });
        });
    const $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjectsOld = ({ projectKey: projectKey, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            if (!projectKey) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: "/jira/projects"
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lADEy")).ProjectContextSubscriber), null, (projectContext)=>{
                if (projectContext.isProjectArchived) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3mYHL")).RedirectToArchivedPage), null);
                if (tenantContext.isAdmin || projectContext.isProjectAdmin) return children;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                    to: `/projects/${projectContext.projectKey}`
                });
            });
        });
    const $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjects = (0, (0, parcelRequire("9QpK7")).componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjectsNew, $3be22f45e427033f$var$RedirectNonAdminsAndArchivedProjectsOld);
});
parcelRegister("3mYHL", function(module, exports) {
    $parcel$export(module.exports, "isProjectArchivedCondition", ()=>$90d8776d2c89f4bd$export$34040938aec58f90);
    $parcel$export(module.exports, "RedirectToArchivedPage", ()=>$90d8776d2c89f4bd$export$36db2ddf32573bd8);
    $parcel$export(module.exports, "default", ()=>$90d8776d2c89f4bd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAfqg;
    var $7tQej;
    const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
    const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
        if (projectKey === null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dAfqg")).ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
            }) : null);
    };
    const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        });
    var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;
});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';
parcelRegister("lADEy", function(module, exports) {
    $parcel$export(module.exports, "ProjectContextSubscriber", ()=>$3bad71e90d481a39$export$b6f3f3997ca8a783);
    var $dxCvy;
    var $2YP9W;
    const $3bad71e90d481a39$export$b6f3f3997ca8a783 = ({ children: children })=>{
        const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache));
        if (!data) return null;
        return children(data);
    };
});
parcelRegister("iBwzF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87921e4e53b11b29$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6IUg1;
    var $63MBm;
    var $joVu9;
    var $l8ruj;
    const $87921e4e53b11b29$var$ProformaProjectFormsSettingsWrapper = ({ projectContext: projectContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "proforma-project-forms-settings-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("joVu9")).SharedSettingsDocumentTitle), {
            projectName: projectContext.projectName,
            section: "proformaForms",
            projectType: projectContext.projectType
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("63MBm")).default), {
            baseUrl: "",
            projectKey: projectContext.projectKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6IUg1")).default), null)));
    var $87921e4e53b11b29$export$2e2bcd8739ae039 = $87921e4e53b11b29$var$ProformaProjectFormsSettingsWrapper;
});
parcelRegister("6IUg1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52474127dbbf33bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $5Zxxp;
    var $aWse0;
    var $iXVV6;
    var $jVbZz;
    var $cC9Cp;
    var $5bpEQ;
    var $dAfqg;
    var $3TpKp;
    var $dZw8H;
    var $koeKL;
    var $2tT7R;
    var $er5ne;
    var $aW3TH;
    var $2N1wE;
    var $hiwyX;
    const $52474127dbbf33bb$var$ProformaProjectFormsSettings = ()=>{
        const { locale: locale } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { projectId: projectId, projectKey: projectKey, projectType: projectType, isProjectAdmin: isProjectAdmin, simplified: simplified } = projectContext ?? {};
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        const onOpenInProductHelpArticle = (0, $5uXOq.useRef)((0, (0, parcelRequire("5Zxxp")).useHelpPanelLink)());
        const [settings, setSettings] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            if (projectId && projectKey && projectType && simplified !== undefined) setSettings({
                analytics: {
                    channel: (0, (0, parcelRequire("5bpEQ")).ANALYTICS_CHANNEL)
                },
                flags: {},
                urls: (0, (0, parcelRequire("5bpEQ")).getUrls)(environment, cloudId),
                environment: (0, (0, parcelRequire("cC9Cp")).toProformaEnvironment)(environment),
                context: {
                    projectId: projectId,
                    projectKey: projectKey,
                    projectType: projectType,
                    userIsProjectAdmin: isProjectAdmin,
                    inProductHelpData: {
                        simplifiedProject: simplified,
                        onOpenInProductHelpArticle: (articleId)=>{
                            if (onOpenInProductHelpArticle.current) onOpenInProductHelpArticle.current(articleId);
                        }
                    },
                    intlLocale: locale
                }
            });
        }, [
            environment,
            cloudId,
            projectId,
            isProjectAdmin,
            projectType,
            simplified,
            onOpenInProductHelpArticle,
            locale,
            projectKey
        ]);
        return projectContext !== null && projectId && settings ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "proformaJiraProjectForms",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            attributes: {
                projectId: projectId,
                projectType: projectType,
                isSimplified: simplified
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aW3TH")).TemplateLibraryContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("er5ne")).JiraProjectFormsApp), {
            settings: settings
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiwyX")).FormSettingsTemplateLibrary), {
            projectId: projectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3TpKp")).JsmPageInteractiveEvent), null), !(0, (0, parcelRequire("jVbZz")).isSyntheticTenant)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2N1wE")).AsyncBenefitModal), null), (0, (0, parcelRequire("4R6GH")).fg)('jsm_simplified_project_settings_navigation') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null)) : null;
    };
    var $52474127dbbf33bb$export$2e2bcd8739ae039 = $52474127dbbf33bb$var$ProformaProjectFormsSettings;
});
parcelRegister("5Zxxp", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanelLink", ()=>$b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
    $parcel$export(module.exports, "default", ()=>$b0d1b3c2fea05784$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bHDKL;
    var $e4yMr;
    var $4R6GH;
    var $6BNJk;
    var $kspz4;
    var $hsmeR;
    const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [, { setNavigationData: setNavigationData }] = (0, (0, parcelRequire("kspz4")).useHelpPanelActions)();
        const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
            openRightSidebar((0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID), (0, (0, parcelRequire("6BNJk")).HELP_PANEL_WIDTH), false, true);
            if (resetHistory) setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                },
                history: []
            });
            else setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                }
            });
        };
        return handleOnClick;
    };
    const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, ...props })=>{
        const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
        const handleOnClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) event.preventDefault();
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle(articleId, (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            ...props,
            onClick: handleOnClick,
            href: href ?? 'https://support.atlassian.com',
            appearance: "default",
            testId: props.testId
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            onClick: handleOnClick,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, children);
    };
    var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
    const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("jVbZz", function(module, exports) {
    $parcel$export(module.exports, "isSyntheticTenant", ()=>$d33af8f54e53b02e$export$f7ab30339d40bcd);
    var $j8DrX;
    const $d33af8f54e53b02e$export$f7ab30339d40bcd = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
});
parcelRegister("cC9Cp", function(module, exports) {
    $parcel$export(module.exports, "toProformaEnvironment", ()=>$498398f11ffa02f4$export$81a9ecf6b01a04d4);
    var $fxMku;
    const $498398f11ffa02f4$export$81a9ecf6b01a04d4 = (environment)=>{
        switch(environment){
            case 'dev':
                return (0, (0, parcelRequire("fxMku")).Environment).DEVELOPMENT;
            case 'staging':
                return (0, (0, parcelRequire("fxMku")).Environment).STAGING;
            case 'prod':
                return (0, (0, parcelRequire("fxMku")).Environment).PRODUCTION;
            case 'local':
            default:
                return (0, (0, parcelRequire("fxMku")).Environment).LOCAL;
        }
    };
});
parcelRegister("fxMku", function(module, exports) {
    $parcel$export(module.exports, "Environment", ()=>$b50f6d5564bbfb55$export$7dc6752a22ab011a);
    let $b50f6d5564bbfb55$export$7dc6752a22ab011a = function(Environment) {
        Environment["PRODUCTION"] = "prod";
        Environment["STAGING"] = "staging";
        Environment["DEVELOPMENT"] = "dev";
        Environment["LOCAL"] = "local";
        return Environment;
    }({});
});
parcelRegister("5bpEQ", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$1cd284857d4cae3e$export$85183a312807388d);
    $parcel$export(module.exports, "getUrls", ()=>$1cd284857d4cae3e$export$c69765bbdb1543ad);
    const $1cd284857d4cae3e$export$85183a312807388d = 'productAnalytics';
    const $1cd284857d4cae3e$export$c69765bbdb1543ad = (environment, cloudId)=>({
            api: `/gateway/api/proforma/cloudid/${cloudId}`,
            jira: '',
            templatesService: environment === 'prod' ? 'https://proforma-templates.services.atlassian.com' : 'https://proforma-templates.stg.services.atlassian.com',
            analyticsService: environment === 'prod' ? 'https://proforma-analytics.services.atlassian.com' : 'https://proforma-analytics.stg.services.atlassian.com'
        });
});
parcelRegister("3TpKp", function(module, exports) {
    $parcel$export(module.exports, "JsmPageInteractiveEvent", ()=>$bbb7386cf97044f2$export$c4ba40c380ee9a11);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    const $bbb7386cf97044f2$export$c4ba40c380ee9a11 = (args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), args);
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.defaultProps = {
        isExpectedToHaveSsr: false,
        withMarks: [],
        extra: {}
    };
    $bbb7386cf97044f2$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("er5ne", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectFormsApp", ()=>$a827c168d371cc5c$export$922aa0b8de5897ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $bKCvK;
    var $i8Qvm;
    var $jkADf;
    var $agcXw;
    var $bv2Tr;
    var $eWfcO;
    var $6W5Vt;
    var $9rYSe;
    var $6jvUj;
    var $bV8dQ;
    var $kyyqC;
    var $qE8Ux;
    var $3STiV;
    var $7Tgou;
    var $1OCFt;
    var $ew6tB;
    var $gmf3c;
    var $2weNo;
    var $lLGUB;
    var $c92ML;
    var $biT53;
    var $cyeJM;
    var $k7zrN;
    const $a827c168d371cc5c$var$JiraProjectFormsBaseApp = ({ settings: settings })=>{
        var _settings$context$use;
        const { showFlag: showFlag } = (0, (0, parcelRequire("bKCvK")).useFlags)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [moduleContext, setModuleContext] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            const utils = (0, (0, parcelRequire("6jvUj")).createUtils)(settings, 'ProjectForms', showFlag, createAnalyticsEvent, settings.context.intlLocale);
            setModuleContext({
                apis: {
                    issueFormsApi: new (0, (0, parcelRequire("7Tgou")).LiveIssueFormsApi)(settings.context.projectId, utils.apiUtil),
                    projectFormApi: new (0, (0, parcelRequire("gmf3c")).LiveProjectFormApi)(settings.context.projectId, utils.apiUtil),
                    templateFormApi: new (0, (0, parcelRequire("biT53")).LiveTemplateFormApi)(utils.apiUtil),
                    projectApi: new (0, (0, parcelRequire("1OCFt")).LiveProjectApi)(utils.apiUtil),
                    requestTypeApi: new (0, (0, parcelRequire("lLGUB")).LiveRequestTypeApi)(settings.context.projectId, utils.apiUtil)
                },
                utils: {
                    errorUtils: utils.errorUtils
                }
            });
        }, [
            createAnalyticsEvent,
            settings,
            showFlag
        ]);
        if (!moduleContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bv2Tr")).ErrorBoundary), {
            errorUtils: moduleContext.utils.errorUtils
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6W5Vt")).PfFlagsProvider), {
            flags: settings.flags
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9rYSe")).UtilsProvider), {
            utils: moduleContext.utils
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew6tB")).ProjectApiProvider), {
            projectApi: moduleContext.apis.projectApi
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2weNo")).ProjectFormApiProvider), {
            projectFormApi: moduleContext.apis.projectFormApi
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cyeJM")).TemplateFormApiProvider), {
            templateFormApi: moduleContext.apis.templateFormApi
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c92ML")).RequestTypeApiProvider), {
            requestTypeApi: moduleContext.apis.requestTypeApi
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eWfcO")).InProductHelpProvider), {
            inProductHelpData: settings.context.inProductHelpData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3STiV")).IssueFormsApiProvider), {
            issueFormsApi: moduleContext.apis.issueFormsApi
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qE8Ux")).ProjectFormsContainer), {
            errorUtils: moduleContext.utils.errorUtils,
            projectFormApi: moduleContext.apis.projectFormApi
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k7zrN")).ProjectForms), {
            projectId: settings.context.projectId,
            projectKey: settings.context.projectKey,
            projectType: settings.context.projectType,
            simplifiedProject: settings.context.inProductHelpData.simplifiedProject,
            userIsProjectAdmin: (_settings$context$use = settings.context.userIsProjectAdmin) !== null && _settings$context$use !== void 0 ? _settings$context$use : false
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agcXw")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: "pf-dialog-container"
        }))))))));
    };
    const $a827c168d371cc5c$export$922aa0b8de5897ae = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bV8dQ")).AnalyticsProvider), props.settings.analytics, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jkADf")).ContextWrapper), {
            sourceName: "proformaJiraProjectForms",
            sourceType: (0, $6e65040b988c460f$export$f636b5b56f1d624a),
            attributes: $a827c168d371cc5c$var$getAnalyticsAttributes(props.settings.context)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kyyqC")).PackageIntlProvider), {
            locale: props.settings.context.intlLocale
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCvK")).FlagsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($a827c168d371cc5c$var$JiraProjectFormsBaseApp, props)))));
    const $a827c168d371cc5c$var$getAnalyticsAttributes = (settings)=>{
        const { projectId: projectId, projectType: projectType } = settings;
        return {
            projectId: projectId,
            projectType: projectType
        };
    };
});
parcelRegister("jkADf", function(module, exports) {
    $parcel$export(module.exports, "ContextWrapper", ()=>$e64f0f96877c6709$export$34282a1f95511a11);
    var $5uXOq = parcelRequire("5uXOq");
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $daJ0i;
    const $e64f0f96877c6709$export$dc30f43798194b03 = (props)=>{
        const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
        const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
        return (0, ($parcel$interopDefault($9xWGk)))({
            source: source,
            ...rest
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
    const $e64f0f96877c6709$export$34282a1f95511a11 = (props)=>{
        const data = $e64f0f96877c6709$export$dc30f43798194b03(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: data
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children));
    };
});
parcelRegister("agcXw", function(module, exports) {
    $parcel$export(module.exports, "FireUIAnalytics", ()=>$5625c4255a3b29d6$export$1f3555c9be6c5e08);
    $parcel$export(module.exports, "FireTrackAnalytics", ()=>$5625c4255a3b29d6$export$5f0d7aae8dfa8b86);
    $parcel$export(module.exports, "FireOperationalAnalytics", ()=>$5625c4255a3b29d6$export$b71c3ada5d4ec5da);
    $parcel$export(module.exports, "FireScreenAnalytics", ()=>$5625c4255a3b29d6$export$2ccf161b817b43b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $h8yj2;
    const $5625c4255a3b29d6$var$getFixedActionAndActionSubject = (props)=>{
        const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
        if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const fixedAction = action || eventNameSplit[1];
        const fixedActionSubject = actionSubject || eventNameSplit[0];
        if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        return {
            action: fixedAction,
            actionSubject: fixedActionSubject
        };
    };
    const $5625c4255a3b29d6$var$getFixedActionSubjectId = (props)=>{
        const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
        if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
        const fixedActionSubjectId = actionSubjectId || componentName;
        return {
            actionSubjectId: fixedActionSubjectId
        };
    };
    class $5625c4255a3b29d6$var$FireComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { type: type, attributes: attributes } = this.props;
            if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
            const { action: action, actionSubject: actionSubject } = $5625c4255a3b29d6$var$getFixedActionAndActionSubject(this.props);
            const { actionSubjectId: actionSubjectId } = $5625c4255a3b29d6$var$getFixedActionSubjectId(this.props);
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: action
            });
            (0, (0, parcelRequire("h8yj2")).fireAnalytics)(analyticsEvent, type, {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        }
        render() {
            return null;
        }
    }
    const $5625c4255a3b29d6$var$WithAnalytics = (0, (0, parcelRequire("cb25w")).default)()($5625c4255a3b29d6$var$FireComponent);
    const $5625c4255a3b29d6$export$1f3555c9be6c5e08 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
            ...props,
            type: (0, $6e65040b988c460f$export$a1562d08625f5d7e)
        });
    const $5625c4255a3b29d6$export$5f0d7aae8dfa8b86 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
            ...props,
            type: (0, $6e65040b988c460f$export$947dac6c72b26f81)
        });
    const $5625c4255a3b29d6$export$b71c3ada5d4ec5da = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
            ...props,
            type: (0, $6e65040b988c460f$export$12346a674644c156)
        });
    const $5625c4255a3b29d6$export$2ccf161b817b43b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5625c4255a3b29d6$var$WithAnalytics, {
            ...props,
            type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
            eventName: "screen viewed"
        });
});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';
parcelRegister("h8yj2", function(module, exports) {
    $parcel$export(module.exports, "fireAnalytics", ()=>$b264de6d6a035739$export$34ac71ce24cddec2);
    $parcel$export(module.exports, "fireUIAnalytics", ()=>$b264de6d6a035739$export$5d00cd31b1bf8e94);
    $parcel$export(module.exports, "fireTrackAnalytics", ()=>$b264de6d6a035739$export$13990ad4625571ed);
    $parcel$export(module.exports, "fireOperationalAnalytics", ()=>$b264de6d6a035739$export$79f423cc3fd39762);
    $parcel$export(module.exports, "fireScreenAnalytics", ()=>$b264de6d6a035739$export$6f46fb37ad7d962b);
    var $hYfgW = parcelRequire("hYfgW");
    var $4zfLY;
    const $b264de6d6a035739$export$34ac71ce24cddec2 = (event, type, payload)=>{
        const castedEvent = event;
        const clonedEvent = castedEvent.clone();
        if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
        clonedEvent.update({
            ...payload,
            analyticsType: type
        }).fire((0, $6e65040b988c460f$export$2ceccf177fae277c));
    };
    const $b264de6d6a035739$var$getActionSubjectFromContext = (event)=>{
        const castedEvent = event;
        return (0, ($parcel$interopDefault($hYfgW)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
    };
    const $b264de6d6a035739$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
        if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
        const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, (0, parcelRequire("4zfLY")).getImperativeAnalyticsDataFromArguments)(rest);
        const castedEvent = event;
        const action = event.payload && event.payload.action || argumentsAction;
        const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b264de6d6a035739$var$getActionSubjectFromContext(castedEvent);
        if (!action) throw new Error('Mandatory "action" field is missing from UI event');
        if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
        $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$a1562d08625f5d7e), {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    };
    const $b264de6d6a035739$export$13990ad4625571ed = (event, ...rest)=>{
        if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, (0, parcelRequire("4zfLY")).getImperativeAnalyticsDataFromArguments)(rest);
        if (!action) throw new Error('Mandatory "action" field is missing from Track event');
        if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
        $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$947dac6c72b26f81), {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    };
    const $b264de6d6a035739$export$79f423cc3fd39762 = (event, ...rest)=>{
        if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, (0, parcelRequire("4zfLY")).getImperativeAnalyticsDataFromArguments)(rest);
        if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
        if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
        $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$12346a674644c156), {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    };
    const $b264de6d6a035739$export$6f46fb37ad7d962b = (event, ...rest)=>{
        if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
        const { attributes: attributes } = (0, (0, parcelRequire("4zfLY")).getImperativeAnalyticsDataFromArguments)(rest);
        $b264de6d6a035739$export$34ac71ce24cddec2(event, (0, $6e65040b988c460f$export$f1d537d508d2945a), {
            attributes: attributes
        });
    };
});
parcelRegister("4zfLY", function(module, exports) {
    $parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", ()=>$ccaec2c661eabde7$export$e6baab532ef8c6bf);
    const $ccaec2c661eabde7$var$extractDataFromStringAttribute = (string)=>{
        const arr = string.split(' ');
        switch(arr.length){
            case 1:
                return {
                    actionSubject: undefined,
                    action: undefined,
                    actionSubjectId: arr[0],
                    attributes: undefined
                };
            case 2:
                return {
                    actionSubject: arr[0],
                    action: arr[1],
                    actionSubjectId: undefined,
                    attributes: undefined
                };
            default:
                throw Error('Event of this type is not supported');
        }
    };
    const $ccaec2c661eabde7$var$extractDataFromOneAttribute = (one)=>{
        if (typeof one === 'string') return $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
        if (typeof one === 'object') return {
            actionSubject: undefined,
            action: undefined,
            actionSubjectId: undefined,
            attributes: one
        };
        throw Error('Event of this type is not supported');
    };
    const $ccaec2c661eabde7$var$extractDataFromTwoAttribute = (one, two)=>{
        if (typeof one === 'string' && typeof two === 'string') {
            const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
            const actionSubjectId = two;
            return {
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: undefined
            };
        }
        if (typeof one === 'string' && typeof two === 'object') {
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
            return {
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: two
            };
        }
        throw Error('Event of this type is not supported');
    };
    const $ccaec2c661eabde7$var$extractDataFromThreeAttribute = (one, two, three)=>{
        if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
            const { action: action, actionSubject: actionSubject } = $ccaec2c661eabde7$var$extractDataFromStringAttribute(one);
            const actionSubjectId = two;
            return {
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: three
            };
        }
        throw Error('Event of this type is not supported');
    };
    const $ccaec2c661eabde7$export$e6baab532ef8c6bf = (args)=>{
        switch(args.length){
            case 0:
                return {
                    actionSubject: undefined,
                    action: undefined,
                    actionSubjectId: undefined,
                    attributes: undefined
                };
            case 1:
                return $ccaec2c661eabde7$var$extractDataFromOneAttribute(args[0]);
            case 2:
                return $ccaec2c661eabde7$var$extractDataFromTwoAttribute(args[0], args[1]);
            case 3:
                return $ccaec2c661eabde7$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
            default:
                throw Error('Can not fire an empty event');
        }
    };
});
parcelRegister("bv2Tr", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$85f4d5778164d0dc$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $cgL5K;
    var $92Z2l;
    var $erWXD;
    class $85f4d5778164d0dc$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false,
                errorInfo: null,
                error: null
            };
        }
        componentDidCatch(error, errorInfo) {
            this.setState({
                hasError: true,
                error: error,
                errorInfo: errorInfo.componentStack
            });
            this.props.errorUtils.reportError(error, {
                actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).PROFORMA_UI,
                id: 'errorBoundary',
                errorInfo: errorInfo
            });
        }
        render() {
            if (this.state.hasError) {
                const { renderError: renderError } = this.props;
                return renderError ? renderError({
                    error: this.state.error
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement($85f4d5778164d0dc$var$ErrorPage, null, (0, ($parcel$interopDefault($5uXOq))).createElement($85f4d5778164d0dc$var$ErrorPageSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
                    appearance: "error",
                    title: "Something went wrong"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "p"
                }, "Refresh the page and try again. ", (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), "If the error persists,", ' ', (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: "https://support.thinktilt.com",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, "contact support"), "."))));
            }
            return this.props.children;
        }
    }
    const $85f4d5778164d0dc$var$ErrorPage = (0, $dAHxw.default).div({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    });
    const $85f4d5778164d0dc$var$ErrorPageSection = (0, $dAHxw.default).div({});
});
parcelRegister("dAHxw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e506934574c3414$export$2e2bcd8739ae039);
    parcelRequire("bS32t");
    parcelRequire("5uXOq");
    parcelRequire("bS0aY");
    var $bWGt6 = parcelRequire("bWGt6");
    parcelRequire("l9ACI");
    parcelRequire("7PpcK");
    parcelRequire("lDKn9");
    var $9e506934574c3414$var$tags = [
        'a',
        'abbr',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'base',
        'bdi',
        'bdo',
        'big',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'cite',
        'code',
        'col',
        'colgroup',
        'data',
        'datalist',
        'dd',
        'del',
        'details',
        'dfn',
        'dialog',
        'div',
        'dl',
        'dt',
        'em',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'iframe',
        'img',
        'input',
        'ins',
        'kbd',
        'keygen',
        'label',
        'legend',
        'li',
        'link',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'meter',
        'nav',
        'noscript',
        'object',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'param',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'script',
        'section',
        'select',
        'small',
        'source',
        'span',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'title',
        'tr',
        'track',
        'u',
        'ul',
        'var',
        'video',
        'wbr',
        'circle',
        'clipPath',
        'defs',
        'ellipse',
        'foreignObject',
        'g',
        'image',
        'line',
        'linearGradient',
        'mask',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialGradient',
        'rect',
        'stop',
        'svg',
        'text',
        'tspan'
    ];
    var $9e506934574c3414$var$newStyled = (0, $bWGt6.default).bind();
    $9e506934574c3414$var$tags.forEach(function(tagName) {
        $9e506934574c3414$var$newStyled[tagName] = $9e506934574c3414$var$newStyled(tagName);
    });
    var $9e506934574c3414$export$2e2bcd8739ae039 = $9e506934574c3414$var$newStyled;
});
parcelRegister("erWXD", function(module, exports) {
    $parcel$export(module.exports, "ActionSubject", ()=>$a85152b408a7fe70$export$7f97440769de1377);
    $parcel$export(module.exports, "Action", ()=>$a85152b408a7fe70$export$e19cd5f9376f8cee);
    $parcel$export(module.exports, "FormUpdateType", ()=>$a85152b408a7fe70$export$d7867a52899740a0);
    let $a85152b408a7fe70$export$7f97440769de1377 = function(ActionSubject) {
        ActionSubject["FORM"] = "form";
        ActionSubject["FORM_FIELD"] = "formField";
        ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
        ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
        ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
        ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
        ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
        ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
        ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
        ActionSubject["TEMPLATE_FORM"] = "templateForm";
        ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
        ActionSubject["BUTTON"] = "button";
        ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
        ActionSubject["SELECT_ITEM"] = "selectItem";
        ActionSubject["FILTER"] = "filter";
        ActionSubject["LIST"] = "list";
        ActionSubject["PANEL"] = "panel";
        ActionSubject["SECTION"] = "section";
        ActionSubject["TABLE"] = "table";
        ActionSubject["MODAL"] = "modal";
        ActionSubject["PROFORMA_API"] = "proformaAPI";
        ActionSubject["PROFORMA_UI"] = "proformaUI";
        ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
        ActionSubject["ATTACHMENT"] = "proformaAttachment";
        ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
        ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
        ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
        ActionSubject["REQUEST_TYPE"] = "requestType";
        ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
        ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
        ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
        ActionSubject["FORM_VALIDATION"] = "formValidation";
        ActionSubject["FORM_EDIT"] = "formEdit";
        ActionSubject["FORM_SAVE"] = "formSave";
        ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
        ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
        ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
        ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
        ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
        ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
        ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
        return ActionSubject;
    }({});
    let $a85152b408a7fe70$export$e19cd5f9376f8cee = function(Action) {
        Action["ADDED"] = "added";
        Action["CLICKED"] = "clicked";
        Action["CREATED"] = "created";
        Action["DELETED"] = "deleted";
        Action["DOWNLOADED"] = "downloaded";
        Action["EXPORTED"] = "exported";
        Action["UPDATED"] = "updated";
        Action["VIEWED"] = "viewed";
        Action["SELECTED"] = "selected";
        Action["COPIED"] = "copied";
        Action["FAILED"] = "failed";
        Action["FINISHED"] = "finished";
        Action["STARTED"] = "started";
        Action["STOPPED"] = "stopped";
        return Action;
    }({});
    let $a85152b408a7fe70$export$d7867a52899740a0 = function(FormUpdateType) {
        FormUpdateType["REOPEN"] = "REOPEN";
        FormUpdateType["SAVE"] = "SAVE";
        FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
        FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
        FormUpdateType["SUBMIT"] = "SUBMIT";
        FormUpdateType["CLOSE"] = "CLOSE";
        return FormUpdateType;
    }({});
});
parcelRegister("eWfcO", function(module, exports) {
    $parcel$export(module.exports, "InProductHelpProvider", ()=>$ae0246fb9ca7a561$export$a61d77bd8effd79e);
    $parcel$export(module.exports, "useInProductHelp", ()=>$ae0246fb9ca7a561$export$804f42d1448e5b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $8251k;
    const $ae0246fb9ca7a561$var$InProductHelpContext = (0, $5uXOq.createContext)(undefined);
    const $ae0246fb9ca7a561$export$a61d77bd8effd79e = ({ inProductHelpData: inProductHelpData, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ae0246fb9ca7a561$var$InProductHelpContext.Provider, {
            value: inProductHelpData
        }, children);
    };
    function $ae0246fb9ca7a561$export$804f42d1448e5b9() {
        const inProductHelpData = (0, $5uXOq.useContext)($ae0246fb9ca7a561$var$InProductHelpContext);
        if (inProductHelpData === undefined) throw new Error(`useInProductHelp() must be used within an InProductHelpProvider. ${(0, (0, parcelRequire("8251k")).errorMessageDuplicateCommonCore)}`);
        return inProductHelpData;
    }
});
parcelRegister("8251k", function(module, exports) {
    $parcel$export(module.exports, "errorMessageDuplicateCommonCore", ()=>$5d926790292467ac$export$202e68bc03a230f);
    const $5d926790292467ac$export$202e68bc03a230f = "Please check that the yarn.lock file contains only 1 version of proforma-common-core. You should bump all Proforma packages to their latest version";
});
parcelRegister("6W5Vt", function(module, exports) {
    $parcel$export(module.exports, "PfFlagsProvider", ()=>$50ccc1a344ad6c19$export$33dbaef47fd9c29b);
    var $5uXOq = parcelRequire("5uXOq");
    var $8251k;
    const $50ccc1a344ad6c19$var$PfFlagsContext = (0, $5uXOq.createContext)(undefined);
    const $50ccc1a344ad6c19$export$33dbaef47fd9c29b = ({ flags: flags, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($50ccc1a344ad6c19$var$PfFlagsContext.Provider, {
            value: flags
        }, children);
    };
    function $50ccc1a344ad6c19$export$a37d68d19485eb11() {
        const flags = (0, $5uXOq.useContext)($50ccc1a344ad6c19$var$PfFlagsContext);
        if (flags === undefined) throw new Error(`usePfFlags must be used within a PfFlagsProvider. ${(0, (0, parcelRequire("8251k")).errorMessageDuplicateCommonCore)}`);
        return flags;
    }
});
parcelRegister("9rYSe", function(module, exports) {
    $parcel$export(module.exports, "UtilsProvider", ()=>$01c68bca0be3a904$export$df5be093c1f55d13);
    var $5uXOq = parcelRequire("5uXOq");
    var $ex6Rw;
    const $01c68bca0be3a904$export$df5be093c1f55d13 = ({ utils: utils, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ex6Rw")).PfErrorUtilsProvider), {
            errorUtils: utils.errorUtils
        }, children);
    };
});
parcelRegister("ex6Rw", function(module, exports) {
    $parcel$export(module.exports, "PfErrorUtilsProvider", ()=>$a9497877cb60343e$export$b71d28c58577f663);
    $parcel$export(module.exports, "usePfErrorUtils", ()=>$a9497877cb60343e$export$19d62bf1891c25ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $8251k;
    const $a9497877cb60343e$var$PfErrorUtilsContext = (0, $5uXOq.createContext)(undefined);
    const $a9497877cb60343e$export$b71d28c58577f663 = ({ errorUtils: errorUtils, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a9497877cb60343e$var$PfErrorUtilsContext.Provider, {
            value: errorUtils
        }, children);
    };
    function $a9497877cb60343e$export$19d62bf1891c25ff() {
        const errorUtils = (0, $5uXOq.useContext)($a9497877cb60343e$var$PfErrorUtilsContext);
        if (errorUtils === undefined) throw new Error(`usePfErrorUtils() must be used within a PfErrorUtilsProvider. ${(0, (0, parcelRequire("8251k")).errorMessageDuplicateCommonCore)}`);
        return errorUtils;
    }
});
parcelRegister("6jvUj", function(module, exports) {
    $parcel$export(module.exports, "createErrorUtils", ()=>$498d4489c00ccef2$export$7a2f0d878b08650d);
    $parcel$export(module.exports, "createUtils", ()=>$498d4489c00ccef2$export$b6881d4b4863cacc);
    $parcel$export(module.exports, "createUtils2", ()=>$498d4489c00ccef2$export$e4e37e88de17afb6);
    var $a1RLT;
    var $j93Fo;
    var $gFGsm;
    function $498d4489c00ccef2$export$7a2f0d878b08650d(errorUtilsModuleName, environment, createAnalyticsEvent, showFlag = ()=>()=>{}) {
        return new (0, (0, parcelRequire("gFGsm")).LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
    }
    function $498d4489c00ccef2$export$b6881d4b4863cacc(settings, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
        const errorUtils = new (0, (0, parcelRequire("gFGsm")).LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, settings.environment);
        (0, (0, parcelRequire("j93Fo")).setNoticeLocale)(locale);
        const apiUtil = new (0, (0, parcelRequire("a1RLT")).ApiUtil)(settings.urls.jira, settings.urls.api, errorUtils, createAnalyticsEvent);
        return {
            apiUtil: apiUtil,
            errorUtils: errorUtils
        };
    }
    function $498d4489c00ccef2$export$e4e37e88de17afb6(jiraUrl, apiUrl, environment, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
        const errorUtils = new (0, (0, parcelRequire("gFGsm")).LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
        (0, (0, parcelRequire("j93Fo")).setNoticeLocale)(locale);
        const apiUtil = new (0, (0, parcelRequire("a1RLT")).ApiUtil)(jiraUrl, apiUrl, errorUtils, createAnalyticsEvent);
        return {
            apiUtil: apiUtil,
            errorUtils: errorUtils
        };
    }
});
parcelRegister("a1RLT", function(module, exports) {
    $parcel$export(module.exports, "AcceptedResponseType", ()=>$74d3b548944c3270$export$9126c50ecfe2a46d);
    $parcel$export(module.exports, "ApiUtil", ()=>$74d3b548944c3270$export$baa861b25a2283a4);
    var $kCVub;
    var $erWXD;
    var $bRqoO;
    var $caW8j;
    let $74d3b548944c3270$export$9126c50ecfe2a46d = function(AcceptedResponseType) {
        AcceptedResponseType["Json"] = "json";
        AcceptedResponseType["Blob"] = "blob";
        return AcceptedResponseType;
    }({});
    class $74d3b548944c3270$export$baa861b25a2283a4 {
        constructor(jiraUrl, proformaUrl, errorUtils, createAnalyticsEvent){
            this.errorUtils = void 0;
            this.jiraUrl = void 0;
            this.proformaUrl = void 0;
            this.createAnalyticsEvent = void 0;
            this.jiraUrl = jiraUrl;
            this.proformaUrl = proformaUrl;
            this.errorUtils = errorUtils;
            this.createAnalyticsEvent = createAnalyticsEvent;
        }
        get(path, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(true, 'GET', path, responseType, requestName);
        }
        jiraGet(path, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(false, 'GET', path, responseType, requestName);
        }
        put(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(true, 'PUT', path, responseType, requestName, body);
        }
        jiraPut(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(false, 'PUT', path, responseType, requestName, body);
        }
        post(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(true, 'POST', path, responseType, requestName, body);
        }
        jiraPost(path, body, requestName, responseType = $74d3b548944c3270$export$9126c50ecfe2a46d.Json) {
            return this.fetchApi(false, 'POST', path, responseType, requestName, body);
        }
        delete(path, body, requestName, responseType = 'none') {
            return this.fetchApi(true, 'DELETE', path, responseType, requestName, body);
        }
        createApiUrl(relativePath) {
            return this.proformaUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
        }
        createJiraUrl(relativePath) {
            return this.jiraUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
        }
        getAnalyticsSource() {
            try {
                var _analyticsData$payloa, _analyticsData$payloa2;
                const analyticsEvent = this.createAnalyticsEvent({});
                const analyticsData = (0, (0, parcelRequire("kCVub")).extractAWCDataFromEvent)(analyticsEvent);
                return (_analyticsData$payloa = analyticsData === null || analyticsData === void 0 ? void 0 : (_analyticsData$payloa2 = analyticsData.payload) === null || _analyticsData$payloa2 === void 0 ? void 0 : _analyticsData$payloa2.source) !== null && _analyticsData$payloa !== void 0 ? _analyticsData$payloa : 'unknown';
            } catch (e) {
                return 'unknown';
            }
        }
        fetchApi(proForma, method, path, responseType, requestName, body) {
            const analyticsSource = this.getAnalyticsSource();
            return fetch(proForma ? this.createApiUrl(path) : this.createJiraUrl(path), {
                method: method,
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Experimental-Experience': analyticsSource,
                    ...responseType === $74d3b548944c3270$export$9126c50ecfe2a46d.Json ? {
                        Accept: 'application/json'
                    } : {}
                },
                ...body && {
                    body: JSON.stringify(body)
                }
            }).catch((error)=>{
                const message = `No response from API: ${error.message || ''}`;
                const apiError = $74d3b548944c3270$var$toApiError(0, {
                    error: message
                }, true, requestName);
                this.errorUtils.reportError(error, {
                    actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).PROFORMA_API,
                    id: 'fetchApi',
                    attributes: {
                        path: path,
                        method: method,
                        responseType: responseType,
                        requestName: requestName,
                        apiError: JSON.stringify(apiError),
                        isClientFetchError: true
                    }
                });
                return Promise.reject(apiError);
            }).then((response)=>{
                let errorObj = new Error(response.statusText);
                if (!response.ok) {
                    var _ref, _response$headers$get;
                    const traceId = (_ref = (_response$headers$get = response.headers.get('x-trace-id')) !== null && _response$headers$get !== void 0 ? _response$headers$get : response.headers.get('atl-traceid')) !== null && _ref !== void 0 ? _ref : undefined;
                    let apiErrorPromise;
                    try {
                        const responseJsonApiError = responseType !== 'json' ? undefined : response.json().then((responseJson)=>$74d3b548944c3270$var$toApiError(response.status, responseJson, false, requestName, traceId)).catch((error)=>{
                            const message = `Failed to parse error response as JSON from API: ${error.message || ''}`;
                            errorObj = error;
                            return $74d3b548944c3270$var$toApiError(response.status, {
                                error: message
                            }, false, requestName, traceId);
                        });
                        if (response.status === 401) this.errorUtils.notifyUser((0, (0, parcelRequire("bRqoO")).NoticeType).ErrorApiUnauthorised);
                        if (response.status === 403) this.errorUtils.notifyUser((0, (0, parcelRequire("bRqoO")).NoticeType).ErrorApiMissingPermissions);
                        if (responseJsonApiError !== undefined) apiErrorPromise = responseJsonApiError.then((apiError)=>Promise.reject(apiError));
                        else apiErrorPromise = Promise.reject($74d3b548944c3270$var$toApiError(response.status, {
                            error: response.body || ''
                        }, false, requestName, traceId));
                    } catch (error) {
                        const message = `Unexpected response from API: ${response.body || ''}`;
                        errorObj = error;
                        apiErrorPromise = Promise.reject($74d3b548944c3270$var$toApiError(response.status, {
                            error: message
                        }, false, requestName, traceId));
                    }
                    apiErrorPromise.catch((apiError)=>{
                        this.errorUtils.reportError(errorObj, {
                            actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).PROFORMA_API,
                            id: 'fetchApi',
                            attributes: {
                                status: response.status,
                                statusGroup: `${Math.floor(response.status / 100)}xx`,
                                traceId: traceId,
                                path: path,
                                method: method,
                                responseType: responseType,
                                requestName: requestName,
                                apiError: JSON.stringify(apiError),
                                isClientFetchError: false
                            }
                        });
                    });
                    return apiErrorPromise;
                }
                if (response.status === 204) return '';
                switch(responseType){
                    case 'json':
                        return response.json();
                    case 'blob':
                        return response.blob();
                    case 'text':
                        return response.text();
                    case 'none':
                        return '';
                    default:
                        return response;
                }
            });
        }
    }
    function $74d3b548944c3270$var$toApiError(status, responseJson, isClientFetchError, requestName, traceId) {
        if (Object.keys(responseJson).length === 0) return (0, (0, parcelRequire("caW8j")).constructApiError)(`Unexpected API reply (HTTP/${status})`, status, responseJson, requestName);
        const error = responseJson['error'] || `Unexpected API reply (HTTP/${status})`;
        const context = responseJson['context'];
        const contextId = responseJson['contextId'];
        const details = responseJson['details'];
        return (0, (0, parcelRequire("caW8j")).constructApiError)(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId);
    }
});
parcelRegister("kCVub", function(module, exports) {
    $parcel$export(module.exports, "extractAWCDataFromEvent", ()=>$d006147c8436533b$export$1c850cf68c053906);
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $8HgKr;
    const $d006147c8436533b$export$1c850cf68c053906 = (event)=>{
        const castedEvent = event;
        const analyticsType = (0, (0, parcelRequire("8HgKr")).getAnalyticsType)(castedEvent);
        const attributes = (0, (0, parcelRequire("8HgKr")).getAttributes)(castedEvent);
        const source = (0, (0, parcelRequire("8HgKr")).getSource)(castedEvent);
        const actionSubject = (0, (0, parcelRequire("8HgKr")).getActionSubject)(castedEvent);
        if (analyticsType === (0, $6e65040b988c460f$export$f1d537d508d2945a)) return {
            type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
            payload: {
                name: source,
                attributes: attributes
            }
        };
        switch(analyticsType){
            case 0, $6e65040b988c460f$export$a1562d08625f5d7e:
            case 0, $6e65040b988c460f$export$947dac6c72b26f81:
            case 0, $6e65040b988c460f$export$12346a674644c156:
                {
                    const action = (0, (0, parcelRequire("8HgKr")).getAction)(castedEvent);
                    const actionSubjectId = (0, (0, parcelRequire("8HgKr")).getActionSubjectId)(castedEvent);
                    const containerId = (0, (0, parcelRequire("8HgKr")).getContainerId)(castedEvent);
                    const containerType = (0, (0, parcelRequire("8HgKr")).getContainerType)(castedEvent);
                    const objectId = (0, (0, parcelRequire("8HgKr")).getObjectId)(castedEvent);
                    const objectType = (0, (0, parcelRequire("8HgKr")).getObjectType)(castedEvent);
                    const tags = (0, (0, parcelRequire("8HgKr")).getTags)(castedEvent);
                    return {
                        type: analyticsType,
                        payload: (0, ($parcel$interopDefault($9xWGk)))({
                            action: action,
                            actionSubject: actionSubject,
                            actionSubjectId: actionSubjectId,
                            source: source,
                            tags: tags,
                            containerType: containerType,
                            containerId: containerId,
                            objectType: objectType,
                            objectId: objectId,
                            attributes: attributes
                        }, (0, ($parcel$interopDefault($cjFoH))))
                    };
                }
            default:
                return {
                    payload: {
                        source: source,
                        actionSubject: actionSubject,
                        attributes: attributes
                    },
                    type: undefined
                };
        }
    };
});
parcelRegister("8HgKr", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsType", ()=>$6831e52439d2a9a2$export$a3569ac53b82a914);
    $parcel$export(module.exports, "getAttributes", ()=>$6831e52439d2a9a2$export$fe94072fee8a6976);
    $parcel$export(module.exports, "getSource", ()=>$6831e52439d2a9a2$export$dd2b6e807fb37ba3);
    $parcel$export(module.exports, "getActionSubject", ()=>$6831e52439d2a9a2$export$6f40cdf6d42c018d);
    $parcel$export(module.exports, "getAction", ()=>$6831e52439d2a9a2$export$6ca3170acb89054);
    $parcel$export(module.exports, "getActionSubjectId", ()=>$6831e52439d2a9a2$export$b6f8db3ad0711b02);
    $parcel$export(module.exports, "getContainerId", ()=>$6831e52439d2a9a2$export$7c8178cc9001d237);
    $parcel$export(module.exports, "getContainerType", ()=>$6831e52439d2a9a2$export$acc6f3e19803b3dc);
    $parcel$export(module.exports, "getObjectId", ()=>$6831e52439d2a9a2$export$fa986b91291934c7);
    $parcel$export(module.exports, "getObjectType", ()=>$6831e52439d2a9a2$export$11cc42aebef2ef3a);
    $parcel$export(module.exports, "getTags", ()=>$6831e52439d2a9a2$export$af63d7414243dad3);
    var $183uB = parcelRequire("183uB");
    var $cjFoH = parcelRequire("cjFoH");
    var $hYfgW = parcelRequire("hYfgW");
    var $1UikQ = parcelRequire("1UikQ");
    var $9xWGk = parcelRequire("9xWGk");
    var $kGsr8 = parcelRequire("kGsr8");
    const $6831e52439d2a9a2$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
    const $6831e52439d2a9a2$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
    const $6831e52439d2a9a2$export$fe94072fee8a6976 = (event)=>{
        const contextAttributes = $6831e52439d2a9a2$var$extractFromContext(event, 'attributes');
        const payloadAttributes = event.payload.attributes;
        const allAttributes = (0, ($parcel$interopDefault($1UikQ)))(contextAttributes.reduce((result, extraAttributes)=>(0, ($parcel$interopDefault($1UikQ)))(result, extraAttributes), {}), payloadAttributes);
        const sources = $6831e52439d2a9a2$var$extractFromContext(event, 'source');
        const namespaces = sources.filter(Boolean).join('.');
        return (0, ($parcel$interopDefault($9xWGk)))({
            ...allAttributes,
            namespaces: namespaces
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
    const $6831e52439d2a9a2$export$dd2b6e807fb37ba3 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'source').filter(Boolean));
    const $6831e52439d2a9a2$export$6f40cdf6d42c018d = (event)=>{
        const { actionSubject: actionSubject } = event.payload;
        if (actionSubject) return actionSubject;
        const component = (0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'component').filter(Boolean)) || (0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'componentName').filter(Boolean));
        return component;
    };
    const $6831e52439d2a9a2$export$6ca3170acb89054 = (event)=>event.payload.action;
    const $6831e52439d2a9a2$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
    const $6831e52439d2a9a2$export$7c8178cc9001d237 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerId').filter(Boolean));
    const $6831e52439d2a9a2$export$acc6f3e19803b3dc = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerType').filter(Boolean));
    const $6831e52439d2a9a2$export$fa986b91291934c7 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectId').filter(Boolean));
    const $6831e52439d2a9a2$export$11cc42aebef2ef3a = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectType').filter(Boolean));
    const $6831e52439d2a9a2$export$af63d7414243dad3 = (event)=>{
        const tags = (0, ($parcel$interopDefault($kGsr8)))((0, ($parcel$interopDefault($183uB)))($6831e52439d2a9a2$var$extractFromContext(event, 'tags'))).filter(Boolean);
        return tags.length ? tags : undefined;
    };
});
parcelRegister("bRqoO", function(module, exports) {
    $parcel$export(module.exports, "NoticeType", ()=>$8a291f441fcc3884$export$3b5003ffe8119af2);
    $parcel$export(module.exports, "Notices", ()=>$8a291f441fcc3884$export$ba15f0a357d713fd);
    var $9svqU;
    var $7fcWf;
    let $8a291f441fcc3884$export$3b5003ffe8119af2 = function(NoticeType) {
        NoticeType["ConfirmDeleteForm"] = "ConfirmDeleteForm";
        NoticeType["ConfirmChangeFormAvailabilityToInternal"] = "ConfirmChangeFormAvailabilityToInternal";
        NoticeType["ConfirmChangeFormToInternal"] = "ConfirmChangeFormToInternal";
        NoticeType["ConfirmChangeFormToExternal"] = "ConfirmChangeFormToExternal";
        NoticeType["ConfirmChangeFormAvailabilityToExternal"] = "ConfirmChangeFormAvailabilityToExternal";
        NoticeType["ConfirmCancelEdit"] = "ConfirmCancelEdit";
        NoticeType["ConfirmSubmitForm"] = "ConfirmSubmitForm";
        NoticeType["ConfirmSubmitFormPdf"] = "ConfirmSubmitFormPdf";
        NoticeType["ConfirmSubmitFormLock"] = "ConfirmSubmitFormLock";
        NoticeType["ConfirmSubmitFormPdfLock"] = "ConfirmSubmitFormPdfLock";
        NoticeType["ConfirmReopenForm"] = "ConfirmReopenForm";
        NoticeType["ErrorApiUnauthorised"] = "ErrorApiUnauthorised";
        NoticeType["ErrorApiMissingPermissions"] = "ErrorApiMissingPermissions";
        NoticeType["ErrorApiAddConnectionFailed"] = "ErrorApiAddConnectionFailed";
        NoticeType["ErrorApiUpdateConnectionFailed"] = "ErrorApiUpdateConnectionFailed";
        NoticeType["ErrorApiSubmitFormFailed"] = "ErrorApiSubmitFormFailed";
        NoticeType["ErrorApiSaveFormFailed"] = "ErrorApiSaveFormFailed";
        NoticeType["ErrorApiSaveFormFailedOnConflict"] = "ErrorApiSaveFormFailedOnConflict";
        NoticeType["ErrorApiSaveFormInvalidAnswersFailed"] = "ErrorApiSaveFormInvalidAnswersFailed";
        NoticeType["ErrorApiSaveTemplateFormFailed"] = "ErrorApiSaveTemplateFormFailed";
        NoticeType["ErrorApiLoadTemplateFormFailed"] = "ErrorApiLoadTemplateFormFailed";
        NoticeType["ErrorApiLoadJiraFieldsFailed"] = "ErrorApiLoadJiraFieldsFailed";
        NoticeType["ErrorApiLoadDataConnectionsFailed"] = "ErrorApiLoadDataConnectionsFailed";
        NoticeType["ErrorApiLoadSettingsRefDataFailed"] = "ErrorApiLoadSettingsRefDataFailed";
        return NoticeType;
    }({});
    const $8a291f441fcc3884$export$ba15f0a357d713fd = {
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmDeleteForm]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).DeleteFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).DeleteFormMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Delete],
            isWarningNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormAvailabilityToInternal]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormAvailabilityTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormAvailabilityToInternalMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Change]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormToInternal]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormToInternalHeader],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormToInternalMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).MakeInternal]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormAvailabilityToExternal]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormAvailabilityTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormAvailabilityToExternalMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Change]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmChangeFormToExternal]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormToExternalHeader],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ChangeFormToExternalMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).MakeExternal]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmCancelEdit]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).CancelEditFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).CancelEditFormMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Confirm]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitForm]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Submit]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitFormPdf]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormPdfMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Submit]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitFormLock]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormLockMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Submit]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmSubmitFormPdfLock]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).SubmitFormPdfLockMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Submit]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ConfirmReopenForm]: {
            title: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ReopenFormTitle],
            message: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ReopenFormMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Reopen]
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiUnauthorised]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).UnauthorisedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).UnauthorisedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiMissingPermissions]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).MissingPermissionsTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).MissingPermissionsMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiAddConnectionFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).AddConnectionFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).AddConnectionFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiUpdateConnectionFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).UpdateConnectionFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).UpdateConnectionFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSubmitFormFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SubmitFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SubmitFormFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormInvalidAnswersFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormInvalidAnswersMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveFormFailedOnConflict]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveFormFailedOnConflictMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiSaveTemplateFormFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveTemplateFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).SaveTemplateFormFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadTemplateFormFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadTemplateFormFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadTemplateFormFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadJiraFieldsFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadJiraFieldsFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadJiraFieldsFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadDataConnectionsFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadDataConnectionsFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadDataConnectionsFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        },
        [$8a291f441fcc3884$export$3b5003ffe8119af2.ErrorApiLoadSettingsRefDataFailed]: {
            title: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadSettingsRefDataFailedTitle],
            message: (0, (0, parcelRequire("9svqU")).IntlApiErrorMessages)[(0, (0, parcelRequire("9svqU")).ApiErrorMessage).LoadSettingsRefDataFailedMsg],
            confirmText: (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close],
            isErrorNotice: true
        }
    };
});
parcelRegister("9svqU", function(module, exports) {
    $parcel$export(module.exports, "ApiErrorMessage", ()=>$6e2f1c86cfbb31d7$export$231e36d3eb058aab);
    $parcel$export(module.exports, "IntlApiErrorMessages", ()=>$6e2f1c86cfbb31d7$export$4a210a14fc5cbd69);
    var $7VHMR;
    let $6e2f1c86cfbb31d7$export$231e36d3eb058aab = function(ApiErrorMessage) {
        ApiErrorMessage["UnauthorisedTitle"] = "UnauthorisedTitle";
        ApiErrorMessage["UnauthorisedMsg"] = "UnauthorisedMsg";
        ApiErrorMessage["MissingPermissionsTitle"] = "MissingPermissionsTitle";
        ApiErrorMessage["MissingPermissionsMsg"] = "MissingPermissionsMsg";
        ApiErrorMessage["AddConnectionFailedTitle"] = "AddConnectionFailedTitle";
        ApiErrorMessage["AddConnectionFailedMsg"] = "AddConnectionFailedMsg";
        ApiErrorMessage["UpdateConnectionFailedTitle"] = "UpdateConnectionFailedTitle";
        ApiErrorMessage["UpdateConnectionFailedMsg"] = "UpdateConnectionFailedMsg";
        ApiErrorMessage["SubmitFormFailedTitle"] = "SubmitFormFailedTitle";
        ApiErrorMessage["SubmitFormFailedMsg"] = "SubmitFormFailedMsg";
        ApiErrorMessage["SaveFormFailedTitle"] = "SaveFormFailedTitle";
        ApiErrorMessage["SaveFormFailedMsg"] = "SaveFormFailedMsg";
        ApiErrorMessage["SaveFormInvalidAnswersMsg"] = "SaveFormInvalidAnswersMsg";
        ApiErrorMessage["SaveFormFailedOnConflictMsg"] = "SaveFormFailedOnConflictMsg";
        ApiErrorMessage["SaveTemplateFormFailedTitle"] = "SaveTemplateFormFailedTitle";
        ApiErrorMessage["SaveTemplateFormFailedMsg"] = "SaveTemplateFormFailedMsg";
        ApiErrorMessage["LoadTemplateFormFailedTitle"] = "LoadTemplateFormFailedTitle";
        ApiErrorMessage["LoadTemplateFormFailedMsg"] = "LoadTemplateFormFailedMsg";
        ApiErrorMessage["LoadJiraFieldsFailedTitle"] = "LoadJiraFieldsFailedTitle";
        ApiErrorMessage["LoadJiraFieldsFailedMsg"] = "LoadJiraFieldsFailedMsg";
        ApiErrorMessage["LoadDataConnectionsFailedTitle"] = "LoadDataConnectionsFailedTitle";
        ApiErrorMessage["LoadDataConnectionsFailedMsg"] = "LoadDataConnectionsFailedMsg";
        ApiErrorMessage["LoadSettingsRefDataFailedTitle"] = "LoadSettingsRefDataFailedTitle";
        ApiErrorMessage["LoadSettingsRefDataFailedMsg"] = "LoadSettingsRefDataFailedMsg";
        return ApiErrorMessage;
    }({});
    const $6e2f1c86cfbb31d7$export$4a210a14fc5cbd69 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UnauthorisedTitle]: {
            id: 'ui-notices.apiError.title.UnauthorisedTitle',
            defaultMessage: 'Error: User Unauthorised'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UnauthorisedMsg]: {
            id: 'ui-notices.apiError.msg.UnauthorisedMsg',
            defaultMessage: 'Try refreshing your page or logging into Jira again.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.MissingPermissionsTitle]: {
            id: 'ui-notices.apiError.title.MissingPermissionsTitle',
            defaultMessage: 'Error: User is not allowed this action'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.MissingPermissionsMsg]: {
            id: 'ui-notices.apiError.msg.MissingPermissionsMsg',
            defaultMessage: 'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.AddConnectionFailedTitle]: {
            id: 'ui-notices.apiError.title.AddConnectionFailedTitle',
            defaultMessage: 'Error: Adding data connection failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.AddConnectionFailedMsg]: {
            id: 'ui-notices.apiError.msg.AddConnectionFailedMsg',
            defaultMessage: 'A server error occurred while trying to add the data connection.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UpdateConnectionFailedTitle]: {
            id: 'ui-notices.apiError.title.UpdateConnectionFailedTitle',
            defaultMessage: 'Error: Updating data connection failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.UpdateConnectionFailedMsg]: {
            id: 'ui-notices.apiError.msg.UpdateConnectionFailedMsg',
            defaultMessage: 'A server error occurred while trying to update the data connection.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SubmitFormFailedTitle]: {
            id: 'ui-notices.apiError.title.SubmitFormFailedTitle',
            defaultMessage: 'Error: Submitting form failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SubmitFormFailedMsg]: {
            id: 'ui-notices.apiError.msg.SubmitFormFailedMsg',
            defaultMessage: 'A server error occurred while trying to submit the form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedTitle]: {
            id: 'ui-notices.apiError.title.SaveFormFailedTitle',
            defaultMessage: "We couldn\u2019t save your changes",
            description: 'The title on the error flag informing customers that their form failed to save.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedMsg]: {
            id: 'ui-notices.apiError.msg.SaveFormFailedMsg',
            defaultMessage: 'A server error occurred while trying to save the form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormInvalidAnswersMsg]: {
            id: 'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg',
            defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
            description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveFormFailedOnConflictMsg]: {
            id: 'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg',
            defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
            description: "The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state doesn't allow the customer to do so."
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveTemplateFormFailedTitle]: {
            id: 'ui-notices.apiError.title.SaveTemplateFormFailedTitle',
            defaultMessage: 'Error: Saving template form failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.SaveTemplateFormFailedMsg]: {
            id: 'ui-notices.apiError.msg.SaveTemplateFormFailedMsg',
            defaultMessage: 'A server error occurred while trying to save the template form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadTemplateFormFailedTitle]: {
            id: 'ui-notices.apiError.title.LoadTemplateFormFailedTitle',
            defaultMessage: "We couldn\u2019t load your form"
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadTemplateFormFailedMsg]: {
            id: 'ui-notices.apiError.msg.LoadTemplateFormFailedMsg',
            defaultMessage: 'Refresh the page to try again'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadJiraFieldsFailedTitle]: {
            id: 'ui-notices.apiError.title.LoadJiraFieldsFailedTitle',
            defaultMessage: 'Error: Loading Jira fields failed'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadJiraFieldsFailedMsg]: {
            id: 'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg',
            defaultMessage: 'A server error occurred while trying to load Jira fields on the template form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadDataConnectionsFailedTitle]: {
            id: 'ui-notices.apiError.title.LoadDataConnectionsFailedTitle',
            defaultMessage: 'Error: Loading data connections failed.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadDataConnectionsFailedMsg]: {
            id: 'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg',
            defaultMessage: 'A server error occurred while trying to load data connections on the template form.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadSettingsRefDataFailedTitle]: {
            id: 'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle',
            defaultMessage: 'Error: Loading form settings reference data failed.'
        },
        [$6e2f1c86cfbb31d7$export$231e36d3eb058aab.LoadSettingsRefDataFailedMsg]: {
            id: 'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg',
            defaultMessage: "A server error occurred while trying to load the reference for the template form's settings."
        }
    });
});
parcelRegister("7fcWf", function(module, exports) {
    $parcel$export(module.exports, "NoticeMessage", ()=>$5463f86ac7c8d952$export$cd61f3d27ce0e442);
    $parcel$export(module.exports, "IntlNoticeMessages", ()=>$5463f86ac7c8d952$export$5f3ce93e2cd01692);
    var $7VHMR;
    let $5463f86ac7c8d952$export$cd61f3d27ce0e442 = function(NoticeMessage) {
        NoticeMessage["Delete"] = "Delete";
        NoticeMessage["Discard"] = "Discard";
        NoticeMessage["Change"] = "Change";
        NoticeMessage["Confirm"] = "Confirm";
        NoticeMessage["Submit"] = "Submit";
        NoticeMessage["Reopen"] = "Reopen";
        NoticeMessage["Close"] = "Close";
        NoticeMessage["Cancel"] = "Cancel";
        NoticeMessage["UpgradeNow"] = "UpgradeNow";
        NoticeMessage["MakeInternal"] = "MakeInternal";
        NoticeMessage["MakeExternal"] = "MakeExternal";
        NoticeMessage["DeleteFormTitle"] = "DeleteFormTitle";
        NoticeMessage["DeleteFormMsg"] = "DeleteFormMsg";
        NoticeMessage["ChangeFormAvailabilityTitle"] = "ChangeFormAvailabilityTitle";
        NoticeMessage["ChangeFormAvailabilityToInternalMsg"] = "ChangeFormAvailabilityToInternalMsg";
        NoticeMessage["ChangeFormAvailabilityToExternalMsg"] = "ChangeFormAvailabilityToExternalMsg";
        NoticeMessage["ChangeFormToInternalHeader"] = "ChangeFormToInternalHeader";
        NoticeMessage["ChangeFormToInternalMsg"] = "ChangeFormToInternalMsg";
        NoticeMessage["ChangeFormToExternalHeader"] = "ChangeFormToExternalHeader";
        NoticeMessage["ChangeFormToExternalMsg"] = "ChangeFormToExternalMsg";
        NoticeMessage["CancelEditFormTitle"] = "CancelEditFormTitle";
        NoticeMessage["CancelEditFormMsg"] = "CancelEditFormMsg";
        NoticeMessage["SubmitFormTitle"] = "SubmitFormTitle";
        NoticeMessage["SubmitFormMsg"] = "SubmitFormMsg";
        NoticeMessage["SubmitFormPdfMsg"] = "SubmitFormPdfMsg";
        NoticeMessage["SubmitFormLockMsg"] = "SubmitFormLockMsg";
        NoticeMessage["SubmitFormPdfLockMsg"] = "SubmitFormPdfLockMsg";
        NoticeMessage["ReopenFormTitle"] = "ReopenFormTitle";
        NoticeMessage["ReopenFormMsg"] = "ReopenFormMsg";
        NoticeMessage["ErrorExplanations1"] = "ErrorExplanations1";
        NoticeMessage["ErrorExplanations2"] = "ErrorExplanations2";
        NoticeMessage["ErrorExplanations3"] = "ErrorExplanations3";
        NoticeMessage["ErrorExplanations4"] = "ErrorExplanations4";
        return NoticeMessage;
    }({});
    const $5463f86ac7c8d952$export$5f3ce93e2cd01692 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Delete]: {
            id: 'ui-notices.confirmText.Delete',
            defaultMessage: 'Delete'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Discard]: {
            id: 'ui-notices.confirmText.Discard',
            defaultMessage: 'Discard'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Change]: {
            id: 'ui-notices.confirmText.Change',
            defaultMessage: 'Change'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Confirm]: {
            id: 'ui-notices.confirmText.Confirm',
            defaultMessage: 'Confirm'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Submit]: {
            id: 'ui-notices.confirmText.Submit',
            defaultMessage: 'Submit'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Reopen]: {
            id: 'ui-notices.confirmText.Reopen',
            defaultMessage: 'Reopen'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Close]: {
            id: 'ui-notices.confirmText.Close',
            defaultMessage: 'Close'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.Cancel]: {
            id: 'ui-notices.confirmText.Cancel',
            defaultMessage: 'Cancel'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.UpgradeNow]: {
            id: 'ui-notices.confirmText.UpgradeNow',
            defaultMessage: 'Upgrade Now'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.MakeInternal]: {
            id: 'ui-notices.confirmText.MakeInternal',
            defaultMessage: 'Make internal'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.MakeExternal]: {
            id: 'ui-notices.confirmText.MakeExternal',
            defaultMessage: 'Make external'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.DeleteFormTitle]: {
            id: 'ui-notices.title.DeleteFormTitle',
            defaultMessage: 'Confirm Deleting Form'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.DeleteFormMsg]: {
            id: 'ui-notices.msg.DeleteFormMsg',
            defaultMessage: "Are you sure you want to delete the \u201C{formName}\u201D form? This cannot be undone."
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormAvailabilityTitle]: {
            id: 'ui-notices.title.ChangeFormAvailabilityTitle',
            defaultMessage: 'Confirm Changing Form Availability'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormAvailabilityToInternalMsg]: {
            id: 'ui-notices.msg.ChangeFormAvailabilityToInternalMsg',
            defaultMessage: 'Please confirm you want to change the form so that it is only accessible through the Jira issue, and not through the Customer Portal.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormAvailabilityToExternalMsg]: {
            id: 'ui-notices.msg.ChangeFormAvailabilityToExternalMsg',
            defaultMessage: 'Please confirm you want to change the form so that it is accessible through the Jira issue and the Customer Portal.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToInternalHeader]: {
            id: 'ui-notices.title.ChangeFormInternalHeader',
            defaultMessage: 'Make form internal only and hide from customer'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToInternalMsg]: {
            id: 'ui-notices.msg.ChangeFormInternalMsg',
            defaultMessage: 'Any forms made internal will only be seen by agents and hidden in the portal from customers.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToExternalHeader]: {
            id: 'ui-notices.title.ChangeFormToExternalHeader',
            defaultMessage: 'Make form external and show to customer'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ChangeFormToExternalMsg]: {
            id: 'ui-notices.msg.ChangeFormToExternalMsg',
            defaultMessage: 'Customers will be able to view this form in the portal and it will no longer be internal only.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.CancelEditFormTitle]: {
            id: 'ui-notices.title.CancelEditFormTitle',
            defaultMessage: 'Confirm Discarding Changes'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.CancelEditFormMsg]: {
            id: 'ui-notices.msg.CancelEditFormMsg',
            defaultMessage: 'There are changes to answers on the \u201C{formName}\u201D form that will be lost if you choose "Confirm". Are you sure you want to continue?'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormTitle]: {
            id: 'ui-notices.title.SubmitFormTitle',
            defaultMessage: 'Confirm Form Submission'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormMsg]: {
            id: 'ui-notices.msg.SubmitFormMsg',
            defaultMessage: 'Are you sure you want to submit this form ?'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormPdfMsg]: {
            id: 'ui-notices.msg.SubmitFormPdfMsg',
            defaultMessage: 'Submitting this form will also attach a PDF of the form to the issue/request. Are you sure you want to submit this form ?'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormLockMsg]: {
            id: 'ui-notices.msg.SubmitFormLockMsg',
            defaultMessage: 'Are you sure you want to submit this form ? Once submitted no further changes can be made.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.SubmitFormPdfLockMsg]: {
            id: 'ui-notices.msg.SubmitFormPdfLockMsg',
            defaultMessage: 'Submitting this form will also attach a PDF of the form to the issue/request. Are you sure you want to submit this form ? Once submitted no further changes can be made.'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ReopenFormTitle]: {
            id: 'ui-notices.title.ReopenFormTitle',
            defaultMessage: 'Confirm Reopening Form'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ReopenFormMsg]: {
            id: 'ui-notices.msg.ReopenFormMsg',
            defaultMessage: 'Are you sure you want to reopen the submitted form for editing?'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations1]: {
            id: 'ui-notices.msg.ErrorExplanations1',
            defaultMessage: 'Please refer to our'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations2]: {
            id: 'ui-notices.msg.ErrorExplanations2',
            defaultMessage: 'Error Explanations'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations3]: {
            id: 'ui-notices.msg.ErrorExplanations3',
            defaultMessage: 'page for more details or contact'
        },
        [$5463f86ac7c8d952$export$cd61f3d27ce0e442.ErrorExplanations4]: {
            id: 'ui-notices.msg.ErrorExplanations4',
            defaultMessage: 'ThinkTilt Support'
        }
    });
});
parcelRegister("caW8j", function(module, exports) {
    $parcel$export(module.exports, "constructApiError", ()=>$8dd38339de80c582$export$4fb8f0e1418096d0);
    $parcel$export(module.exports, "isUnknownApiError", ()=>$8dd38339de80c582$export$a072859f46abbb91);
    $parcel$export(module.exports, "getFormSaveErrors", ()=>$8dd38339de80c582$export$ed98b2247c52f4f6);
    var $3KrJl;
    var $8w794;
    function $8dd38339de80c582$export$4fb8f0e1418096d0(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId) {
        switch(error){
            case (0, (0, parcelRequire("3KrJl")).ApiErrorType).client:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).client,
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    status: status,
                    requestName: requestName
                };
            case (0, (0, parcelRequire("3KrJl")).ApiErrorType).clientWithDetails:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).clientWithDetails,
                    context: (0, (0, parcelRequire("8w794")).ErrorContextOf)(context),
                    details: details || '',
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    status: status,
                    requestName: requestName
                };
            case (0, (0, parcelRequire("3KrJl")).ApiErrorType).json:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).json,
                    details: details || '',
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    status: status,
                    requestName: requestName
                };
            case (0, (0, parcelRequire("3KrJl")).ApiErrorType).jwt:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).jwt,
                    details: details || '',
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    status: status,
                    requestName: requestName
                };
            default:
                return {
                    error: (0, (0, parcelRequire("3KrJl")).ApiErrorType).unknown,
                    message: error,
                    status: status,
                    responseJson: responseJson,
                    isClientFetchError: isClientFetchError,
                    traceId: traceId,
                    requestName: requestName
                };
        }
    }
    const $8dd38339de80c582$export$a072859f46abbb91 = (apiError)=>apiError.error === (0, (0, parcelRequire("3KrJl")).ApiErrorType).unknown;
    const $8dd38339de80c582$export$ed98b2247c52f4f6 = (apiError)=>{
        if ($8dd38339de80c582$export$a072859f46abbb91(apiError) && apiError.status === 400) return {
            generalErrors: [],
            errorsByQuestionId: {},
            ...apiError.responseJson
        };
        return undefined;
    };
});
parcelRegister("3KrJl", function(module, exports) {
    $parcel$export(module.exports, "ApiErrorType", ()=>$2bab2d9fb6f6d466$export$eb26b24d7b7bab09);
    let $2bab2d9fb6f6d466$export$eb26b24d7b7bab09 = function(ApiErrorType) {
        ApiErrorType["client"] = "client";
        ApiErrorType["clientWithDetails"] = "clientWithDetails";
        ApiErrorType["json"] = "json";
        ApiErrorType["jwt"] = "jwt";
        ApiErrorType["unknown"] = "unknown";
        ApiErrorType["timeout"] = "timeout";
        return ApiErrorType;
    }({});
});
parcelRegister("8w794", function(module, exports) {
    $parcel$export(module.exports, "ErrorContextOf", ()=>$6336dacbdad88890$export$2c172aed648e926c);
    let $6336dacbdad88890$export$21818dff4f4f7174 = function(ErrorContext) {
        ErrorContext["I18nAccessPathKey"] = "err.access.path";
        ErrorContext["I18nEntityConnectionKey"] = "err.entity.connection";
        ErrorContext["I18nEntityFormKey"] = "err.entity.form";
        ErrorContext["I18nEntityIssueKey"] = "err.entity.issue";
        ErrorContext["I18nEntityIssueCreateKey"] = "err.entity.issue.create";
        ErrorContext["I18nEntityPreferredFormKey"] = "err.entity.preferredform";
        ErrorContext["I18nEntityProjectKey"] = "err.entity.project";
        ErrorContext["I18nEntityRequestTypeKey"] = "err.entity.requesttype";
        ErrorContext["I18nEntityServiceDeskKey"] = "err.entity.servicedesk";
        ErrorContext["I18nJwtParseKey"] = "err.jwt.parse";
        ErrorContext["I18nJwtSignatureKey"] = "err.jwt.signed";
        ErrorContext["I18nJwtVerifyKey"] = "err.jwt.verify";
        ErrorContext["I18nInternalServerError"] = "err.server.internal";
        ErrorContext["I18nUnknownContextError"] = "err.context.unknown";
        return ErrorContext;
    }({});
    function $6336dacbdad88890$export$2c172aed648e926c(context) {
        switch(context){
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nAccessPathKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nAccessPathKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityConnectionKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityConnectionKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityFormKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityFormKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueCreateKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityIssueCreateKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityPreferredFormKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityPreferredFormKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityProjectKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityProjectKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityRequestTypeKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityRequestTypeKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityServiceDeskKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nEntityServiceDeskKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtParseKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtParseKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtSignatureKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtSignatureKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtVerifyKey:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nJwtVerifyKey;
            case $6336dacbdad88890$export$21818dff4f4f7174.I18nInternalServerError:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nInternalServerError;
            default:
                return $6336dacbdad88890$export$21818dff4f4f7174.I18nUnknownContextError;
        }
    }
});
parcelRegister("j93Fo", function(module, exports) {
    $parcel$export(module.exports, "setNoticeLocale", ()=>$df01b3b500941fc5$export$caf904df61b5b10d);
    $parcel$export(module.exports, "showNotice", ()=>$df01b3b500941fc5$export$b25305d7fdb340d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $24oqM;
    let $df01b3b500941fc5$var$locale = 'en-US';
    function $df01b3b500941fc5$export$caf904df61b5b10d(newLocale) {
        $df01b3b500941fc5$var$locale = newLocale;
    }
    function $df01b3b500941fc5$export$b25305d7fdb340d7(noticeType, intlValues, errorDetails) {
        return new Promise((resolve)=>{
            const dialogTargetNode = document.getElementById('pf-dialog-container');
            if (!dialogTargetNode) {
                console.error(`Could not show notice ${noticeType}. The target Node for the dialog is not available`);
                resolve(false);
            }
            const handleClose = (confirmed)=>{
                resolve(!!confirmed);
                $df01b3b500941fc5$var$closeNotice();
            };
            (0, ($parcel$interopDefault($7nsd3))).render((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("24oqM")).Notice), {
                noticeType: noticeType,
                handleClose: handleClose,
                settings: {
                    intlValues: intlValues,
                    errorDetails: errorDetails,
                    customLocale: $df01b3b500941fc5$var$locale
                }
            }), dialogTargetNode);
        });
    }
    function $df01b3b500941fc5$var$closeNotice() {
        const dialogTargetNode = document.getElementById('pf-dialog-container');
        if (!dialogTargetNode) {
            console.error(`Could not close notice. The target Node for the dialog is not available`);
            return false;
        }
        const closed = (0, ($parcel$interopDefault($7nsd3))).unmountComponentAtNode(dialogTargetNode);
        if (!closed) console.error(`Could not close notice. There is no dialog to unmount`);
        return closed;
    }
});
parcelRegister("24oqM", function(module, exports) {
    $parcel$export(module.exports, "Notice", ()=>$181ee7fa9c781879$export$71802e30fd294f61);
    var $5uXOq = parcelRequire("5uXOq");
    var $dlLGv;
    var $fiX4W;
    var $8v3RR;
    var $bRqoO;
    const $181ee7fa9c781879$export$71802e30fd294f61 = ({ noticeType: noticeType, handleClose: handleClose, settings: { customLocale: customLocale = (0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE), intlValues: intlValues, errorDetails: errorDetails, overrideZIndex: overrideZIndex } })=>{
        const notice = (0, (0, parcelRequire("bRqoO")).Notices)[noticeType];
        if (!notice) {
            console.error(`Could not show notice, notice type ${noticeType} does not exist`);
            handleClose();
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dlLGv")).PackageIntlProvider), {
            locale: customLocale
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8v3RR")).NoticeDialog), {
            title: notice.title,
            titleVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.titleVars,
            message: notice.message,
            messageVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.msgVars,
            confirmText: notice.confirmText,
            confirmLink: notice.confirmLink,
            handleClose: handleClose,
            isErrorNotice: notice.isErrorNotice,
            errorDetails: errorDetails,
            isWarningNotice: notice.isWarningNotice,
            overrideZIndex: overrideZIndex
        }));
    };
});
parcelRegister("dlLGv", function(module, exports) {
    $parcel$export(module.exports, "PackageIntlProvider", ()=>$9b8239ac40bcdc9c$export$dfce9acc1b75df7a);
    $parcel$export(module.exports, "withPackageIntlProvider", ()=>$9b8239ac40bcdc9c$export$38662a78c6a3a7ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $i9OHB;
    var $ioVpW;
    const $9b8239ac40bcdc9c$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i9OHB")).ProformaIntlProvider), {
            locale: locale,
            messages: (0, (0, parcelRequire("ioVpW")).default)
        }, children);
    const $9b8239ac40bcdc9c$export$38662a78c6a3a7ce = (WrappedComponent)=>(props)=>{
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement($9b8239ac40bcdc9c$export$dfce9acc1b75df7a, {
                locale: intl.locale
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
        };
});
parcelRegister("i9OHB", function(module, exports) {
    $parcel$export(module.exports, "ProformaIntlProvider", ()=>$d38065afc4acf5f2$export$f345b4b8e42e419e);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $cgL5K;
    var $iyjlq;
    const $d38065afc4acf5f2$export$f345b4b8e42e419e = ({ children: children, locale: locale, messages: messages })=>{
        var _getCodesFromLocale;
        const { language: language, country: country } = (_getCodesFromLocale = (0, (0, parcelRequire("iyjlq")).getCodesFromLocale)(locale)) !== null && _getCodesFromLocale !== void 0 ? _getCodesFromLocale : {};
        const lazyMessages = (0, (0, parcelRequire("iyjlq")).useLazyMessages)(messages, language !== null && language !== void 0 ? language : (0, (0, parcelRequire("iyjlq")).DEFAULT_LOCALE), country);
        if (lazyMessages === undefined) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            messages: lazyMessages,
            locale: country && `${language}-${country}` || language || locale.replace('_', '-'),
            defaultLocale: (0, (0, parcelRequire("iyjlq")).DEFAULT_LOCALE),
            defaultRichTextElements: {
                b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        weight: "bold"
                    }, chunks),
                strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong"
                    }, chunks)
            }
        }, children);
    };
});
parcelRegister("iyjlq", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LOCALE", ()=>$d81a686b660c1f7e$export$1af4c7e47ad72f44);
    $parcel$export(module.exports, "getCodesFromLocale", ()=>$d81a686b660c1f7e$export$4d25b49b6dc1b540);
    $parcel$export(module.exports, "useLazyMessages", ()=>$d81a686b660c1f7e$export$7ddce3b5511cfaa8);
    var $5uXOq = parcelRequire("5uXOq");
    const $d81a686b660c1f7e$export$1af4c7e47ad72f44 = 'en';
    const $d81a686b660c1f7e$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
    const $d81a686b660c1f7e$export$4d25b49b6dc1b540 = (locale)=>{
        const match = $d81a686b660c1f7e$var$localeRegex.exec(locale);
        if (match) {
            const [, language, country] = match;
            return {
                language: language.toLowerCase(),
                country: country === null || country === void 0 ? void 0 : country.toUpperCase()
            };
        }
        console.error('Unable to determine language and country from invalid locale.');
        return undefined;
    };
    const $d81a686b660c1f7e$var$loadLazyMessages = async (lazyMessages, language, country)=>{
        var _await$default, _await, _ref;
        return (_await$default = (_await = await ((_ref = country && lazyMessages[`${language}_${country}`] || lazyMessages[language] || lazyMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
    };
    const $d81a686b660c1f7e$export$7ddce3b5511cfaa8 = (lazyMessages, language, country)=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            $d81a686b660c1f7e$var$loadLazyMessages(lazyMessages, language, country).catch(()=>({})).then(setMessages);
        }, [
            country,
            language,
            lazyMessages,
            setMessages
        ]);
        return messages;
    };
});
parcelRegister("ioVpW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d65701c9e2552e18$export$2e2bcd8739ae039);
    const $d65701c9e2552e18$var$lazyMessages = {
        cs: ()=>(parcelRequire("5KuqU")),
        da: ()=>(parcelRequire("iA3yG")),
        de: ()=>(parcelRequire("568Uq")),
        en: ()=>(parcelRequire("63JIa")),
        en_GB: ()=>(parcelRequire("9ZY0m")),
        en_ZZ: ()=>(parcelRequire("cjbck")),
        es: ()=>(parcelRequire("5WaKz")),
        fi: ()=>(parcelRequire("2sFGM")),
        fr: ()=>(parcelRequire("cbXIS")),
        hu: ()=>(parcelRequire("3YLM7")),
        it: ()=>(parcelRequire("gmriO")),
        ja: ()=>(parcelRequire("iJL6I")),
        ko: ()=>(parcelRequire("cmjAj")),
        nb: ()=>(parcelRequire("1lBem")),
        nl: ()=>(parcelRequire("g1Q3q")),
        pl: ()=>(parcelRequire("c8WMF")),
        pt_BR: ()=>(parcelRequire("1CmlQ")),
        ru: ()=>(parcelRequire("kyGpX")),
        sv: ()=>(parcelRequire("aaBSS")),
        th: ()=>(parcelRequire("e1jaB")),
        tr: ()=>(parcelRequire("3VPFe")),
        uk: ()=>(parcelRequire("263DJ")),
        vi: ()=>(parcelRequire("YbVTE")),
        zh: ()=>(parcelRequire("c6pcg")),
        zh_TW: ()=>(parcelRequire("j8MqE"))
    };
    var $d65701c9e2552e18$export$2e2bcd8739ae039 = $d65701c9e2552e18$var$lazyMessages;
});
parcelRegister("5KuqU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bOMSG").then(()=>parcelRequire('bSYnh'));
});
parcelRegister("iA3yG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("99s0m").then(()=>parcelRequire('fr8Uf'));
});
parcelRegister("568Uq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("41WhO").then(()=>parcelRequire('6EC1L'));
});
parcelRegister("63JIa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iZTjR").then(()=>parcelRequire('iSOzX'));
});
parcelRegister("9ZY0m", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dzFRq").then(()=>parcelRequire('eBxLi'));
});
parcelRegister("cjbck", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("DijSr").then(()=>parcelRequire('8e7FB'));
});
parcelRegister("5WaKz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("abWEg").then(()=>parcelRequire('bSBGI'));
});
parcelRegister("2sFGM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6OcKU").then(()=>parcelRequire('jStmS'));
});
parcelRegister("cbXIS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ffJfg").then(()=>parcelRequire('lVomF'));
});
parcelRegister("3YLM7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3qpTf").then(()=>parcelRequire('gV19l'));
});
parcelRegister("gmriO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eK7PP").then(()=>parcelRequire('iRfhX'));
});
parcelRegister("iJL6I", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lt3Cs").then(()=>parcelRequire('kEMuB'));
});
parcelRegister("cmjAj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dHRzd").then(()=>parcelRequire('lJY2E'));
});
parcelRegister("1lBem", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hwtzD").then(()=>parcelRequire('icvbb'));
});
parcelRegister("g1Q3q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7KTDh").then(()=>parcelRequire('btUKW'));
});
parcelRegister("c8WMF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ly7Tk").then(()=>parcelRequire('UaJXH'));
});
parcelRegister("1CmlQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5nTxr").then(()=>parcelRequire('dqi2n'));
});
parcelRegister("kyGpX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cuJeo").then(()=>parcelRequire('deEZs'));
});
parcelRegister("aaBSS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7khh5").then(()=>parcelRequire('gtyia'));
});
parcelRegister("e1jaB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("35Enp").then(()=>parcelRequire('cRlYl'));
});
parcelRegister("3VPFe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2yjYv").then(()=>parcelRequire('c7xZi'));
});
parcelRegister("263DJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3l58i").then(()=>parcelRequire('4rorX'));
});
parcelRegister("YbVTE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4mWuc").then(()=>parcelRequire('1vLaj'));
});
parcelRegister("c6pcg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lG0k3").then(()=>parcelRequire('auLUs'));
});
parcelRegister("j8MqE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jvhrA").then(()=>parcelRequire('3SBDK'));
});
parcelRegister("fiX4W", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LOCALE", ()=>$b2465d41ca8b525b$export$1af4c7e47ad72f44);
    $parcel$export(module.exports, "ProFormaIntlProvider", ()=>$b2465d41ca8b525b$export$23e25b3437f9c000);
    $parcel$export(module.exports, "withProFormaIntlProvider", ()=>$b2465d41ca8b525b$export$a98a2d834cadecf0);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $cgL5K;
    var $ioVpW;
    var $hPkt9;
    const $b2465d41ca8b525b$export$1af4c7e47ad72f44 = 'en-US';
    const $b2465d41ca8b525b$export$23e25b3437f9c000 = ({ children: children, i18nMessages: i18nMessages, locale: locale })=>{
        var _ref, _ref2;
        const commonCoreI18nMessages = (0, (0, parcelRequire("hPkt9")).useLazyI18nMessages)(locale, (0, (0, parcelRequire("ioVpW")).default));
        if (!commonCoreI18nMessages) return null;
        const { language: language, country: country } = (0, (0, parcelRequire("hPkt9")).getCodesFromLocale)(locale);
        const messages = (_ref = (_ref2 = country && i18nMessages[`${language}_${country}`]) !== null && _ref2 !== void 0 ? _ref2 : i18nMessages[language]) !== null && _ref !== void 0 ? _ref : i18nMessages.en;
        const aggregateMessages = {
            ...commonCoreI18nMessages,
            ...messages
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            messages: aggregateMessages,
            locale: country ? `${language}-${country}` : language,
            defaultLocale: $b2465d41ca8b525b$export$1af4c7e47ad72f44,
            defaultRichTextElements: {
                b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        weight: "bold"
                    }, chunks),
                strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong"
                    }, chunks)
            }
        }, children);
    };
    const $b2465d41ca8b525b$export$a98a2d834cadecf0 = (i18nMessages, WrappedComponent)=>(props)=>{
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement($b2465d41ca8b525b$export$23e25b3437f9c000, {
                i18nMessages: i18nMessages,
                locale: intl.locale
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
        };
});
parcelRegister("hPkt9", function(module, exports) {
    $parcel$export(module.exports, "getCodesFromLocale", ()=>$cfa713d6b7186a1c$export$4d25b49b6dc1b540);
    $parcel$export(module.exports, "useLazyI18nMessages", ()=>$cfa713d6b7186a1c$export$30a7082641f381ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $fiX4W;
    const $cfa713d6b7186a1c$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
    const $cfa713d6b7186a1c$export$4d25b49b6dc1b540 = (locale)=>{
        let match = $cfa713d6b7186a1c$var$localeRegex.exec(locale);
        if (!match) {
            console.error('Unable to get language and country from invalid locale, falling back to default locale.');
            match = $cfa713d6b7186a1c$var$localeRegex.exec((0, (0, parcelRequire("fiX4W")).DEFAULT_LOCALE));
        }
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country === null || country === void 0 ? void 0 : country.toUpperCase()
        };
    };
    const $cfa713d6b7186a1c$var$loadLazyI18nMessages = async (locale, lazyI18nMessages)=>{
        var _await$default, _await, _ref;
        const { language: language, country: country } = $cfa713d6b7186a1c$export$4d25b49b6dc1b540(locale);
        return (_await$default = (_await = await ((_ref = country && lazyI18nMessages[`${language}_${country}`] || lazyI18nMessages[language] || lazyI18nMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
    };
    const $cfa713d6b7186a1c$export$30a7082641f381ea = (locale, lazyI18nMessages)=>{
        const [messages, setMessages] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            $cfa713d6b7186a1c$var$loadLazyI18nMessages(locale, lazyI18nMessages).catch(()=>({})).then(setMessages);
        }, [
            locale,
            setMessages,
            lazyI18nMessages
        ]);
        return messages;
    };
});
parcelRegister("8v3RR", function(module, exports) {
    $parcel$export(module.exports, "NoticeDialog", ()=>$63043807ff653784$export$7ccde09c2c5f5940);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    var $abT4b;
    var $fsAfP;
    var $7fcWf;
    var $42b2A;
    const $63043807ff653784$export$7ccde09c2c5f5940 = ({ title: title, titleVars: titleVars, message: message, messageVars: messageVars, confirmText: confirmText, confirmLink: confirmLink, handleClose: handleClose, isErrorNotice: isErrorNotice, errorDetails: errorDetails, isWarningNotice: isWarningNotice, overrideZIndex: overrideZIndex })=>{
        const appearance = isErrorNotice ? 'danger' : isWarningNotice ? 'warning' : undefined;
        const actions = [];
        if (isErrorNotice) ;
        else if (confirmLink) actions.push({
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Close]),
            onClick: ()=>handleClose(false),
            appearance: 'subtle'
        });
        else actions.push({
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).Cancel]),
            onClick: ()=>handleClose(false),
            appearance: 'subtle'
        });
        const primaryButtonAppearance = appearance || 'primary';
        if (confirmLink) actions.push({
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), confirmText),
            href: confirmLink,
            target: '_blank',
            rel: 'noopener noreferrer',
            appearance: primaryButtonAppearance
        });
        else actions.push({
            text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), confirmText),
            onClick: ()=>handleClose(true),
            appearance: primaryButtonAppearance
        });
        let onOpenCompleteF;
        if (overrideZIndex) onOpenCompleteF = (node, isAppearing)=>{
            overrideZIndex && node.parentElement ? node.parentElement.style.zIndex = '5000' : undefined;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onOpenComplete: onOpenCompleteF,
            onClose: ()=>handleClose(),
            shouldCloseOnOverlayClick: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42b2A")).ModalTitleContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: appearance
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, title, {
            values: titleVars
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, message, {
            values: messageVars
        }))), isErrorNotice && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ErrorExplanations1]), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abT4b")).PfLink), {
            href: "http://links.thinktilt.net/error-explanations"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ErrorExplanations2])), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ErrorExplanations3]), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abT4b")).PfLink), {
            href: "https://support.thinktilt.com/"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7fcWf")).IntlNoticeMessages)[(0, (0, parcelRequire("7fcWf")).NoticeMessage).ErrorExplanations4])), "."), !!errorDetails && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fsAfP")).ErrorSection), {
            errorDetails: errorDetails
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, actions.map(({ text: text, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), props, text))));
    };
});
parcelRegister("abT4b", function(module, exports) {
    $parcel$export(module.exports, "PfLink", ()=>$76b5a57dfb2cdc0a$export$9522c077a5f2be27);
    var $5uXOq = parcelRequire("5uXOq");
    const $76b5a57dfb2cdc0a$export$9522c077a5f2be27 = ({ href: href, onClick: onClick, id: id, popup: popup = true, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: href,
            id: id,
            rel: popup ? 'noreferrer noopener' : undefined,
            target: popup ? '_blank' : undefined,
            onClick: onClick
        }, children);
    };
});
parcelRegister("fsAfP", function(module, exports) {
    $parcel$export(module.exports, "ErrorSection", ()=>$b41597dfedacbba9$export$b0bceea2ea86179a);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $cgL5K;
    var $dTlW6;
    const $b41597dfedacbba9$export$b0bceea2ea86179a = ({ errorDetails: errorDetails })=>{
        const [showErrorDetails, setShowErrorDetails] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement($b41597dfedacbba9$var$ErrorSectionLabel, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, "Show error details:"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
            isChecked: showErrorDetails,
            onChange: ()=>{
                setShowErrorDetails(!showErrorDetails);
            }
        })), showErrorDetails && (0, ($parcel$interopDefault($5uXOq))).createElement($b41597dfedacbba9$var$ErrorDetailsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("code", null, errorDetails)));
    };
    const $b41597dfedacbba9$var$ErrorSectionLabel = (0, $dAHxw.default).div({
        display: 'flex',
        marginTop: "var(--ds-space-250, 20px)",
        '> p': {
            marginTop: "var(--ds-space-025, 2px)"
        }
    });
    const $b41597dfedacbba9$var$ErrorDetailsWrapper = (0, $dAHxw.default).div({
        backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        padding: "var(--ds-space-100, 8px)",
        fontSize: "var(--ds-font-body-UNSAFE_small, 12px)"
    });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("dTlW6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3db77843cf29c460$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $7fA4P;
    var $aFYTH;
    var $lahQ6;
    var $hzG2v;
    const $3db77843cf29c460$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $3db77843cf29c460$var$analyticsAttributes = {
        componentName: 'toggle',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $3db77843cf29c460$var$iconSizeMap = {
        regular: 'small',
        large: 'medium'
    };
    const $3db77843cf29c460$var$Toggle = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
        const isControlled = typeof isChecked === 'undefined';
        const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
        const handleBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnBlur,
            action: 'blur',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedFocus,
            action: 'focus',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleChange = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (isControlled) setChecked((checked)=>!checked);
                return providedChange(event, analyticsEvent);
            },
            action: 'change',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const shouldChecked = isControlled ? checked : isChecked;
        const controlProps = {
            'data-checked': shouldChecked ? shouldChecked : undefined,
            'data-disabled': isDisabled ? isDisabled : undefined,
            'data-size': size,
            'data-testid': testId ? testId : undefined
        };
        const toggleStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hzG2v")).getStyles)(size), [
            size
        ]);
        const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
        const labelId = (0, (0, parcelRequire("9KnKW")).useId)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            ...controlProps,
            css: toggleStyles
        }, label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: labelId,
            hidden: true
        }, label) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: ref,
            checked: shouldChecked,
            disabled: isDisabled,
            id: id,
            name: name,
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            type: "checkbox",
            value: value,
            "data-testid": testId && `${testId}--input`,
            "aria-labelledby": label ? labelId : undefined,
            "aria-describedby": descriptionId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: !shouldChecked,
            position: "left"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7fA4P"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-check-icon`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: shouldChecked,
            position: "right"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aFYTH"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-cross-icon`
        }))));
    }));
    $3db77843cf29c460$var$Toggle.displayName = 'Toggle';
    var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;
});
parcelRegister("7fA4P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));
    var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>$5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
        }, props));
    $5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;
});
parcelRegister("f22iM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $af18d40ba5b744b4$var$_UNSAFE_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>$af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
            type: 'utility'
        }, props));
    $af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("aFYTH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));
    var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
    function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c5cf8a572bea882$var$CrossIcon = (props)=>$7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
            LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
        }, props));
    $7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
    var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("lahQ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca1cdaa1eb34599d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    const $ca1cdaa1eb34599d$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.2s ease',
        position: 'absolute',
        insetBlockStart: 'space.025'
    });
    const $ca1cdaa1eb34599d$var$iconContainerRegularStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '16px',
        height: '16px'
    });
    const $ca1cdaa1eb34599d$var$iconContainerLargeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '20px',
        height: '20px'
    });
    const $ca1cdaa1eb34599d$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca1cdaa1eb34599d$var$leftStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineStart: '3px'
    });
    const $ca1cdaa1eb34599d$var$rightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineEnd: '3px'
    });
    const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: [
                $ca1cdaa1eb34599d$var$iconContainerStyles,
                isHidden && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$hiddenStyles,
                size === 'regular' && $ca1cdaa1eb34599d$var$iconContainerRegularStyles,
                size === 'large' && $ca1cdaa1eb34599d$var$iconContainerLargeStyles,
                position === 'left' && $ca1cdaa1eb34599d$var$leftStyles,
                position === 'right' && $ca1cdaa1eb34599d$var$rightStyles
            ]
        }, children);
    };
    var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;
});
parcelRegister("hzG2v", function(module, exports) {
    $parcel$export(module.exports, "getStyles", ()=>$3af6a5b9114f4fd0$export$ffd58b7f6f099a57);
    var $f8Sb3;
    var $VSDnB;
    var $k5uoT;
    var $3VjLl;
    const $3af6a5b9114f4fd0$var$globalGridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $3af6a5b9114f4fd0$var$dimensions = {
        regular: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 4
        },
        large: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2 + $3af6a5b9114f4fd0$var$globalGridSize / 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 5
        }
    };
    const $3af6a5b9114f4fd0$var$getHeight = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].height;
    const $3af6a5b9114f4fd0$var$getWidth = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].width;
    const $3af6a5b9114f4fd0$var$borderWidth = 2;
    const $3af6a5b9114f4fd0$var$paddingUnitless = $3af6a5b9114f4fd0$var$globalGridSize / 4;
    const $3af6a5b9114f4fd0$var$transition = 'transform 0.2s ease';
    const $3af6a5b9114f4fd0$export$ffd58b7f6f099a57 = (size)=>{
        const colors = (0, (0, parcelRequire("3VjLl")).getColors)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            boxSizing: 'content-box',
            display: 'inline-block',
            padding: $3af6a5b9114f4fd0$var$borderWidth,
            margin: $3af6a5b9114f4fd0$var$borderWidth,
            backgroundClip: 'content-box',
            backgroundColor: colors.backgroundColorUnchecked,
            borderRadius: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid transparent`,
            height: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            position: 'relative',
            transition: `${$3af6a5b9114f4fd0$var$transition}`,
            width: `${$3af6a5b9114f4fd0$var$getWidth({
                size: size
            })}px`,
            '&[data-checked]': {
                backgroundColor: colors.backgroundColorChecked,
                color: colors.iconColorChecked
            },
            '&[data-disabled]:not([data-checked])': {
                backgroundColor: colors.backgroundColorUncheckedDisabled
            },
            '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            '&:focus-within': {
                border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid ${colors.borderColorFocus}`
            },
            '&:hover': {
                backgroundColor: colors.backgroundColorUncheckedHover,
                cursor: 'pointer'
            },
            '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
                cursor: 'not-allowed'
            },
            '&[data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedHover
            },
            '&:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorUncheckedHover
            },
            '&[data-disabled]:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            color: colors.iconColorUnchecked,
            '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
                color: colors.iconColorDisabled
            },
            'input[type="checkbox"]': {
                opacity: 0,
                margin: 0,
                padding: 0,
                border: 'none',
                '&:focus': {
                    outline: 'none !important'
                }
            },
            '::before': {
                backgroundColor: colors.handleBackgroundColor,
                borderRadius: "var(--ds-border-radius-circle, 50%)",
                content: '""',
                position: 'absolute',
                transform: 'initial',
                transition: $3af6a5b9114f4fd0$var$transition,
                insetBlockEnd: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`,
                height: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                width: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                insetInlineStart: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`
            },
            '&[data-checked]::before': {
                backgroundColor: colors.handleBackgroundColorChecked,
                transform: `translateX(${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                })}px)`
            },
            '&[data-disabled]::before': {
                backgroundColor: colors.handleBackgroundColorDisabled,
                zIndex: 1
            },
            ...size === 'large' && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && {
                '> span > span': {
                    height: '20px',
                    width: '20px'
                }
            },
            '@media screen and (forced-colors: active)': {
                '::before': {
                    filter: 'grayscale(100%) invert(1)'
                },
                '&:focus-within': {
                    outline: '1px solid'
                }
            }
        });
    };
});
parcelRegister("3VjLl", function(module, exports) {
    $parcel$export(module.exports, "getColors", ()=>$7761f9acd89472cc$export$6cee60e8aa85e528);
    const $7761f9acd89472cc$var$colorMap = {
        backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        borderColorFocus: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        iconColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        iconColorDisabled: `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $7761f9acd89472cc$export$6cee60e8aa85e528 = ()=>$7761f9acd89472cc$var$colorMap;
});
parcelRegister("42b2A", function(module, exports) {
    $parcel$export(module.exports, "ModalTitleContainer", ()=>$2effe9ca9018cbff$export$8bbe98d958a85a9d);
    var $dAHxw = parcelRequire("dAHxw");
    const $2effe9ca9018cbff$export$8bbe98d958a85a9d = (0, $dAHxw.default).span({
        'h1, h1 > span': {
            fontSize: "var(--ds-font-heading-medium, 20px)",
            fontWeight: 500,
            lineHeight: 1
        }
    });
});
parcelRegister("gFGsm", function(module, exports) {
    $parcel$export(module.exports, "LiveErrorUtils", ()=>$c23168a474488ad4$export$f2a509cffb92cb9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $31NxU;
    var $3kk8J;
    var $8vvJk;
    var $ousew;
    var $7nnPp;
    var $h8yj2;
    var $aIZdc;
    var $9e9ba;
    var $erWXD;
    var $bRqoO;
    var $fxMku;
    const $c23168a474488ad4$var$TAGS = [
        'module',
        'actionSubject',
        'url'
    ];
    const $c23168a474488ad4$var$SENTRY_PUBLIC_KEY = 'c6ac6cc7ef554e3286ec09d412c9c1f4';
    const $c23168a474488ad4$var$SENTRY_PROJECT_ID = '6388218';
    const $c23168a474488ad4$var$SENTRY_COMMERCIAL_DSN = `https://${$c23168a474488ad4$var$SENTRY_PUBLIC_KEY}@o55978.ingest.sentry.io/${$c23168a474488ad4$var$SENTRY_PROJECT_ID}`;
    const $c23168a474488ad4$var$SENTRY_FEDRAMP_DSN = `https://${$c23168a474488ad4$var$SENTRY_PUBLIC_KEY}@sentry.atlassian-us-gov-mod.com/${$c23168a474488ad4$var$SENTRY_PROJECT_ID}`;
    const $c23168a474488ad4$var$PROFORMA_SENTRY_PROJECT_DSN = (0, (0, parcelRequire("aIZdc")).isFedRamp)() ? $c23168a474488ad4$var$SENTRY_FEDRAMP_DSN : $c23168a474488ad4$var$SENTRY_COMMERCIAL_DSN;
    class $c23168a474488ad4$export$f2a509cffb92cb9c {
        constructor(moduleName, showFlag, createAnalyticsEvent, environment){
            this.moduleName = void 0;
            this.showFlag = void 0;
            this.createAnalyticsEvent = void 0;
            this.sentryHub = void 0;
            this.environment = void 0;
            this.moduleName = moduleName;
            this.showFlag = showFlag;
            this.createAnalyticsEvent = createAnalyticsEvent;
            this.environment = environment;
            this.sentryHub = this.getSentryHub(environment);
        }
        reportError(error, options) {
            var _options$actionSubjec;
            const errorPrefix = `Proforma(${this.moduleName}): `;
            const severity = options !== null && options !== void 0 && options.severity ? options.severity : (0, (0, parcelRequire("8vvJk")).Severity).Error;
            switch(severity){
                case (0, (0, parcelRequire("8vvJk")).Severity).Warning:
                    console.warn(errorPrefix, error);
                    break;
                case (0, (0, parcelRequire("8vvJk")).Severity).Info:
                    console.info(errorPrefix, error);
                    break;
                default:
                    console.error(errorPrefix, error);
                    break;
            }
            const actionSubject = (_options$actionSubjec = options === null || options === void 0 ? void 0 : options.actionSubject) !== null && _options$actionSubjec !== void 0 ? _options$actionSubjec : (0, (0, parcelRequire("erWXD")).ActionSubject).PROFORMA_UI;
            const attributes = (options === null || options === void 0 ? void 0 : options.attributes) && Object.fromEntries(Object.entries(options.attributes).map(([key, value])=>[
                    key,
                    typeof value === 'string' ? (0, (0, parcelRequire("9e9ba")).maskEmailIds)(value) : value
                ]));
            const details = {
                actionSubject: actionSubject,
                errorId: options === null || options === void 0 ? void 0 : options.id,
                severity: severity,
                module: this.moduleName,
                errorMsg: error.message,
                errorInfo: options === null || options === void 0 ? void 0 : options.errorInfo,
                isClientFetchError: error.isClientFetchError,
                requestName: error.requestName,
                traceId: error.traceId,
                status: error.status,
                userAgent: this.getBrowserUserAgent(),
                url: this.getUrl(),
                ...attributes
            };
            (0, (0, parcelRequire("h8yj2")).fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, (0, parcelRequire("erWXD")).Action).FAILED}`, details);
            if (this.environment === (0, (0, parcelRequire("fxMku")).Environment).LOCAL || this.sentryHub === undefined) return;
            const sentryHub = this.sentryHub;
            sentryHub.withScope((scope)=>{
                scope.setLevel(severity);
                Object.keys(details).forEach((key)=>{
                    const value = details[key];
                    if (value) {
                        if ($c23168a474488ad4$var$TAGS.includes(key)) scope.setTag(key, value.toString());
                        else scope.setExtra(key, value);
                    }
                });
                sentryHub.captureException(error);
            });
        }
        notifyUser(errorNotice, customDescription) {
            const notice = (0, (0, parcelRequire("bRqoO")).Notices)[errorNotice];
            if (notice) {
                this.showFlag({
                    appearance: 'error',
                    isAutoDismiss: true,
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                        label: "",
                        primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                    }),
                    title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), notice.title),
                    description: customDescription ? customDescription : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), notice.message)
                });
                return Promise.resolve();
            } else {
                console.error(`Could not show error, notice type ${errorNotice} does not exist`);
                return Promise.reject();
            }
        }
        getSentryHub(environment) {
            try {
                const client = new (0, (0, parcelRequire("31NxU")).BrowserClient)({
                    environment: environment,
                    dsn: $c23168a474488ad4$var$PROFORMA_SENTRY_PROJECT_DSN
                });
                return new (0, (0, parcelRequire("3kk8J")).Hub)(client);
            } catch (error) {
                const actionSubject = 'getProformaSentryHub';
                const details = {
                    actionSubject: actionSubject,
                    severity: (0, (0, parcelRequire("8vvJk")).Severity).Error,
                    module: this.moduleName,
                    errorMsg: error.message,
                    userAgent: this.getBrowserUserAgent(),
                    url: this.getUrl()
                };
                (0, (0, parcelRequire("h8yj2")).fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, (0, parcelRequire("erWXD")).Action).FAILED}`, details);
            }
        }
        getBrowserUserAgent() {
            var _window$navigator$use, _window, _window$navigator;
            return (_window$navigator$use = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) !== null && _window$navigator$use !== void 0 ? _window$navigator$use : 'unknown';
        }
        getUrl() {
            var _window$document$loca, _window2, _window2$document, _window2$document$loc;
            return (_window$document$loca = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$document = _window2.document) === null || _window2$document === void 0 ? void 0 : (_window2$document$loc = _window2$document.location) === null || _window2$document$loc === void 0 ? void 0 : _window2$document$loc.host) !== null && _window$document$loca !== void 0 ? _window$document$loca : 'unknown';
        }
    }
});
parcelRegister("31NxU", function(module, exports) {
    $parcel$export(module.exports, "BrowserClient", ()=>$2347e5dedbca2ded$export$1df9218a526d318d);
    var $3VFsf;
    var $fVKZK;
    var $9Up1Q;
    parcelRequire("3xuhl");
    var $eUO5L;
    var $aHQIJ;
    var $1jQdQ;
    var $86ilb;
    var $7n7dK;
    var $3Y2SJ;
    var $2347e5dedbca2ded$export$1df9218a526d318d = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BrowserClient, _super);
        function BrowserClient(options) {
            if (options === void 0) options = {};
            var _this = this;
            options._metadata = options._metadata || {};
            options._metadata.sdk = options._metadata.sdk || {
                name: 'sentry.javascript.browser',
                packages: [
                    {
                        name: 'npm:@sentry/browser',
                        version: (0, (0, parcelRequire("9Up1Q")).SDK_VERSION)
                    }
                ],
                version: (0, (0, parcelRequire("9Up1Q")).SDK_VERSION)
            };
            _this = _super.call(this, (0, (0, parcelRequire("1jQdQ")).BrowserBackend), options) || this;
            return _this;
        }
        BrowserClient.prototype.showReportDialog = function(options) {
            if (options === void 0) options = {};
            var document = (0, (0, parcelRequire("eUO5L")).getGlobalObject)().document;
            if (!document) return;
            if (!this._isEnabled()) {
                (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Trying to call showReportDialog with Sentry Client disabled');
                return;
            }
            (0, (0, parcelRequire("7n7dK")).injectReportDialog)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                dsn: options.dsn || this.getDsn()
            }));
        };
        BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
            event.platform = event.platform || 'javascript';
            return _super.prototype._prepareEvent.call(this, event, scope, hint);
        };
        BrowserClient.prototype._sendEvent = function(event) {
            var integration = this.getIntegration((0, (0, parcelRequire("3Y2SJ")).Breadcrumbs));
            if (integration) integration.addSentryBreadcrumb(event);
            _super.prototype._sendEvent.call(this, event);
        };
        return BrowserClient;
    }((0, (0, parcelRequire("fVKZK")).BaseClient));
});
parcelRegister("fVKZK", function(module, exports) {
    $parcel$export(module.exports, "BaseClient", ()=>$b990a217eb724e06$export$4f22f74eddb7716a);
    var $3VFsf;
    var $gfYRq;
    parcelRequire("3xuhl");
    var $1vYJz;
    var $gI8Be;
    var $okkfE;
    var $aHQIJ;
    var $ha3jm;
    var $gBQwe;
    var $4mVTs;
    var $f7sqx;
    var $keOcA;
    var $3knVN;
    var $bYhbK;
    var $b990a217eb724e06$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
    var $b990a217eb724e06$export$4f22f74eddb7716a = function() {
        function BaseClient(backendClass, options) {
            this._integrations = {};
            this._numProcessing = 0;
            this._backend = new backendClass(options);
            this._options = options;
            if (options.dsn) this._dsn = (0, (0, parcelRequire("ha3jm")).makeDsn)(options.dsn);
        }
        BaseClient.prototype.captureException = function(exception, hint, scope) {
            var _this = this;
            if ((0, (0, parcelRequire("1vYJz")).checkOrSetAlreadyCaught)(exception)) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log($b990a217eb724e06$var$ALREADY_SEEN_ERROR);
                return;
            }
            var eventId = hint && hint.event_id;
            this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
                return _this._captureEvent(event, hint, scope);
            }).then(function(result) {
                eventId = result;
            }));
            return eventId;
        };
        BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
            var _this = this;
            var eventId = hint && hint.event_id;
            var promisedEvent = (0, (0, parcelRequire("okkfE")).isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
            this._process(promisedEvent.then(function(event) {
                return _this._captureEvent(event, hint, scope);
            }).then(function(result) {
                eventId = result;
            }));
            return eventId;
        };
        BaseClient.prototype.captureEvent = function(event, hint, scope) {
            if (hint && hint.originalException && (0, (0, parcelRequire("1vYJz")).checkOrSetAlreadyCaught)(hint.originalException)) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log($b990a217eb724e06$var$ALREADY_SEEN_ERROR);
                return;
            }
            var eventId = hint && hint.event_id;
            this._process(this._captureEvent(event, hint, scope).then(function(result) {
                eventId = result;
            }));
            return eventId;
        };
        BaseClient.prototype.captureSession = function(session) {
            if (!this._isEnabled()) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('SDK not enabled, will not capture session.');
                return;
            }
            if (!(typeof session.release === 'string')) (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('Discarded session because of missing or non-string release');
            else {
                this._sendSession(session);
                session.update({
                    init: false
                });
            }
        };
        BaseClient.prototype.getDsn = function() {
            return this._dsn;
        };
        BaseClient.prototype.getOptions = function() {
            return this._options;
        };
        BaseClient.prototype.getTransport = function() {
            return this._getBackend().getTransport();
        };
        BaseClient.prototype.flush = function(timeout) {
            var _this = this;
            return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
                return _this.getTransport().close(timeout).then(function(transportFlushed) {
                    return clientFinished && transportFlushed;
                });
            });
        };
        BaseClient.prototype.close = function(timeout) {
            var _this = this;
            return this.flush(timeout).then(function(result) {
                _this.getOptions().enabled = false;
                return result;
            });
        };
        BaseClient.prototype.setupIntegrations = function() {
            if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, (0, parcelRequire("bYhbK")).setupIntegrations)(this._options);
        };
        BaseClient.prototype.getIntegration = function(integration) {
            try {
                return this._integrations[integration.id] || null;
            } catch (_oO) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
                return null;
            }
        };
        BaseClient.prototype._updateSessionFromEvent = function(session, event) {
            var e_1, _a;
            var crashed = false;
            var errored = false;
            var exceptions = event.exception && event.exception.values;
            if (exceptions) {
                errored = true;
                try {
                    for(var exceptions_1 = (0, (0, parcelRequire("3VFsf")).__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                        var ex = exceptions_1_1.value;
                        var mechanism = ex.mechanism;
                        if (mechanism && mechanism.handled === false) {
                            crashed = true;
                            break;
                        }
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
            var sessionNonTerminal = session.status === 'ok';
            var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
            if (shouldUpdateAndSend) {
                session.update((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, crashed && {
                    status: 'crashed'
                }), {
                    errors: session.errors || Number(errored || crashed)
                }));
                this.captureSession(session);
            }
        };
        BaseClient.prototype._sendSession = function(session) {
            this._getBackend().sendSession(session);
        };
        BaseClient.prototype._isClientDoneProcessing = function(timeout) {
            var _this = this;
            return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve) {
                var ticked = 0;
                var tick = 1;
                var interval = setInterval(function() {
                    if (_this._numProcessing == 0) {
                        clearInterval(interval);
                        resolve(true);
                    } else {
                        ticked += tick;
                        if (timeout && ticked >= timeout) {
                            clearInterval(interval);
                            resolve(false);
                        }
                    }
                }, tick);
            });
        };
        BaseClient.prototype._getBackend = function() {
            return this._backend;
        };
        BaseClient.prototype._isEnabled = function() {
            return this.getOptions().enabled !== false && this._dsn !== undefined;
        };
        BaseClient.prototype._prepareEvent = function(event, scope, hint) {
            var _this = this;
            var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
            var prepared = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, event), {
                event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, (0, parcelRequire("1vYJz")).uuid4)()),
                timestamp: event.timestamp || (0, (0, parcelRequire("gI8Be")).dateTimestampInSeconds)()
            });
            this._applyClientOptions(prepared);
            this._applyIntegrationsMetadata(prepared);
            var finalScope = scope;
            if (hint && hint.captureContext) finalScope = (0, (0, parcelRequire("gfYRq")).Scope).clone(finalScope).update(hint.captureContext);
            var result = (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(prepared);
            if (finalScope) result = finalScope.applyToEvent(prepared, hint);
            return result.then(function(evt) {
                if (evt) evt.sdkProcessingMetadata = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, evt.sdkProcessingMetadata), {
                    normalizeDepth: (0, (0, parcelRequire("gBQwe")).normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
                });
                if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
                return evt;
            });
        };
        BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
            if (!event) return null;
            var normalized = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, event), event.breadcrumbs && {
                breadcrumbs: event.breadcrumbs.map(function(b) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, b), b.data && {
                        data: (0, (0, parcelRequire("gBQwe")).normalize)(b.data, depth, maxBreadth)
                    });
                })
            }), event.user && {
                user: (0, (0, parcelRequire("gBQwe")).normalize)(event.user, depth, maxBreadth)
            }), event.contexts && {
                contexts: (0, (0, parcelRequire("gBQwe")).normalize)(event.contexts, depth, maxBreadth)
            }), event.extra && {
                extra: (0, (0, parcelRequire("gBQwe")).normalize)(event.extra, depth, maxBreadth)
            });
            if (event.contexts && event.contexts.trace) normalized.contexts.trace = event.contexts.trace;
            normalized.sdkProcessingMetadata = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, normalized.sdkProcessingMetadata), {
                baseClientNormalized: true
            });
            return normalized;
        };
        BaseClient.prototype._applyClientOptions = function(event) {
            var options = this.getOptions();
            var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
            if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
            if (event.release === undefined && release !== undefined) event.release = release;
            if (event.dist === undefined && dist !== undefined) event.dist = dist;
            if (event.message) event.message = (0, (0, parcelRequire("keOcA")).truncate)(event.message, maxValueLength);
            var exception = event.exception && event.exception.values && event.exception.values[0];
            if (exception && exception.value) exception.value = (0, (0, parcelRequire("keOcA")).truncate)(exception.value, maxValueLength);
            var request = event.request;
            if (request && request.url) request.url = (0, (0, parcelRequire("keOcA")).truncate)(request.url, maxValueLength);
        };
        BaseClient.prototype._applyIntegrationsMetadata = function(event) {
            var integrationsArray = Object.keys(this._integrations);
            if (integrationsArray.length > 0) {
                event.sdk = event.sdk || {};
                event.sdk.integrations = (0, (0, parcelRequire("3VFsf")).__spread)(event.sdk.integrations || [], integrationsArray);
            }
        };
        BaseClient.prototype._sendEvent = function(event) {
            this._getBackend().sendEvent(event);
        };
        BaseClient.prototype._captureEvent = function(event, hint, scope) {
            return this._processEvent(event, hint, scope).then(function(finalEvent) {
                return finalEvent.event_id;
            }, function(reason) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error(reason);
                return undefined;
            });
        };
        BaseClient.prototype._processEvent = function(event, hint, scope) {
            var _this = this;
            var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
            var transport = this.getTransport();
            function recordLostEvent(outcome, category) {
                if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
            }
            if (!this._isEnabled()) return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)(new (0, (0, parcelRequire("f7sqx")).SentryError)('SDK not enabled, will not capture event.'));
            var isTransaction = event.type === 'transaction';
            if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
                recordLostEvent('sample_rate', 'event');
                return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)(new (0, (0, parcelRequire("f7sqx")).SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
            }
            return this._prepareEvent(event, scope, hint).then(function(prepared) {
                if (prepared === null) {
                    recordLostEvent('event_processor', event.type || 'event');
                    throw new (0, (0, parcelRequire("f7sqx")).SentryError)('An event processor returned null, will not send event.');
                }
                var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                if (isInternalException || isTransaction || !beforeSend) return prepared;
                var beforeSendResult = beforeSend(prepared, hint);
                return $b990a217eb724e06$var$_ensureBeforeSendRv(beforeSendResult);
            }).then(function(processedEvent) {
                if (processedEvent === null) {
                    recordLostEvent('before_send', event.type || 'event');
                    throw new (0, (0, parcelRequire("f7sqx")).SentryError)('`beforeSend` returned `null`, will not send event.');
                }
                var session = scope && scope.getSession && scope.getSession();
                if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
                _this._sendEvent(processedEvent);
                return processedEvent;
            }).then(null, function(reason) {
                if (reason instanceof (0, (0, parcelRequire("f7sqx")).SentryError)) throw reason;
                _this.captureException(reason, {
                    data: {
                        __sentry__: true
                    },
                    originalException: reason
                });
                throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
            });
        };
        BaseClient.prototype._process = function(promise) {
            var _this = this;
            this._numProcessing += 1;
            promise.then(function(value) {
                _this._numProcessing -= 1;
                return value;
            }, function(reason) {
                _this._numProcessing -= 1;
                return reason;
            });
        };
        return BaseClient;
    }();
    function $b990a217eb724e06$var$_ensureBeforeSendRv(rv) {
        var nullErr = '`beforeSend` method has to return `null` or a valid event.';
        if ((0, (0, parcelRequire("okkfE")).isThenable)(rv)) return rv.then(function(event) {
            if (!((0, (0, parcelRequire("okkfE")).isPlainObject)(event) || event === null)) throw new (0, (0, parcelRequire("f7sqx")).SentryError)(nullErr);
            return event;
        }, function(e) {
            throw new (0, (0, parcelRequire("f7sqx")).SentryError)("beforeSend rejected with " + e);
        });
        else if (!((0, (0, parcelRequire("okkfE")).isPlainObject)(rv) || rv === null)) throw new (0, (0, parcelRequire("f7sqx")).SentryError)(nullErr);
        return rv;
    }
});
parcelRegister("gfYRq", function(module, exports) {
    $parcel$export(module.exports, "Scope", ()=>$bd5d41be26a98453$export$775b6bb06e53a214);
    $parcel$export(module.exports, "addGlobalEventProcessor", ()=>$bd5d41be26a98453$export$8e4e25f54d456511);
    var $3VFsf;
    parcelRequire("2zyAl");
    var $gI8Be;
    var $eUO5L;
    var $okkfE;
    var $4mVTs;
    var $bd5d41be26a98453$var$MAX_BREADCRUMBS = 100;
    var $bd5d41be26a98453$export$775b6bb06e53a214 = function() {
        function Scope() {
            this._notifyingListeners = false;
            this._scopeListeners = [];
            this._eventProcessors = [];
            this._breadcrumbs = [];
            this._user = {};
            this._tags = {};
            this._extra = {};
            this._contexts = {};
            this._sdkProcessingMetadata = {};
        }
        Scope.clone = function(scope) {
            var newScope = new Scope();
            if (scope) {
                newScope._breadcrumbs = (0, (0, parcelRequire("3VFsf")).__spread)(scope._breadcrumbs);
                newScope._tags = (0, (0, parcelRequire("3VFsf")).__assign)({}, scope._tags);
                newScope._extra = (0, (0, parcelRequire("3VFsf")).__assign)({}, scope._extra);
                newScope._contexts = (0, (0, parcelRequire("3VFsf")).__assign)({}, scope._contexts);
                newScope._user = scope._user;
                newScope._level = scope._level;
                newScope._span = scope._span;
                newScope._session = scope._session;
                newScope._transactionName = scope._transactionName;
                newScope._fingerprint = scope._fingerprint;
                newScope._eventProcessors = (0, (0, parcelRequire("3VFsf")).__spread)(scope._eventProcessors);
                newScope._requestSession = scope._requestSession;
            }
            return newScope;
        };
        Scope.prototype.addScopeListener = function(callback) {
            this._scopeListeners.push(callback);
        };
        Scope.prototype.addEventProcessor = function(callback) {
            this._eventProcessors.push(callback);
            return this;
        };
        Scope.prototype.setUser = function(user) {
            this._user = user || {};
            if (this._session) this._session.update({
                user: user
            });
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.getUser = function() {
            return this._user;
        };
        Scope.prototype.getRequestSession = function() {
            return this._requestSession;
        };
        Scope.prototype.setRequestSession = function(requestSession) {
            this._requestSession = requestSession;
            return this;
        };
        Scope.prototype.setTags = function(tags) {
            this._tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), tags);
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setTag = function(key, value) {
            var _a;
            this._tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setExtras = function(extras) {
            this._extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), extras);
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setExtra = function(key, extra) {
            var _a;
            this._extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setFingerprint = function(fingerprint) {
            this._fingerprint = fingerprint;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setLevel = function(level) {
            this._level = level;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setTransactionName = function(name) {
            this._transactionName = name;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setTransaction = function(name) {
            return this.setTransactionName(name);
        };
        Scope.prototype.setContext = function(key, context) {
            var _a;
            if (context === null) delete this._contexts[key];
            else this._contexts = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.setSpan = function(span) {
            this._span = span;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.getSpan = function() {
            return this._span;
        };
        Scope.prototype.getTransaction = function() {
            var span = this.getSpan();
            return span && span.transaction;
        };
        Scope.prototype.setSession = function(session) {
            if (!session) delete this._session;
            else this._session = session;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.getSession = function() {
            return this._session;
        };
        Scope.prototype.update = function(captureContext) {
            if (!captureContext) return this;
            if (typeof captureContext === 'function') {
                var updatedScope = captureContext(this);
                return updatedScope instanceof Scope ? updatedScope : this;
            }
            if (captureContext instanceof Scope) {
                this._tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), captureContext._tags);
                this._extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), captureContext._extra);
                this._contexts = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._contexts), captureContext._contexts);
                if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
                if (captureContext._level) this._level = captureContext._level;
                if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
                if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
            } else if ((0, (0, parcelRequire("okkfE")).isPlainObject)(captureContext)) {
                captureContext;
                this._tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), captureContext.tags);
                this._extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), captureContext.extra);
                this._contexts = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._contexts), captureContext.contexts);
                if (captureContext.user) this._user = captureContext.user;
                if (captureContext.level) this._level = captureContext.level;
                if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
                if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
            }
            return this;
        };
        Scope.prototype.clear = function() {
            this._breadcrumbs = [];
            this._tags = {};
            this._extra = {};
            this._user = {};
            this._contexts = {};
            this._level = undefined;
            this._transactionName = undefined;
            this._fingerprint = undefined;
            this._requestSession = undefined;
            this._span = undefined;
            this._session = undefined;
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
            var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $bd5d41be26a98453$var$MAX_BREADCRUMBS) : $bd5d41be26a98453$var$MAX_BREADCRUMBS;
            if (maxCrumbs <= 0) return this;
            var mergedBreadcrumb = (0, (0, parcelRequire("3VFsf")).__assign)({
                timestamp: (0, (0, parcelRequire("gI8Be")).dateTimestampInSeconds)()
            }, breadcrumb);
            this._breadcrumbs = (0, (0, parcelRequire("3VFsf")).__spread)(this._breadcrumbs, [
                mergedBreadcrumb
            ]).slice(-maxCrumbs);
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.clearBreadcrumbs = function() {
            this._breadcrumbs = [];
            this._notifyScopeListeners();
            return this;
        };
        Scope.prototype.applyToEvent = function(event, hint) {
            if (this._extra && Object.keys(this._extra).length) event.extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._extra), event.extra);
            if (this._tags && Object.keys(this._tags).length) event.tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._tags), event.tags);
            if (this._user && Object.keys(this._user).length) event.user = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._user), event.user);
            if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._contexts), event.contexts);
            if (this._level) event.level = this._level;
            if (this._transactionName) event.transaction = this._transactionName;
            if (this._span) {
                event.contexts = (0, (0, parcelRequire("3VFsf")).__assign)({
                    trace: this._span.getTraceContext()
                }, event.contexts);
                var transactionName = this._span.transaction && this._span.transaction.name;
                if (transactionName) event.tags = (0, (0, parcelRequire("3VFsf")).__assign)({
                    transaction: transactionName
                }, event.tags);
            }
            this._applyFingerprint(event);
            event.breadcrumbs = (0, (0, parcelRequire("3VFsf")).__spread)(event.breadcrumbs || [], this._breadcrumbs);
            event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
            event.sdkProcessingMetadata = this._sdkProcessingMetadata;
            return this._notifyEventProcessors((0, (0, parcelRequire("3VFsf")).__spread)($bd5d41be26a98453$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
        };
        Scope.prototype.setSDKProcessingMetadata = function(newData) {
            this._sdkProcessingMetadata = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._sdkProcessingMetadata), newData);
            return this;
        };
        Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
            var _this = this;
            if (index === void 0) index = 0;
            return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, reject) {
                var processor = processors[index];
                if (event === null || typeof processor !== 'function') resolve(event);
                else {
                    var result = processor((0, (0, parcelRequire("3VFsf")).__assign)({}, event), hint);
                    if ((0, (0, parcelRequire("okkfE")).isThenable)(result)) result.then(function(final) {
                        return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                    }).then(null, reject);
                    else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
                }
            });
        };
        Scope.prototype._notifyScopeListeners = function() {
            var _this = this;
            if (!this._notifyingListeners) {
                this._notifyingListeners = true;
                this._scopeListeners.forEach(function(callback) {
                    callback(_this);
                });
                this._notifyingListeners = false;
            }
        };
        Scope.prototype._applyFingerprint = function(event) {
            event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
                event.fingerprint
            ] : [];
            if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
            if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
        };
        return Scope;
    }();
    function $bd5d41be26a98453$var$getGlobalEventProcessors() {
        return (0, (0, parcelRequire("eUO5L")).getGlobalSingleton)('globalEventProcessors', function() {
            return [];
        });
    }
    function $bd5d41be26a98453$export$8e4e25f54d456511(callback) {
        $bd5d41be26a98453$var$getGlobalEventProcessors().push(callback);
    }
});
parcelRegister("2zyAl", function(module, exports) {
    $parcel$export(module.exports, "getGlobalObject", ()=>(parcelRequire("eUO5L")).getGlobalObject);
    $parcel$export(module.exports, "getGlobalSingleton", ()=>(parcelRequire("eUO5L")).getGlobalSingleton);
    $parcel$export(module.exports, "isPlainObject", ()=>(parcelRequire("okkfE")).isPlainObject);
    $parcel$export(module.exports, "isThenable", ()=>(parcelRequire("okkfE")).isThenable);
    $parcel$export(module.exports, "consoleSandbox", ()=>(parcelRequire("aHQIJ")).consoleSandbox);
    $parcel$export(module.exports, "logger", ()=>(parcelRequire("aHQIJ")).logger);
    $parcel$export(module.exports, "uuid4", ()=>(parcelRequire("1vYJz")).uuid4);
    $parcel$export(module.exports, "dropUndefinedKeys", ()=>(parcelRequire("59M0S")).dropUndefinedKeys);
    $parcel$export(module.exports, "SyncPromise", ()=>(parcelRequire("4mVTs")).SyncPromise);
    parcelRequire("eUO5L");
    parcelRequire("okkfE");
    parcelRequire("aHQIJ");
    parcelRequire("1vYJz");
    var $3kiq9;
    parcelRequire("59M0S");
    parcelRequire("4mVTs");
    var $gI8Be;
    $parcel$exportWildcard(module.exports, (0, parcelRequire("3kiq9")));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("gI8Be")));
});
parcelRegister("eUO5L", function(module, exports) {
    $parcel$export(module.exports, "getGlobalObject", ()=>$adbd26dd4cdaba08$export$256479dc0cea61c4);
    $parcel$export(module.exports, "getGlobalSingleton", ()=>$adbd26dd4cdaba08$export$7e223ec222791509);
    var $3kiq9;
    var $adbd26dd4cdaba08$var$fallbackGlobalObject = {};
    function $adbd26dd4cdaba08$export$256479dc0cea61c4() {
        return (0, (0, parcelRequire("3kiq9")).isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : $adbd26dd4cdaba08$var$fallbackGlobalObject;
    }
    function $adbd26dd4cdaba08$export$7e223ec222791509(name, creator, obj) {
        var global1 = obj || $adbd26dd4cdaba08$export$256479dc0cea61c4();
        var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
        var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
        return singleton;
    }
});
parcelRegister("3kiq9", function(module, exports) {
    $parcel$export(module.exports, "isNodeEnv", ()=>isNodeEnv, (v)=>isNodeEnv = v);
    $parcel$export(module.exports, "dynamicRequire", ()=>dynamicRequire, (v)=>dynamicRequire = v);
    var $diNsD;
    var $6cAn5 = parcelRequire("6cAn5");
    function isNodeEnv() {
        return !(0, (0, parcelRequire("diNsD")).isBrowserBundle)() && Object.prototype.toString.call(typeof $6cAn5 !== 'undefined' ? $6cAn5 : 0) === '[object process]';
    }
    function dynamicRequire(mod, request) {
        return mod.require(request);
    }
    function loadModule(moduleName) {
        var mod;
        try {
            mod = dynamicRequire(module, moduleName);
        } catch (e) {}
        try {
            var cwd = dynamicRequire(module, 'process').cwd;
            mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
        } catch (e) {}
        return mod;
    }
});
parcelRegister("diNsD", function(module, exports) {
    $parcel$export(module.exports, "isBrowserBundle", ()=>$9af352b66430744d$export$2928c40372e623c0);
    function $9af352b66430744d$export$2928c40372e623c0() {
        return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
    }
});
parcelRegister("okkfE", function(module, exports) {
    $parcel$export(module.exports, "isError", ()=>$04920240eebc235f$export$e6127cc7fe7395c3);
    $parcel$export(module.exports, "isInstanceOf", ()=>$04920240eebc235f$export$49034edbe6b62415);
    $parcel$export(module.exports, "isErrorEvent", ()=>$04920240eebc235f$export$9f9636d330b71954);
    $parcel$export(module.exports, "isDOMError", ()=>$04920240eebc235f$export$ef9e2056653f0c8e);
    $parcel$export(module.exports, "isDOMException", ()=>$04920240eebc235f$export$12e869b2a583f783);
    $parcel$export(module.exports, "isString", ()=>$04920240eebc235f$export$844ec244b1367d54);
    $parcel$export(module.exports, "isPrimitive", ()=>$04920240eebc235f$export$c3825b437cbdea5c);
    $parcel$export(module.exports, "isPlainObject", ()=>$04920240eebc235f$export$53b83ca8eaab0383);
    $parcel$export(module.exports, "isEvent", ()=>$04920240eebc235f$export$9671ea99bd126ace);
    $parcel$export(module.exports, "isElement", ()=>$04920240eebc235f$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isRegExp", ()=>$04920240eebc235f$export$49841c62b9eff15);
    $parcel$export(module.exports, "isThenable", ()=>$04920240eebc235f$export$f5b060c2914b97c8);
    $parcel$export(module.exports, "isSyntheticEvent", ()=>$04920240eebc235f$export$bc2894c7158efbac);
    $parcel$export(module.exports, "isNaN", ()=>$04920240eebc235f$export$c9f5652083b8129d);
    var $04920240eebc235f$var$objectToString = Object.prototype.toString;
    function $04920240eebc235f$export$e6127cc7fe7395c3(wat) {
        switch($04920240eebc235f$var$objectToString.call(wat)){
            case '[object Error]':
            case '[object Exception]':
            case '[object DOMException]':
                return true;
            default:
                return $04920240eebc235f$export$49034edbe6b62415(wat, Error);
        }
    }
    function $04920240eebc235f$var$isBuiltin(wat, ty) {
        return $04920240eebc235f$var$objectToString.call(wat) === "[object " + ty + "]";
    }
    function $04920240eebc235f$export$9f9636d330b71954(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'ErrorEvent');
    }
    function $04920240eebc235f$export$ef9e2056653f0c8e(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'DOMError');
    }
    function $04920240eebc235f$export$12e869b2a583f783(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'DOMException');
    }
    function $04920240eebc235f$export$844ec244b1367d54(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'String');
    }
    function $04920240eebc235f$export$c3825b437cbdea5c(wat) {
        return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
    }
    function $04920240eebc235f$export$53b83ca8eaab0383(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'Object');
    }
    function $04920240eebc235f$export$9671ea99bd126ace(wat) {
        return typeof Event !== 'undefined' && $04920240eebc235f$export$49034edbe6b62415(wat, Event);
    }
    function $04920240eebc235f$export$45a5e7f76e0caa8d(wat) {
        return typeof Element !== 'undefined' && $04920240eebc235f$export$49034edbe6b62415(wat, Element);
    }
    function $04920240eebc235f$export$49841c62b9eff15(wat) {
        return $04920240eebc235f$var$isBuiltin(wat, 'RegExp');
    }
    function $04920240eebc235f$export$f5b060c2914b97c8(wat) {
        return Boolean(wat && wat.then && typeof wat.then === 'function');
    }
    function $04920240eebc235f$export$bc2894c7158efbac(wat) {
        return $04920240eebc235f$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
    }
    function $04920240eebc235f$export$c9f5652083b8129d(wat) {
        return typeof wat === 'number' && wat !== wat;
    }
    function $04920240eebc235f$export$49034edbe6b62415(wat, base) {
        try {
            return wat instanceof base;
        } catch (_e) {
            return false;
        }
    }
});
parcelRegister("aHQIJ", function(module, exports) {
    $parcel$export(module.exports, "CONSOLE_LEVELS", ()=>$7cb6d0bbf859a350$export$2a2b1d2252a69ecb);
    $parcel$export(module.exports, "consoleSandbox", ()=>$7cb6d0bbf859a350$export$cda52e2a8927a2ca);
    $parcel$export(module.exports, "logger", ()=>$7cb6d0bbf859a350$export$af88d00dbe7f521);
    var $3VFsf;
    var $1pUkh;
    var $eUO5L;
    var $7cb6d0bbf859a350$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $7cb6d0bbf859a350$var$PREFIX = 'Sentry Logger ';
    var $7cb6d0bbf859a350$export$2a2b1d2252a69ecb = [
        'debug',
        'info',
        'warn',
        'error',
        'log',
        'assert'
    ];
    function $7cb6d0bbf859a350$export$cda52e2a8927a2ca(callback) {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        if (!('console' in global)) return callback();
        var originalConsole = global.console;
        var wrappedLevels = {};
        $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(level) {
            var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
            if (level in global.console && originalWrappedFunc) {
                wrappedLevels[level] = originalConsole[level];
                originalConsole[level] = originalWrappedFunc;
            }
        });
        try {
            return callback();
        } finally{
            Object.keys(wrappedLevels).forEach(function(level) {
                originalConsole[level] = wrappedLevels[level];
            });
        }
    }
    function $7cb6d0bbf859a350$var$makeLogger() {
        var enabled = false;
        var logger = {
            enable: function() {
                enabled = true;
            },
            disable: function() {
                enabled = false;
            }
        };
        if (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(name) {
            logger[name] = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (enabled) $7cb6d0bbf859a350$export$cda52e2a8927a2ca(function() {
                    var _a;
                    (_a = $7cb6d0bbf859a350$var$global.console)[name].apply(_a, (0, (0, parcelRequire("3VFsf")).__spread)([
                        $7cb6d0bbf859a350$var$PREFIX + "[" + name + "]:"
                    ], args));
                });
            };
        });
        else $7cb6d0bbf859a350$export$2a2b1d2252a69ecb.forEach(function(name) {
            logger[name] = function() {
                return undefined;
            };
        });
        return logger;
    }
    var $7cb6d0bbf859a350$export$af88d00dbe7f521;
    if (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) $7cb6d0bbf859a350$export$af88d00dbe7f521 = (0, (0, parcelRequire("eUO5L")).getGlobalSingleton)('logger', $7cb6d0bbf859a350$var$makeLogger);
    else $7cb6d0bbf859a350$export$af88d00dbe7f521 = $7cb6d0bbf859a350$var$makeLogger();
});
parcelRegister("1pUkh", function(module, exports) {
    $parcel$export(module.exports, "IS_DEBUG_BUILD", ()=>$1083d16d6e02eb4b$export$48a8984ec0bf2e44);
    var $1083d16d6e02eb4b$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
});
parcelRegister("1vYJz", function(module, exports) {
    $parcel$export(module.exports, "uuid4", ()=>$11a7cc3993e3d0c3$export$19f53698e68b2496);
    $parcel$export(module.exports, "parseUrl", ()=>$11a7cc3993e3d0c3$export$7a5253c0f62e0150);
    $parcel$export(module.exports, "getEventDescription", ()=>$11a7cc3993e3d0c3$export$4157119e2b157127);
    $parcel$export(module.exports, "addExceptionTypeValue", ()=>$11a7cc3993e3d0c3$export$f26508487bf83ee7);
    $parcel$export(module.exports, "addExceptionMechanism", ()=>$11a7cc3993e3d0c3$export$c69a9a0313b03bb1);
    $parcel$export(module.exports, "checkOrSetAlreadyCaught", ()=>$11a7cc3993e3d0c3$export$6de4ffac6a2f1098);
    var $3VFsf;
    var $eUO5L;
    var $59M0S;
    var $keOcA;
    function $11a7cc3993e3d0c3$export$19f53698e68b2496() {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        var crypto = global.crypto || global.msCrypto;
        if (!(crypto === void 0) && crypto.getRandomValues) {
            var arr = new Uint16Array(8);
            crypto.getRandomValues(arr);
            arr[3] = arr[3] & 0xfff | 0x4000;
            arr[4] = arr[4] & 0x3fff | 0x8000;
            var pad = function(num) {
                var v = num.toString(16);
                while(v.length < 4)v = "0" + v;
                return v;
            };
            return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
        }
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }
    function $11a7cc3993e3d0c3$export$7a5253c0f62e0150(url) {
        if (!url) return {};
        var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
        if (!match) return {};
        var query = match[6] || '';
        var fragment = match[8] || '';
        return {
            host: match[4],
            path: match[5],
            protocol: match[2],
            relative: match[5] + query + fragment
        };
    }
    function $11a7cc3993e3d0c3$var$getFirstException(event) {
        return event.exception && event.exception.values ? event.exception.values[0] : undefined;
    }
    function $11a7cc3993e3d0c3$export$4157119e2b157127(event) {
        var message = event.message, eventId = event.event_id;
        if (message) return message;
        var firstException = $11a7cc3993e3d0c3$var$getFirstException(event);
        if (firstException) {
            if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
            return firstException.type || firstException.value || eventId || '<unknown>';
        }
        return eventId || '<unknown>';
    }
    function $11a7cc3993e3d0c3$export$f26508487bf83ee7(event, value, type) {
        var exception = event.exception = event.exception || {};
        var values = exception.values = exception.values || [];
        var firstException = values[0] = values[0] || {};
        if (!firstException.value) firstException.value = value || '';
        if (!firstException.type) firstException.type = type || 'Error';
    }
    function $11a7cc3993e3d0c3$export$c69a9a0313b03bb1(event, newMechanism) {
        var firstException = $11a7cc3993e3d0c3$var$getFirstException(event);
        if (!firstException) return;
        var defaultMechanism = {
            type: 'generic',
            handled: true
        };
        var currentMechanism = firstException.mechanism;
        firstException.mechanism = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, defaultMechanism), currentMechanism), newMechanism);
        if (newMechanism && 'data' in newMechanism) {
            var mergedData = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
            firstException.mechanism.data = mergedData;
        }
    }
    var $11a7cc3993e3d0c3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
    function $11a7cc3993e3d0c3$export$d364f2020ab30578(input) {
        var match = input.match($11a7cc3993e3d0c3$var$SEMVER_REGEXP) || [];
        var major = parseInt(match[1], 10);
        var minor = parseInt(match[2], 10);
        var patch = parseInt(match[3], 10);
        return {
            buildmetadata: match[5],
            major: isNaN(major) ? undefined : major,
            minor: isNaN(minor) ? undefined : minor,
            patch: isNaN(patch) ? undefined : patch,
            prerelease: match[4]
        };
    }
    function $11a7cc3993e3d0c3$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
        if (linesOfContext === void 0) linesOfContext = 5;
        var lineno = frame.lineno || 0;
        var maxLines = lines.length;
        var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
        frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
            return (0, (0, parcelRequire("keOcA")).snipLine)(line, 0);
        });
        frame.context_line = (0, (0, parcelRequire("keOcA")).snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
        frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
            return (0, (0, parcelRequire("keOcA")).snipLine)(line, 0);
        });
    }
    function $11a7cc3993e3d0c3$export$ce084c78234bd35(urlPath) {
        return urlPath.split(/[\?#]/, 1)[0];
    }
    function $11a7cc3993e3d0c3$export$6de4ffac6a2f1098(exception) {
        if (exception && exception.__sentry_captured__) return true;
        try {
            (0, (0, parcelRequire("59M0S")).addNonEnumerableProperty)(exception, '__sentry_captured__', true);
        } catch (err) {}
        return false;
    }
});
parcelRegister("59M0S", function(module, exports) {
    $parcel$export(module.exports, "fill", ()=>$3c130969d9628ee3$export$9563e054e6f787fb);
    $parcel$export(module.exports, "markFunctionWrapped", ()=>$3c130969d9628ee3$export$5c1499e2e5d010ae);
    $parcel$export(module.exports, "addNonEnumerableProperty", ()=>$3c130969d9628ee3$export$e73679ffaf56810e);
    $parcel$export(module.exports, "getOriginalFunction", ()=>$3c130969d9628ee3$export$e6cc1e135e2092e5);
    $parcel$export(module.exports, "urlEncode", ()=>$3c130969d9628ee3$export$9ef804feabbcbaf1);
    $parcel$export(module.exports, "convertToPlainObject", ()=>$3c130969d9628ee3$export$62ff257738bf57f5);
    $parcel$export(module.exports, "extractExceptionKeysForMessage", ()=>$3c130969d9628ee3$export$b0244d5063c0b61b);
    $parcel$export(module.exports, "dropUndefinedKeys", ()=>$3c130969d9628ee3$export$d25f2688db1bb433);
    var $3VFsf;
    var $fB1v8;
    var $okkfE;
    var $keOcA;
    function $3c130969d9628ee3$export$9563e054e6f787fb(source, name, replacementFactory) {
        if (!(name in source)) return;
        var original = source[name];
        var wrapped = replacementFactory(original);
        if (typeof wrapped === 'function') try {
            $3c130969d9628ee3$export$5c1499e2e5d010ae(wrapped, original);
        } catch (_Oo) {}
        source[name] = wrapped;
    }
    function $3c130969d9628ee3$export$e73679ffaf56810e(obj, name, value) {
        Object.defineProperty(obj, name, {
            value: value,
            writable: true,
            configurable: true
        });
    }
    function $3c130969d9628ee3$export$5c1499e2e5d010ae(wrapped, original) {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $3c130969d9628ee3$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    }
    function $3c130969d9628ee3$export$e6cc1e135e2092e5(func) {
        return func.__sentry_original__;
    }
    function $3c130969d9628ee3$export$9ef804feabbcbaf1(object) {
        return Object.keys(object).map(function(key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
        }).join('&');
    }
    function $3c130969d9628ee3$export$62ff257738bf57f5(value) {
        var newObj = value;
        if ((0, (0, parcelRequire("okkfE")).isError)(value)) newObj = (0, (0, parcelRequire("3VFsf")).__assign)({
            message: value.message,
            name: value.name,
            stack: value.stack
        }, $3c130969d9628ee3$var$getOwnProperties(value));
        else if ((0, (0, parcelRequire("okkfE")).isEvent)(value)) {
            var event_1 = value;
            newObj = (0, (0, parcelRequire("3VFsf")).__assign)({
                type: event_1.type,
                target: $3c130969d9628ee3$var$serializeEventTarget(event_1.target),
                currentTarget: $3c130969d9628ee3$var$serializeEventTarget(event_1.currentTarget)
            }, $3c130969d9628ee3$var$getOwnProperties(event_1));
            if (typeof CustomEvent !== 'undefined' && (0, (0, parcelRequire("okkfE")).isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
        }
        return newObj;
    }
    function $3c130969d9628ee3$var$serializeEventTarget(target) {
        try {
            return (0, (0, parcelRequire("okkfE")).isElement)(target) ? (0, (0, parcelRequire("fB1v8")).htmlTreeAsString)(target) : Object.prototype.toString.call(target);
        } catch (_oO) {
            return '<unknown>';
        }
    }
    function $3c130969d9628ee3$var$getOwnProperties(obj) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    }
    function $3c130969d9628ee3$export$b0244d5063c0b61b(exception, maxLength) {
        if (maxLength === void 0) maxLength = 40;
        var keys = Object.keys($3c130969d9628ee3$export$62ff257738bf57f5(exception));
        keys.sort();
        if (!keys.length) return '[object has no keys]';
        if (keys[0].length >= maxLength) return (0, (0, parcelRequire("keOcA")).truncate)(keys[0], maxLength);
        for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
            var serialized = keys.slice(0, includedKeys).join(', ');
            if (serialized.length > maxLength) continue;
            if (includedKeys === keys.length) return serialized;
            return (0, (0, parcelRequire("keOcA")).truncate)(serialized, maxLength);
        }
        return '';
    }
    function $3c130969d9628ee3$export$d25f2688db1bb433(val) {
        var e_1, _a;
        if ((0, (0, parcelRequire("okkfE")).isPlainObject)(val)) {
            var rv = {};
            try {
                for(var _b = (0, (0, parcelRequire("3VFsf")).__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var key = _c.value;
                    if (typeof val[key] !== 'undefined') rv[key] = $3c130969d9628ee3$export$d25f2688db1bb433(val[key]);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return rv;
        }
        if (Array.isArray(val)) return val.map($3c130969d9628ee3$export$d25f2688db1bb433);
        return val;
    }
    function $3c130969d9628ee3$export$92b78acdbe066b6b(wat) {
        var objectified;
        switch(true){
            case wat === undefined || wat === null:
                objectified = new String(wat);
                break;
            case typeof wat === 'symbol' || typeof wat === 'bigint':
                objectified = Object(wat);
                break;
            case (0, (0, parcelRequire("okkfE")).isPrimitive)(wat):
                objectified = new wat.constructor(wat);
                break;
            default:
                objectified = wat;
                break;
        }
        return objectified;
    }
});
parcelRegister("fB1v8", function(module, exports) {
    $parcel$export(module.exports, "htmlTreeAsString", ()=>$b5ab79d71b24e1dd$export$5647df6b7814ac86);
    $parcel$export(module.exports, "getLocationHref", ()=>$b5ab79d71b24e1dd$export$1cfafeee2987818b);
    var $eUO5L;
    var $okkfE;
    function $b5ab79d71b24e1dd$export$5647df6b7814ac86(elem, keyAttrs) {
        try {
            var currentElem = elem;
            var MAX_TRAVERSE_HEIGHT = 5;
            var MAX_OUTPUT_LEN = 80;
            var out = [];
            var height = 0;
            var len = 0;
            var separator = ' > ';
            var sepLength = separator.length;
            var nextStr = void 0;
            while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
                nextStr = $b5ab79d71b24e1dd$var$_htmlElementAsString(currentElem, keyAttrs);
                if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
                out.push(nextStr);
                len += nextStr.length;
                currentElem = currentElem.parentNode;
            }
            return out.reverse().join(separator);
        } catch (_oO) {
            return '<unknown>';
        }
    }
    function $b5ab79d71b24e1dd$var$_htmlElementAsString(el, keyAttrs) {
        var elem = el;
        var out = [];
        var className;
        var classes;
        var key;
        var attr;
        var i;
        if (!elem || !elem.tagName) return '';
        out.push(elem.tagName.toLowerCase());
        var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
            return elem.getAttribute(keyAttr);
        }).map(function(keyAttr) {
            return [
                keyAttr,
                elem.getAttribute(keyAttr)
            ];
        }) : null;
        if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
        else {
            if (elem.id) out.push("#" + elem.id);
            className = elem.className;
            if (className && (0, (0, parcelRequire("okkfE")).isString)(className)) {
                classes = className.split(/\s+/);
                for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
            }
        }
        var allowedAttrs = [
            'type',
            'name',
            'title',
            'alt'
        ];
        for(i = 0; i < allowedAttrs.length; i++){
            key = allowedAttrs[i];
            attr = elem.getAttribute(key);
            if (attr) out.push("[" + key + "=\"" + attr + "\"]");
        }
        return out.join('');
    }
    function $b5ab79d71b24e1dd$export$1cfafeee2987818b() {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        try {
            return global.document.location.href;
        } catch (oO) {
            return '';
        }
    }
});
parcelRegister("keOcA", function(module, exports) {
    $parcel$export(module.exports, "truncate", ()=>$ebbc0e804ef05913$export$6a506b36fdea397d);
    $parcel$export(module.exports, "snipLine", ()=>$ebbc0e804ef05913$export$4215662d762d6f9d);
    $parcel$export(module.exports, "safeJoin", ()=>$ebbc0e804ef05913$export$465e9d514283d4fd);
    $parcel$export(module.exports, "isMatchingPattern", ()=>$ebbc0e804ef05913$export$cdded5b28a5f8c6d);
    var $okkfE;
    function $ebbc0e804ef05913$export$6a506b36fdea397d(str, max) {
        if (max === void 0) max = 0;
        if (typeof str !== 'string' || max === 0) return str;
        return str.length <= max ? str : str.substr(0, max) + "...";
    }
    function $ebbc0e804ef05913$export$4215662d762d6f9d(line, colno) {
        var newLine = line;
        var lineLength = newLine.length;
        if (lineLength <= 150) return newLine;
        if (colno > lineLength) colno = lineLength;
        var start = Math.max(colno - 60, 0);
        if (start < 5) start = 0;
        var end = Math.min(start + 140, lineLength);
        if (end > lineLength - 5) end = lineLength;
        if (end === lineLength) start = Math.max(end - 140, 0);
        newLine = newLine.slice(start, end);
        if (start > 0) newLine = "'{snip} " + newLine;
        if (end < lineLength) newLine += ' {snip}';
        return newLine;
    }
    function $ebbc0e804ef05913$export$465e9d514283d4fd(input, delimiter) {
        if (!Array.isArray(input)) return '';
        var output = [];
        for(var i = 0; i < input.length; i++){
            var value = input[i];
            try {
                output.push(String(value));
            } catch (e) {
                output.push('[value cannot be serialized]');
            }
        }
        return output.join(delimiter);
    }
    function $ebbc0e804ef05913$export$cdded5b28a5f8c6d(value, pattern) {
        if (!(0, (0, parcelRequire("okkfE")).isString)(value)) return false;
        if ((0, (0, parcelRequire("okkfE")).isRegExp)(pattern)) return pattern.test(value);
        if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
        return false;
    }
    function $ebbc0e804ef05913$export$466fc863a824cea6(regexString) {
        return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
    }
});
parcelRegister("4mVTs", function(module, exports) {
    $parcel$export(module.exports, "resolvedSyncPromise", ()=>$32e61feb582e8017$export$1fda8aa4d135f8aa);
    $parcel$export(module.exports, "SyncPromise", ()=>$32e61feb582e8017$export$6f292d4960313241);
    $parcel$export(module.exports, "rejectedSyncPromise", ()=>$32e61feb582e8017$export$78e43115b553f358);
    var $okkfE;
    function $32e61feb582e8017$export$1fda8aa4d135f8aa(value) {
        return new $32e61feb582e8017$export$6f292d4960313241(function(resolve) {
            resolve(value);
        });
    }
    function $32e61feb582e8017$export$78e43115b553f358(reason) {
        return new $32e61feb582e8017$export$6f292d4960313241(function(_, reject) {
            reject(reason);
        });
    }
    var $32e61feb582e8017$export$6f292d4960313241 = function() {
        function SyncPromise(executor) {
            var _this = this;
            this._state = 0;
            this._handlers = [];
            this._resolve = function(value) {
                _this._setResult(1, value);
            };
            this._reject = function(reason) {
                _this._setResult(2, reason);
            };
            this._setResult = function(state, value) {
                if (_this._state !== 0) return;
                if ((0, (0, parcelRequire("okkfE")).isThenable)(value)) {
                    value.then(_this._resolve, _this._reject);
                    return;
                }
                _this._state = state;
                _this._value = value;
                _this._executeHandlers();
            };
            this._executeHandlers = function() {
                if (_this._state === 0) return;
                var cachedHandlers = _this._handlers.slice();
                _this._handlers = [];
                cachedHandlers.forEach(function(handler) {
                    if (handler[0]) return;
                    if (_this._state === 1) handler[1](_this._value);
                    if (_this._state === 2) handler[2](_this._value);
                    handler[0] = true;
                });
            };
            try {
                executor(this._resolve, this._reject);
            } catch (e) {
                this._reject(e);
            }
        }
        SyncPromise.prototype.then = function(onfulfilled, onrejected) {
            var _this = this;
            return new SyncPromise(function(resolve, reject) {
                _this._handlers.push([
                    false,
                    function(result) {
                        if (!onfulfilled) resolve(result);
                        else try {
                            resolve(onfulfilled(result));
                        } catch (e) {
                            reject(e);
                        }
                    },
                    function(reason) {
                        if (!onrejected) reject(reason);
                        else try {
                            resolve(onrejected(reason));
                        } catch (e) {
                            reject(e);
                        }
                    }
                ]);
                _this._executeHandlers();
            });
        };
        SyncPromise.prototype.catch = function(onrejected) {
            return this.then(function(val) {
                return val;
            }, onrejected);
        };
        SyncPromise.prototype.finally = function(onfinally) {
            var _this = this;
            return new SyncPromise(function(resolve, reject) {
                var val;
                var isRejected;
                return _this.then(function(value) {
                    isRejected = false;
                    val = value;
                    if (onfinally) onfinally();
                }, function(reason) {
                    isRejected = true;
                    val = reason;
                    if (onfinally) onfinally();
                }).then(function() {
                    if (isRejected) {
                        reject(val);
                        return;
                    }
                    resolve(val);
                });
            });
        };
        return SyncPromise;
    }();
});
parcelRegister("gI8Be", function(module, exports) {
    $parcel$export(module.exports, "dateTimestampInSeconds", ()=>dateTimestampInSeconds, (v)=>dateTimestampInSeconds = v);
    $parcel$export(module.exports, "timestampInSeconds", ()=>timestampInSeconds, (v)=>timestampInSeconds = v);
    var $eUO5L;
    var $3kiq9;
    var dateTimestampSource = {
        nowSeconds: function() {
            return Date.now() / 1000;
        }
    };
    function getBrowserPerformance() {
        var performance = (0, (0, parcelRequire("eUO5L")).getGlobalObject)().performance;
        if (!performance || !performance.now) return undefined;
        var timeOrigin = Date.now() - performance.now();
        return {
            now: function() {
                return performance.now();
            },
            timeOrigin: timeOrigin
        };
    }
    function getNodePerformance() {
        try {
            var perfHooks = (0, (0, parcelRequire("3kiq9")).dynamicRequire)(module, 'perf_hooks');
            return perfHooks.performance;
        } catch (_) {
            return undefined;
        }
    }
    var platformPerformance = (0, (0, parcelRequire("3kiq9")).isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
    var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
        nowSeconds: function() {
            return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
        }
    };
    var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
    var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
    var timestampWithMs = timestampInSeconds;
    var usingPerformanceAPI = platformPerformance !== undefined;
    var _browserPerformanceTimeOriginMode;
    var browserPerformanceTimeOrigin = function() {
        var performance = (0, (0, parcelRequire("eUO5L")).getGlobalObject)().performance;
        if (!performance || !performance.now) {
            _browserPerformanceTimeOriginMode = 'none';
            return undefined;
        }
        var threshold = 3600000;
        var performanceNow = performance.now();
        var dateNow = Date.now();
        var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
        var timeOriginIsReliable = timeOriginDelta < threshold;
        var navigationStart = performance.timing && performance.timing.navigationStart;
        var hasNavigationStart = typeof navigationStart === 'number';
        var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
        var navigationStartIsReliable = navigationStartDelta < threshold;
        if (timeOriginIsReliable || navigationStartIsReliable) {
            if (timeOriginDelta <= navigationStartDelta) {
                _browserPerformanceTimeOriginMode = 'timeOrigin';
                return performance.timeOrigin;
            } else {
                _browserPerformanceTimeOriginMode = 'navigationStart';
                return navigationStart;
            }
        }
        _browserPerformanceTimeOriginMode = 'dateNow';
        return dateNow;
    }();
});
parcelRegister("3xuhl", function(module, exports) {
    $parcel$export(module.exports, "forget", ()=>(parcelRequire("hZpZ3")).forget);
    $parcel$export(module.exports, "getLocationHref", ()=>(parcelRequire("fB1v8")).getLocationHref);
    $parcel$export(module.exports, "htmlTreeAsString", ()=>(parcelRequire("fB1v8")).htmlTreeAsString);
    $parcel$export(module.exports, "dsnToString", ()=>(parcelRequire("ha3jm")).dsnToString);
    $parcel$export(module.exports, "makeDsn", ()=>(parcelRequire("ha3jm")).makeDsn);
    $parcel$export(module.exports, "SentryError", ()=>(parcelRequire("f7sqx")).SentryError);
    $parcel$export(module.exports, "getGlobalObject", ()=>(parcelRequire("eUO5L")).getGlobalObject);
    $parcel$export(module.exports, "addInstrumentationHandler", ()=>(parcelRequire("iDqcL")).addInstrumentationHandler);
    $parcel$export(module.exports, "isDOMError", ()=>(parcelRequire("okkfE")).isDOMError);
    $parcel$export(module.exports, "isDOMException", ()=>(parcelRequire("okkfE")).isDOMException);
    $parcel$export(module.exports, "isError", ()=>(parcelRequire("okkfE")).isError);
    $parcel$export(module.exports, "isErrorEvent", ()=>(parcelRequire("okkfE")).isErrorEvent);
    $parcel$export(module.exports, "isEvent", ()=>(parcelRequire("okkfE")).isEvent);
    $parcel$export(module.exports, "isInstanceOf", ()=>(parcelRequire("okkfE")).isInstanceOf);
    $parcel$export(module.exports, "isPlainObject", ()=>(parcelRequire("okkfE")).isPlainObject);
    $parcel$export(module.exports, "isPrimitive", ()=>(parcelRequire("okkfE")).isPrimitive);
    $parcel$export(module.exports, "isString", ()=>(parcelRequire("okkfE")).isString);
    $parcel$export(module.exports, "isThenable", ()=>(parcelRequire("okkfE")).isThenable);
    $parcel$export(module.exports, "logger", ()=>(parcelRequire("aHQIJ")).logger);
    $parcel$export(module.exports, "addExceptionMechanism", ()=>(parcelRequire("1vYJz")).addExceptionMechanism);
    $parcel$export(module.exports, "addExceptionTypeValue", ()=>(parcelRequire("1vYJz")).addExceptionTypeValue);
    $parcel$export(module.exports, "checkOrSetAlreadyCaught", ()=>(parcelRequire("1vYJz")).checkOrSetAlreadyCaught);
    $parcel$export(module.exports, "getEventDescription", ()=>(parcelRequire("1vYJz")).getEventDescription);
    $parcel$export(module.exports, "parseUrl", ()=>(parcelRequire("1vYJz")).parseUrl);
    $parcel$export(module.exports, "uuid4", ()=>(parcelRequire("1vYJz")).uuid4);
    $parcel$export(module.exports, "normalize", ()=>(parcelRequire("gBQwe")).normalize);
    $parcel$export(module.exports, "normalizeToSize", ()=>(parcelRequire("gBQwe")).normalizeToSize);
    $parcel$export(module.exports, "addNonEnumerableProperty", ()=>(parcelRequire("59M0S")).addNonEnumerableProperty);
    $parcel$export(module.exports, "extractExceptionKeysForMessage", ()=>(parcelRequire("59M0S")).extractExceptionKeysForMessage);
    $parcel$export(module.exports, "fill", ()=>(parcelRequire("59M0S")).fill);
    $parcel$export(module.exports, "getOriginalFunction", ()=>(parcelRequire("59M0S")).getOriginalFunction);
    $parcel$export(module.exports, "markFunctionWrapped", ()=>(parcelRequire("59M0S")).markFunctionWrapped);
    $parcel$export(module.exports, "urlEncode", ()=>(parcelRequire("59M0S")).urlEncode);
    $parcel$export(module.exports, "makePromiseBuffer", ()=>(parcelRequire("6dKoA")).makePromiseBuffer);
    $parcel$export(module.exports, "severityFromString", ()=>(parcelRequire("5L8AU")).severityFromString);
    $parcel$export(module.exports, "createStackParser", ()=>(parcelRequire("1M66C")).createStackParser);
    $parcel$export(module.exports, "getFunctionName", ()=>(parcelRequire("1M66C")).getFunctionName);
    $parcel$export(module.exports, "eventStatusFromHttpCode", ()=>(parcelRequire("h2Oxu")).eventStatusFromHttpCode);
    $parcel$export(module.exports, "isMatchingPattern", ()=>(parcelRequire("keOcA")).isMatchingPattern);
    $parcel$export(module.exports, "safeJoin", ()=>(parcelRequire("keOcA")).safeJoin);
    $parcel$export(module.exports, "truncate", ()=>(parcelRequire("keOcA")).truncate);
    $parcel$export(module.exports, "isNativeFetch", ()=>(parcelRequire("9BO8q")).isNativeFetch);
    $parcel$export(module.exports, "supportsFetch", ()=>(parcelRequire("9BO8q")).supportsFetch);
    $parcel$export(module.exports, "supportsReferrerPolicy", ()=>(parcelRequire("9BO8q")).supportsReferrerPolicy);
    $parcel$export(module.exports, "rejectedSyncPromise", ()=>(parcelRequire("4mVTs")).rejectedSyncPromise);
    $parcel$export(module.exports, "resolvedSyncPromise", ()=>(parcelRequire("4mVTs")).resolvedSyncPromise);
    $parcel$export(module.exports, "SyncPromise", ()=>(parcelRequire("4mVTs")).SyncPromise);
    $parcel$export(module.exports, "createEnvelope", ()=>(parcelRequire("2cvr9")).createEnvelope);
    $parcel$export(module.exports, "getEnvelopeType", ()=>(parcelRequire("2cvr9")).getEnvelopeType);
    $parcel$export(module.exports, "serializeEnvelope", ()=>(parcelRequire("2cvr9")).serializeEnvelope);
    $parcel$export(module.exports, "createClientReportEnvelope", ()=>(parcelRequire("fLq1q")).createClientReportEnvelope);
    $parcel$export(module.exports, "disabledUntil", ()=>(parcelRequire("giEo2")).disabledUntil);
    $parcel$export(module.exports, "isRateLimited", ()=>(parcelRequire("giEo2")).isRateLimited);
    $parcel$export(module.exports, "updateRateLimits", ()=>(parcelRequire("giEo2")).updateRateLimits);
    parcelRequire("hZpZ3");
    parcelRequire("fB1v8");
    parcelRequire("ha3jm");
    parcelRequire("f7sqx");
    parcelRequire("eUO5L");
    parcelRequire("iDqcL");
    parcelRequire("okkfE");
    parcelRequire("aHQIJ");
    parcelRequire("1vYJz");
    var $3kiq9;
    parcelRequire("gBQwe");
    parcelRequire("59M0S");
    parcelRequire("6dKoA");
    parcelRequire("5L8AU");
    parcelRequire("1M66C");
    parcelRequire("h2Oxu");
    parcelRequire("keOcA");
    parcelRequire("9BO8q");
    parcelRequire("4mVTs");
    var $gI8Be;
    parcelRequire("2cvr9");
    parcelRequire("fLq1q");
    parcelRequire("giEo2");
    $parcel$exportWildcard(module.exports, (0, parcelRequire("3kiq9")));
    $parcel$exportWildcard(module.exports, (0, parcelRequire("gI8Be")));
});
parcelRegister("hZpZ3", function(module, exports) {
    $parcel$export(module.exports, "forget", ()=>$d18c4a06ec047594$export$93c25f2590a5b540);
    function $d18c4a06ec047594$export$93c25f2590a5b540(promise) {
        promise.then(null, function(e) {
            console.error(e);
        });
    }
});
parcelRegister("ha3jm", function(module, exports) {
    $parcel$export(module.exports, "dsnToString", ()=>$033962d845f489d3$export$44d472fbb931a776);
    $parcel$export(module.exports, "makeDsn", ()=>$033962d845f489d3$export$128827c3562ec0cb);
    var $3VFsf;
    var $f7sqx;
    var $1pUkh;
    var $033962d845f489d3$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
    function $033962d845f489d3$var$isValidProtocol(protocol) {
        return protocol === 'http' || protocol === 'https';
    }
    function $033962d845f489d3$export$44d472fbb931a776(dsn, withPassword) {
        if (withPassword === void 0) withPassword = false;
        var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
        return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
    }
    function $033962d845f489d3$var$dsnFromString(str) {
        var match = $033962d845f489d3$var$DSN_REGEX.exec(str);
        if (!match) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: " + str);
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) projectId = projectMatch[0];
        }
        return $033962d845f489d3$var$dsnFromComponents({
            host: host,
            pass: pass,
            path: path,
            projectId: projectId,
            port: port,
            protocol: protocol,
            publicKey: publicKey
        });
    }
    function $033962d845f489d3$var$dsnFromComponents(components) {
        if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
        return {
            user: components.publicKey || '',
            protocol: components.protocol,
            publicKey: components.publicKey || '',
            pass: components.pass || '',
            host: components.host,
            port: components.port || '',
            path: components.path || '',
            projectId: components.projectId
        };
    }
    function $033962d845f489d3$var$validateDsn(dsn) {
        if (!(0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD)) return;
        var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
        var requiredComponents = [
            'protocol',
            'publicKey',
            'host',
            'projectId'
        ];
        requiredComponents.forEach(function(component) {
            if (!dsn[component]) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: " + component + " missing");
        });
        if (!projectId.match(/^\d+$/)) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
        if (!$033962d845f489d3$var$isValidProtocol(protocol)) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
        if (port && isNaN(parseInt(port, 10))) throw new (0, (0, parcelRequire("f7sqx")).SentryError)("Invalid Sentry Dsn: Invalid port " + port);
        return true;
    }
    function $033962d845f489d3$export$128827c3562ec0cb(from) {
        var components = typeof from === 'string' ? $033962d845f489d3$var$dsnFromString(from) : $033962d845f489d3$var$dsnFromComponents(from);
        $033962d845f489d3$var$validateDsn(components);
        return components;
    }
});
parcelRegister("f7sqx", function(module, exports) {
    $parcel$export(module.exports, "SentryError", ()=>$b01d8f7464044e0f$export$5949942ba2a7c0e2);
    var $3VFsf;
    var $aKKyi;
    var $b01d8f7464044e0f$export$5949942ba2a7c0e2 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SentryError, _super);
        function SentryError(message) {
            var _newTarget = this.constructor;
            var _this = _super.call(this, message) || this;
            _this.message = message;
            _this.name = _newTarget.prototype.constructor.name;
            (0, (0, parcelRequire("aKKyi")).setPrototypeOf)(_this, _newTarget.prototype);
            return _this;
        }
        return SentryError;
    }(Error);
});
parcelRegister("aKKyi", function(module, exports) {
    $parcel$export(module.exports, "setPrototypeOf", ()=>$020532d4ed9bf426$export$1cb0d91350beb6cc);
    var $020532d4ed9bf426$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
        __proto__: []
    }) instanceof Array ? $020532d4ed9bf426$var$setProtoOf : $020532d4ed9bf426$var$mixinProperties);
    function $020532d4ed9bf426$var$setProtoOf(obj, proto) {
        obj.__proto__ = proto;
        return obj;
    }
    function $020532d4ed9bf426$var$mixinProperties(obj, proto) {
        for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) obj[prop] = proto[prop];
        return obj;
    }
});
parcelRegister("iDqcL", function(module, exports) {
    $parcel$export(module.exports, "addInstrumentationHandler", ()=>$d9103240d7f3ffea$export$285b9172a3741fb7);
    var $3VFsf;
    var $1pUkh;
    var $eUO5L;
    var $okkfE;
    var $aHQIJ;
    var $59M0S;
    var $1M66C;
    var $9BO8q;
    var $d9103240d7f3ffea$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $d9103240d7f3ffea$var$handlers = {};
    var $d9103240d7f3ffea$var$instrumented = {};
    function $d9103240d7f3ffea$var$instrument(type) {
        if ($d9103240d7f3ffea$var$instrumented[type]) return;
        $d9103240d7f3ffea$var$instrumented[type] = true;
        switch(type){
            case 'console':
                $d9103240d7f3ffea$var$instrumentConsole();
                break;
            case 'dom':
                $d9103240d7f3ffea$var$instrumentDOM();
                break;
            case 'xhr':
                $d9103240d7f3ffea$var$instrumentXHR();
                break;
            case 'fetch':
                $d9103240d7f3ffea$var$instrumentFetch();
                break;
            case 'history':
                $d9103240d7f3ffea$var$instrumentHistory();
                break;
            case 'error':
                $d9103240d7f3ffea$var$instrumentError();
                break;
            case 'unhandledrejection':
                $d9103240d7f3ffea$var$instrumentUnhandledRejection();
                break;
            default:
                (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('unknown instrumentation type:', type);
                return;
        }
    }
    function $d9103240d7f3ffea$export$285b9172a3741fb7(type, callback) {
        $d9103240d7f3ffea$var$handlers[type] = $d9103240d7f3ffea$var$handlers[type] || [];
        $d9103240d7f3ffea$var$handlers[type].push(callback);
        $d9103240d7f3ffea$var$instrument(type);
    }
    function $d9103240d7f3ffea$var$triggerHandlers(type, data) {
        var e_1, _a;
        if (!type || !$d9103240d7f3ffea$var$handlers[type]) return;
        try {
            for(var _b = (0, (0, parcelRequire("3VFsf")).__values)($d9103240d7f3ffea$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
                var handler = _c.value;
                try {
                    handler(data);
                } catch (e) {
                    (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, (0, parcelRequire("1M66C")).getFunctionName)(handler) + "\nError:", e);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    function $d9103240d7f3ffea$var$instrumentConsole() {
        if (!('console' in $d9103240d7f3ffea$var$global)) return;
        (0, (0, parcelRequire("aHQIJ")).CONSOLE_LEVELS).forEach(function(level) {
            if (!(level in $d9103240d7f3ffea$var$global.console)) return;
            (0, (0, parcelRequire("59M0S")).fill)($d9103240d7f3ffea$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    $d9103240d7f3ffea$var$triggerHandlers('console', {
                        args: args,
                        level: level
                    });
                    if (originalConsoleMethod) originalConsoleMethod.apply($d9103240d7f3ffea$var$global.console, args);
                };
            });
        });
    }
    function $d9103240d7f3ffea$var$instrumentFetch() {
        if (!(0, (0, parcelRequire("9BO8q")).supportsNativeFetch)()) return;
        (0, (0, parcelRequire("59M0S")).fill)($d9103240d7f3ffea$var$global, 'fetch', function(originalFetch) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var handlerData = {
                    args: args,
                    fetchData: {
                        method: $d9103240d7f3ffea$var$getFetchMethod(args),
                        url: $d9103240d7f3ffea$var$getFetchUrl(args)
                    },
                    startTimestamp: Date.now()
                };
                $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, (0, parcelRequire("3VFsf")).__assign)({}, handlerData));
                return originalFetch.apply($d9103240d7f3ffea$var$global, args).then(function(response) {
                    $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, handlerData), {
                        endTimestamp: Date.now(),
                        response: response
                    }));
                    return response;
                }, function(error) {
                    $d9103240d7f3ffea$var$triggerHandlers('fetch', (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, handlerData), {
                        endTimestamp: Date.now(),
                        error: error
                    }));
                    throw error;
                });
            };
        });
    }
    function $d9103240d7f3ffea$var$getFetchMethod(fetchArgs) {
        if (fetchArgs === void 0) fetchArgs = [];
        if ('Request' in $d9103240d7f3ffea$var$global && (0, (0, parcelRequire("okkfE")).isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
        if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
        return 'GET';
    }
    function $d9103240d7f3ffea$var$getFetchUrl(fetchArgs) {
        if (fetchArgs === void 0) fetchArgs = [];
        if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
        if ('Request' in $d9103240d7f3ffea$var$global && (0, (0, parcelRequire("okkfE")).isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
        return String(fetchArgs[0]);
    }
    function $d9103240d7f3ffea$var$instrumentXHR() {
        if (!('XMLHttpRequest' in $d9103240d7f3ffea$var$global)) return;
        var xhrproto = XMLHttpRequest.prototype;
        (0, (0, parcelRequire("59M0S")).fill)(xhrproto, 'open', function(originalOpen) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var xhr = this;
                var url = args[1];
                var xhrInfo = xhr.__sentry_xhr__ = {
                    method: (0, (0, parcelRequire("okkfE")).isString)(args[0]) ? args[0].toUpperCase() : args[0],
                    url: args[1]
                };
                if ((0, (0, parcelRequire("okkfE")).isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
                var onreadystatechangeHandler = function() {
                    if (xhr.readyState === 4) {
                        try {
                            xhrInfo.status_code = xhr.status;
                        } catch (e) {}
                        $d9103240d7f3ffea$var$triggerHandlers('xhr', {
                            args: args,
                            endTimestamp: Date.now(),
                            startTimestamp: Date.now(),
                            xhr: xhr
                        });
                    }
                };
                if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, (0, parcelRequire("59M0S")).fill)(xhr, 'onreadystatechange', function(original) {
                    return function() {
                        var readyStateArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
                else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
                return originalOpen.apply(xhr, args);
            };
        });
        (0, (0, parcelRequire("59M0S")).fill)(xhrproto, 'send', function(originalSend) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
                $d9103240d7f3ffea$var$triggerHandlers('xhr', {
                    args: args,
                    startTimestamp: Date.now(),
                    xhr: this
                });
                return originalSend.apply(this, args);
            };
        });
    }
    var $d9103240d7f3ffea$var$lastHref;
    function $d9103240d7f3ffea$var$instrumentHistory() {
        if (!(0, (0, parcelRequire("9BO8q")).supportsHistory)()) return;
        var oldOnPopState = $d9103240d7f3ffea$var$global.onpopstate;
        $d9103240d7f3ffea$var$global.onpopstate = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var to = $d9103240d7f3ffea$var$global.location.href;
            var from = $d9103240d7f3ffea$var$lastHref;
            $d9103240d7f3ffea$var$lastHref = to;
            $d9103240d7f3ffea$var$triggerHandlers('history', {
                from: from,
                to: to
            });
            if (oldOnPopState) try {
                return oldOnPopState.apply(this, args);
            } catch (_oO) {}
        };
        function historyReplacementFunction(originalHistoryFunction) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var url = args.length > 2 ? args[2] : undefined;
                if (url) {
                    var from = $d9103240d7f3ffea$var$lastHref;
                    var to = String(url);
                    $d9103240d7f3ffea$var$lastHref = to;
                    $d9103240d7f3ffea$var$triggerHandlers('history', {
                        from: from,
                        to: to
                    });
                }
                return originalHistoryFunction.apply(this, args);
            };
        }
        (0, (0, parcelRequire("59M0S")).fill)($d9103240d7f3ffea$var$global.history, 'pushState', historyReplacementFunction);
        (0, (0, parcelRequire("59M0S")).fill)($d9103240d7f3ffea$var$global.history, 'replaceState', historyReplacementFunction);
    }
    var $d9103240d7f3ffea$var$debounceDuration = 1000;
    var $d9103240d7f3ffea$var$debounceTimerID;
    var $d9103240d7f3ffea$var$lastCapturedEvent;
    function $d9103240d7f3ffea$var$shouldShortcircuitPreviousDebounce(previous, current) {
        if (!previous) return true;
        if (previous.type !== current.type) return true;
        try {
            if (previous.target !== current.target) return true;
        } catch (e) {}
        return false;
    }
    function $d9103240d7f3ffea$var$shouldSkipDOMEvent(event) {
        if (event.type !== 'keypress') return false;
        try {
            var target = event.target;
            if (!target || !target.tagName) return true;
            if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
        } catch (e) {}
        return true;
    }
    function $d9103240d7f3ffea$var$makeDOMEventHandler(handler, globalListener) {
        if (globalListener === void 0) globalListener = false;
        return function(event) {
            if (!event || $d9103240d7f3ffea$var$lastCapturedEvent === event) return;
            if ($d9103240d7f3ffea$var$shouldSkipDOMEvent(event)) return;
            var name = event.type === 'keypress' ? 'input' : event.type;
            if ($d9103240d7f3ffea$var$debounceTimerID === undefined) {
                handler({
                    event: event,
                    name: name,
                    global: globalListener
                });
                $d9103240d7f3ffea$var$lastCapturedEvent = event;
            } else if ($d9103240d7f3ffea$var$shouldShortcircuitPreviousDebounce($d9103240d7f3ffea$var$lastCapturedEvent, event)) {
                handler({
                    event: event,
                    name: name,
                    global: globalListener
                });
                $d9103240d7f3ffea$var$lastCapturedEvent = event;
            }
            clearTimeout($d9103240d7f3ffea$var$debounceTimerID);
            $d9103240d7f3ffea$var$debounceTimerID = $d9103240d7f3ffea$var$global.setTimeout(function() {
                $d9103240d7f3ffea$var$debounceTimerID = undefined;
            }, $d9103240d7f3ffea$var$debounceDuration);
        };
    }
    function $d9103240d7f3ffea$var$instrumentDOM() {
        if (!('document' in $d9103240d7f3ffea$var$global)) return;
        var triggerDOMHandler = $d9103240d7f3ffea$var$triggerHandlers.bind(null, 'dom');
        var globalDOMEventHandler = $d9103240d7f3ffea$var$makeDOMEventHandler(triggerDOMHandler, true);
        $d9103240d7f3ffea$var$global.document.addEventListener('click', globalDOMEventHandler, false);
        $d9103240d7f3ffea$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
        [
            'EventTarget',
            'Node'
        ].forEach(function(target) {
            var proto = $d9103240d7f3ffea$var$global[target] && $d9103240d7f3ffea$var$global[target].prototype;
            if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
            (0, (0, parcelRequire("59M0S")).fill)(proto, 'addEventListener', function(originalAddEventListener) {
                return function(type, listener, options) {
                    if (type === 'click' || type == 'keypress') try {
                        var el = this;
                        var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_1[type] = handlers_1[type] || {
                            refCount: 0
                        };
                        if (!handlerForType.handler) {
                            var handler = $d9103240d7f3ffea$var$makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    } catch (e) {}
                    return originalAddEventListener.call(this, type, listener, options);
                };
            });
            (0, (0, parcelRequire("59M0S")).fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
                return function(type, listener, options) {
                    if (type === 'click' || type == 'keypress') try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type];
                            }
                            if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                        }
                    } catch (e) {}
                    return originalRemoveEventListener.call(this, type, listener, options);
                };
            });
        });
    }
    var $d9103240d7f3ffea$var$_oldOnErrorHandler = null;
    function $d9103240d7f3ffea$var$instrumentError() {
        $d9103240d7f3ffea$var$_oldOnErrorHandler = $d9103240d7f3ffea$var$global.onerror;
        $d9103240d7f3ffea$var$global.onerror = function(msg, url, line, column, error) {
            $d9103240d7f3ffea$var$triggerHandlers('error', {
                column: column,
                error: error,
                line: line,
                msg: msg,
                url: url
            });
            if ($d9103240d7f3ffea$var$_oldOnErrorHandler) return $d9103240d7f3ffea$var$_oldOnErrorHandler.apply(this, arguments);
            return false;
        };
    }
    var $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler = null;
    function $d9103240d7f3ffea$var$instrumentUnhandledRejection() {
        $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler = $d9103240d7f3ffea$var$global.onunhandledrejection;
        $d9103240d7f3ffea$var$global.onunhandledrejection = function(e) {
            $d9103240d7f3ffea$var$triggerHandlers('unhandledrejection', e);
            if ($d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler) return $d9103240d7f3ffea$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
            return true;
        };
    }
});
parcelRegister("1M66C", function(module, exports) {
    $parcel$export(module.exports, "createStackParser", ()=>$14af02975f6319e3$export$a5739666fb2d03d4);
    $parcel$export(module.exports, "getFunctionName", ()=>$14af02975f6319e3$export$aad197c7121a6651);
    var $3VFsf;
    var $14af02975f6319e3$var$STACKTRACE_LIMIT = 50;
    function $14af02975f6319e3$export$a5739666fb2d03d4() {
        var parsers = [];
        for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
        var sortedParsers = parsers.sort(function(a, b) {
            return a[0] - b[0];
        }).map(function(p) {
            return p[1];
        });
        return function(stack, skipFirst) {
            var e_1, _a, e_2, _b;
            if (skipFirst === void 0) skipFirst = 0;
            var frames = [];
            try {
                for(var _c = (0, (0, parcelRequire("3VFsf")).__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var line = _d.value;
                    try {
                        for(var sortedParsers_1 = (e_2 = void 0, (0, (0, parcelRequire("3VFsf")).__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                            var parser = sortedParsers_1_1.value;
                            var frame = parser(line);
                            if (frame) {
                                frames.push(frame);
                                break;
                            }
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return $14af02975f6319e3$export$c55c24c0eeba0205(frames);
        };
    }
    function $14af02975f6319e3$export$c55c24c0eeba0205(stack) {
        if (!stack.length) return [];
        var localStack = stack;
        var firstFrameFunction = localStack[0].function || '';
        var lastFrameFunction = localStack[localStack.length - 1].function || '';
        if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
        if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
        return localStack.slice(0, $14af02975f6319e3$var$STACKTRACE_LIMIT).map(function(frame) {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, frame), {
                filename: frame.filename || localStack[0].filename,
                function: frame.function || '?'
            });
        }).reverse();
    }
    var $14af02975f6319e3$var$defaultFunctionName = '<anonymous>';
    function $14af02975f6319e3$export$aad197c7121a6651(fn) {
        try {
            if (!fn || typeof fn !== 'function') return $14af02975f6319e3$var$defaultFunctionName;
            return fn.name || $14af02975f6319e3$var$defaultFunctionName;
        } catch (e) {
            return $14af02975f6319e3$var$defaultFunctionName;
        }
    }
});
parcelRegister("9BO8q", function(module, exports) {
    $parcel$export(module.exports, "supportsFetch", ()=>$6fee758568fb716d$export$edf3cb81fd7d2a3e);
    $parcel$export(module.exports, "isNativeFetch", ()=>$6fee758568fb716d$export$18cf36ed71d733e7);
    $parcel$export(module.exports, "supportsNativeFetch", ()=>$6fee758568fb716d$export$c82d238e23c40b21);
    $parcel$export(module.exports, "supportsReferrerPolicy", ()=>$6fee758568fb716d$export$2d308b428295192f);
    $parcel$export(module.exports, "supportsHistory", ()=>$6fee758568fb716d$export$67fc34576016d6ec);
    var $1pUkh;
    var $eUO5L;
    var $aHQIJ;
    function $6fee758568fb716d$export$caa710b4d7f9cadf() {
        try {
            new ErrorEvent('');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$1c08bd1a7eb3c472() {
        try {
            new DOMError('');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$ab12a5d056f1d3a() {
        try {
            new DOMException('');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$edf3cb81fd7d2a3e() {
        if (!('fetch' in (0, (0, parcelRequire("eUO5L")).getGlobalObject)())) return false;
        try {
            new Headers();
            new Request('');
            new Response();
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$18cf36ed71d733e7(func) {
        return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
    }
    function $6fee758568fb716d$export$c82d238e23c40b21() {
        if (!$6fee758568fb716d$export$edf3cb81fd7d2a3e()) return false;
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        if ($6fee758568fb716d$export$18cf36ed71d733e7(global.fetch)) return true;
        var result = false;
        var doc = global.document;
        if (doc && typeof doc.createElement === 'function') try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) result = $6fee758568fb716d$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
            doc.head.removeChild(sandbox);
        } catch (err) {
            (0, (0, parcelRequire("1pUkh")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
        return result;
    }
    function $6fee758568fb716d$export$531055a6c684a70a() {
        return 'ReportingObserver' in (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    }
    function $6fee758568fb716d$export$2d308b428295192f() {
        if (!$6fee758568fb716d$export$edf3cb81fd7d2a3e()) return false;
        try {
            new Request('_', {
                referrerPolicy: 'origin'
            });
            return true;
        } catch (e) {
            return false;
        }
    }
    function $6fee758568fb716d$export$67fc34576016d6ec() {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        var chrome = global.chrome;
        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
        var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
        return !isChromePackagedApp && hasHistoryApi;
    }
});
parcelRegister("gBQwe", function(module, exports) {
    $parcel$export(module.exports, "normalize", ()=>$c178d7365214c01f$export$a3295358bff77e);
    $parcel$export(module.exports, "normalizeToSize", ()=>$c178d7365214c01f$export$23fbbb20bed71033);
    var $3VFsf;
    var $okkfE;
    var $kbQkj;
    var $59M0S;
    var $1M66C;
    function $c178d7365214c01f$export$a3295358bff77e(input, depth, maxProperties) {
        if (depth === void 0) depth = Infinity;
        if (maxProperties === void 0) maxProperties = Infinity;
        try {
            return $c178d7365214c01f$export$588732934346abbf('', input, depth, maxProperties);
        } catch (err) {
            return {
                ERROR: "**non-serializable** (" + err + ")"
            };
        }
    }
    function $c178d7365214c01f$export$23fbbb20bed71033(object, depth, maxSize) {
        if (depth === void 0) depth = 3;
        if (maxSize === void 0) maxSize = 102400;
        var normalized = $c178d7365214c01f$export$a3295358bff77e(object, depth);
        if ($c178d7365214c01f$var$jsonSize(normalized) > maxSize) return $c178d7365214c01f$export$23fbbb20bed71033(object, depth - 1, maxSize);
        return normalized;
    }
    function $c178d7365214c01f$export$588732934346abbf(key, value, depth, maxProperties, memo) {
        if (depth === void 0) depth = Infinity;
        if (maxProperties === void 0) maxProperties = Infinity;
        if (memo === void 0) memo = (0, (0, parcelRequire("kbQkj")).memoBuilder)();
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
        var valueWithToJSON = value;
        if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
            return valueWithToJSON.toJSON();
        } catch (err) {}
        if (value === null || [
            'number',
            'boolean',
            'string'
        ].includes(typeof value) && !(0, (0, parcelRequire("okkfE")).isNaN)(value)) return value;
        var stringified = $c178d7365214c01f$var$stringifyValue(key, value);
        if (!stringified.startsWith('[object ')) return stringified;
        if (depth === 0) return stringified.replace('object ', '');
        if (memoize(value)) return '[Circular ~]';
        var normalized = Array.isArray(value) ? [] : {};
        var numAdded = 0;
        var visitable = (0, (0, parcelRequire("okkfE")).isError)(value) || (0, (0, parcelRequire("okkfE")).isEvent)(value) ? (0, (0, parcelRequire("59M0S")).convertToPlainObject)(value) : value;
        for(var visitKey in visitable){
            if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
            if (numAdded >= maxProperties) {
                normalized[visitKey] = '[MaxProperties ~]';
                break;
            }
            var visitValue = visitable[visitKey];
            normalized[visitKey] = $c178d7365214c01f$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
            numAdded += 1;
        }
        unmemoize(value);
        return normalized;
    }
    function $c178d7365214c01f$var$stringifyValue(key, value) {
        try {
            if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
            if (key === 'domainEmitter') return '[DomainEmitter]';
            if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
            if (typeof window !== 'undefined' && value === window) return '[Window]';
            if (typeof document !== 'undefined' && value === document) return '[Document]';
            if ((0, (0, parcelRequire("okkfE")).isSyntheticEvent)(value)) return '[SyntheticEvent]';
            if (typeof value === 'number' && value !== value) return '[NaN]';
            if (value === void 0) return '[undefined]';
            if (typeof value === 'function') return "[Function: " + (0, (0, parcelRequire("1M66C")).getFunctionName)(value) + "]";
            if (typeof value === 'symbol') return "[" + String(value) + "]";
            if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
            return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
        } catch (err) {
            return "**non-serializable** (" + err + ")";
        }
    }
    function $c178d7365214c01f$var$utf8Length(value) {
        return ~-encodeURI(value).split(/%..|./).length;
    }
    function $c178d7365214c01f$var$jsonSize(value) {
        return $c178d7365214c01f$var$utf8Length(JSON.stringify(value));
    }
});
parcelRegister("kbQkj", function(module, exports) {
    $parcel$export(module.exports, "memoBuilder", ()=>$eb2d6cb7d9719f25$export$8115b0b78e956ab3);
    function $eb2d6cb7d9719f25$export$8115b0b78e956ab3() {
        var hasWeakSet = typeof WeakSet === 'function';
        var inner = hasWeakSet ? new WeakSet() : [];
        function memoize(obj) {
            if (hasWeakSet) {
                if (inner.has(obj)) return true;
                inner.add(obj);
                return false;
            }
            for(var i = 0; i < inner.length; i++){
                var value = inner[i];
                if (value === obj) return true;
            }
            inner.push(obj);
            return false;
        }
        function unmemoize(obj) {
            if (hasWeakSet) inner.delete(obj);
            else {
                for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
        return [
            memoize,
            unmemoize
        ];
    }
});
parcelRegister("6dKoA", function(module, exports) {
    $parcel$export(module.exports, "makePromiseBuffer", ()=>$4877f229d6ada624$export$85a4f67f852183e6);
    var $f7sqx;
    var $4mVTs;
    function $4877f229d6ada624$export$85a4f67f852183e6(limit) {
        var buffer = [];
        function isReady() {
            return limit === undefined || buffer.length < limit;
        }
        function remove(task) {
            return buffer.splice(buffer.indexOf(task), 1)[0];
        }
        function add(taskProducer) {
            if (!isReady()) return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)(new (0, (0, parcelRequire("f7sqx")).SentryError)('Not adding Promise due to buffer limit reached.'));
            var task = taskProducer();
            if (buffer.indexOf(task) === -1) buffer.push(task);
            task.then(function() {
                return remove(task);
            }).then(null, function() {
                return remove(task).then(null, function() {});
            });
            return task;
        }
        function drain(timeout) {
            return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, reject) {
                var counter = buffer.length;
                if (!counter) return resolve(true);
                var capturedSetTimeout = setTimeout(function() {
                    if (timeout && timeout > 0) resolve(false);
                }, timeout);
                buffer.forEach(function(item) {
                    (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(item).then(function() {
                        if (!--counter) {
                            clearTimeout(capturedSetTimeout);
                            resolve(true);
                        }
                    }, reject);
                });
            });
        }
        return {
            $: buffer,
            add: add,
            drain: drain
        };
    }
});
parcelRegister("5L8AU", function(module, exports) {
    $parcel$export(module.exports, "severityFromString", ()=>$431802330db86aeb$export$e01cef29b4327697);
    var $8vvJk;
    var $c1CzK;
    function $431802330db86aeb$var$isSupportedSeverity(level) {
        return (0, (0, parcelRequire("c1CzK")).SeverityLevels).indexOf(level) !== -1;
    }
    function $431802330db86aeb$export$e01cef29b4327697(level) {
        if (level === 'warn') return (0, (0, parcelRequire("8vvJk")).Severity).Warning;
        if ($431802330db86aeb$var$isSupportedSeverity(level)) return level;
        return (0, (0, parcelRequire("8vvJk")).Severity).Log;
    }
});
parcelRegister("8vvJk", function(module, exports) {
    $parcel$export(module.exports, "Severity", ()=>$6319d4e940dba412$export$918a9776c0a3cf27);
    var $6319d4e940dba412$export$918a9776c0a3cf27;
    (function(Severity) {
        Severity["Fatal"] = "fatal";
        Severity["Error"] = "error";
        Severity["Warning"] = "warning";
        Severity["Log"] = "log";
        Severity["Info"] = "info";
        Severity["Debug"] = "debug";
        Severity["Critical"] = "critical";
    })($6319d4e940dba412$export$918a9776c0a3cf27 || ($6319d4e940dba412$export$918a9776c0a3cf27 = {}));
    var $6319d4e940dba412$export$484b1ea9aec914c = [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug',
        'critical'
    ];
});
parcelRegister("c1CzK", function(module, exports) {
    $parcel$export(module.exports, "SeverityLevels", ()=>$8c138058cfd4daeb$export$484b1ea9aec914c);
    var $8c138058cfd4daeb$export$484b1ea9aec914c = [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug',
        'critical'
    ];
});
parcelRegister("h2Oxu", function(module, exports) {
    $parcel$export(module.exports, "eventStatusFromHttpCode", ()=>$c689d399d8025b2a$export$82713360d763c449);
    function $c689d399d8025b2a$export$82713360d763c449(code) {
        if (code >= 200 && code < 300) return 'success';
        if (code === 429) return 'rate_limit';
        if (code >= 400 && code < 500) return 'invalid';
        if (code >= 500) return 'failed';
        return 'unknown';
    }
});
parcelRegister("2cvr9", function(module, exports) {
    $parcel$export(module.exports, "createEnvelope", ()=>$19a51673c063482c$export$f93f7f385160c44e);
    $parcel$export(module.exports, "getEnvelopeType", ()=>$19a51673c063482c$export$d84939284bbafcd4);
    $parcel$export(module.exports, "serializeEnvelope", ()=>$19a51673c063482c$export$32f9b428425aac85);
    var $3VFsf;
    var $okkfE;
    function $19a51673c063482c$export$f93f7f385160c44e(headers, items) {
        if (items === void 0) items = [];
        return [
            headers,
            items
        ];
    }
    function $19a51673c063482c$export$d650323442802f6f(envelope, newItem) {
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(envelope, 2), headers = _a[0], items = _a[1];
        return [
            headers,
            (0, (0, parcelRequire("3VFsf")).__spread)(items, [
                newItem
            ])
        ];
    }
    function $19a51673c063482c$export$d84939284bbafcd4(envelope) {
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(envelope, 2), _b = (0, (0, parcelRequire("3VFsf")).__read)(_a[1], 1), _c = (0, (0, parcelRequire("3VFsf")).__read)(_b[0], 1), firstItemHeader = _c[0];
        return firstItemHeader.type;
    }
    function $19a51673c063482c$export$32f9b428425aac85(envelope) {
        var _a = (0, (0, parcelRequire("3VFsf")).__read)(envelope, 2), headers = _a[0], items = _a[1];
        var serializedHeaders = JSON.stringify(headers);
        return items.reduce(function(acc, item) {
            var _a = (0, (0, parcelRequire("3VFsf")).__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
            var serializedPayload = (0, (0, parcelRequire("okkfE")).isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
            return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
        }, serializedHeaders);
    }
});
parcelRegister("fLq1q", function(module, exports) {
    $parcel$export(module.exports, "createClientReportEnvelope", ()=>$b79f6e3445ee6042$export$f3b9ed77c03eeb00);
    var $2cvr9;
    var $gI8Be;
    function $b79f6e3445ee6042$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
        var clientReportItem = [
            {
                type: 'client_report'
            },
            {
                timestamp: timestamp || (0, (0, parcelRequire("gI8Be")).dateTimestampInSeconds)(),
                discarded_events: discarded_events
            }
        ];
        return (0, (0, parcelRequire("2cvr9")).createEnvelope)(dsn ? {
            dsn: dsn
        } : {}, [
            clientReportItem
        ]);
    }
});
parcelRegister("giEo2", function(module, exports) {
    $parcel$export(module.exports, "disabledUntil", ()=>$bddda7bd22e98b4c$export$b89fc7b2e4c799e7);
    $parcel$export(module.exports, "isRateLimited", ()=>$bddda7bd22e98b4c$export$6c91fec22056810a);
    $parcel$export(module.exports, "updateRateLimits", ()=>$bddda7bd22e98b4c$export$699aff705e0d49d4);
    var $3VFsf;
    var $bddda7bd22e98b4c$export$b09ce39faaeb1e7c = 60000;
    function $bddda7bd22e98b4c$export$615352e17ed7741(header, now) {
        if (now === void 0) now = Date.now();
        var headerDelay = parseInt("" + header, 10);
        if (!isNaN(headerDelay)) return headerDelay * 1000;
        var headerDate = Date.parse("" + header);
        if (!isNaN(headerDate)) return headerDate - now;
        return $bddda7bd22e98b4c$export$b09ce39faaeb1e7c;
    }
    function $bddda7bd22e98b4c$export$b89fc7b2e4c799e7(limits, category) {
        return limits[category] || limits.all || 0;
    }
    function $bddda7bd22e98b4c$export$6c91fec22056810a(limits, category, now) {
        if (now === void 0) now = Date.now();
        return $bddda7bd22e98b4c$export$b89fc7b2e4c799e7(limits, category) > now;
    }
    function $bddda7bd22e98b4c$export$699aff705e0d49d4(limits, headers, now) {
        var e_1, _a, e_2, _b;
        if (now === void 0) now = Date.now();
        var updatedRateLimits = (0, (0, parcelRequire("3VFsf")).__assign)({}, limits);
        var rateLimitHeader = headers['x-sentry-rate-limits'];
        var retryAfterHeader = headers['retry-after'];
        if (rateLimitHeader) try {
            for(var _c = (0, (0, parcelRequire("3VFsf")).__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
                var limit = _d.value;
                var parameters = limit.split(':', 2);
                var headerDelay = parseInt(parameters[0], 10);
                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000;
                if (!parameters[1]) updatedRateLimits.all = now + delay;
                else try {
                    for(var _e = (e_2 = void 0, (0, (0, parcelRequire("3VFsf")).__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var category = _f.value;
                        updatedRateLimits[category] = now + delay;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        else if (retryAfterHeader) updatedRateLimits.all = now + $bddda7bd22e98b4c$export$615352e17ed7741(retryAfterHeader, now);
        return updatedRateLimits;
    }
});
parcelRegister("3knVN", function(module, exports) {
    $parcel$export(module.exports, "IS_DEBUG_BUILD", ()=>$26c5cd9556cd8ba2$export$48a8984ec0bf2e44);
    var $26c5cd9556cd8ba2$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
});
parcelRegister("bYhbK", function(module, exports) {
    $parcel$export(module.exports, "setupIntegrations", ()=>$8b72a18ea9aa7e3f$export$51abed9797baa598);
    var $3VFsf;
    var $gfYRq;
    var $3kk8J;
    parcelRequire("3xuhl");
    var $59M0S;
    var $aHQIJ;
    var $3knVN;
    var $8b72a18ea9aa7e3f$export$b14a8888f80a0b3e = [];
    function $8b72a18ea9aa7e3f$var$filterDuplicates(integrations) {
        return integrations.reduce(function(acc, integrations) {
            if (acc.every(function(accIntegration) {
                return integrations.name !== accIntegration.name;
            })) acc.push(integrations);
            return acc;
        }, []);
    }
    function $8b72a18ea9aa7e3f$export$68bc4c01ab8ae766(options) {
        var defaultIntegrations = options.defaultIntegrations && (0, (0, parcelRequire("3VFsf")).__spread)(options.defaultIntegrations) || [];
        var userIntegrations = options.integrations;
        var integrations = (0, (0, parcelRequire("3VFsf")).__spread)($8b72a18ea9aa7e3f$var$filterDuplicates(defaultIntegrations));
        if (Array.isArray(userIntegrations)) integrations = (0, (0, parcelRequire("3VFsf")).__spread)(integrations.filter(function(integrations) {
            return userIntegrations.every(function(userIntegration) {
                return userIntegration.name !== integrations.name;
            });
        }), $8b72a18ea9aa7e3f$var$filterDuplicates(userIntegrations));
        else if (typeof userIntegrations === 'function') {
            integrations = userIntegrations(integrations);
            integrations = Array.isArray(integrations) ? integrations : [
                integrations
            ];
        }
        var integrationsNames = integrations.map(function(i) {
            return i.name;
        });
        var alwaysLastToRun = 'Debug';
        if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, (0, parcelRequire("3VFsf")).__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
        return integrations;
    }
    function $8b72a18ea9aa7e3f$export$e7390a03b70a6f2f(integration) {
        if ($8b72a18ea9aa7e3f$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
        integration.setupOnce((0, (0, parcelRequire("gfYRq")).addGlobalEventProcessor), (0, (0, parcelRequire("3kk8J")).getCurrentHub));
        $8b72a18ea9aa7e3f$export$b14a8888f80a0b3e.push(integration.name);
        (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log("Integration installed: " + integration.name);
    }
    function $8b72a18ea9aa7e3f$export$51abed9797baa598(options) {
        var integrations = {};
        $8b72a18ea9aa7e3f$export$68bc4c01ab8ae766(options).forEach(function(integration) {
            integrations[integration.name] = integration;
            $8b72a18ea9aa7e3f$export$e7390a03b70a6f2f(integration);
        });
        (0, (0, parcelRequire("59M0S")).addNonEnumerableProperty)(integrations, 'initialized', true);
        return integrations;
    }
});
parcelRegister("3kk8J", function(module, exports) {
    $parcel$export(module.exports, "Hub", ()=>$26c2dcb27d4dffef$export$8c41bb232f1008b1);
    $parcel$export(module.exports, "makeMain", ()=>$26c2dcb27d4dffef$export$4188a14ad302d1bc);
    $parcel$export(module.exports, "getHubFromCarrier", ()=>$26c2dcb27d4dffef$export$bfa8a924a84a76b7);
    $parcel$export(module.exports, "getCurrentHub", ()=>$26c2dcb27d4dffef$export$a07cdf6544bbd7c);
    var $3VFsf;
    parcelRequire("2zyAl");
    var $aHQIJ;
    var $gI8Be;
    var $eUO5L;
    var $3kiq9;
    var $1vYJz;
    var $23Apf;
    var $gfYRq;
    var $lTZg9;
    var $26c2dcb27d4dffef$export$24a86ef7798177e4 = 4;
    var $26c2dcb27d4dffef$var$DEFAULT_BREADCRUMBS = 100;
    var $26c2dcb27d4dffef$export$8c41bb232f1008b1 = function() {
        function Hub(client, scope, _version) {
            if (scope === void 0) scope = new (0, (0, parcelRequire("gfYRq")).Scope)();
            if (_version === void 0) _version = $26c2dcb27d4dffef$export$24a86ef7798177e4;
            this._version = _version;
            this._stack = [
                {}
            ];
            this.getStackTop().scope = scope;
            if (client) this.bindClient(client);
        }
        Hub.prototype.isOlderThan = function(version) {
            return this._version < version;
        };
        Hub.prototype.bindClient = function(client) {
            var top = this.getStackTop();
            top.client = client;
            if (client && client.setupIntegrations) client.setupIntegrations();
        };
        Hub.prototype.pushScope = function() {
            var scope = (0, (0, parcelRequire("gfYRq")).Scope).clone(this.getScope());
            this.getStack().push({
                client: this.getClient(),
                scope: scope
            });
            return scope;
        };
        Hub.prototype.popScope = function() {
            if (this.getStack().length <= 1) return false;
            return !!this.getStack().pop();
        };
        Hub.prototype.withScope = function(callback) {
            var scope = this.pushScope();
            try {
                callback(scope);
            } finally{
                this.popScope();
            }
        };
        Hub.prototype.getClient = function() {
            return this.getStackTop().client;
        };
        Hub.prototype.getScope = function() {
            return this.getStackTop().scope;
        };
        Hub.prototype.getStack = function() {
            return this._stack;
        };
        Hub.prototype.getStackTop = function() {
            return this._stack[this._stack.length - 1];
        };
        Hub.prototype.captureException = function(exception, hint) {
            var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, (0, parcelRequire("1vYJz")).uuid4)();
            var finalHint = hint;
            if (!hint) {
                var syntheticException = void 0;
                try {
                    throw new Error('Sentry syntheticException');
                } catch (exception) {
                    syntheticException = exception;
                }
                finalHint = {
                    originalException: exception,
                    syntheticException: syntheticException
                };
            }
            this._invokeClient('captureException', exception, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, finalHint), {
                event_id: eventId
            }));
            return eventId;
        };
        Hub.prototype.captureMessage = function(message, level, hint) {
            var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, (0, parcelRequire("1vYJz")).uuid4)();
            var finalHint = hint;
            if (!hint) {
                var syntheticException = void 0;
                try {
                    throw new Error(message);
                } catch (exception) {
                    syntheticException = exception;
                }
                finalHint = {
                    originalException: message,
                    syntheticException: syntheticException
                };
            }
            this._invokeClient('captureMessage', message, level, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, finalHint), {
                event_id: eventId
            }));
            return eventId;
        };
        Hub.prototype.captureEvent = function(event, hint) {
            var eventId = hint && hint.event_id ? hint.event_id : (0, (0, parcelRequire("1vYJz")).uuid4)();
            if (event.type !== 'transaction') this._lastEventId = eventId;
            this._invokeClient('captureEvent', event, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, hint), {
                event_id: eventId
            }));
            return eventId;
        };
        Hub.prototype.lastEventId = function() {
            return this._lastEventId;
        };
        Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
            var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
            if (!scope || !client) return;
            var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $26c2dcb27d4dffef$var$DEFAULT_BREADCRUMBS : _d;
            if (maxBreadcrumbs <= 0) return;
            var timestamp = (0, (0, parcelRequire("gI8Be")).dateTimestampInSeconds)();
            var mergedBreadcrumb = (0, (0, parcelRequire("3VFsf")).__assign)({
                timestamp: timestamp
            }, breadcrumb);
            var finalBreadcrumb = beforeBreadcrumb ? (0, (0, parcelRequire("aHQIJ")).consoleSandbox)(function() {
                return beforeBreadcrumb(mergedBreadcrumb, hint);
            }) : mergedBreadcrumb;
            if (finalBreadcrumb === null) return;
            scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
        };
        Hub.prototype.setUser = function(user) {
            var scope = this.getScope();
            if (scope) scope.setUser(user);
        };
        Hub.prototype.setTags = function(tags) {
            var scope = this.getScope();
            if (scope) scope.setTags(tags);
        };
        Hub.prototype.setExtras = function(extras) {
            var scope = this.getScope();
            if (scope) scope.setExtras(extras);
        };
        Hub.prototype.setTag = function(key, value) {
            var scope = this.getScope();
            if (scope) scope.setTag(key, value);
        };
        Hub.prototype.setExtra = function(key, extra) {
            var scope = this.getScope();
            if (scope) scope.setExtra(key, extra);
        };
        Hub.prototype.setContext = function(name, context) {
            var scope = this.getScope();
            if (scope) scope.setContext(name, context);
        };
        Hub.prototype.configureScope = function(callback) {
            var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
            if (scope && client) callback(scope);
        };
        Hub.prototype.run = function(callback) {
            var oldHub = $26c2dcb27d4dffef$export$4188a14ad302d1bc(this);
            try {
                callback(this);
            } finally{
                $26c2dcb27d4dffef$export$4188a14ad302d1bc(oldHub);
            }
        };
        Hub.prototype.getIntegration = function(integration) {
            var client = this.getClient();
            if (!client) return null;
            try {
                return client.getIntegration(integration);
            } catch (_oO) {
                (0, (0, parcelRequire("23Apf")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
                return null;
            }
        };
        Hub.prototype.startSpan = function(context) {
            return this._callExtensionMethod('startSpan', context);
        };
        Hub.prototype.startTransaction = function(context, customSamplingContext) {
            return this._callExtensionMethod('startTransaction', context, customSamplingContext);
        };
        Hub.prototype.traceHeaders = function() {
            return this._callExtensionMethod('traceHeaders');
        };
        Hub.prototype.captureSession = function(endSession) {
            if (endSession === void 0) endSession = false;
            if (endSession) return this.endSession();
            this._sendSessionUpdate();
        };
        Hub.prototype.endSession = function() {
            var layer = this.getStackTop();
            var scope = layer && layer.scope;
            var session = scope && scope.getSession();
            if (session) session.close();
            this._sendSessionUpdate();
            if (scope) scope.setSession();
        };
        Hub.prototype.startSession = function(context) {
            var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
            var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
            var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
            var userAgent = (global.navigator || {}).userAgent;
            var session = new (0, (0, parcelRequire("lTZg9")).Session)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({
                release: release,
                environment: environment
            }, scope && {
                user: scope.getUser()
            }), userAgent && {
                userAgent: userAgent
            }), context));
            if (scope) {
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === 'ok') currentSession.update({
                    status: 'exited'
                });
                this.endSession();
                scope.setSession(session);
            }
            return session;
        };
        Hub.prototype._sendSessionUpdate = function() {
            var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
            if (!scope) return;
            var session = scope.getSession && scope.getSession();
            if (session) {
                if (client && client.captureSession) client.captureSession(session);
            }
        };
        Hub.prototype._invokeClient = function(method) {
            var _a;
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
            if (client && client[method]) (_a = client)[method].apply(_a, (0, (0, parcelRequire("3VFsf")).__spread)(args, [
                scope
            ]));
        };
        Hub.prototype._callExtensionMethod = function(method) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var carrier = $26c2dcb27d4dffef$export$19eade501500c6c1();
            var sentry = carrier.__SENTRY__;
            if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
            (0, (0, parcelRequire("23Apf")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
        };
        return Hub;
    }();
    function $26c2dcb27d4dffef$export$19eade501500c6c1() {
        var carrier = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        carrier.__SENTRY__ = carrier.__SENTRY__ || {
            extensions: {},
            hub: undefined
        };
        return carrier;
    }
    function $26c2dcb27d4dffef$export$4188a14ad302d1bc(hub) {
        var registry = $26c2dcb27d4dffef$export$19eade501500c6c1();
        var oldHub = $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
        $26c2dcb27d4dffef$export$849f05434e95d2f2(registry, hub);
        return oldHub;
    }
    function $26c2dcb27d4dffef$export$a07cdf6544bbd7c() {
        var registry = $26c2dcb27d4dffef$export$19eade501500c6c1();
        if (!$26c2dcb27d4dffef$var$hasHubOnCarrier(registry) || $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry).isOlderThan($26c2dcb27d4dffef$export$24a86ef7798177e4)) $26c2dcb27d4dffef$export$849f05434e95d2f2(registry, new $26c2dcb27d4dffef$export$8c41bb232f1008b1());
        if ((0, (0, parcelRequire("3kiq9")).isNodeEnv)()) return $26c2dcb27d4dffef$var$getHubFromActiveDomain(registry);
        return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
    }
    function $26c2dcb27d4dffef$export$1c4d656130202699() {
        (0, (0, parcelRequire("23Apf")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
        var sentry = $26c2dcb27d4dffef$export$19eade501500c6c1().__SENTRY__;
        return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
    }
    function $26c2dcb27d4dffef$var$getHubFromActiveDomain(registry) {
        try {
            var sentry = $26c2dcb27d4dffef$export$19eade501500c6c1().__SENTRY__;
            var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
            if (!activeDomain) return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
            if (!$26c2dcb27d4dffef$var$hasHubOnCarrier(activeDomain) || $26c2dcb27d4dffef$export$bfa8a924a84a76b7(activeDomain).isOlderThan($26c2dcb27d4dffef$export$24a86ef7798177e4)) {
                var registryHubTopStack = $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry).getStackTop();
                $26c2dcb27d4dffef$export$849f05434e95d2f2(activeDomain, new $26c2dcb27d4dffef$export$8c41bb232f1008b1(registryHubTopStack.client, (0, (0, parcelRequire("gfYRq")).Scope).clone(registryHubTopStack.scope)));
            }
            return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(activeDomain);
        } catch (_Oo) {
            return $26c2dcb27d4dffef$export$bfa8a924a84a76b7(registry);
        }
    }
    function $26c2dcb27d4dffef$var$hasHubOnCarrier(carrier) {
        return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
    }
    function $26c2dcb27d4dffef$export$bfa8a924a84a76b7(carrier) {
        return (0, (0, parcelRequire("eUO5L")).getGlobalSingleton)('hub', function() {
            return new $26c2dcb27d4dffef$export$8c41bb232f1008b1();
        }, carrier);
    }
    function $26c2dcb27d4dffef$export$849f05434e95d2f2(carrier, hub) {
        if (!carrier) return false;
        var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
        __SENTRY__.hub = hub;
        return true;
    }
});
parcelRegister("23Apf", function(module, exports) {
    $parcel$export(module.exports, "IS_DEBUG_BUILD", ()=>$17f81a1bea39bc90$export$48a8984ec0bf2e44);
    var $17f81a1bea39bc90$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
});
parcelRegister("lTZg9", function(module, exports) {
    $parcel$export(module.exports, "Session", ()=>$ff1e40e1db4f1b32$export$1fb4852a55678982);
    parcelRequire("2zyAl");
    var $59M0S;
    var $gI8Be;
    var $1vYJz;
    var $ff1e40e1db4f1b32$export$1fb4852a55678982 = function() {
        function Session(context) {
            this.errors = 0;
            this.sid = (0, (0, parcelRequire("1vYJz")).uuid4)();
            this.duration = 0;
            this.status = 'ok';
            this.init = true;
            this.ignoreDuration = false;
            var startingTime = (0, (0, parcelRequire("gI8Be")).timestampInSeconds)();
            this.timestamp = startingTime;
            this.started = startingTime;
            if (context) this.update(context);
        }
        Session.prototype.update = function(context) {
            if (context === void 0) context = {};
            if (context.user) {
                if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
                if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
            }
            this.timestamp = context.timestamp || (0, (0, parcelRequire("gI8Be")).timestampInSeconds)();
            if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
            if (context.sid) this.sid = context.sid.length === 32 ? context.sid : (0, (0, parcelRequire("1vYJz")).uuid4)();
            if (context.init !== undefined) this.init = context.init;
            if (!this.did && context.did) this.did = "" + context.did;
            if (typeof context.started === 'number') this.started = context.started;
            if (this.ignoreDuration) this.duration = undefined;
            else if (typeof context.duration === 'number') this.duration = context.duration;
            else {
                var duration = this.timestamp - this.started;
                this.duration = duration >= 0 ? duration : 0;
            }
            if (context.release) this.release = context.release;
            if (context.environment) this.environment = context.environment;
            if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
            if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
            if (typeof context.errors === 'number') this.errors = context.errors;
            if (context.status) this.status = context.status;
        };
        Session.prototype.close = function(status) {
            if (status) this.update({
                status: status
            });
            else if (this.status === 'ok') this.update({
                status: 'exited'
            });
            else this.update();
        };
        Session.prototype.toJSON = function() {
            return (0, (0, parcelRequire("59M0S")).dropUndefinedKeys)({
                sid: "" + this.sid,
                init: this.init,
                started: new Date(this.started * 1000).toISOString(),
                timestamp: new Date(this.timestamp * 1000).toISOString(),
                status: this.status,
                errors: this.errors,
                did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
                duration: this.duration,
                attrs: {
                    release: this.release,
                    environment: this.environment,
                    ip_address: this.ipAddress,
                    user_agent: this.userAgent
                }
            });
        };
        return Session;
    }();
});
parcelRegister("9Up1Q", function(module, exports) {
    $parcel$export(module.exports, "SDK_VERSION", ()=>$736cc23961be74e3$export$31499a9cd224b78c);
    var $736cc23961be74e3$export$31499a9cd224b78c = '6.19.7';
});
parcelRegister("1jQdQ", function(module, exports) {
    $parcel$export(module.exports, "BrowserBackend", ()=>$0f601308e4e6ba6f$export$2526e21aec9d0ce7);
    var $3VFsf;
    var $ccWrZ;
    var $S4fte;
    var $8vvJk;
    parcelRequire("3xuhl");
    var $9BO8q;
    var $c8Het;
    var $bUa9S;
    var $huxes;
    var $5egvK;
    var $2EUFJ;
    var $0f601308e4e6ba6f$export$2526e21aec9d0ce7 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(BrowserBackend, _super);
        function BrowserBackend() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        BrowserBackend.prototype.eventFromException = function(exception, hint) {
            return (0, (0, parcelRequire("c8Het")).eventFromException)(exception, hint, this._options.attachStacktrace);
        };
        BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
            if (level === void 0) level = (0, (0, parcelRequire("8vvJk")).Severity).Info;
            return (0, (0, parcelRequire("c8Het")).eventFromMessage)(message, level, hint, this._options.attachStacktrace);
        };
        BrowserBackend.prototype._setupTransport = function() {
            if (!this._options.dsn) return _super.prototype._setupTransport.call(this);
            var transportOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this._options.transportOptions), {
                dsn: this._options.dsn,
                tunnel: this._options.tunnel,
                sendClientReports: this._options.sendClientReports,
                _metadata: this._options._metadata
            });
            var api = (0, (0, parcelRequire("S4fte")).initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
            var url = (0, (0, parcelRequire("S4fte")).getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
            if (this._options.transport) return new this._options.transport(transportOptions);
            if ((0, (0, parcelRequire("9BO8q")).supportsFetch)()) {
                var requestOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, transportOptions.fetchParameters);
                this._newTransport = (0, (0, parcelRequire("huxes")).makeNewFetchTransport)({
                    requestOptions: requestOptions,
                    url: url
                });
                return new (0, (0, parcelRequire("bUa9S")).FetchTransport)(transportOptions);
            }
            this._newTransport = (0, (0, parcelRequire("5egvK")).makeNewXHRTransport)({
                url: url,
                headers: transportOptions.headers
            });
            return new (0, (0, parcelRequire("2EUFJ")).XHRTransport)(transportOptions);
        };
        return BrowserBackend;
    }((0, (0, parcelRequire("ccWrZ")).BaseBackend));
});
parcelRegister("ccWrZ", function(module, exports) {
    $parcel$export(module.exports, "BaseBackend", ()=>$8e33f21400272aa3$export$8f43a53a38d7e95f);
    var $3VFsf;
    parcelRequire("3xuhl");
    var $aHQIJ;
    var $f7sqx;
    var $S4fte;
    var $3knVN;
    var $bf08D;
    var $aMFZ3;
    var $8e33f21400272aa3$export$8f43a53a38d7e95f = function() {
        function BaseBackend(options) {
            this._options = options;
            if (!this._options.dsn) (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('No DSN provided, backend will not do anything.');
            this._transport = this._setupTransport();
        }
        BaseBackend.prototype.eventFromException = function(_exception, _hint) {
            throw new (0, (0, parcelRequire("f7sqx")).SentryError)('Backend has to implement `eventFromException` method');
        };
        BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
            throw new (0, (0, parcelRequire("f7sqx")).SentryError)('Backend has to implement `eventFromMessage` method');
        };
        BaseBackend.prototype.sendEvent = function(event) {
            if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
                var api = (0, (0, parcelRequire("S4fte")).initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
                var env = (0, (0, parcelRequire("bf08D")).createEventEnvelope)(event, api);
                this._newTransport.send(env).then(null, function(reason) {
                    (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Error while sending event:', reason);
                });
            } else this._transport.sendEvent(event).then(null, function(reason) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Error while sending event:', reason);
            });
        };
        BaseBackend.prototype.sendSession = function(session) {
            if (!this._transport.sendSession) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Dropping session because custom transport doesn't implement sendSession");
                return;
            }
            if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
                var api = (0, (0, parcelRequire("S4fte")).initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
                var _a = (0, (0, parcelRequire("3VFsf")).__read)((0, (0, parcelRequire("bf08D")).createSessionEnvelope)(session, api), 1), env = _a[0];
                this._newTransport.send(env).then(null, function(reason) {
                    (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Error while sending session:', reason);
                });
            } else this._transport.sendSession(session).then(null, function(reason) {
                (0, (0, parcelRequire("3knVN")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Error while sending session:', reason);
            });
        };
        BaseBackend.prototype.getTransport = function() {
            return this._transport;
        };
        BaseBackend.prototype._setupTransport = function() {
            return new (0, (0, parcelRequire("aMFZ3")).NoopTransport)();
        };
        return BaseBackend;
    }();
});
parcelRegister("S4fte", function(module, exports) {
    $parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", ()=>$0a2856eddb28200f$export$c1677e22ac2217a5);
    $parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", ()=>$0a2856eddb28200f$export$9964600bfe84e6a3);
    $parcel$export(module.exports, "initAPIDetails", ()=>$0a2856eddb28200f$export$ad00a06efb2a29cb);
    $parcel$export(module.exports, "getReportDialogEndpoint", ()=>$0a2856eddb28200f$export$671c7ed8e40a7a57);
    parcelRequire("3xuhl");
    var $ha3jm;
    var $59M0S;
    var $0a2856eddb28200f$var$SENTRY_API_VERSION = '7';
    var $0a2856eddb28200f$export$2c4e825dc9120f87 = function() {
        function API(dsn, metadata, tunnel) {
            if (metadata === void 0) metadata = {};
            this.dsn = dsn;
            this._dsnObject = (0, (0, parcelRequire("ha3jm")).makeDsn)(dsn);
            this.metadata = metadata;
            this._tunnel = tunnel;
        }
        API.prototype.getDsn = function() {
            return this._dsnObject;
        };
        API.prototype.forceEnvelope = function() {
            return !!this._tunnel;
        };
        API.prototype.getBaseApiEndpoint = function() {
            return $0a2856eddb28200f$var$getBaseApiEndpoint(this._dsnObject);
        };
        API.prototype.getStoreEndpoint = function() {
            return $0a2856eddb28200f$var$getStoreEndpoint(this._dsnObject);
        };
        API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
            return $0a2856eddb28200f$export$c1677e22ac2217a5(this._dsnObject);
        };
        API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
            return $0a2856eddb28200f$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
        };
        return API;
    }();
    function $0a2856eddb28200f$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
        return {
            initDsn: dsn,
            metadata: metadata || {},
            dsn: (0, (0, parcelRequire("ha3jm")).makeDsn)(dsn),
            tunnel: tunnel
        };
    }
    function $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) {
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
    }
    function $0a2856eddb28200f$var$_getIngestEndpoint(dsn, target) {
        return "" + $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
    }
    function $0a2856eddb28200f$var$_encodedAuth(dsn) {
        return (0, (0, parcelRequire("59M0S")).urlEncode)({
            sentry_key: dsn.publicKey,
            sentry_version: $0a2856eddb28200f$var$SENTRY_API_VERSION
        });
    }
    function $0a2856eddb28200f$var$getStoreEndpoint(dsn) {
        return $0a2856eddb28200f$var$_getIngestEndpoint(dsn, 'store');
    }
    function $0a2856eddb28200f$export$c1677e22ac2217a5(dsn) {
        return $0a2856eddb28200f$var$getStoreEndpoint(dsn) + "?" + $0a2856eddb28200f$var$_encodedAuth(dsn);
    }
    function $0a2856eddb28200f$var$_getEnvelopeEndpoint(dsn) {
        return $0a2856eddb28200f$var$_getIngestEndpoint(dsn, 'envelope');
    }
    function $0a2856eddb28200f$export$9964600bfe84e6a3(dsn, tunnel) {
        return tunnel ? tunnel : $0a2856eddb28200f$var$_getEnvelopeEndpoint(dsn) + "?" + $0a2856eddb28200f$var$_encodedAuth(dsn);
    }
    function $0a2856eddb28200f$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
        var header = [
            "Sentry sentry_version=" + $0a2856eddb28200f$var$SENTRY_API_VERSION
        ];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.publicKey);
        if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', ')
        };
    }
    function $0a2856eddb28200f$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
        var dsn = (0, (0, parcelRequire("ha3jm")).makeDsn)(dsnLike);
        var endpoint = $0a2856eddb28200f$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
        var encodedOptions = "dsn=" + (0, (0, parcelRequire("ha3jm")).dsnToString)(dsn);
        for(var key in dialogOptions){
            if (key === 'dsn') continue;
            if (key === 'user') {
                if (!dialogOptions.user) continue;
                if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
                if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
            } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
        }
        return endpoint + "?" + encodedOptions;
    }
});
parcelRegister("bf08D", function(module, exports) {
    $parcel$export(module.exports, "createSessionEnvelope", ()=>$82f133e7faf6394e$export$124b03c077baa2f3);
    $parcel$export(module.exports, "sessionToSentryRequest", ()=>$82f133e7faf6394e$export$977ee6eda1884ec3);
    $parcel$export(module.exports, "createEventEnvelope", ()=>$82f133e7faf6394e$export$c31057337a18010f);
    $parcel$export(module.exports, "eventToSentryRequest", ()=>$82f133e7faf6394e$export$2006389de558b996);
    var $3VFsf;
    parcelRequire("3xuhl");
    var $2cvr9;
    var $ha3jm;
    var $gBQwe;
    var $S4fte;
    function $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api) {
        if (!api.metadata || !api.metadata.sdk) return;
        var _a = api.metadata.sdk, name = _a.name, version = _a.version;
        return {
            name: name,
            version: version
        };
    }
    function $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, sdkInfo) {
        if (!sdkInfo) return event;
        event.sdk = event.sdk || {};
        event.sdk.name = event.sdk.name || sdkInfo.name;
        event.sdk.version = event.sdk.version || sdkInfo.version;
        event.sdk.integrations = (0, (0, parcelRequire("3VFsf")).__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
        event.sdk.packages = (0, (0, parcelRequire("3VFsf")).__spread)(event.sdk.packages || [], sdkInfo.packages || []);
        return event;
    }
    function $82f133e7faf6394e$export$124b03c077baa2f3(session, api) {
        var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
        var envelopeHeaders = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, (0, parcelRequire("ha3jm")).dsnToString)(api.dsn)
        });
        var type = 'aggregates' in session ? 'sessions' : 'session';
        var envelopeItem = [
            {
                type: type
            },
            session
        ];
        var envelope = (0, (0, parcelRequire("2cvr9")).createEnvelope)(envelopeHeaders, [
            envelopeItem
        ]);
        return [
            envelope,
            type
        ];
    }
    function $82f133e7faf6394e$export$977ee6eda1884ec3(session, api) {
        var _a = (0, (0, parcelRequire("3VFsf")).__read)($82f133e7faf6394e$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
        return {
            body: (0, (0, parcelRequire("2cvr9")).serializeEnvelope)(envelope),
            type: type,
            url: (0, (0, parcelRequire("S4fte")).getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
        };
    }
    function $82f133e7faf6394e$export$c31057337a18010f(event, api) {
        var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
        var eventType = event.type || 'event';
        var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
        var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
        $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
        event.tags = event.tags || {};
        event.extra = event.extra || {};
        if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
            event.tags.skippedNormalization = true;
            event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
        }
        delete event.sdkProcessingMetadata;
        var envelopeHeaders = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, (0, parcelRequire("ha3jm")).dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            event
        ];
        return (0, (0, parcelRequire("2cvr9")).createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
    }
    function $82f133e7faf6394e$export$2006389de558b996(event, api) {
        var sdkInfo = $82f133e7faf6394e$var$getSdkMetadataForEnvelopeHeader(api);
        var eventType = event.type || 'event';
        var useEnvelope = eventType === 'transaction' || !!api.tunnel;
        var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
        var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
        $82f133e7faf6394e$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
        event.tags = event.tags || {};
        event.extra = event.extra || {};
        if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
            event.tags.skippedNormalization = true;
            event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
        }
        delete event.sdkProcessingMetadata;
        var body;
        try {
            body = JSON.stringify(event);
        } catch (err) {
            event.tags.JSONStringifyError = true;
            event.extra.JSONStringifyError = err;
            try {
                body = JSON.stringify((0, (0, parcelRequire("gBQwe")).normalize)(event));
            } catch (newErr) {
                var innerErr = newErr;
                body = JSON.stringify({
                    message: 'JSON.stringify error after renormalization',
                    extra: {
                        message: innerErr.message,
                        stack: innerErr.stack
                    }
                });
            }
        }
        var req = {
            body: body,
            type: eventType,
            url: useEnvelope ? (0, (0, parcelRequire("S4fte")).getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, (0, parcelRequire("S4fte")).getStoreEndpointWithUrlEncodedAuth)(api.dsn)
        };
        if (useEnvelope) {
            var envelopeHeaders = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({
                event_id: event.event_id,
                sent_at: new Date().toISOString()
            }, sdkInfo && {
                sdk: sdkInfo
            }), !!api.tunnel && {
                dsn: (0, (0, parcelRequire("ha3jm")).dsnToString)(api.dsn)
            });
            var eventItem = [
                {
                    type: eventType,
                    sample_rates: [
                        {
                            id: samplingMethod,
                            rate: sampleRate
                        }
                    ]
                },
                req.body
            ];
            var envelope = (0, (0, parcelRequire("2cvr9")).createEnvelope)(envelopeHeaders, [
                eventItem
            ]);
            req.body = (0, (0, parcelRequire("2cvr9")).serializeEnvelope)(envelope);
        }
        return req;
    }
});
parcelRegister("aMFZ3", function(module, exports) {
    $parcel$export(module.exports, "NoopTransport", ()=>$7d9ef429c62e7388$export$6f2767450ea1346c);
    parcelRequire("3xuhl");
    var $4mVTs;
    var $7d9ef429c62e7388$export$6f2767450ea1346c = function() {
        function NoopTransport() {}
        NoopTransport.prototype.sendEvent = function(_) {
            return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)({
                reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
                status: 'skipped'
            });
        };
        NoopTransport.prototype.close = function(_) {
            return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(true);
        };
        return NoopTransport;
    }();
});
parcelRegister("c8Het", function(module, exports) {
    $parcel$export(module.exports, "exceptionFromError", ()=>$8d67c476e355940c$export$a6c2d27607295951);
    $parcel$export(module.exports, "eventFromException", ()=>$8d67c476e355940c$export$ea3ec7e569b823fc);
    $parcel$export(module.exports, "eventFromUnknownInput", ()=>$8d67c476e355940c$export$9dd56ed1ef0c3420);
    $parcel$export(module.exports, "eventFromMessage", ()=>$8d67c476e355940c$export$5425b53185d13d6c);
    var $3VFsf;
    var $8vvJk;
    parcelRequire("3xuhl");
    var $1vYJz;
    var $1M66C;
    var $59M0S;
    var $okkfE;
    var $gBQwe;
    var $4mVTs;
    var $6hYiK;
    function $8d67c476e355940c$export$a6c2d27607295951(ex) {
        var frames = $8d67c476e355940c$export$d478b2c12fbcfdda(ex);
        var exception = {
            type: ex && ex.name,
            value: $8d67c476e355940c$var$extractMessage(ex)
        };
        if (frames.length) exception.stacktrace = {
            frames: frames
        };
        if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
        return exception;
    }
    function $8d67c476e355940c$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
        var event = {
            exception: {
                values: [
                    {
                        type: (0, (0, parcelRequire("okkfE")).isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                        value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, (0, parcelRequire("59M0S")).extractExceptionKeysForMessage)(exception)
                    }
                ]
            },
            extra: {
                __serialized__: (0, (0, parcelRequire("gBQwe")).normalizeToSize)(exception)
            }
        };
        if (syntheticException) {
            var frames_1 = $8d67c476e355940c$export$d478b2c12fbcfdda(syntheticException);
            if (frames_1.length) event.stacktrace = {
                frames: frames_1
            };
        }
        return event;
    }
    function $8d67c476e355940c$export$73fbea5a0a5234af(ex) {
        return {
            exception: {
                values: [
                    $8d67c476e355940c$export$a6c2d27607295951(ex)
                ]
            }
        };
    }
    function $8d67c476e355940c$export$d478b2c12fbcfdda(ex) {
        var stacktrace = ex.stacktrace || ex.stack || '';
        var popSize = $8d67c476e355940c$var$getPopSize(ex);
        try {
            return (0, (0, parcelRequire("1M66C")).createStackParser)((0, (0, parcelRequire("6hYiK")).opera10StackParser), (0, (0, parcelRequire("6hYiK")).opera11StackParser), (0, (0, parcelRequire("6hYiK")).chromeStackParser), (0, (0, parcelRequire("6hYiK")).winjsStackParser), (0, (0, parcelRequire("6hYiK")).geckoStackParser))(stacktrace, popSize);
        } catch (e) {}
        return [];
    }
    var $8d67c476e355940c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
    function $8d67c476e355940c$var$getPopSize(ex) {
        if (ex) {
            if (typeof ex.framesToPop === 'number') return ex.framesToPop;
            if ($8d67c476e355940c$var$reactMinifiedRegexp.test(ex.message)) return 1;
        }
        return 0;
    }
    function $8d67c476e355940c$var$extractMessage(ex) {
        var message = ex && ex.message;
        if (!message) return 'No error message';
        if (message.error && typeof message.error.message === 'string') return message.error.message;
        return message;
    }
    function $8d67c476e355940c$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
        var syntheticException = hint && hint.syntheticException || undefined;
        var event = $8d67c476e355940c$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
        (0, (0, parcelRequire("1vYJz")).addExceptionMechanism)(event);
        event.level = (0, (0, parcelRequire("8vvJk")).Severity).Error;
        if (hint && hint.event_id) event.event_id = hint.event_id;
        return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(event);
    }
    function $8d67c476e355940c$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
        if (level === void 0) level = (0, (0, parcelRequire("8vvJk")).Severity).Info;
        var syntheticException = hint && hint.syntheticException || undefined;
        var event = $8d67c476e355940c$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
        event.level = level;
        if (hint && hint.event_id) event.event_id = hint.event_id;
        return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)(event);
    }
    function $8d67c476e355940c$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
        var event;
        if ((0, (0, parcelRequire("okkfE")).isErrorEvent)(exception) && exception.error) {
            var errorEvent = exception;
            return $8d67c476e355940c$export$73fbea5a0a5234af(errorEvent.error);
        }
        if ((0, (0, parcelRequire("okkfE")).isDOMError)(exception) || (0, (0, parcelRequire("okkfE")).isDOMException)(exception)) {
            var domException = exception;
            if ('stack' in exception) event = $8d67c476e355940c$export$73fbea5a0a5234af(exception);
            else {
                var name_1 = domException.name || ((0, (0, parcelRequire("okkfE")).isDOMError)(domException) ? 'DOMError' : 'DOMException');
                var message = domException.message ? name_1 + ": " + domException.message : name_1;
                event = $8d67c476e355940c$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
                (0, (0, parcelRequire("1vYJz")).addExceptionTypeValue)(event, message);
            }
            if ('code' in domException) event.tags = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, event.tags), {
                'DOMException.code': "" + domException.code
            });
            return event;
        }
        if ((0, (0, parcelRequire("okkfE")).isError)(exception)) return $8d67c476e355940c$export$73fbea5a0a5234af(exception);
        if ((0, (0, parcelRequire("okkfE")).isPlainObject)(exception) || (0, (0, parcelRequire("okkfE")).isEvent)(exception)) {
            var objectException = exception;
            event = $8d67c476e355940c$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
            (0, (0, parcelRequire("1vYJz")).addExceptionMechanism)(event, {
                synthetic: true
            });
            return event;
        }
        event = $8d67c476e355940c$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
        (0, (0, parcelRequire("1vYJz")).addExceptionTypeValue)(event, "" + exception, undefined);
        (0, (0, parcelRequire("1vYJz")).addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    function $8d67c476e355940c$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
        var event = {
            message: input
        };
        if (attachStacktrace && syntheticException) {
            var frames_2 = $8d67c476e355940c$export$d478b2c12fbcfdda(syntheticException);
            if (frames_2.length) event.stacktrace = {
                frames: frames_2
            };
        }
        return event;
    }
});
parcelRegister("6hYiK", function(module, exports) {
    $parcel$export(module.exports, "chromeStackParser", ()=>$49431b32a95d7ea3$export$c693d9295441d8f9);
    $parcel$export(module.exports, "geckoStackParser", ()=>$49431b32a95d7ea3$export$c9ddf1e2b5d48bff);
    $parcel$export(module.exports, "winjsStackParser", ()=>$49431b32a95d7ea3$export$b6d155d85c1dcba5);
    $parcel$export(module.exports, "opera10StackParser", ()=>$49431b32a95d7ea3$export$966ec832d9699d6);
    $parcel$export(module.exports, "opera11StackParser", ()=>$49431b32a95d7ea3$export$989a1824b4734ce6);
    var $3VFsf;
    var $49431b32a95d7ea3$var$UNKNOWN_FUNCTION = '?';
    var $49431b32a95d7ea3$var$OPERA10_PRIORITY = 10;
    var $49431b32a95d7ea3$var$OPERA11_PRIORITY = 20;
    var $49431b32a95d7ea3$var$CHROME_PRIORITY = 30;
    var $49431b32a95d7ea3$var$WINJS_PRIORITY = 40;
    var $49431b32a95d7ea3$var$GECKO_PRIORITY = 50;
    function $49431b32a95d7ea3$var$createFrame(filename, func, lineno, colno) {
        var frame = {
            filename: filename,
            function: func,
            in_app: true
        };
        if (lineno !== undefined) frame.lineno = lineno;
        if (colno !== undefined) frame.colno = colno;
        return frame;
    }
    var $49431b32a95d7ea3$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var $49431b32a95d7ea3$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var $49431b32a95d7ea3$var$chrome = function(line) {
        var parts = $49431b32a95d7ea3$var$chromeRegex.exec(line);
        if (parts) {
            var isEval = parts[2] && parts[2].indexOf('eval') === 0;
            if (isEval) {
                var subMatch = $49431b32a95d7ea3$var$chromeEvalRegex.exec(parts[2]);
                if (subMatch) {
                    parts[2] = subMatch[1];
                    parts[3] = subMatch[2];
                    parts[4] = subMatch[3];
                }
            }
            var _a = (0, (0, parcelRequire("3VFsf")).__read)($49431b32a95d7ea3$var$extractSafariExtensionDetails(parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
            return $49431b32a95d7ea3$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
        }
        return;
    };
    var $49431b32a95d7ea3$export$c693d9295441d8f9 = [
        $49431b32a95d7ea3$var$CHROME_PRIORITY,
        $49431b32a95d7ea3$var$chrome
    ];
    var $49431b32a95d7ea3$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
    var $49431b32a95d7ea3$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var $49431b32a95d7ea3$var$gecko = function(line) {
        var _a;
        var parts = $49431b32a95d7ea3$var$geckoREgex.exec(line);
        if (parts) {
            var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval) {
                var subMatch = $49431b32a95d7ea3$var$geckoEvalRegex.exec(parts[3]);
                if (subMatch) {
                    parts[1] = parts[1] || 'eval';
                    parts[3] = subMatch[1];
                    parts[4] = subMatch[2];
                    parts[5] = '';
                }
            }
            var filename = parts[3];
            var func = parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION;
            _a = (0, (0, parcelRequire("3VFsf")).__read)($49431b32a95d7ea3$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
            return $49431b32a95d7ea3$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
        }
        return;
    };
    var $49431b32a95d7ea3$export$c9ddf1e2b5d48bff = [
        $49431b32a95d7ea3$var$GECKO_PRIORITY,
        $49431b32a95d7ea3$var$gecko
    ];
    var $49431b32a95d7ea3$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    var $49431b32a95d7ea3$var$winjs = function(line) {
        var parts = $49431b32a95d7ea3$var$winjsRegex.exec(line);
        return parts ? $49431b32a95d7ea3$var$createFrame(parts[2], parts[1] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
    };
    var $49431b32a95d7ea3$export$b6d155d85c1dcba5 = [
        $49431b32a95d7ea3$var$WINJS_PRIORITY,
        $49431b32a95d7ea3$var$winjs
    ];
    var $49431b32a95d7ea3$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var $49431b32a95d7ea3$var$opera10 = function(line) {
        var parts = $49431b32a95d7ea3$var$opera10Regex.exec(line);
        return parts ? $49431b32a95d7ea3$var$createFrame(parts[2], parts[3] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
    };
    var $49431b32a95d7ea3$export$966ec832d9699d6 = [
        $49431b32a95d7ea3$var$OPERA10_PRIORITY,
        $49431b32a95d7ea3$var$opera10
    ];
    var $49431b32a95d7ea3$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
    var $49431b32a95d7ea3$var$opera11 = function(line) {
        var parts = $49431b32a95d7ea3$var$opera11Regex.exec(line);
        return parts ? $49431b32a95d7ea3$var$createFrame(parts[5], parts[3] || parts[4] || $49431b32a95d7ea3$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
    };
    var $49431b32a95d7ea3$export$989a1824b4734ce6 = [
        $49431b32a95d7ea3$var$OPERA11_PRIORITY,
        $49431b32a95d7ea3$var$opera11
    ];
    var $49431b32a95d7ea3$var$extractSafariExtensionDetails = function(func, filename) {
        var isSafariExtension = func.indexOf('safari-extension') !== -1;
        var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
        return isSafariExtension || isSafariWebExtension ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : $49431b32a95d7ea3$var$UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
        ] : [
            func,
            filename
        ];
    };
});
parcelRegister("bUa9S", function(module, exports) {
    $parcel$export(module.exports, "FetchTransport", ()=>$8aaccde9cc8aea61$export$2bdee3f9b92f4e82);
    var $3VFsf;
    parcelRequire("3xuhl");
    var $f7sqx;
    var $9BO8q;
    var $4mVTs;
    var $7xYoj;
    var $ad8JG;
    var $8aaccde9cc8aea61$export$2bdee3f9b92f4e82 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(FetchTransport, _super);
        function FetchTransport(options, fetchImpl) {
            if (fetchImpl === void 0) fetchImpl = (0, (0, parcelRequire("ad8JG")).getNativeFetchImplementation)();
            var _this = _super.call(this, options) || this;
            _this._fetch = fetchImpl;
            return _this;
        }
        FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
            var _this = this;
            if (this._isRateLimited(sentryRequest.type)) {
                this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
                return Promise.reject({
                    event: originalPayload,
                    type: sentryRequest.type,
                    reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                    status: 429
                });
            }
            var options = {
                body: sentryRequest.body,
                method: 'POST',
                referrerPolicy: (0, (0, parcelRequire("9BO8q")).supportsReferrerPolicy)() ? 'origin' : ''
            };
            if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
            if (this.options.headers !== undefined) options.headers = this.options.headers;
            return this._buffer.add(function() {
                return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, reject) {
                    _this._fetch(sentryRequest.url, options).then(function(response) {
                        var headers = {
                            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                            'retry-after': response.headers.get('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: response,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }).catch(reject);
                });
            }).then(undefined, function(reason) {
                if (reason instanceof (0, (0, parcelRequire("f7sqx")).SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
                else _this.recordLostEvent('network_error', sentryRequest.type);
                throw reason;
            });
        };
        return FetchTransport;
    }((0, (0, parcelRequire("7xYoj")).BaseTransport));
});
parcelRegister("7xYoj", function(module, exports) {
    $parcel$export(module.exports, "BaseTransport", ()=>$57ea75eadd985084$export$74b99d619e90f481);
    var $3VFsf;
    var $bf08D;
    var $S4fte;
    parcelRequire("3xuhl");
    var $fLq1q;
    var $giEo2;
    var $ha3jm;
    var $h2Oxu;
    var $eUO5L;
    var $aHQIJ;
    var $6dKoA;
    var $2cvr9;
    var $86ilb;
    var $ad8JG;
    function $57ea75eadd985084$var$requestTypeToCategory(ty) {
        var tyStr = ty;
        return tyStr === 'event' ? 'error' : tyStr;
    }
    var $57ea75eadd985084$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $57ea75eadd985084$export$74b99d619e90f481 = function() {
        function BaseTransport(options) {
            var _this = this;
            this.options = options;
            this._buffer = (0, (0, parcelRequire("6dKoA")).makePromiseBuffer)(30);
            this._rateLimits = {};
            this._outcomes = {};
            this._api = (0, (0, parcelRequire("S4fte")).initAPIDetails)(options.dsn, options._metadata, options.tunnel);
            this.url = (0, (0, parcelRequire("S4fte")).getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
            if (this.options.sendClientReports && $57ea75eadd985084$var$global.document) $57ea75eadd985084$var$global.document.addEventListener('visibilitychange', function() {
                if ($57ea75eadd985084$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
            });
        }
        BaseTransport.prototype.sendEvent = function(event) {
            return this._sendRequest((0, (0, parcelRequire("bf08D")).eventToSentryRequest)(event, this._api), event);
        };
        BaseTransport.prototype.sendSession = function(session) {
            return this._sendRequest((0, (0, parcelRequire("bf08D")).sessionToSentryRequest)(session, this._api), session);
        };
        BaseTransport.prototype.close = function(timeout) {
            return this._buffer.drain(timeout);
        };
        BaseTransport.prototype.recordLostEvent = function(reason, category) {
            var _a;
            if (!this.options.sendClientReports) return;
            var key = $57ea75eadd985084$var$requestTypeToCategory(category) + ":" + reason;
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log("Adding outcome: " + key);
            this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
        };
        BaseTransport.prototype._flushOutcomes = function() {
            if (!this.options.sendClientReports) return;
            var outcomes = this._outcomes;
            this._outcomes = {};
            if (!Object.keys(outcomes).length) {
                (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log('No outcomes to flush');
                return;
            }
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
            var url = (0, (0, parcelRequire("S4fte")).getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
            var discardedEvents = Object.keys(outcomes).map(function(key) {
                var _a = (0, (0, parcelRequire("3VFsf")).__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
                return {
                    reason: reason,
                    category: category,
                    quantity: outcomes[key]
                };
            });
            var envelope = (0, (0, parcelRequire("fLq1q")).createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, (0, parcelRequire("ha3jm")).dsnToString)(this._api.dsn));
            try {
                (0, (0, parcelRequire("ad8JG")).sendReport)(url, (0, (0, parcelRequire("2cvr9")).serializeEnvelope)(envelope));
            } catch (e) {
                (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error(e);
            }
        };
        BaseTransport.prototype._handleResponse = function(_a) {
            var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
            var status = (0, (0, parcelRequire("h2Oxu")).eventStatusFromHttpCode)(response.status);
            this._rateLimits = (0, (0, parcelRequire("giEo2")).updateRateLimits)(this._rateLimits, headers);
            if (this._isRateLimited(requestType)) (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
            if (status === 'success') {
                resolve({
                    status: status
                });
                return;
            }
            reject(response);
        };
        BaseTransport.prototype._disabledUntil = function(requestType) {
            var category = $57ea75eadd985084$var$requestTypeToCategory(requestType);
            return new Date((0, (0, parcelRequire("giEo2")).disabledUntil)(this._rateLimits, category));
        };
        BaseTransport.prototype._isRateLimited = function(requestType) {
            var category = $57ea75eadd985084$var$requestTypeToCategory(requestType);
            return (0, (0, parcelRequire("giEo2")).isRateLimited)(this._rateLimits, category);
        };
        return BaseTransport;
    }();
});
parcelRegister("86ilb", function(module, exports) {
    $parcel$export(module.exports, "IS_DEBUG_BUILD", ()=>$5e5d1c5a13c7017d$export$48a8984ec0bf2e44);
    var $5e5d1c5a13c7017d$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
});
parcelRegister("ad8JG", function(module, exports) {
    $parcel$export(module.exports, "getNativeFetchImplementation", ()=>$76f1e50a4e2b3aa8$export$8be2119ce08e3379);
    $parcel$export(module.exports, "sendReport", ()=>$76f1e50a4e2b3aa8$export$84bb63b2c17ec44d);
    parcelRequire("3xuhl");
    var $hZpZ3;
    var $eUO5L;
    var $9BO8q;
    var $aHQIJ;
    var $86ilb;
    var $76f1e50a4e2b3aa8$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $76f1e50a4e2b3aa8$var$cachedFetchImpl;
    function $76f1e50a4e2b3aa8$export$8be2119ce08e3379() {
        if ($76f1e50a4e2b3aa8$var$cachedFetchImpl) return $76f1e50a4e2b3aa8$var$cachedFetchImpl;
        if ((0, (0, parcelRequire("9BO8q")).isNativeFetch)($76f1e50a4e2b3aa8$var$global.fetch)) return $76f1e50a4e2b3aa8$var$cachedFetchImpl = $76f1e50a4e2b3aa8$var$global.fetch.bind($76f1e50a4e2b3aa8$var$global);
        var document = $76f1e50a4e2b3aa8$var$global.document;
        var fetchImpl = $76f1e50a4e2b3aa8$var$global.fetch;
        if (document && typeof document.createElement === 'function') try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
            document.head.removeChild(sandbox);
        } catch (e) {
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
        }
        return $76f1e50a4e2b3aa8$var$cachedFetchImpl = fetchImpl.bind($76f1e50a4e2b3aa8$var$global);
    }
    function $76f1e50a4e2b3aa8$export$84bb63b2c17ec44d(url, body) {
        var isRealNavigator = Object.prototype.toString.call($76f1e50a4e2b3aa8$var$global && $76f1e50a4e2b3aa8$var$global.navigator) === '[object Navigator]';
        var hasSendBeacon = isRealNavigator && typeof $76f1e50a4e2b3aa8$var$global.navigator.sendBeacon === 'function';
        if (hasSendBeacon) {
            var sendBeacon = $76f1e50a4e2b3aa8$var$global.navigator.sendBeacon.bind($76f1e50a4e2b3aa8$var$global.navigator);
            return sendBeacon(url, body);
        }
        if ((0, (0, parcelRequire("9BO8q")).supportsFetch)()) {
            var fetch_1 = $76f1e50a4e2b3aa8$export$8be2119ce08e3379();
            return (0, (0, parcelRequire("hZpZ3")).forget)(fetch_1(url, {
                body: body,
                method: 'POST',
                credentials: 'omit',
                keepalive: true
            }));
        }
    }
});
parcelRegister("huxes", function(module, exports) {
    $parcel$export(module.exports, "makeNewFetchTransport", ()=>$cbbf04388348e7ab$export$1c57e6bfd09bad13);
    var $3VFsf;
    var $6Vta0;
    var $ad8JG;
    function $cbbf04388348e7ab$export$1c57e6bfd09bad13(options, nativeFetch) {
        if (nativeFetch === void 0) nativeFetch = (0, (0, parcelRequire("ad8JG")).getNativeFetchImplementation)();
        function makeRequest(request) {
            var requestOptions = (0, (0, parcelRequire("3VFsf")).__assign)({
                body: request.body,
                method: 'POST',
                referrerPolicy: 'origin'
            }, options.requestOptions);
            return nativeFetch(options.url, requestOptions).then(function(response) {
                return response.text().then(function(body) {
                    return {
                        body: body,
                        headers: {
                            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                            'retry-after': response.headers.get('Retry-After')
                        },
                        reason: response.statusText,
                        statusCode: response.status
                    };
                });
            });
        }
        return (0, (0, parcelRequire("6Vta0")).createTransport)({
            bufferSize: options.bufferSize
        }, makeRequest);
    }
});
parcelRegister("6Vta0", function(module, exports) {
    $parcel$export(module.exports, "createTransport", ()=>$50aeaf944e235b68$export$d09f50d9ab7f7b69);
    parcelRequire("3xuhl");
    var $giEo2;
    var $h2Oxu;
    var $2cvr9;
    var $6dKoA;
    var $4mVTs;
    var $50aeaf944e235b68$export$d8a725a7dce95622 = 'error';
    var $50aeaf944e235b68$export$99adc6fe67a3c63e = 'transaction';
    var $50aeaf944e235b68$export$9d7ad34f132fe68f = 'attachment';
    var $50aeaf944e235b68$export$42d9e7b5fc564c45 = 'session';
    var $50aeaf944e235b68$export$e515cf6dfd2f98b8 = 30;
    function $50aeaf944e235b68$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
        if (buffer === void 0) buffer = (0, (0, parcelRequire("6dKoA")).makePromiseBuffer)(options.bufferSize || $50aeaf944e235b68$export$e515cf6dfd2f98b8);
        var rateLimits = {};
        var flush = function(timeout) {
            return buffer.drain(timeout);
        };
        function send(envelope) {
            var envCategory = (0, (0, parcelRequire("2cvr9")).getEnvelopeType)(envelope);
            var category = envCategory === 'event' ? 'error' : envCategory;
            var request = {
                category: category,
                body: (0, (0, parcelRequire("2cvr9")).serializeEnvelope)(envelope)
            };
            if ((0, (0, parcelRequire("giEo2")).isRateLimited)(rateLimits, category)) return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)({
                status: 'rate_limit',
                reason: $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category)
            });
            var requestTask = function() {
                return makeRequest(request).then(function(_a) {
                    var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                    var status = (0, (0, parcelRequire("h2Oxu")).eventStatusFromHttpCode)(statusCode);
                    if (headers) rateLimits = (0, (0, parcelRequire("giEo2")).updateRateLimits)(rateLimits, headers);
                    if (status === 'success') return (0, (0, parcelRequire("4mVTs")).resolvedSyncPromise)({
                        status: status,
                        reason: reason
                    });
                    return (0, (0, parcelRequire("4mVTs")).rejectedSyncPromise)({
                        status: status,
                        reason: reason || body || (status === 'rate_limit' ? $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                    });
                });
            };
            return buffer.add(requestTask);
        }
        return {
            send: send,
            flush: flush
        };
    }
    function $50aeaf944e235b68$var$getRateLimitReason(rateLimits, category) {
        return "Too many " + category + " requests, backing off until: " + new Date((0, (0, parcelRequire("giEo2")).disabledUntil)(rateLimits, category)).toISOString();
    }
});
parcelRegister("5egvK", function(module, exports) {
    $parcel$export(module.exports, "makeNewXHRTransport", ()=>$3ceb115445ff80d8$export$4c0ac1dd4bbf4921);
    var $6Vta0;
    parcelRequire("3xuhl");
    var $4mVTs;
    var $3ceb115445ff80d8$var$XHR_READYSTATE_DONE = 4;
    function $3ceb115445ff80d8$export$4c0ac1dd4bbf4921(options) {
        function makeRequest(request) {
            return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, _reject) {
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === $3ceb115445ff80d8$var$XHR_READYSTATE_DONE) {
                        var response = {
                            body: xhr.response,
                            headers: {
                                'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                                'retry-after': xhr.getResponseHeader('Retry-After')
                            },
                            reason: xhr.statusText,
                            statusCode: xhr.status
                        };
                        resolve(response);
                    }
                };
                xhr.open('POST', options.url);
                for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
                xhr.send(request.body);
            });
        }
        return (0, (0, parcelRequire("6Vta0")).createTransport)({
            bufferSize: options.bufferSize
        }, makeRequest);
    }
});
parcelRegister("2EUFJ", function(module, exports) {
    $parcel$export(module.exports, "XHRTransport", ()=>$1efb47151abb73ac$export$874a283af77e8e62);
    var $3VFsf;
    parcelRequire("3xuhl");
    var $f7sqx;
    var $4mVTs;
    var $7xYoj;
    var $1efb47151abb73ac$export$874a283af77e8e62 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(XHRTransport, _super);
        function XHRTransport() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
            var _this = this;
            if (this._isRateLimited(sentryRequest.type)) {
                this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
                return Promise.reject({
                    event: originalPayload,
                    type: sentryRequest.type,
                    reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                    status: 429
                });
            }
            return this._buffer.add(function() {
                return new (0, (0, parcelRequire("4mVTs")).SyncPromise)(function(resolve, reject) {
                    var request = new XMLHttpRequest();
                    request.onreadystatechange = function() {
                        if (request.readyState === 4) {
                            var headers = {
                                'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                                'retry-after': request.getResponseHeader('Retry-After')
                            };
                            _this._handleResponse({
                                requestType: sentryRequest.type,
                                response: request,
                                headers: headers,
                                resolve: resolve,
                                reject: reject
                            });
                        }
                    };
                    request.open('POST', sentryRequest.url);
                    for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                    request.send(sentryRequest.body);
                });
            }).then(undefined, function(reason) {
                if (reason instanceof (0, (0, parcelRequire("f7sqx")).SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
                else _this.recordLostEvent('network_error', sentryRequest.type);
                throw reason;
            });
        };
        return XHRTransport;
    }((0, (0, parcelRequire("7xYoj")).BaseTransport));
});
parcelRegister("7n7dK", function(module, exports) {
    $parcel$export(module.exports, "shouldIgnoreOnError", ()=>$55e0484034c91259$export$b79738ab10c590b2);
    $parcel$export(module.exports, "wrap", ()=>$55e0484034c91259$export$4997ffc0176396a6);
    $parcel$export(module.exports, "injectReportDialog", ()=>$55e0484034c91259$export$deb9aac8ea0b576c);
    var $3VFsf;
    var $7zHWg;
    var $S4fte;
    parcelRequire("3xuhl");
    var $1vYJz;
    var $59M0S;
    var $eUO5L;
    var $aHQIJ;
    var $86ilb;
    var $55e0484034c91259$var$global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
    var $55e0484034c91259$var$ignoreOnError = 0;
    function $55e0484034c91259$export$b79738ab10c590b2() {
        return $55e0484034c91259$var$ignoreOnError > 0;
    }
    function $55e0484034c91259$export$1265a142ff5ba165() {
        $55e0484034c91259$var$ignoreOnError += 1;
        setTimeout(function() {
            $55e0484034c91259$var$ignoreOnError -= 1;
        });
    }
    function $55e0484034c91259$export$4997ffc0176396a6(fn, options, before) {
        if (options === void 0) options = {};
        if (typeof fn !== 'function') return fn;
        try {
            var wrapper = fn.__sentry_wrapped__;
            if (wrapper) return wrapper;
            if ((0, (0, parcelRequire("59M0S")).getOriginalFunction)(fn)) return fn;
        } catch (e) {
            return fn;
        }
        var sentryWrapped = function() {
            var args = Array.prototype.slice.call(arguments);
            try {
                if (before && typeof before === 'function') before.apply(this, arguments);
                var wrappedArguments = args.map(function(arg) {
                    return $55e0484034c91259$export$4997ffc0176396a6(arg, options);
                });
                return fn.apply(this, wrappedArguments);
            } catch (ex) {
                $55e0484034c91259$export$1265a142ff5ba165();
                (0, (0, parcelRequire("7zHWg")).withScope)(function(scope) {
                    scope.addEventProcessor(function(event) {
                        if (options.mechanism) {
                            (0, (0, parcelRequire("1vYJz")).addExceptionTypeValue)(event, undefined, undefined);
                            (0, (0, parcelRequire("1vYJz")).addExceptionMechanism)(event, options.mechanism);
                        }
                        event.extra = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, event.extra), {
                            arguments: args
                        });
                        return event;
                    });
                    (0, (0, parcelRequire("7zHWg")).captureException)(ex);
                });
                throw ex;
            }
        };
        try {
            for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
        } catch (_oO) {}
        (0, (0, parcelRequire("59M0S")).markFunctionWrapped)(sentryWrapped, fn);
        (0, (0, parcelRequire("59M0S")).addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
        try {
            var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
            if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
                get: function() {
                    return fn.name;
                }
            });
        } catch (_oO) {}
        return sentryWrapped;
    }
    function $55e0484034c91259$export$deb9aac8ea0b576c(options) {
        if (options === void 0) options = {};
        if (!$55e0484034c91259$var$global.document) return;
        if (!options.eventId) {
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Missing eventId option in showReportDialog call');
            return;
        }
        if (!options.dsn) {
            (0, (0, parcelRequire("86ilb")).IS_DEBUG_BUILD) && (0, (0, parcelRequire("aHQIJ")).logger).error('Missing dsn option in showReportDialog call');
            return;
        }
        var script = $55e0484034c91259$var$global.document.createElement('script');
        script.async = true;
        script.src = (0, (0, parcelRequire("S4fte")).getReportDialogEndpoint)(options.dsn, options);
        if (options.onLoad) script.onload = options.onLoad;
        var injectionPoint = $55e0484034c91259$var$global.document.head || $55e0484034c91259$var$global.document.body;
        if (injectionPoint) injectionPoint.appendChild(script);
    }
});
parcelRegister("7zHWg", function(module, exports) {
    $parcel$export(module.exports, "captureException", ()=>$583de2969a487e4e$export$f5282963edea4a68);
    $parcel$export(module.exports, "captureMessage", ()=>$583de2969a487e4e$export$45654777c133ae80);
    $parcel$export(module.exports, "captureEvent", ()=>$583de2969a487e4e$export$1462b974fdcf6ba2);
    $parcel$export(module.exports, "configureScope", ()=>$583de2969a487e4e$export$99d44f04437e9cb8);
    $parcel$export(module.exports, "addBreadcrumb", ()=>$583de2969a487e4e$export$efda9a273d7a036d);
    $parcel$export(module.exports, "setContext", ()=>$583de2969a487e4e$export$2f04de43fe27971a);
    $parcel$export(module.exports, "setExtras", ()=>$583de2969a487e4e$export$bb4922da0dd51b92);
    $parcel$export(module.exports, "setTags", ()=>$583de2969a487e4e$export$74a8fb34822092e6);
    $parcel$export(module.exports, "setExtra", ()=>$583de2969a487e4e$export$8e8e7789d42ed61d);
    $parcel$export(module.exports, "setTag", ()=>$583de2969a487e4e$export$a37d07ee78eb4569);
    $parcel$export(module.exports, "setUser", ()=>$583de2969a487e4e$export$8b6bb3dd62a01be2);
    $parcel$export(module.exports, "withScope", ()=>$583de2969a487e4e$export$ec58d9285c204497);
    $parcel$export(module.exports, "startTransaction", ()=>$583de2969a487e4e$export$e262da7ae6480481);
    var $3VFsf;
    var $3kk8J;
    function $583de2969a487e4e$var$callOnHub(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var hub = (0, (0, parcelRequire("3kk8J")).getCurrentHub)();
        if (hub && hub[method]) return hub[method].apply(hub, (0, (0, parcelRequire("3VFsf")).__spread)(args));
        throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
    }
    function $583de2969a487e4e$export$f5282963edea4a68(exception, captureContext) {
        var syntheticException = new Error('Sentry syntheticException');
        return $583de2969a487e4e$var$callOnHub('captureException', exception, {
            captureContext: captureContext,
            originalException: exception,
            syntheticException: syntheticException
        });
    }
    function $583de2969a487e4e$export$45654777c133ae80(message, captureContext) {
        var syntheticException = new Error(message);
        var level = typeof captureContext === 'string' ? captureContext : undefined;
        var context = typeof captureContext !== 'string' ? {
            captureContext: captureContext
        } : undefined;
        return $583de2969a487e4e$var$callOnHub('captureMessage', message, level, (0, (0, parcelRequire("3VFsf")).__assign)({
            originalException: message,
            syntheticException: syntheticException
        }, context));
    }
    function $583de2969a487e4e$export$1462b974fdcf6ba2(event) {
        return $583de2969a487e4e$var$callOnHub('captureEvent', event);
    }
    function $583de2969a487e4e$export$99d44f04437e9cb8(callback) {
        $583de2969a487e4e$var$callOnHub('configureScope', callback);
    }
    function $583de2969a487e4e$export$efda9a273d7a036d(breadcrumb) {
        $583de2969a487e4e$var$callOnHub('addBreadcrumb', breadcrumb);
    }
    function $583de2969a487e4e$export$2f04de43fe27971a(name, context) {
        $583de2969a487e4e$var$callOnHub('setContext', name, context);
    }
    function $583de2969a487e4e$export$bb4922da0dd51b92(extras) {
        $583de2969a487e4e$var$callOnHub('setExtras', extras);
    }
    function $583de2969a487e4e$export$74a8fb34822092e6(tags) {
        $583de2969a487e4e$var$callOnHub('setTags', tags);
    }
    function $583de2969a487e4e$export$8e8e7789d42ed61d(key, extra) {
        $583de2969a487e4e$var$callOnHub('setExtra', key, extra);
    }
    function $583de2969a487e4e$export$a37d07ee78eb4569(key, value) {
        $583de2969a487e4e$var$callOnHub('setTag', key, value);
    }
    function $583de2969a487e4e$export$8b6bb3dd62a01be2(user) {
        $583de2969a487e4e$var$callOnHub('setUser', user);
    }
    function $583de2969a487e4e$export$ec58d9285c204497(callback) {
        $583de2969a487e4e$var$callOnHub('withScope', callback);
    }
    function $583de2969a487e4e$export$5b9bc6fc91daaf9f(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        $583de2969a487e4e$var$callOnHub.apply(void 0, (0, (0, parcelRequire("3VFsf")).__spread)([
            '_invokeClient',
            method
        ], args));
    }
    function $583de2969a487e4e$export$e262da7ae6480481(context, customSamplingContext) {
        return $583de2969a487e4e$var$callOnHub('startTransaction', (0, (0, parcelRequire("3VFsf")).__assign)({}, context), customSamplingContext);
    }
});
parcelRegister("3Y2SJ", function(module, exports) {
    $parcel$export(module.exports, "Breadcrumbs", ()=>$2e3935ee4e2a5168$export$2dc68d50d56fbbd);
    var $3VFsf;
    var $3kk8J;
    var $8vvJk;
    parcelRequire("3xuhl");
    var $iDqcL;
    var $1vYJz;
    var $eUO5L;
    var $fB1v8;
    var $keOcA;
    var $5L8AU;
    var $2e3935ee4e2a5168$export$2dc68d50d56fbbd = function() {
        function Breadcrumbs(options) {
            this.name = Breadcrumbs.id;
            this._options = (0, (0, parcelRequire("3VFsf")).__assign)({
                console: true,
                dom: true,
                fetch: true,
                history: true,
                sentry: true,
                xhr: true
            }, options);
        }
        Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
            if (!this._options.sentry) return;
            (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
                category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
                event_id: event.event_id,
                level: event.level,
                message: (0, (0, parcelRequire("1vYJz")).getEventDescription)(event)
            }, {
                event: event
            });
        };
        Breadcrumbs.prototype.setupOnce = function() {
            if (this._options.console) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('console', $2e3935ee4e2a5168$var$_consoleBreadcrumb);
            if (this._options.dom) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('dom', $2e3935ee4e2a5168$var$_domBreadcrumb(this._options.dom));
            if (this._options.xhr) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('xhr', $2e3935ee4e2a5168$var$_xhrBreadcrumb);
            if (this._options.fetch) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('fetch', $2e3935ee4e2a5168$var$_fetchBreadcrumb);
            if (this._options.history) (0, (0, parcelRequire("iDqcL")).addInstrumentationHandler)('history', $2e3935ee4e2a5168$var$_historyBreadcrumb);
        };
        Breadcrumbs.id = 'Breadcrumbs';
        return Breadcrumbs;
    }();
    function $2e3935ee4e2a5168$var$_domBreadcrumb(dom) {
        function _innerDomBreadcrumb(handlerData) {
            var target;
            var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
            if (typeof keyAttrs === 'string') keyAttrs = [
                keyAttrs
            ];
            try {
                target = handlerData.event.target ? (0, (0, parcelRequire("fB1v8")).htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, (0, parcelRequire("fB1v8")).htmlTreeAsString)(handlerData.event, keyAttrs);
            } catch (e) {
                target = '<unknown>';
            }
            if (target.length === 0) return;
            (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
                category: "ui." + handlerData.name,
                message: target
            }, {
                event: handlerData.event,
                name: handlerData.name,
                global: handlerData.global
            });
        }
        return _innerDomBreadcrumb;
    }
    function $2e3935ee4e2a5168$var$_consoleBreadcrumb(handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, (0, parcelRequire("5L8AU")).severityFromString)(handlerData.level),
            message: (0, (0, parcelRequire("keOcA")).safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + ((0, (0, parcelRequire("keOcA")).safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else return;
        }
        (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    }
    function $2e3935ee4e2a5168$var$_xhrBreadcrumb(handlerData) {
        if (handlerData.endTimestamp) {
            if (handlerData.xhr.__sentry_own_request__) return;
            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
            (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
                category: 'xhr',
                data: {
                    method: method,
                    url: url,
                    status_code: status_code
                },
                type: 'http'
            }, {
                xhr: handlerData.xhr,
                input: body
            });
            return;
        }
    }
    function $2e3935ee4e2a5168$var$_fetchBreadcrumb(handlerData) {
        if (!handlerData.endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') return;
        if (handlerData.error) (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: (0, (0, parcelRequire("8vvJk")).Severity).Error,
            type: 'http'
        }, {
            data: handlerData.error,
            input: handlerData.args
        });
        else (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
            category: 'fetch',
            data: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, handlerData.fetchData), {
                status_code: handlerData.response.status
            }),
            type: 'http'
        }, {
            input: handlerData.args,
            response: handlerData.response
        });
    }
    function $2e3935ee4e2a5168$var$_historyBreadcrumb(handlerData) {
        var global = (0, (0, parcelRequire("eUO5L")).getGlobalObject)();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, (0, parcelRequire("1vYJz")).parseUrl)(global.location.href);
        var parsedFrom = (0, (0, parcelRequire("1vYJz")).parseUrl)(from);
        var parsedTo = (0, (0, parcelRequire("1vYJz")).parseUrl)(to);
        if (!parsedFrom.path) parsedFrom = parsedLoc;
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, (0, parcelRequire("3kk8J")).getCurrentHub)().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    }
});
parcelRegister("9e9ba", function(module, exports) {
    $parcel$export(module.exports, "maskEmailIds", ()=>$6b7c8aa13a9e7ef7$export$7a75efd77ad928b4);
    const $6b7c8aa13a9e7ef7$var$EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
    const $6b7c8aa13a9e7ef7$export$7a75efd77ad928b4 = (text)=>text.replace($6b7c8aa13a9e7ef7$var$EMAIL_REGEX, '***@***');
});
parcelRegister("bV8dQ", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsProvider", ()=>$8adb655be51f0bfa$export$1b581a2ec13e37f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvUB1;
    const $8adb655be51f0bfa$export$1b581a2ec13e37f1 = ({ children: children, channel: channel })=>{
        const sendEvent = (0, $5uXOq.useCallback)((event)=>{
            var _event$clone;
            const { actionSubject: actionSubject, attributes: attributes } = event.payload;
            const context = {};
            if (actionSubject) {
                context.component = actionSubject;
                context.componentName = actionSubject;
            }
            if (attributes) context.attributes = attributes;
            event.context.push(context);
            (_event$clone = event.clone()) === null || _event$clone === void 0 || _event$clone.fire(channel);
        }, [
            channel
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvUB1")).default), {
            channel: (0, $6e65040b988c460f$export$2ceccf177fae277c),
            onEvent: sendEvent
        }, children);
    };
});
parcelRegister("kyyqC", function(module, exports) {
    $parcel$export(module.exports, "PackageIntlProvider", ()=>$ef71b05e5955c4f6$export$dfce9acc1b75df7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $fiX4W;
    var $ljaem;
    const $ef71b05e5955c4f6$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiX4W")).ProFormaIntlProvider), {
            i18nMessages: (0, parcelRequire("ljaem")),
            locale: locale
        }, children);
});
parcelRegister("ljaem", function(module, exports) {
    $parcel$export(module.exports, "cs", ()=>(parcelRequire("140H8")).default);
    $parcel$export(module.exports, "da", ()=>(parcelRequire("iagph")).default);
    $parcel$export(module.exports, "de", ()=>(parcelRequire("62iOL")).default);
    $parcel$export(module.exports, "en", ()=>(parcelRequire("40XiA")).default);
    $parcel$export(module.exports, "en_GB", ()=>(parcelRequire("aV389")).default);
    $parcel$export(module.exports, "en_ZZ", ()=>(parcelRequire("2Ju2T")).default);
    $parcel$export(module.exports, "es", ()=>(parcelRequire("5rE8m")).default);
    $parcel$export(module.exports, "fi", ()=>(parcelRequire("efqGL")).default);
    $parcel$export(module.exports, "fr", ()=>(parcelRequire("aNJ3F")).default);
    $parcel$export(module.exports, "hu", ()=>(parcelRequire("8YQ69")).default);
    $parcel$export(module.exports, "it", ()=>(parcelRequire("lYlPo")).default);
    $parcel$export(module.exports, "ja", ()=>(parcelRequire("g1CKL")).default);
    $parcel$export(module.exports, "ko", ()=>(parcelRequire("7MhDj")).default);
    $parcel$export(module.exports, "nb", ()=>(parcelRequire("KEmmm")).default);
    $parcel$export(module.exports, "nl", ()=>(parcelRequire("asac5")).default);
    $parcel$export(module.exports, "pl", ()=>(parcelRequire("fW5Kc")).default);
    $parcel$export(module.exports, "pt_BR", ()=>(parcelRequire("29KrS")).default);
    $parcel$export(module.exports, "ru", ()=>(parcelRequire("2lZU4")).default);
    $parcel$export(module.exports, "sv", ()=>(parcelRequire("lA0ZP")).default);
    $parcel$export(module.exports, "th", ()=>(parcelRequire("3Hnao")).default);
    $parcel$export(module.exports, "tr", ()=>(parcelRequire("lqxIV")).default);
    $parcel$export(module.exports, "uk", ()=>(parcelRequire("1E54q")).default);
    $parcel$export(module.exports, "vi", ()=>(parcelRequire("bkYAf")).default);
    $parcel$export(module.exports, "zh", ()=>(parcelRequire("bzQcg")).default);
    $parcel$export(module.exports, "zh_TW", ()=>(parcelRequire("fBEDb")).default);
    var $140H8;
    var $iagph;
    var $62iOL;
    var $40XiA;
    var $aV389;
    var $2Ju2T;
    var $5rE8m;
    var $efqGL;
    var $aNJ3F;
    var $8YQ69;
    var $lYlPo;
    var $g1CKL;
    var $7MhDj;
    var $KEmmm;
    var $asac5;
    var $fW5Kc;
    var $29KrS;
    var $2lZU4;
    var $lA0ZP;
    var $3Hnao;
    var $lqxIV;
    var $1E54q;
    var $bkYAf;
    var $bzQcg;
    var $fBEDb;
});
parcelRegister("140H8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c66b41af5c111a1$export$2e2bcd8739ae039);
    var $0c66b41af5c111a1$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Upravit',
        'form-system.general.Form': "N\xe1zev",
        'jira-common.ListProjectForms.AffectExistingIssues': "Tato akce neovlivn\xed st\xe1vaj\xedc\xed po\u017Eadavky, kter\xe9 u\u017E pou\u017E\xedvaj\xed tento formul\xe1\u0159, ani \u017E\xe1dn\xe9 kopie tohoto formul\xe1\u0159e v\xa0jin\xfdch projektech.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "Typ po\u017Eadavku",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "Typ \u017E\xe1dosti",
        'jira-common.ListProjectForms.Cancel': "Zru\u0161it",
        'jira-common.ListProjectForms.Copy': "Kop\xedrovat do projektu",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Chyba: Formul\xe1\u0159 {formName} nelze zkop\xedrovat",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektu {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do obchodn\xedho projektu} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfBusinessProjects,number}\xa0obchodn\xedch projekt\u016F} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfBusinessProjects,number}\xa0obchodn\xedch projekt\u016F} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfBusinessProjects,number}\xa0obchodn\xedch projekt\u016F}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projektu} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "Formul\xe1\u0159 {formName} lze nyn\xed pou\u017E\xedt v\xa0projektu {projectName}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektech ({numberOfServiceProjectsMessage} a\xa0{numberOfBusinessProjectsMessage}).',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektech ({numberOfServiceProjectsMessage} a\xa0{numberOfSoftwareProjectsMessage}).',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektu {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do projektu slu\u017Eby} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfServiceProjects,number}\xa0projekt\u016F slu\u017Eby} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfServiceProjects,number}\xa0projekt\u016F slu\u017Eby} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfServiceProjects,number}\xa0projekt\u016F slu\u017Eby}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektech ({numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} a\xa0{numberOfBusinessProjectsMessage}).',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektech ({numberOfSoftwareProjectsMessage} a\xa0{numberOfBusinessProjectsMessage}).',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektu {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do softwarov\xe9ho projektu} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfSoftwareProjects,number}\xa0softwarov\xfdch projekt\u016F} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfSoftwareProjects,number}\xa0softwarov\xfdch projekt\u016F} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfSoftwareProjects,number}\xa0softwarov\xfdch projekt\u016F}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0{numberOfProjects,number}\xa0projektu.} few {Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt ve\xa0{numberOfProjects,number}\xa0projektech.} many {Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0{numberOfProjects,number}\xa0projektech.} other {Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0{numberOfProjects,number}\xa0projektech.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do projektu} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "Zru\u0161it",
        'jira-common.ListProjectForms.CopyModal.Copy': "Kop\xedrovat",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Kop\xedrovat do projekt\u016F",
        'jira-common.ListProjectForms.CopyModal.Heading': "Kop\xedrovat formul\xe1\u0159 {formName} do jin\xfdch projekt\u016F",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Dal\u0161\xed informace o\xa0kop\xedrov\xe1n\xed formul\xe1\u0159\u016F",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "Na\u010D\xedt\xe1n\xed projekt\u016F",
        'jira-common.ListProjectForms.CopyModal.Name': "N\xe1zev",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "Vybrat v\u0161echny projekty",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Zm\u011Bny proveden\xe9 ve formul\xe1\u0159i se neprojev\xed v\xa0\u017E\xe1dn\xe9 z\xa0jeho kopi\xed v\xa0ostatn\xedch projektech.",
        'jira-common.ListProjectForms.CopyText': "Kop\xedrovat {formName}",
        'jira-common.ListProjectForms.Delete': 'Odstranit',
        'jira-common.ListProjectForms.DeleteFormSuccess': "Formul\xe1\u0159 {formName} byl odstran\u011Bn",
        'jira-common.ListProjectForms.Duplicate': 'Duplikovat',
        'jira-common.ListProjectForms.EmptyFormName': "Formul\xe1\u0159 bez n\xe1zvu",
        'jira-common.ListProjectForms.FilterForms': "Filtrovat formul\xe1\u0159e",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "Soubor {filename} byl sta\u017Een",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Obnovte str\xe1nku a\xa0zkuste to znovu.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "Soubor {filename} nebyl sta\u017Een",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% dokon\u010Deno} few {{percentCount,number}\xa0% dokon\u010Deno} many {{percentCount,number}\xa0% dokon\u010Deno} other {{percentCount,number}\xa0% dokon\u010Deno}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Stahov\xe1n\xed souboru {filename}",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Exportovat do souboru XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': "Dal\u0161\xed akce",
        'jira-common.ListProjectForms.FutureIssueMessage': "Budouc\xed po\u017Eadavky vytvo\u0159en\xe9 pomoc\xed t\u011Bchto typ\u016F po\u017Eadavk\u016F u\u017E nebudou obsahovat tento formul\xe1\u0159:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Budouc\xed \u017E\xe1dosti vytvo\u0159en\xe9 pomoc\xed t\u011Bchto typ\u016F \u017E\xe1dost\xed u\u017E nebudou obsahovat tento formul\xe1\u0159.",
        'jira-common.ListProjectForms.Heading': 'Odstranit formul\xe1\u0159 "{formName}"?',
        'jira-common.ListProjectForms.IssueType': "Typ po\u017Eadavku",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "Vyhledat typy po\u017Eadavk\u016F",
        'jira-common.ListProjectForms.LastUpdated': "Naposledy aktualizov\xe1no",
        'jira-common.ListProjectForms.LearnMoreLink': "Dal\u0161\xed informace o\xa0odstra\u0148ov\xe1n\xed formul\xe1\u0159\u016F",
        'jira-common.ListProjectForms.RequestType': "Typ \u017E\xe1dosti",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "Vyhledat typy \u017E\xe1dost\xed",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Odstran\u011Bn\xedm tohoto formul\xe1\u0159e jej odeberete z\xa0n\xe1sleduj\xedc\xedch typ\u016F po\u017Eadavk\u016F:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Odstran\u011Bn\xedm tohoto formul\xe1\u0159e jej odeberete z\xa0n\xe1sleduj\xedc\xedch typ\u016F \u017E\xe1dost\xed:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Zkop\xedrovat p\u0159\xedm\xfd odkaz",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "Typ po\u017Eadavku",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Typ \u017E\xe1dosti",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0obchodn\xed projekt} few {{numberOfBusinessProjects,number}\xa0obchodn\xed projekty} many {{numberOfBusinessProjects,number}\xa0obchodn\xedho projektu} other {{numberOfBusinessProjects,number}\xa0obchodn\xedch projekt\u016F}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0projekt slu\u017Eby} few {{numberOfServiceProjects,number}\xa0projekty slu\u017Eby} many {{numberOfServiceProjects,number}\xa0projektu slu\u017Eby} other {{numberOfServiceProjects,number}\xa0projekt\u016F slu\u017Eby}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0softwarov\xfd projekt} few {{numberOfSoftwareProjects,number}\xa0softwarov\xe9 projekty} many {{numberOfSoftwareProjects,number}\xa0softwarov\xe9ho projektu} other {{numberOfSoftwareProjects,number}\xa0softwarov\xfdch projekt\u016F}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "Po\u010Det typ\u016F po\u017Eadavk\u016F: {count}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "Po\u010Det typ\u016F \u017E\xe1dost\xed: {count}",
        'proforma-project-forms.BusinessForms': "Pokro\u010Dil\xe9 formul\xe1\u0159e",
        'proforma-project-forms.CreateForm': "Vytvo\u0159it formul\xe1\u0159",
        'proforma-project-forms.Description': "Vytv\xe1\u0159ejte, upravujte, exportujte a\xa0odstra\u0148ujte formul\xe1\u0159e. Kop\xedrujte formul\xe1\u0159e a\xa0pou\u017E\xedvejte je v\xa0jin\xfdch projektech.",
        'proforma-project-forms.Forms': "Formul\xe1\u0159e",
        'proforma-project-forms.LearnMore': "Dal\u0161\xed informace o\xa0formul\xe1\u0159\xedch",
        'proforma-project-forms.LoadingForms': "Na\u010D\xedt\xe1n\xed\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "P\u0159id\xe1vejte pro z\xe1kazn\xedky formul\xe1\u0159e, kter\xe9 maj\xed vyplnit p\u0159i zad\xe1v\xe1n\xed \u017E\xe1dost\xed, nebo p\u0159ipojte formul\xe1\u0159e k\xa0existuj\xedc\xedm po\u017Eadavk\u016Fm, abyste z\xedskali v\xedce informac\xed.",
        'proforma-project-forms.NoFormsDescriptionJsw': "P\u0159id\xe1vejte pro z\xe1kazn\xedky formul\xe1\u0159e, kter\xe9 maj\xed vyplnit p\u0159i vytv\xe1\u0159en\xed po\u017Eadavk\u016F, nebo p\u0159ipojte formul\xe1\u0159e k\xa0existuj\xedc\xedm po\u017Eadavk\u016Fm, abyste z\xedskali v\xedce informac\xed.",
        'proforma-project-forms.NoFormsDescriptionJwm': "P\u0159id\xe1vejte pro z\xe1kazn\xedky formul\xe1\u0159e, kter\xe9 maj\xed vyplnit p\u0159i vytv\xe1\u0159en\xed polo\u017Eek, nebo p\u0159ipojte formul\xe1\u0159e k\xa0existuj\xedc\xedm po\u017Eadavk\u016Fm, abyste z\xedskali v\xedce informac\xed.",
        'proforma-project-forms.NoFormsHeading': "V\u0161echny va\u0161e formul\xe1\u0159e se zobraz\xed zde",
        'proforma-project-forms.NoFormsHeadingAdvanced': "V\u0161echny va\u0161e pokro\u010Dil\xe9 formul\xe1\u0159e se zobraz\xed zde",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "Vytvo\u0159it z\xa0importu",
        'proforma-project-forms.create-form-button.create-blank': "Vytvo\u0159it pr\xe1zdn\xfd formul\xe1\u0159",
        'proforma-project-forms.create-form-button.create-from-blank': "Vytvo\u0159it od nuly",
        'proforma-project-forms.create-form-button.create-with-template': "Vytvo\u0159it ze \u0161ablony",
        'proforma-project-forms.create-form-button.trigger': "Vytvo\u0159it formul\xe1\u0159"
    };
});
parcelRegister("iagph", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d395e33301fb3c4d$export$2e2bcd8739ae039);
    var $d395e33301fb3c4d$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Rediger',
        'form-system.general.Form': 'Navn',
        'jira-common.ListProjectForms.AffectExistingIssues': "Dette p\xe5virker ikke eksisterende sager, der allerede anvender denne formular, eller kopier af denne formular p\xe5 andre projekter.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Sagstype',
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Anmodningstype',
        'jira-common.ListProjectForms.Cancel': 'Annuller',
        'jira-common.ListProjectForms.Copy': "Kopi\xe9r til projekt",
        'jira-common.ListProjectForms.CopyFormErrorTitle': 'Fejl: "{formName}" kunne ikke kopieres',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" kan nu bruges i {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Formular blev kopieret til et forretningsprojekt} other {Formularen blev kopieret til {numberOfBusinessProjects,number} forretningsprojekter}}',
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Formularen blev kopieret til {numberOfProjects,number} projekt} other {Formularen blev kopieret til {numberOfProjects,number} projekter}}',
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" kan nu anvendes p\xe5 "{projectName}"',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" kan nu bruges i {numberOfServiceProjectsMessage} og {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" kan nu bruges i {numberOfServiceProjectsMessage} og {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" kan nu bruges i {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Formularen blev kopieret til et serviceprojekt} other {Formularen blev kopieret til {numberOfServiceProjects,number} serviceprojekter}}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" kan nu bruges i {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} og {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" kan nu bruges i {numberOfSoftwareProjectsMessage} og {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" kan nu bruges i {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Formularen blev kopieret til et softwareprojekt} other {Formularen blev kopieret til {numberOfSoftwareProjects,number} softwareprojekter}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" kan nu bruges i {numberOfProjects,number} projekt.} other {"{formName}" kan nu bruges i {numberOfProjects,number} projekter.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Formularen blev kopieret til et projekt} other {Formularen blev kopieret til {numberOfProjects,number} projekter}}',
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Annuller',
        'jira-common.ListProjectForms.CopyModal.Copy': "Kopi\xe9r",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Kopi\xe9r til projekt(er)",
        'jira-common.ListProjectForms.CopyModal.Heading': 'Kopi\xe9r "{formName}" til andre projekter',
        'jira-common.ListProjectForms.CopyModal.LearnMore': "F\xe5 mere at vide om, hvordan du kopierer formularer",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "Indl\xe6ser projekter",
        'jira-common.ListProjectForms.CopyModal.Name': 'Navn',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "V\xe6lg alle projekter",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Hvis der foretages \xe6ndringer i en formular, bliver disse \xe6ndringer ikke afspejlet i kopier af formularen, der ligger i andre projekter.",
        'jira-common.ListProjectForms.CopyText': 'Kopi af {formName}',
        'jira-common.ListProjectForms.Delete': 'Slet',
        'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" blev slettet',
        'jira-common.ListProjectForms.Duplicate': 'Dupliker',
        'jira-common.ListProjectForms.EmptyFormName': 'Formular uden titel',
        'jira-common.ListProjectForms.FilterForms': 'Filtrer formularer',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" blev downloadet',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Opdater siden, og pr\xf8v igen.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" blev ikke downloadet',
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% fuldf\xf8rt} other {{percentCount,number}\xa0% fuldf\xf8rt}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': 'Downloader "{filename}"',
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "Eksport\xe9r som xlsx-fil",
        'jira-common.ListProjectForms.FormActions.MoreActions': 'Flere handlinger',
        'jira-common.ListProjectForms.FutureIssueMessage': "Sager, der fremover oprettes med disse sagstyper, vil ikke l\xe6ngere indeholde denne formular:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Fremtidige anmodninger, der oprettes med disse anmodningstyper, vil ikke l\xe6ngere indeholde denne formular.",
        'jira-common.ListProjectForms.Heading': 'Vil du slette "{formName}"?',
        'jira-common.ListProjectForms.IssueType': 'Sagstype',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "S\xf8g efter sagstyper",
        'jira-common.ListProjectForms.LastUpdated': 'Senest opdateret',
        'jira-common.ListProjectForms.LearnMoreLink': "L\xe6s mere om, hvordan du sletter formularer.",
        'jira-common.ListProjectForms.RequestType': 'Anmodningstype',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "S\xf8g efter anmodningstyper",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Hvis du sletter denne formular, fjernes den fra f\xf8lgende sagstyper:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Hvis du sletter denne formular, fjernes den fra f\xf8lgende anmodningstyper:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Kopi\xe9r direkte link",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Sagstype',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Anmodningstype',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} forretningsprojekt} other {{numberOfBusinessProjects,number} forretningsprojekter}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} serviceprojekt} other {{numberOfServiceProjects,number} serviceprojekter}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} softwareprojekt} other {{numberOfSoftwareProjects,number} softwareprojekter}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} sagstyper',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} anmodningstyper',
        'proforma-project-forms.BusinessForms': 'Avancerede formularer',
        'proforma-project-forms.CreateForm': 'Opret formular',
        'proforma-project-forms.Description': "Opret, rediger, eksport\xe9r og slet formularer. Kopi\xe9r formularer, og brug dem i andre projekter.",
        'proforma-project-forms.Forms': 'Formularer',
        'proforma-project-forms.LearnMore': "F\xe5 mere at vide om formularer.",
        'proforma-project-forms.LoadingForms': "Indl\xe6ser \u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "Tilf\xf8j formularer, som kunderne skal udfylde, n\xe5r de opretter en anmodning, eller vedh\xe6ft formularer til eksisterende sager for at indsamle flere oplysninger.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Tilf\xf8j formularer, som kunderne skal udfylde, n\xe5r de opretter en sag, eller vedh\xe6ft formularer til eksisterende sager for at indsamle flere oplysninger.",
        'proforma-project-forms.NoFormsDescriptionJwm': "Tilf\xf8j formularer, som kunderne skal udfylde, n\xe5r de opretter et element, eller vedh\xe6ft formularer til eksisterende sager for at indsamle flere oplysninger.",
        'proforma-project-forms.NoFormsHeading': 'Alle dine formularer bliver vist her',
        'proforma-project-forms.NoFormsHeadingAdvanced': 'Alle dine avancerede formularer vises her',
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': 'Opret fra import',
        'proforma-project-forms.create-form-button.create-blank': 'Opret blank',
        'proforma-project-forms.create-form-button.create-from-blank': 'Opret fra blank',
        'proforma-project-forms.create-form-button.create-with-template': 'Opret fra skabelon',
        'proforma-project-forms.create-form-button.trigger': 'Opret formular'
    };
});
parcelRegister("62iOL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$465186cf71750e83$export$2e2bcd8739ae039);
    var $465186cf71750e83$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Bearbeiten',
        'form-system.general.Form': 'Name',
        'jira-common.ListProjectForms.AffectExistingIssues': "Dies wirkt sich weder auf bestehende Vorg\xe4nge aus, in denen dieses Formular bereits verwendet wird, noch auf Kopien dieses Formulars in anderen Projekten.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Vorgangstyp',
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Anfragetyp',
        'jira-common.ListProjectForms.Cancel': 'Abbrechen',
        'jira-common.ListProjectForms.Copy': 'In Projekt kopieren',
        'jira-common.ListProjectForms.CopyFormErrorTitle': 'Fehler: {formName} konnte nicht kopiert werden.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" kann jetzt in {numberOfBusinessProjectsMessage} verwendet werden.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formular in Gesch\xe4ftsprojekt kopiert} other {Formular in {numberOfBusinessProjects,number}\xa0Gesch\xe4ftsprojekte kopiert}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formular in {numberOfProjects,number}\xa0Projekt kopiert} other {Formular in {numberOfProjects,number}\xa0Projekte kopiert}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" kann jetzt in "{projectName}" verwendet werden.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" kann jetzt in {numberOfServiceProjectsMessage} und {numberOfBusinessProjectsMessage} verwendet werden.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" kann jetzt in {numberOfServiceProjectsMessage} und {numberOfSoftwareProjectsMessage} verwendet werden.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" kann jetzt in {numberOfServiceProjectsMessage} verwendet werden.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formular in Serviceprojekt kopiert} other {Formular in {numberOfServiceProjects,number}\xa0Serviceprojekte kopiert}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" kann jetzt in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} und {numberOfBusinessProjectsMessage} verwendet werden.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" kann jetzt in {numberOfSoftwareProjectsMessage} und {numberOfBusinessProjectsMessage} verwendet werden.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" kann jetzt in {numberOfSoftwareProjectsMessage} verwendet werden.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formular in Softwareprojekt kopiert} other {Formular in {numberOfSoftwareProjects,number}\xa0Softwareprojekte kopiert}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" kann jetzt in {numberOfProjects,number}\xa0Projekt verwendet werden.} other {"{formName}" kann jetzt in {numberOfProjects,number}\xa0Projekten verwendet werden.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formular in Projekt kopiert} other {Formular in {numberOfProjects,number}\xa0Projekte kopiert}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Abbrechen',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Kopieren',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'In Projekt(e) kopieren',
        'jira-common.ListProjectForms.CopyModal.Heading': '"{formName}" in andere Projekte kopieren',
        'jira-common.ListProjectForms.CopyModal.LearnMore': 'Weitere Informationen zum Kopieren von Formularen',
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Projekte werden geladen',
        'jira-common.ListProjectForms.CopyModal.Name': 'Name',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "Alle Projekte ausw\xe4hlen",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "An einem Formular vorgenommene \xc4nderungen werden f\xfcr keine seiner Kopien in anderen Projekten \xfcbernommen.",
        'jira-common.ListProjectForms.CopyText': 'Kopie von {formName}',
        'jira-common.ListProjectForms.Delete': "L\xf6schen",
        'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" gel\xf6scht',
        'jira-common.ListProjectForms.Duplicate': 'Duplizieren',
        'jira-common.ListProjectForms.EmptyFormName': 'Formular ohne Namen',
        'jira-common.ListProjectForms.FilterForms': 'Formulare filtern',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" wurde heruntergeladen',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" wurde nicht heruntergeladen',
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% abgeschlossen} other {{percentCount,number}\xa0% abgeschlossen}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': '"{filename}" wird heruntergeladen',
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'In XLSX exportieren',
        'jira-common.ListProjectForms.FormActions.MoreActions': 'Weitere Aktionen',
        'jira-common.ListProjectForms.FutureIssueMessage': "Zuk\xfcnftige Vorg\xe4nge, die mit diesen Vorgangstypen erstellt werden, enthalten dieses Formular nicht mehr:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Zuk\xfcnftige Anfragen, die mit diesen Anfragetypen erstellt werden, enthalten dieses Formular nicht mehr.",
        'jira-common.ListProjectForms.Heading': '"{formName}" l\xf6schen?',
        'jira-common.ListProjectForms.IssueType': 'Vorgangstyp',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Vorgangstypen suchen',
        'jira-common.ListProjectForms.LastUpdated': 'Letzte Aktualisierung',
        'jira-common.ListProjectForms.LearnMoreLink': "Weitere Informationen zum L\xf6schen von Formularen.",
        'jira-common.ListProjectForms.RequestType': 'Anfragetyp',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Anfragetypen suchen',
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Wenn Sie dieses Formular l\xf6schen, wird es aus den folgenden Vorgangstypen entfernt:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Wenn Sie dieses Formular l\xf6schen, wird es aus den folgenden Anfragetypen entfernt:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Direktlink kopieren',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Vorgangstyp',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Anfragetyp',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0Gesch\xe4ftsprojekt} other {{numberOfBusinessProjects,number}\xa0Gesch\xe4ftsprojekte}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0Serviceprojekt} other {{numberOfServiceProjects,number}\xa0Serviceprojekte}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0Softwareprojekt} other {{numberOfSoftwareProjects,number}\xa0Softwareprojekte}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count}\xa0Vorgangstypen",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count}\xa0Anfragetypen",
        'proforma-project-forms.BusinessForms': 'Erweiterte Formulare',
        'proforma-project-forms.CreateForm': 'Formular erstellen',
        'proforma-project-forms.Description': "Erstellen, bearbeiten, exportieren und l\xf6schen Sie Formulare. Kopieren Sie Formulare und nutzen Sie sie in anderen Projekten.",
        'proforma-project-forms.Forms': 'Formulare',
        'proforma-project-forms.LearnMore': 'Weitere Informationen zu Formularen',
        'proforma-project-forms.LoadingForms': "Wird geladen\xa0\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "F\xfcgen Sie Formulare hinzu, die Kunden ausf\xfcllen sollen, wenn sie eine Anfrage stellen, oder h\xe4ngen Sie Formulare an bestehende Vorg\xe4nge an, um weitere Informationen zu erfassen.",
        'proforma-project-forms.NoFormsDescriptionJsw': "F\xfcgen Sie Formulare hinzu, die Kunden ausf\xfcllen sollen, wenn sie einen Vorgang erstellen, oder h\xe4ngen Sie Formulare an bestehende Vorg\xe4nge an, um weitere Informationen zu erfassen.",
        'proforma-project-forms.NoFormsDescriptionJwm': "F\xfcgen Sie Formulare hinzu, die Kunden ausf\xfcllen sollen, wenn sie ein Element erstellen, oder h\xe4ngen Sie Formulare an bestehende Vorg\xe4nge an, um weitere Informationen zu erfassen.",
        'proforma-project-forms.NoFormsHeading': 'Alle Ihre Formulare werden hier angezeigt.',
        'proforma-project-forms.NoFormsHeadingAdvanced': 'Alle Ihre erweiterten Formulare werden hier angezeigt',
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': 'Aus Import erstellen',
        'proforma-project-forms.create-form-button.create-blank': 'Leeres Formular erstellen',
        'proforma-project-forms.create-form-button.create-from-blank': 'Neu erstellen',
        'proforma-project-forms.create-form-button.create-with-template': 'Aus Vorlage erstellen',
        'proforma-project-forms.create-form-button.trigger': 'Formular erstellen'
    };
});
parcelRegister("40XiA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ec52901e11cbd3e$export$2e2bcd8739ae039);
    var $2ec52901e11cbd3e$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Edit',
        'form-system.general.Form': 'Name',
        'jira-common.ListProjectForms.AffectExistingIssues': "This won\u2019t affect existing issues that already use this form, or any copies of this form in other projects.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Issue type',
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Request type',
        'jira-common.ListProjectForms.Cancel': 'Cancel',
        'jira-common.ListProjectForms.Copy': 'Copy to project',
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Error: Could not copy \u201C{formName}\u201D over",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': 'Form copied to {numberOfBusinessProjects, plural, one {business project} other {# business projects}}',
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': 'Form copied to {numberOfProjects, plural, one {# project} other {# projects}}',
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201C{formName}\u201D can now be used in \u201C{projectName}\u201D.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': 'Form copied to {numberOfServiceProjects, plural, one {service project} other {# service projects}}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': 'Form copied to {numberOfSoftwareProjects, plural, one {software project} other {# software projects}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfProjects, plural, one {# project} other {# projects}}.",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': 'Form copied to {numberOfProjects, plural, one {project} other {# projects}}',
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Cancel',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Copy',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copy to project(s)',
        'jira-common.ListProjectForms.CopyModal.Heading': "Copy \u201C{formName}\u201D to other projects",
        'jira-common.ListProjectForms.CopyModal.LearnMore': 'Learn more about copying forms',
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Loading projects',
        'jira-common.ListProjectForms.CopyModal.Name': 'Name',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Select all projects',
        'jira-common.ListProjectForms.CopyModal.SubHeading': 'Changes made to a form are not reflected across any of its copies in other projects.',
        'jira-common.ListProjectForms.CopyText': '{formName} copy',
        'jira-common.ListProjectForms.Delete': 'Delete',
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u201C{formName}\u201D deleted",
        'jira-common.ListProjectForms.Duplicate': 'Duplicate',
        'jira-common.ListProjectForms.EmptyFormName': 'Untitled Form',
        'jira-common.ListProjectForms.FilterForms': 'Filter forms',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201C{filename}\u201D downloaded",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Refresh the page and try again.',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201C{filename}\u201D not downloaded",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {# % complete} other {# % complete}}',
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Downloading \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Export in XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': 'More actions',
        'jira-common.ListProjectForms.FutureIssueMessage': 'Future issues created using these issue types will no longer include this form:',
        'jira-common.ListProjectForms.FutureRequestMessage': 'Future requests created using these request types will no longer include this form.',
        'jira-common.ListProjectForms.Heading': "Delete \u201C{formName}\u201D?",
        'jira-common.ListProjectForms.IssueType': 'Issue type',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Search issue types',
        'jira-common.ListProjectForms.LastUpdated': 'Last updated',
        'jira-common.ListProjectForms.LearnMoreLink': 'Learn more about deleting forms.',
        'jira-common.ListProjectForms.RequestType': 'Request type',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Search request types',
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': 'Deleting this form will remove it from the following issue types:',
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': 'Deleting this form will remove it from the following request types:',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copy direct link',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Issue type',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Request type',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {# business project} other {# business projects}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {# service project} other {# service projects}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {# software project} other {# software projects}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} issue types',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} request types',
        'proforma-project-forms.BusinessForms': 'Advanced Forms',
        'proforma-project-forms.CreateForm': 'Create form',
        'proforma-project-forms.Description': 'Create, edit, export, and delete forms. Copy forms and use them in other projects.',
        'proforma-project-forms.Forms': 'Forms',
        'proforma-project-forms.LearnMore': 'Learn more about forms.',
        'proforma-project-forms.LoadingForms': 'Loading...',
        'proforma-project-forms.NoFormsDescriptionJsm': 'Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.',
        'proforma-project-forms.NoFormsDescriptionJsw': 'Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.',
        'proforma-project-forms.NoFormsDescriptionJwm': 'Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.',
        'proforma-project-forms.NoFormsHeading': 'All of your forms will show up here',
        'proforma-project-forms.NoFormsHeadingAdvanced': 'All of your advanced forms will show up here',
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': 'Create from import',
        'proforma-project-forms.create-form-button.create-blank': 'Create blank',
        'proforma-project-forms.create-form-button.create-from-blank': 'Create from blank',
        'proforma-project-forms.create-form-button.create-with-template': 'Create from template',
        'proforma-project-forms.create-form-button.trigger': 'Create form'
    };
});
parcelRegister("aV389", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f31a7e15eb385a0$export$2e2bcd8739ae039);
    var $7f31a7e15eb385a0$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Edit',
        'form-system.general.Form': 'Name',
        'jira-common.ListProjectForms.AffectExistingIssues': "This won\u2019t affect existing issues that already use this form, or any copies of this form in other projects.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Issue type',
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Request type',
        'jira-common.ListProjectForms.Cancel': 'Cancel',
        'jira-common.ListProjectForms.Copy': 'Copy to project',
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Error: Could not copy \u201C{formName}\u201D over",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': 'Form copied to {numberOfBusinessProjects, plural, one {business project} other {# business projects}}',
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': 'Form copied to {numberOfProjects, plural, one {# project} other {# projects}}',
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201C{formName}\u201D can now be used in \u201C{projectName}\u201D.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': 'Form copied to {numberOfServiceProjects, plural, one {service project} other {# service projects}}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': 'Form copied to {numberOfSoftwareProjects, plural, one {software project} other {# software projects}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfProjects, plural, one {# project} other {# projects}}.",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': 'Form copied to {numberOfProjects, plural, one {project} other {# projects}}',
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Cancel',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Copy',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copy to project(s)',
        'jira-common.ListProjectForms.CopyModal.Heading': "Copy \u201C{formName}\u201D to other projects",
        'jira-common.ListProjectForms.CopyModal.LearnMore': 'Learn more about copying forms',
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Loading projects',
        'jira-common.ListProjectForms.CopyModal.Name': 'Name',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Select all projects',
        'jira-common.ListProjectForms.CopyModal.SubHeading': 'Changes made to a form are not reflected across any of its copies in other projects.',
        'jira-common.ListProjectForms.CopyText': '{formName} copy',
        'jira-common.ListProjectForms.Delete': 'Delete',
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u201C{formName}\u201D deleted",
        'jira-common.ListProjectForms.Duplicate': 'Duplicate',
        'jira-common.ListProjectForms.EmptyFormName': 'Untitled Form',
        'jira-common.ListProjectForms.FilterForms': 'Filter forms',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201C{filename}\u201D downloaded",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Refresh the page and try again.',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201C{filename}\u201D not downloaded",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {# % complete} other {# % complete}}',
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Downloading \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Export in XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': 'More actions',
        'jira-common.ListProjectForms.FutureIssueMessage': 'Future issues created using these issue types will no longer include this form:',
        'jira-common.ListProjectForms.FutureRequestMessage': 'Future requests created using these request types will no longer include this form.',
        'jira-common.ListProjectForms.Heading': "Delete \u201C{formName}\u201D?",
        'jira-common.ListProjectForms.IssueType': 'Issue type',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Search issue types',
        'jira-common.ListProjectForms.LastUpdated': 'Last updated',
        'jira-common.ListProjectForms.LearnMoreLink': 'Learn more about deleting forms.',
        'jira-common.ListProjectForms.RequestType': 'Request type',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Search request types',
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': 'Deleting this form will remove it from the following issue types:',
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': 'Deleting this form will remove it from the following request types:',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copy direct link',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Issue type',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Request type',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {# business project} other {# business projects}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {# service project} other {# service projects}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {# software project} other {# software projects}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} issue types',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} request types',
        'proforma-project-forms.BusinessForms': 'Advanced Forms',
        'proforma-project-forms.CreateForm': 'Create form',
        'proforma-project-forms.Description': 'Create, edit, export, and delete forms. Copy forms and use them in other projects.',
        'proforma-project-forms.Forms': 'Forms',
        'proforma-project-forms.LearnMore': 'Learn more about forms.',
        'proforma-project-forms.LoadingForms': 'Loading...',
        'proforma-project-forms.NoFormsDescriptionJsm': 'Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.',
        'proforma-project-forms.NoFormsDescriptionJsw': 'Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.',
        'proforma-project-forms.NoFormsDescriptionJwm': 'Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.',
        'proforma-project-forms.NoFormsHeading': 'All of your forms will show up here',
        'proforma-project-forms.NoFormsHeadingAdvanced': 'All of your advanced forms will show up here',
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': 'Create from import',
        'proforma-project-forms.create-form-button.create-blank': 'Create blank',
        'proforma-project-forms.create-form-button.create-from-blank': 'Create from blank',
        'proforma-project-forms.create-form-button.create-with-template': 'Create from template',
        'proforma-project-forms.create-form-button.trigger': 'Create form'
    };
});
parcelRegister("2Ju2T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fd7172b8c029d69$export$2e2bcd8739ae039);
    var $1fd7172b8c029d69$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "\u2063\u2062Edit\x90\u2061\u2061\u206D\x8f\x81\u206A\x90\u206A\x9d\x8f\u2060\u206F\u206A\u200C\u200D\u206C\u2061\u206D\x90\x81\x81\x9d\x81\u200C\u206E\x90\u200C\u200C\u206B\u206E\x90\u2063\u2064",
        'form-system.general.Form': "\u2063\u2062Name\x8d\x8f\u200C\x8f\x8d\u206B\u061C\x90\u200D\u2061\u2060\u061C\x8d\u2060\u200C\u206D\u200C\u206C\u206E\u200C\u200C\u206B\x90\u2061\x81\u206E\u206F\u206C\u206F\u200C\u206F\u206F\u2063\u2064",
        'jira-common.ListProjectForms.AffectExistingIssues': "\u2063\u2062This won\u2019t affect existing issues that already use this form, or any copies of this form in other projects.\u206F\u2060\x90\u200C\u200D\u206B\u061C\x90\u206D\u200D\x9d\u206C\u061C\u206D\u2061\x8d\u206A\u200C\u2061\u206F\u206A\x8f\u206F\x8d\u200D\x8f\x9d\x90\x8f\u200D\x8d\u061C\u2063\u2064",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\u2063\u2062Issue type\u200D\u206A\x8d\u2060\x8d\u206E\u200C\u206E\u206E\x8f\u2060\u206D\x90\u200C\u206E\u206E\u206C\u2061\u206D\x9d\x81\u206D\u2061\u206C\x90\u200C\x9d\u206F\x9d\x90\u2060\u206E\u2063\u2064",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "\u2063\u2062Request type\u206C\u206B\u206D\u206D\u2060\x8f\u206D\x90\u2061\x8f\u206A\u206F\u061C\u200D\u200D\x9d\u206D\x81\x9d\u2061\u206D\x8f\u061C\u2060\x81\u061C\u2060\x8d\u200C\u200C\u200C\u206B\u2063\u2064",
        'jira-common.ListProjectForms.Cancel': "\u2063\u2062Cancel\u206E\x8f\x9d\u200C\u206C\u200D\u206A\u200C\u200D\u2061\x90\u200C\u200C\u061C\x9d\u206F\u206A\x9d\u2060\x8f\x81\x90\u200C\u2061\u200D\u206C\u200C\u206B\u206E\u206B\x9d\u200C\u2063\u2064",
        'jira-common.ListProjectForms.Copy': "\u2063\u2062Copy to project\x8f\x9d\u206D\u200C\u061C\u206C\u206D\x81\u206E\x8d\x8f\u200C\x90\u206B\u206C\u206A\u200D\u206D\u200D\u061C\u206E\u2061\x90\u206F\u200C\x81\u206E\u200D\u200C\u206D\u200D\x9d\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "\u2063\u2062Error: Could not copy \u201C{formName}\u201D over\x90\u206A\u206C\u200C\u206C\x8d\u206E\x90\x81\u2060\u206D\u206A\x8f\u206C\u206C\u206B\u206B\x90\x90\x9d\x9d\x9d\u061C\u206D\x8d\u206A\x90\u061C\u2060\u206C\x8f\u2061\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfBusinessProjectsMessage}.\u061C\u061C\u061C\u2061\u206F\u061C\u2060\u206A\u061C\u206E\u206A\x81\u206C\u206B\u2061\u200C\u206C\u200D\u206A\u206B\u206A\x9d\u061C\u061C\u206B\u206D\x8f\u206C\u2060\x90\x90\u206F\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {\u2063\u2062Form copied to business project\u2060\u206C\u206A\x90\x9d\x90\u206D\u200C\u2061\u206B\u206D\u200D\x8d\x90\u206E\u2060\u206B\u206B\u206D\u206C\u2061\u206B\u2061\u061C\u206A\x9d\u206B\u206B\u2060\u206C\u206E\u206E\u2063\u2064} other {\u2063\u2062Form copied to {numberOfBusinessProjects,number} business projects\u2060\u206C\u206A\x90\x9d\x90\u206D\u200C\u2061\u206B\u206D\u200D\x8d\x90\u206E\u2060\u206B\u206B\u206D\u206C\u2061\u206B\u2061\u061C\u206A\x9d\u206B\u206B\u2060\u206C\u206E\u206E\u2063\u2064}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {\u2063\u2062Form copied to {numberOfProjects,number} project\u2061\u206E\u061C\x9d\u200D\u2060\u206D\u206F\u2061\x8d\u2061\x81\u061C\u200D\x90\x8f\x81\u2060\u200D\u200D\u206F\u206B\x90\x8d\u200D\u200C\u200C\u206D\u206A\u200D\u2061\u206F\u2063\u2064} other {\u2063\u2062Form copied to {numberOfProjects,number} projects\u2061\u206E\u061C\x9d\u200D\u2060\u206D\u206F\u2061\x8d\u2061\x81\u061C\u200D\x90\x8f\x81\u2060\u200D\u200D\u206F\u206B\x90\x8d\u200D\u200C\u200C\u206D\u206A\u200D\u2061\u206F\u2063\u2064}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in \u201C{projectName}\u201D.\x81\u061C\x8f\x90\u2060\x8d\u2061\u206A\u206D\u206D\u2061\x8f\u2060\u206F\x90\u206D\u2060\u2060\u206E\x8f\u2060\u206C\u061C\u206D\u2061\u206C\x81\x81\x8d\x8f\u206E\x90\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.\u206B\u2060\u2060\u206D\x9d\u206B\x8f\u206E\u206A\u206A\u206A\u206E\u200D\u200C\u206F\u061C\x8d\u2061\u2060\u206C\x81\u2061\x9d\u206B\u2061\u2061\u206D\u061C\x90\x90\x8f\u2061\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.\u200D\u206E\u2061\u061C\x9d\x90\u206C\x9d\u206D\u200C\u206E\u061C\x81\u206A\u206C\u206A\u2060\u206E\u206B\u206F\u206F\u206F\x8d\u206E\u200C\u206C\u2061\u2061\u206E\u206A\u2061\u2060\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}.\x8f\x9d\u2060\x90\u206F\u206F\u206A\u206D\x8d\u206B\u200C\u206B\u206B\u061C\x8d\u200D\u206F\x90\u206D\u206F\u206D\u2061\u206F\x8f\u206A\u2060\u206C\u200C\u061C\u206A\u206A\u200D\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {\u2063\u2062Form copied to service project\u2060\x8f\u2061\u061C\x81\u206B\u206D\u200C\u206E\u206A\u061C\u2061\x8f\u200D\u061C\u206D\u206C\u206E\u2060\u206F\x9d\x8f\u200C\x8f\u206A\u2060\x8f\x8f\x8d\u061C\u206B\x90\u2063\u2064} other {\u2063\u2062Form copied to {numberOfServiceProjects,number} service projects\u2060\x8f\u2061\u061C\x81\u206B\u206D\u200C\u206E\u206A\u061C\u2061\x8f\u200D\u061C\u206D\u206C\u206E\u2060\u206F\x9d\x8f\u200C\x8f\u206A\u2060\x8f\x8f\x8d\u061C\u206B\x90\u2063\u2064}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.\x90\u206E\x8f\x8d\x8d\u2060\u200C\x9d\x9d\u206A\x9d\x8d\u2060\u206E\u206A\u206C\u2060\u200C\x8d\x9d\x9d\u206D\u200C\x90\u200C\x8d\u206C\u206E\u2060\x9d\u206B\x81\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.\x81\u206D\x90\u2060\u200C\u2061\u061C\x8d\u200C\u206C\x8f\x8f\x8d\x81\u206D\x8d\u206C\x81\x8d\u206E\x90\u200D\x8d\u200C\u061C\u200C\u206B\u206E\u2060\u2061\u2061\u200D\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage}.\u2061\x81\x9d\u206B\x8f\u206D\u061C\u200D\x8f\x81\x8f\x8d\u206E\u206A\u2060\u061C\x81\x81\x9d\x9d\u206F\u2060\u2061\u206A\u061C\x8f\x8f\x90\u206B\u206D\u061C\x9d\u2063\u2064",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {\u2063\u2062Form copied to software project\x8f\u200D\u206D\x8f\x81\u206C\x9d\x90\u2060\u2061\x81\x8f\x90\x8d\u2061\u2060\u061C\x9d\u200D\u2061\u206C\u206C\u206A\u061C\x8d\u200C\u200C\u206A\u206E\x9d\u206B\x81\u2063\u2064} other {\u2063\u2062Form copied to {numberOfSoftwareProjects,number} software projects\x8f\u200D\u206D\x8f\x81\u206C\x9d\x90\u2060\u2061\x81\x8f\x90\x8d\u2061\u2060\u061C\x9d\u200D\u2061\u206C\u206C\u206A\u061C\x8d\u200C\u200C\u206A\u206E\x9d\u206B\x81\u2063\u2064}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfProjects,number} project.\u206D\u206F\x90\u206A\x8f\u206C\u206E\u206A\x90\u200D\u206D\u206C\u061C\u206B\u206F\u206F\u206D\u206D\x90\x8d\x90\u2060\x9d\x8d\u2061\u200D\x81\x81\x81\u206A\x90\u206D\u2063\u2064} other {\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfProjects,number} projects.\u206D\u206F\x90\u206A\x8f\u206C\u206E\u206A\x90\u200D\u206D\u206C\u061C\u206B\u206F\u206F\u206D\u206D\x90\x8d\x90\u2060\x9d\x8d\u2061\u200D\x81\x81\x81\u206A\x90\u206D\u2063\u2064}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {\u2063\u2062Form copied to project\u206E\u206F\u200C\u206F\u200C\x81\x9d\x8d\u200C\u206F\u206A\x8f\x8f\u2060\x8f\u206C\u206F\x8d\x9d\u206F\u2060\u206B\u200D\x9d\u2061\x9d\u206C\u200C\u206A\u206B\x81\u2061\u2063\u2064} other {\u2063\u2062Form copied to {numberOfProjects,number} projects\u206E\u206F\u200C\u206F\u200C\x81\x9d\x8d\u200C\u206F\u206A\x8f\x8f\u2060\x8f\u206C\u206F\x8d\x9d\u206F\u2060\u206B\u200D\x9d\u2061\x9d\u206C\u200C\u206A\u206B\x81\u2061\u2063\u2064}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\u2063\u2062Cancel\u061C\u206D\u206D\u206C\u206F\u200C\u206C\u206F\x90\x8f\u206F\x8f\u206C\u2061\x90\u200C\u200C\x9d\x8f\u200D\u206C\u206A\u206C\u206C\u061C\u2061\u2060\u206D\x9d\u061C\x9d\u206F\u2063\u2064",
        'jira-common.ListProjectForms.CopyModal.Copy': "\u2063\u2062Copy\x8d\u206D\u206E\u206A\x8f\u206C\u206E\u061C\x8d\u206C\x81\u200D\u206B\u2061\u200C\x81\x81\u206E\x90\u206F\u206E\x8f\u206A\x9d\u200D\u206B\u206C\u061C\u206E\x90\u2060\u206B\u2063\u2064",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u2063\u2062Copy to project(s)\u206D\x8d\u206B\u061C\u206A\u061C\u206D\x81\x81\x90\u200C\x9d\u206E\u206C\u206F\u2061\u206C\x81\u206B\u206C\u2061\u200C\u200C\u2061\u200D\u206D\u2061\x90\u206B\u2060\x8d\x8f\u2063\u2064",
        'jira-common.ListProjectForms.CopyModal.Heading': "\u2063\u2062Copy \u201C{formName}\u201D to other projects\u206C\u206F\x9d\x8f\u206F\x8f\u200C\x8f\u2060\x81\x90\x8d\u206F\u061C\u061C\u206B\x90\x9d\x8d\u206A\u2060\u206E\u200C\u200D\u200D\u206E\u206E\u2061\u200C\x9d\x8f\u2060\u2063\u2064",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "\u2063\u2062Learn more about copying forms\u206F\u206C\u206D\x90\x81\u206E\u206D\u206F\x8f\x81\u206D\x8d\x81\u206D\u206E\u206E\x90\u206E\u200C\x9d\u206E\u061C\u200D\u2060\u206C\u200C\u2060\x8f\u206A\x8d\x90\x8d\u2063\u2064",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u2063\u2062Loading projects\u206E\x8f\u206E\u206A\u200D\x9d\u206C\u206F\x81\u061C\x8f\u206A\u206B\u2060\x9d\u206F\x8f\x8f\x81\u206E\x9d\u200D\u206E\u2061\x90\u2061\x8d\u206A\x90\u206C\x8d\x8d\u2063\u2064",
        'jira-common.ListProjectForms.CopyModal.Name': "\u2063\u2062Name\u206C\u206B\x8d\x81\u206A\u206D\u206B\u206B\u206A\u206C\u206C\u206D\u206C\u206A\x81\u2061\x9d\u206D\x90\x90\u200D\u2060\x8d\x9d\u200C\u206C\u200C\u200D\u2061\x8f\u206F\u2061\u2063\u2064",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u2063\u2062Select all projects\x8f\u206D\u200D\u061C\x8d\x9d\u061C\x8f\x90\x90\u200D\u200C\x90\u206A\x8d\u2060\u206D\u206E\x90\u206E\u200C\u206D\x90\x81\u206C\x8d\x8f\x9d\u206A\x81\x81\x90\u2063\u2064",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\u2063\u2062Changes made to a form are not reflected across any of its copies in other projects.\u206E\u2061\u206D\x90\u2061\u206D\x9d\u061C\u2060\x9d\x9d\x9d\u2061\u206C\u206F\x81\u206B\u061C\x9d\u206E\x9d\u206B\u2061\x8f\x8d\u206B\u2061\u206E\u2060\x8f\u2060\u200D\u2063\u2064",
        'jira-common.ListProjectForms.CopyText': "\u2063\u2062{formName} copy\u206D\x8f\x81\x9d\u200C\u206D\u200D\x9d\u206C\u2060\x81\x81\u200D\x9d\x90\u206D\x9d\x81\u206E\u206B\u206C\x8d\u200C\u206B\u206D\x90\x8f\u200C\u206E\u200D\u061C\u061C\u2063\u2064",
        'jira-common.ListProjectForms.Delete': "\u2063\u2062Delete\x81\u206D\u2060\x8f\x9d\u200D\u206E\u206A\x8d\u206F\u206E\x90\u200C\u206C\x81\x8f\u206B\u206D\u200C\u206C\u200D\u206F\x90\u061C\u206A\x8d\u206A\x9d\x9d\x8f\u200C\u2061\u2063\u2064",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u2063\u2062\u201C{formName}\u201D deleted\x8d\u206C\u061C\u206C\u061C\u200C\u206D\u200D\x8f\x8f\u200C\x81\u200D\u200D\u2061\u206A\u200D\u200D\u206A\u206E\u206F\u200C\x90\u206C\u206A\u206B\u206D\u206F\u061C\u200D\u206F\u206C\u2063\u2064",
        'jira-common.ListProjectForms.Duplicate': "\u2063\u2062Duplicate\u061C\u206B\u206C\x81\u206B\u2060\u2061\u206A\u206C\u206D\u2060\x8d\u206C\u206A\u206D\u206E\x81\u200C\x90\x9d\u206A\u206C\u206C\u206B\u206E\u2060\u206D\u206B\u200C\u206B\u206F\x81\u2063\u2064",
        'jira-common.ListProjectForms.EmptyFormName': "\u2063\u2062Untitled Form\u2061\u206D\u206F\x90\x9d\u2061\x90\x8f\u200C\u200C\u200D\x81\x9d\u200D\u2061\u2061\u206D\x9d\u206B\u200D\u206F\u206C\u061C\u200D\x81\x90\x8d\x9d\x9d\u206A\x90\x8d\u2063\u2064",
        'jira-common.ListProjectForms.FilterForms': "\u2063\u2062Filter forms\u206E\u206D\u206B\u2061\u2061\u206E\x81\x81\u206B\u061C\u2060\u206D\u061C\u206D\u2061\u2060\x8f\x81\x90\u206A\u206A\u206F\u061C\u200C\u206B\x90\u206B\u2061\x9d\u2060\u206E\x8d\u2063\u2064",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u2063\u2062\u201C{filename}\u201D downloaded\u200C\x9d\u206F\x8f\u2060\u206B\u200D\u206C\u206F\x9d\u200D\x8f\u061C\x90\u200C\u206F\x81\u206C\u206C\x9d\u061C\x81\u206E\u206B\x81\u061C\u206B\u206D\x8d\u206C\u061C\u206E\u2063\u2064",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u2063\u2062Refresh the page and try again.\u206C\x8d\u200C\u206A\u206C\u206C\u206B\x9d\u2060\u206D\x8f\u2061\u206A\x8d\x8f\x81\u2061\u2060\u206B\x8f\u206E\x81\x8d\x9d\u200C\x8d\u206C\u206D\u206C\u206E\u061C\u206D\u2063\u2064",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u2063\u2062\u201C{filename}\u201D not downloaded\x9d\u061C\u200D\x90\u2061\u206F\x9d\x8f\x90\x8f\u200C\u2060\u2060\x90\u206C\u206D\x8d\u206A\x81\u206E\x8d\u206A\u2061\x90\u206C\u206A\u2060\u200C\u061C\u061C\u206F\u206F\u2063\u2064",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {\u2063\u2062{percentCount,number} % complete\u061C\u206B\x8f\x8f\x9d\x8d\u200C\x8f\x81\u206B\u206A\u2060\u2061\u206D\u206E\x9d\u206B\x90\u200D\u200C\u2061\x90\u206B\u206B\u061C\u061C\u206F\u206D\u2060\u2060\u200C\u2061\u2063\u2064} other {\u2063\u2062{percentCount,number} % complete\u061C\u206B\x8f\x8f\x9d\x8d\u200C\x8f\x81\u206B\u206A\u2060\u2061\u206D\u206E\x9d\u206B\x90\u200D\u200C\u2061\x90\u206B\u206B\u061C\u061C\u206F\u206D\u2060\u2060\u200C\u2061\u2063\u2064}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u2063\u2062Downloading \u201C{filename}\u201D\x8d\u061C\x8d\x81\x81\u206C\x8f\u206A\x90\x90\x81\u206B\u200C\u206A\u206B\x8d\u206B\x8f\x8d\u206D\x8d\u2060\u2061\u2060\u206F\u061C\u2061\x90\x81\x8d\u200D\x8d\u2063\u2064",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u2063\u2062Export in XLSX\x8d\u206D\x90\u206C\u061C\u206D\x9d\x90\u200C\x8f\x8f\x9d\u2061\x90\x90\u206B\x81\u206B\x8d\u206A\u206C\x8d\u061C\u2060\u206B\u206F\x8f\u206C\u206D\u2060\x9d\u206E\u2063\u2064",
        'jira-common.ListProjectForms.FormActions.MoreActions': "\u2063\u2062More actions\u200C\x8d\u200C\u2061\x90\u206B\x8f\x8d\u206B\u206D\u206B\u206C\u2060\x8f\u206C\u206A\u200D\u206B\x9d\u061C\x8f\x8f\u206C\u2060\x9d\u206D\u206F\x90\u061C\u2060\x8d\u206B\u2063\u2064",
        'jira-common.ListProjectForms.FutureIssueMessage': "\u2063\u2062Future issues created using these issue types will no longer include this form:\u200C\x81\x81\x8f\x8f\u206C\u206A\u206A\u206F\u206D\u2060\u2060\x81\x8d\u206A\u206D\u200C\u206B\u206E\x8d\x9d\u200D\x81\u206C\u206B\u2060\u061C\u2061\u206B\u206F\u200D\x8d\u2063\u2064",
        'jira-common.ListProjectForms.FutureRequestMessage': "\u2063\u2062Future requests created using these request types will no longer include this form.\u206D\u206F\u2060\x90\u200C\u2060\u061C\u200C\u206B\u206A\u206C\u206B\u206B\u206C\u206D\u206A\u206B\u206A\u200C\u061C\x8f\u2060\u206F\u206D\x81\u206E\u2060\u206D\u206B\u206C\u206E\x90\u2063\u2064",
        'jira-common.ListProjectForms.Heading': "\u2063\u2062Delete \u201C{formName}\u201D?\u061C\u206D\u2061\u206C\u206E\u206A\x8d\u206B\u200C\u2060\u206A\u2061\u2060\u206A\u206B\u206A\x9d\x90\x9d\u061C\u206C\u206E\u206F\x81\x8d\x8d\u061C\x8d\u206B\x8f\u2060\u2061\u2063\u2064",
        'jira-common.ListProjectForms.IssueType': "\u2063\u2062Issue type\u206F\x9d\x8f\x90\x81\x81\u200D\x9d\u200D\u200C\u206E\u2060\x9d\u206E\u061C\u206B\x8f\u206E\u200D\u206F\u2060\u061C\x81\x8d\u200C\u206B\u200C\u206A\x8f\u206F\u206C\x8f\u2063\u2064",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u2063\u2062Search issue types\u200C\x8f\u206B\x81\u206B\x8f\u206F\u061C\x81\u200C\x8d\u206F\u206D\u200D\x81\x8f\u206E\u206A\x9d\x8d\u206E\u206A\u2060\u2060\u206C\x8d\u2060\u206B\u2060\u206D\u206A\u206D\u2063\u2064",
        'jira-common.ListProjectForms.LastUpdated': "\u2063\u2062Last updated\u2061\u200C\u200D\u200C\x81\u206B\u200D\x9d\u2061\x81\x90\u200D\x8d\u200D\u206B\u200D\x8d\u206A\u2060\x90\x90\x90\u061C\u206A\u206E\u061C\u061C\x90\u206B\u206C\u2060\u200D\u2063\u2064",
        'jira-common.ListProjectForms.LearnMoreLink': "\u2063\u2062Learn more about deleting forms.\u206F\x8d\u2060\u061C\x90\x90\u206E\u206A\u200D\x81\u206D\x81\x9d\x8f\u206E\u206C\u206E\u206D\x81\u206C\u206C\u2060\u061C\u2060\u206C\u200D\x8d\x81\u061C\u200D\u206A\u206B\u2063\u2064",
        'jira-common.ListProjectForms.RequestType': "\u2063\u2062Request type\u206A\u200C\x8d\x8f\u206E\u200C\u206E\u206C\x9d\x81\u200D\u2060\u206F\u2060\x90\u061C\u206D\x9d\u200D\u206A\u061C\u206C\x81\u206D\u200C\u2061\u206D\u061C\u200C\u206C\u200D\u061C\u2063\u2064",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u2063\u2062Search request types\u2061\u2060\u2060\u061C\x9d\u061C\u061C\x81\x90\u061C\u061C\x90\u206D\x8f\u206F\u200C\u206A\x90\u200C\u206D\x8d\u200C\x8f\u206B\u2060\u206C\x81\u206F\x90\x8f\u206F\u206B\u2063\u2064",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u2063\u2062Deleting this form will remove it from the following issue types:\u206C\x81\u2060\u206C\u200C\x81\u2061\x8f\u206F\u206F\x8d\u200C\x8f\u061C\x8d\u206A\u061C\u206F\u206C\u206F\x8d\u2060\u061C\u2060\x9d\u2060\u206B\u206F\x8f\u200D\x90\x8d\u2063\u2064",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u2063\u2062Deleting this form will remove it from the following request types:\u206A\u200C\u206A\x90\u206F\x8f\u206E\u2060\u206B\u206C\u206C\u2061\u206F\u206C\x81\u206E\u206E\u2061\x9d\u2060\u200C\u206C\u206C\u061C\u2060\u206A\u206F\x9d\u200C\x9d\u206D\u200D\u2063\u2064",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u2063\u2062Copy direct link\x8f\x9d\x8f\u206C\u2060\u200D\x81\u206E\u206C\u200C\x90\u206A\u206F\x8d\u206A\u206A\x90\u2061\u061C\u200D\u200C\u2060\x81\u200C\x81\u206C\u061C\x8f\x90\u206D\u206D\u206D\u2063\u2064",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u2063\u2062Issue type\x81\x8f\u2060\u2061\u200C\x8d\u2061\x8d\x8d\u206F\u206A\u206A\u206F\x9d\u206F\u206F\u206F\x9d\u206B\u206C\u206D\u2061\u206A\u206C\u200D\x9d\x9d\u206D\u206F\u200D\u061C\u2061\u2063\u2064",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u2063\u2062Request type\u206A\u200D\u200D\x8f\u206A\x8d\u206C\u206B\x8f\x81\u206D\u206F\u2060\x8d\u206B\x8f\x8f\u206B\u206F\u2060\u061C\u206A\x8d\u206C\u061C\u061C\u206C\u206F\u206C\u200D\u206E\x81\u2063\u2064",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {\u2063\u2062{numberOfBusinessProjects,number} business project\u206D\u206B\u2060\x8f\x90\x81\u206A\u2061\u200D\u206C\u206D\u206B\u206F\u061C\u061C\u200D\u206F\u206F\u206E\u206D\x8f\u200D\u206E\u206B\u2061\u206A\u206E\u206E\x81\x8d\x90\u2060\u2063\u2064} other {\u2063\u2062{numberOfBusinessProjects,number} business projects\u206D\u206B\u2060\x8f\x90\x81\u206A\u2061\u200D\u206C\u206D\u206B\u206F\u061C\u061C\u200D\u206F\u206F\u206E\u206D\x8f\u200D\u206E\u206B\u2061\u206A\u206E\u206E\x81\x8d\x90\u2060\u2063\u2064}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {\u2063\u2062{numberOfServiceProjects,number} service project\u2060\u206B\x8d\u206B\u2061\x8f\u200C\x8f\u206D\u2061\x8f\u061C\u200C\x90\x8d\u206C\u206C\x8f\u2061\u206A\u206D\u206A\u206E\x8d\u206A\u200C\u206E\u206F\u206F\x81\u206E\u206A\u2063\u2064} other {\u2063\u2062{numberOfServiceProjects,number} service projects\u2060\u206B\x8d\u206B\u2061\x8f\u200C\x8f\u206D\u2061\x8f\u061C\u200C\x90\x8d\u206C\u206C\x8f\u2061\u206A\u206D\u206A\u206E\x8d\u206A\u200C\u206E\u206F\u206F\x81\u206E\u206A\u2063\u2064}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {\u2063\u2062{numberOfSoftwareProjects,number} software project\x9d\u2060\x90\u206D\u2060\u2060\x8f\x9d\u206A\x8f\u2060\x8f\u206B\u200C\u061C\x8d\x81\u061C\x8f\u061C\u206A\u2060\u061C\x90\x81\u2061\u061C\u206F\x8d\u200C\u206B\u206B\u2063\u2064} other {\u2063\u2062{numberOfSoftwareProjects,number} software projects\x9d\u2060\x90\u206D\u2060\u2060\x8f\x9d\u206A\x8f\u2060\x8f\u206B\u200C\u061C\x8d\x81\u061C\x8f\u061C\u206A\u2060\u061C\x90\x81\u2061\u061C\u206F\x8d\u200C\u206B\u206B\u2063\u2064}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "\u2063\u2062{count} issue types\u206F\x8d\x8f\x8f\u2061\u061C\u206F\u206E\u206A\u206C\x9d\x9d\u206C\u206B\u200D\u206B\u206C\u206E\u061C\u2060\u200C\u206E\u206B\u206D\u2060\u200C\x8d\u206D\x81\x9d\u206C\x81\u2063\u2064",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "\u2063\u2062{count} request types\x8d\x90\u200C\u206C\x9d\u206F\u206F\u206B\u200D\u206B\u206F\u206B\u206E\u2061\u206A\u206F\u206D\u200C\u206F\x9d\u206B\u061C\u200D\x81\x9d\u206B\u206D\x81\u2060\x9d\u061C\u206C\u2063\u2064",
        'proforma-project-forms.BusinessForms': "\u2063\u2062Advanced Forms\u206A\x90\u206D\u206A\x8f\u206C\u2061\u206D\x8f\u206E\x8d\x8f\u2061\u2061\x90\u206A\u206B\u206B\u206F\x81\u206B\u200D\x81\u2061\u2060\x9d\u200C\x8f\u2061\x81\x90\u206D\u2063\u2064",
        'proforma-project-forms.CreateForm': "\u2063\u2062Create form\u2060\x8d\u206A\u2061\u206B\u200D\u200C\x81\x9d\u206B\u206A\u200D\x81\u061C\u206B\x8f\u206B\x8f\u206D\u206F\x9d\x8d\x81\u206B\u061C\x9d\x8d\u206A\u061C\u206D\u206B\x9d\u2063\u2064",
        'proforma-project-forms.Description': "\u2063\u2062Create, edit, export, and delete forms. Copy forms and use them in other projects.\x9d\u2061\x8f\u206D\x9d\u200C\u200C\x90\u206B\u206B\u200C\u2060\u206F\u206F\x8f\u206A\u2060\u206D\x81\x81\u206D\x81\u200C\u200C\x81\u206E\u206C\x8f\u200D\u206B\u206C\u206E\u2063\u2064",
        'proforma-project-forms.Forms': "\u2063\u2062Forms\x8f\u206F\x8f\x8f\u061C\x8f\x9d\u206D\u206B\u206D\x81\u206E\x81\u061C\u2061\x90\u206F\u2060\u206B\u206C\u206F\x81\x8d\x8f\u200C\u2060\u206D\u206C\x90\u206F\u2060\u200D\u2063\u2064",
        'proforma-project-forms.LearnMore': "\u2063\u2062Learn more about forms.\u200C\x8d\u206D\u206D\u206D\x9d\u061C\u206F\u200C\u2060\u061C\u206E\x9d\u206F\u206C\u206A\x90\u206D\x90\x90\u2060\x81\u206F\u061C\u206D\x8d\x8f\u206B\x90\u206E\u206C\x9d\u2063\u2064",
        'proforma-project-forms.LoadingForms': "\u2063\u2062Loading...\u206A\u206D\u206A\x81\u2060\u061C\x8d\u206A\x81\x81\u206C\x8d\u200D\u2060\u2061\x9d\u200C\u2060\u2060\u206F\u206E\u206D\u206E\u200D\x9d\x90\x8f\x8d\x9d\u2060\u2061\u206A\u2063\u2064",
        'proforma-project-forms.NoFormsDescriptionJsm': "\u2063\u2062Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.\x8d\x81\x81\u206E\u206D\x90\u206F\u206C\u206E\u206C\u206F\u2061\u206E\u061C\u206B\u206D\u061C\u206D\u206F\u206B\u206F\u2060\u206D\x90\u2061\x9d\x90\x90\x81\x8f\x8f\u061C\u2063\u2064",
        'proforma-project-forms.NoFormsDescriptionJsw': "\u2063\u2062Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.\x9d\x81\u206D\x8d\u206C\x81\x8d\x81\u061C\x9d\u206C\x8d\u206E\x90\u206F\u206A\u206F\x8f\x8f\u061C\u200C\u206A\x8f\x8f\u206B\u061C\u206C\x90\u2060\x8d\u206F\u206C\u2063\u2064",
        'proforma-project-forms.NoFormsDescriptionJwm': "\u2063\u2062Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.\u2060\u200C\x8d\u206A\x8d\u206E\u206E\u206B\u061C\u2060\u206B\u061C\u2060\u206E\x81\u206D\x8d\x9d\x8d\x8f\u200D\u200C\u200C\x81\u200D\x8f\x8f\u206E\u061C\u2060\u206A\u206D\u2063\u2064",
        'proforma-project-forms.NoFormsHeading': "\u2063\u2062All of your forms will show up here\u206E\u2060\x9d\u2060\u206A\u061C\u200C\u2060\u200C\u2061\x9d\x81\u206C\x81\u200D\u206C\u061C\x9d\u206C\u206F\u2060\u206A\x9d\x8d\u200D\x8f\u206A\u2060\u206C\u206E\u2060\u200D\u2063\u2064",
        'proforma-project-forms.NoFormsHeadingAdvanced': "\u2063\u2062All of your advanced forms will show up here\x81\u206C\u2061\u2060\u206F\u2060\u200C\u206F\u206E\u2060\u206D\u206A\x90\x8f\x8f\u206E\u061C\u206F\x9d\u061C\u206F\u206F\x81\u061C\u206E\u061C\u200C\u206F\x9d\x8d\u206C\x8f\u2063\u2064",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': "\u2063\u2062Atlassian Intelligence\u200C\u206E\u206A\u200C\x9d\u200D\x90\x81\u200C\x8d\u206C\u206C\u200D\u206E\u2060\x81\u206A\u2060\u2060\x8f\u206B\u2061\u2060\x8f\x8d\u200C\x9d\x8d\x8f\u2060\x81\u206A\u2063\u2064",
        'proforma-project-forms.create-form-button.convert-form': "\u2063\u2062Create from import\u200C\x90\x90\u206D\u061C\x8f\x9d\u206B\u2061\u206D\u206F\u200C\u206C\u206D\u206B\u061C\u2061\u206A\u200C\u2060\x81\x81\x9d\u206F\u206C\u200D\x9d\u2061\u206C\u061C\u206B\u206A\u2063\u2064",
        'proforma-project-forms.create-form-button.create-blank': "\u2063\u2062Create blank\u206C\u200C\u2060\u200D\u2060\u061C\u206C\u2060\x8d\u206E\u200D\u200D\x9d\u206A\u206C\u206E\u206E\u061C\u200C\u2060\u206E\u206E\u200D\u200C\x90\u206A\u206C\u206F\x90\u2060\u206A\x90\u2063\u2064",
        'proforma-project-forms.create-form-button.create-from-blank': "\u2063\u2062Create from blank\x8d\u206D\u206C\x9d\u200D\u206D\x90\u200C\x81\x9d\u206B\u206C\x9d\x8f\u206F\u206D\x90\u061C\u206A\x90\u061C\x90\x8d\u2061\u200D\u206A\u206F\u206E\u200C\u206F\u2061\u206F\u2063\u2064",
        'proforma-project-forms.create-form-button.create-with-template': "\u2063\u2062Create from template\u200C\u206A\x9d\u2061\u206C\u206A\u206C\x8d\x81\u2061\u206C\x8f\x8f\x81\u206B\x9d\x8d\u2060\x81\x9d\u206E\u206A\x9d\u200D\u061C\u206A\x90\u2060\u2061\u206F\x90\x9d\u2063\u2064",
        'proforma-project-forms.create-form-button.trigger': "\u2063\u2062Create form\x8d\u206F\x8f\u206C\u200C\u200D\u200C\x8d\u200D\u200D\u206E\x8d\x81\u206B\u206A\u061C\u200D\u2060\x8d\x8d\u200D\x81\u206F\x90\u206A\x81\x90\u061C\u206F\u206F\x90\u206E\u2063\u2064"
    };
});
parcelRegister("5rE8m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f6e9b2286cb6fb5$export$2e2bcd8739ae039);
    var $3f6e9b2286cb6fb5$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Editar',
        'form-system.general.Form': 'Nombre',
        'jira-common.ListProjectForms.AffectExistingIssues': "Esto no afectar\xe1 a las incidencias existentes que ya usen este formulario ni a ninguna copia de este formulario en otros proyectos.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Tipo de incidencia',
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Tipo de solicitud',
        'jira-common.ListProjectForms.Cancel': 'Cancelar',
        'jira-common.ListProjectForms.Copy': 'Copiar en el proyecto',
        'jira-common.ListProjectForms.CopyFormErrorTitle': 'Error: No se ha podido copiar "{formName}"',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Formulario copiado en el proyecto empresarial} other {Formulario copiado en {numberOfBusinessProjects,number} proyectos empresariales}}',
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Formulario copiado en {numberOfProjects,number} proyecto} other {Formulario copiado en {numberOfProjects,number} proyectos}}',
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" ahora se puede utilizar en "{projectName}".',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfServiceProjectsMessage} y {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfServiceProjectsMessage} y {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Formulario copiado en el proyecto de asistencia} other {Formulario copiado en {numberOfServiceProjects,number} proyectos de asistencia}}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} y {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfSoftwareProjectsMessage} y {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Formulario copiado en el proyecto de software} other {Formulario copiado en {numberOfSoftwareProjects,number} proyectos de software}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" ahora se puede utilizar en {numberOfProjects,number} proyecto.} other {"{formName}" ahora se puede utilizar en {numberOfProjects,number} proyectos.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Formulario copiado en el proyecto} other {Formulario copiado en {numberOfProjects,number} proyectos}}',
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Cancelar',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Copiar',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copiar en proyectos',
        'jira-common.ListProjectForms.CopyModal.Heading': 'Copiar "{formName}" en otros proyectos',
        'jira-common.ListProjectForms.CopyModal.LearnMore': "M\xe1s informaci\xf3n sobre c\xf3mo copiar formularios",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Cargando proyectos',
        'jira-common.ListProjectForms.CopyModal.Name': 'Nombre',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Seleccionar todos los proyectos',
        'jira-common.ListProjectForms.CopyModal.SubHeading': 'Los cambios realizados en un formulario no se reflejan en ninguna de sus copias en otros proyectos.',
        'jira-common.ListProjectForms.CopyText': 'Copia de {formName}',
        'jira-common.ListProjectForms.Delete': 'Eliminar',
        'jira-common.ListProjectForms.DeleteFormSuccess': 'Se ha eliminado "{formName}"',
        'jira-common.ListProjectForms.Duplicate': 'Duplicar',
        'jira-common.ListProjectForms.EmptyFormName': "Formulario sin t\xedtulo",
        'jira-common.ListProjectForms.FilterForms': 'Filtrar formularios',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" se ha descargado',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Actualiza la p\xe1gina e int\xe9ntalo de nuevo.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" no se ha descargado',
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {{percentCount,number} % completado} other {{percentCount,number} % completado}}',
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': 'Descargando "{filename}"',
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Exportar en XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': "M\xe1s acciones",
        'jira-common.ListProjectForms.FutureIssueMessage': "Las incidencias futuras creadas con estos tipos de incidencia ya no incluir\xe1n este formulario:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Las futuras solicitudes creadas con estos tipos de solicitudes ya no incluir\xe1n este formulario.",
        'jira-common.ListProjectForms.Heading': '\xbfQuieres eliminar "{formName}"?',
        'jira-common.ListProjectForms.IssueType': 'Tipo de incidencia',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Buscar tipos de incidencias',
        'jira-common.ListProjectForms.LastUpdated': "\xdaltima actualizaci\xf3n",
        'jira-common.ListProjectForms.LearnMoreLink': "M\xe1s informaci\xf3n sobre c\xf3mo eliminar formularios.",
        'jira-common.ListProjectForms.RequestType': 'Tipo de solicitud',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Buscar tipos de solicitud',
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Al eliminar este formulario, se eliminar\xe1 de los siguientes tipos de incidencias:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Al eliminar este formulario, se eliminar\xe1 de los siguientes tipos de solicitud:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copiar enlace directo',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Tipo de incidencia',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Tipo de solicitud',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} proyecto empresarial} other {{numberOfBusinessProjects,number} proyectos empresariales}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} proyecto de asistencia} other {{numberOfServiceProjects,number} proyectos de asistencia}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} proyecto de software} other {{numberOfSoftwareProjects,number} proyectos de software}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} tipos de incidencia',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} tipos de solicitud',
        'proforma-project-forms.BusinessForms': 'Formularios avanzados',
        'proforma-project-forms.CreateForm': 'Crear formulario',
        'proforma-project-forms.Description': "Crea, edita, exporta y elimina formularios. Copia formularios y util\xedzalos en otros proyectos.",
        'proforma-project-forms.Forms': 'Formularios',
        'proforma-project-forms.LearnMore': "M\xe1s informaci\xf3n sobre los formularios.",
        'proforma-project-forms.LoadingForms': 'Cargando...',
        'proforma-project-forms.NoFormsDescriptionJsm': "A\xf1ade formularios para que los clientes los cumplimenten cuando presenten una solicitud o adjunta formularios a las incidencias existentes para recopilar m\xe1s informaci\xf3n.",
        'proforma-project-forms.NoFormsDescriptionJsw': "A\xf1ade formularios para que los clientes los cumplimenten cuando creen una incidencia o adjunta formularios a las incidencias existentes para recopilar m\xe1s informaci\xf3n.",
        'proforma-project-forms.NoFormsDescriptionJwm': "A\xf1ade formularios para que los clientes los cumplimenten cuando creen un elemento o adjunta formularios a las incidencias existentes para recopilar m\xe1s informaci\xf3n.",
        'proforma-project-forms.NoFormsHeading': "Todos tus formularios aparecer\xe1n aqu\xed",
        'proforma-project-forms.NoFormsHeadingAdvanced': "Todos tus formularios avanzados aparecer\xe1n aqu\xed",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "Crear desde la importaci\xf3n",
        'proforma-project-forms.create-form-button.create-blank': 'Crear formulario en blanco',
        'proforma-project-forms.create-form-button.create-from-blank': 'Crear desde cero',
        'proforma-project-forms.create-form-button.create-with-template': 'Crear desde plantilla',
        'proforma-project-forms.create-form-button.trigger': 'Crear formulario'
    };
});
parcelRegister("efqGL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5f72b4050e89126$export$2e2bcd8739ae039);
    var $a5f72b4050e89126$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Muokkaa',
        'form-system.general.Form': 'Nimi',
        'jira-common.ListProjectForms.AffectExistingIssues': "T\xe4m\xe4 ei vaikuta olemassa oleviin asioihin, jotka k\xe4ytt\xe4v\xe4t jo t\xe4t\xe4 lomaketta, tai t\xe4m\xe4n lomakkeen kopioihin muissa projekteissa.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Asiatyyppi',
        'jira-common.ListProjectForms.AssociatedRequestTypes': "Pyynt\xf6tyyppi",
        'jira-common.ListProjectForms.Cancel': 'Peruuta',
        'jira-common.ListProjectForms.Copy': 'Kopioi projektiin',
        'jira-common.ListProjectForms.CopyFormErrorTitle': 'Virhe: lomaketta {formName} ei voitu kopioida',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 projektissa {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Lomake kopioitu liiketoimintaprojektiin} other {Lomake kopioitu {numberOfBusinessProjects,number} liiketoimintaprojektiin}}',
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Lomake kopioitu {numberOfProjects,number} projektiin} other {Lomake kopioitu {numberOfProjects,number} projektiin}}',
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "Lomaketta {formName} voi nyt k\xe4ytt\xe4\xe4 projektissa {projectName}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfServiceProjectsMessage} ja {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfServiceProjectsMessage} ja {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Lomake kopioitu palveluprojektiin} other {Lomake kopioitu {numberOfServiceProjects,number} palveluprojektiin}}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} ja {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfSoftwareProjectsMessage} ja {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Lomake kopioitu ohjelmistoprojektiin} other {Lomake kopioitu {numberOfSoftwareProjects,number} ohjelmistoprojektiin}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 {numberOfProjects,number} projektissa.} other {Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 {numberOfProjects,number} projektissa.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Lomake kopioitu projektiin} other {Lomake kopioitu {numberOfProjects,number} projektiin}}',
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Peruuta',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Kopioi',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Kopioi projekteihin',
        'jira-common.ListProjectForms.CopyModal.Heading': 'Kopioi {formName} muihin projekteihin',
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Lue lis\xe4\xe4 lomakkeiden kopioimisesta",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Ladataan projekteja',
        'jira-common.ListProjectForms.CopyModal.Name': 'Nimi',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Valitse kaikki projektit',
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Lomakkeeseen tehdyt muutokset eiv\xe4t vaikuta sen kopioihin muissa projekteissa.",
        'jira-common.ListProjectForms.CopyText': 'Lomakkeen {formName} kopio',
        'jira-common.ListProjectForms.Delete': 'Poista',
        'jira-common.ListProjectForms.DeleteFormSuccess': '{formName} poistettu',
        'jira-common.ListProjectForms.Duplicate': 'Kopioi',
        'jira-common.ListProjectForms.EmptyFormName': "Nimet\xf6n lomake",
        'jira-common.ListProjectForms.FilterForms': 'Suodata lomakkeita',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '{filename} ladattiin',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "P\xe4ivit\xe4 sivu ja yrit\xe4 uudelleen.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': 'Tiedostoa {filename} ei ladattu',
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% valmiina} other {{percentCount,number}\xa0% valmiina}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': 'Tiedostoa {filename} ladataan',
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Vie XLSX-muodossa',
        'jira-common.ListProjectForms.FormActions.MoreActions': "Lis\xe4\xe4 toimintoja",
        'jira-common.ListProjectForms.FutureIssueMessage': "Tulevat asiat, jotka luodaan k\xe4ytt\xe4en n\xe4it\xe4 asiatyyppej\xe4, eiv\xe4t en\xe4\xe4 sis\xe4ll\xe4 t\xe4t\xe4 lomaketta:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Tulevat pyynn\xf6t, jotka luodaan k\xe4ytt\xe4en n\xe4it\xe4 pyynt\xf6tyyppej\xe4, eiv\xe4t en\xe4\xe4 sis\xe4ll\xe4 t\xe4t\xe4 lomaketta.",
        'jira-common.ListProjectForms.Heading': 'Poistetaanko "{formName}"?',
        'jira-common.ListProjectForms.IssueType': 'Asiatyyppi',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "Hae asiatyyppej\xe4",
        'jira-common.ListProjectForms.LastUpdated': "Viimeksi p\xe4ivitetty",
        'jira-common.ListProjectForms.LearnMoreLink': "Lue lis\xe4\xe4 lomakkeiden poistamisesta.",
        'jira-common.ListProjectForms.RequestType': "Pyynt\xf6tyyppi",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "Hae pyynt\xf6tyyppej\xe4",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "T\xe4m\xe4n lomakkeen poistaminen poistaa sen seuraavista asiatyypeist\xe4:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "T\xe4m\xe4n lomakkeen poistaminen poistaa sen seuraavista pyynt\xf6tyypeist\xe4:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Kopioi suora linkki',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Asiatyyppi',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Pyynt\xf6tyyppi",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} liiketoimintaprojekti} other {{numberOfBusinessProjects,number} liiketoimintaprojektia}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} palveluprojekti} other {{numberOfServiceProjects,number} palveluprojektia}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} ohjelmistoprojekti} other {{numberOfSoftwareProjects,number} ohjelmistoprojektia}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} asiatyyppi\xe4",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} pyynt\xf6tyyppi\xe4",
        'proforma-project-forms.BusinessForms': 'Edistyneet lomakkeet',
        'proforma-project-forms.CreateForm': 'Luo lomake',
        'proforma-project-forms.Description': "Luo, muokkaa, vie ja poista lomakkeita. Kopioi lomakkeita ja k\xe4yt\xe4 niit\xe4 muissa projekteissa.",
        'proforma-project-forms.Forms': 'Lomakkeet',
        'proforma-project-forms.LearnMore': "Lue lis\xe4\xe4 lomakkeista.",
        'proforma-project-forms.LoadingForms': 'Ladataan...',
        'proforma-project-forms.NoFormsDescriptionJsm': "Lis\xe4\xe4 lomakkeita, joita asiakkaat voivat t\xe4ytt\xe4\xe4 tehdess\xe4\xe4n pyynn\xf6n, tai liit\xe4 lomakkeita olemassa oleviin asioihin lis\xe4tietojen ker\xe4\xe4mist\xe4 varten.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Lis\xe4\xe4 lomakkeita, joita asiakkaat voivat t\xe4ytt\xe4\xe4 luodessaan asian, tai liit\xe4 lomakkeita olemassa oleviin asioihin lis\xe4tietojen ker\xe4\xe4mist\xe4 varten.",
        'proforma-project-forms.NoFormsDescriptionJwm': "Lis\xe4\xe4 lomakkeita, joita asiakkaat voivat t\xe4ytt\xe4\xe4 luodessaan teht\xe4v\xe4n, tai liit\xe4 lomakkeita olemassa oleviin asioihin lis\xe4tietojen ker\xe4\xe4mist\xe4 varten.",
        'proforma-project-forms.NoFormsHeading': "Kaikki lomakkeesi n\xe4kyv\xe4t t\xe4\xe4ll\xe4",
        'proforma-project-forms.NoFormsHeadingAdvanced': "Kaikki edistyneet lomakkeesi n\xe4ytet\xe4\xe4n t\xe4ss\xe4",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': 'Luo tuonnista',
        'proforma-project-forms.create-form-button.create-blank': "Luo tyhj\xe4",
        'proforma-project-forms.create-form-button.create-from-blank': "Luo tyhj\xe4st\xe4",
        'proforma-project-forms.create-form-button.create-with-template': 'Luo sivupohjasta',
        'proforma-project-forms.create-form-button.trigger': 'Luo lomake'
    };
});
parcelRegister("aNJ3F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7dd16e948ae0ebc6$export$2e2bcd8739ae039);
    var $7dd16e948ae0ebc6$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Modifier',
        'form-system.general.Form': 'Nom',
        'jira-common.ListProjectForms.AffectExistingIssues': "Cela n'affectera pas les tickets existants qui utilisent d\xe9j\xe0 ce formulaire, ni aucune copie de ce formulaire dans d'autres projets.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Type de ticket',
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Type de demande',
        'jira-common.ListProjectForms.Cancel': 'Annuler',
        'jira-common.ListProjectForms.Copy': 'Copier vers un projet',
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Erreur\xa0: impossible de copier le formulaire \xab\xa0{formName}\xa0\xbb vers le projet",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formulaire copi\xe9 vers le projet m\xe9tier} other {Formulaire copi\xe9 vers {numberOfBusinessProjects,number}\xa0projets m\xe9tier}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formulaire copi\xe9 vers {numberOfProjects,number}\xa0projet} other {Formulaire copi\xe9 vers {numberOfProjects,number}\xa0projets}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans \xab\xa0{projectName}\xa0\xbb.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfServiceProjectsMessage} et {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfServiceProjectsMessage} et {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfServiceProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formulaire copi\xe9 vers le projet de services} other {Formulaire copi\xe9 vers {numberOfServiceProjects,number}\xa0projets de services}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} et {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfSoftwareProjectsMessage} et {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formulaire copi\xe9 vers le projet logiciel} other {Formulaire copi\xe9 vers {numberOfSoftwareProjects,number}\xa0projets logiciels}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfProjects,number}\xa0projet.} other {\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfProjects,number}\xa0projets.}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formulaire copi\xe9 vers le projet} other {Formulaire copi\xe9 vers {numberOfProjects,number}\xa0projets}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Annuler',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Copier',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copier vers un ou plusieurs projets',
        'jira-common.ListProjectForms.CopyModal.Heading': "Copier \xab\xa0{formName}\xa0\xbb vers d'autres projets",
        'jira-common.ListProjectForms.CopyModal.LearnMore': 'En savoir plus sur la copie de formulaires',
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Chargement de projets en cours',
        'jira-common.ListProjectForms.CopyModal.Name': 'Nom',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "S\xe9lectionner tous les projets",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Les changements apport\xe9s \xe0 un formulaire ne sont pas appliqu\xe9s \xe0 ses copies dans d'autres projets.",
        'jira-common.ListProjectForms.CopyText': "Copie de\xa0{formName}",
        'jira-common.ListProjectForms.Delete': 'Supprimer',
        'jira-common.ListProjectForms.DeleteFormSuccess': "\xab\xa0{formName}\xa0\xbb a \xe9t\xe9 supprim\xe9",
        'jira-common.ListProjectForms.Duplicate': 'Dupliquer',
        'jira-common.ListProjectForms.EmptyFormName': 'Formulaire sans titre',
        'jira-common.ListProjectForms.FilterForms': 'Filtrez les formulaires',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\xab\xa0{filename}\xa0\xbb t\xe9l\xe9charg\xe9",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Actualisez la page, puis r\xe9essayez.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\xab\xa0{filename}\xa0\xbb non t\xe9l\xe9charg\xe9",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% termin\xe9} other {{percentCount,number}\xa0% termin\xe9s}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "T\xe9l\xe9chargement de \xab\xa0{filename}\xa0\xbb",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "Exporter au format\xa0XLSX",
        'jira-common.ListProjectForms.FormActions.MoreActions': "Plus d'actions",
        'jira-common.ListProjectForms.FutureIssueMessage': "Les tickets ult\xe9rieurs cr\xe9\xe9s \xe0 l'aide de ces types de ticket ne seront plus inclus dans ce formulaire\xa0:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Les demandes ult\xe9rieures cr\xe9\xe9es \xe0 l'aide de ces types de demande ne seront plus incluses dans ce formulaire.",
        'jira-common.ListProjectForms.Heading': "Supprimer \xab\xa0{formName}\xa0\xbb\xa0?",
        'jira-common.ListProjectForms.IssueType': 'Type de ticket',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Rechercher des types de ticket',
        'jira-common.ListProjectForms.LastUpdated': "Derni\xe8re mise \xe0 jour",
        'jira-common.ListProjectForms.LearnMoreLink': 'En savoir plus sur la suppression de formulaires.',
        'jira-common.ListProjectForms.RequestType': 'Type de demande',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Rechercher des types de demande',
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Si vous supprimez ce formulaire, il sera supprim\xe9 des types de ticket suivants\xa0:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Si vous supprimez ce formulaire, il sera supprim\xe9 des types de demande suivants\xa0:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copier le lien direct',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Type de ticket',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Type de demande',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0projet m\xe9tier} other {{numberOfBusinessProjects,number}\xa0projets m\xe9tier}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0projet de services} other {{numberOfServiceProjects,number}\xa0projets de services}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0projet logiciel} other {{numberOfSoftwareProjects,number}\xa0projets logiciels}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count}\xa0types de tickets",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count}\xa0types de demandes",
        'proforma-project-forms.BusinessForms': "Formulaires avanc\xe9s",
        'proforma-project-forms.CreateForm': "Cr\xe9er un formulaire",
        'proforma-project-forms.Description': "Cr\xe9ez, modifiez, exportez et supprimez des formulaires. Copiez des formulaires et utilisez-les dans d'autres projets.",
        'proforma-project-forms.Forms': 'Formulaires',
        'proforma-project-forms.LearnMore': 'En savoir plus sur les formulaires.',
        'proforma-project-forms.LoadingForms': "Chargement\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "Ajoutez des formulaires que les clients doivent remplir lorsqu'ils cr\xe9ent une demande, ou joignez des formulaires aux tickets existants pour recueillir plus d'informations.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Ajoutez des formulaires que les clients doivent remplir lorsqu'ils cr\xe9ent un ticket, ou joignez des formulaires aux tickets existants pour recueillir plus d'informations.",
        'proforma-project-forms.NoFormsDescriptionJwm': "Ajoutez des formulaires que les clients doivent remplir lorsqu'ils cr\xe9ent un \xe9l\xe9ment, ou joignez des formulaires aux tickets existants pour recueillir plus d'informations.",
        'proforma-project-forms.NoFormsHeading': "Tous vos formulaires s'afficheront ici",
        'proforma-project-forms.NoFormsHeadingAdvanced': "Tous vos formulaires avanc\xe9s s'afficheront ici",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': "Atlassian\xa0Intelligence",
        'proforma-project-forms.create-form-button.convert-form': "Cr\xe9er \xe0 partir de l'importation",
        'proforma-project-forms.create-form-button.create-blank': "Cr\xe9er un formulaire vierge",
        'proforma-project-forms.create-form-button.create-from-blank': "Cr\xe9er \xe0 partir de z\xe9ro",
        'proforma-project-forms.create-form-button.create-with-template': "Cr\xe9er \xe0 partir d'un mod\xe8le",
        'proforma-project-forms.create-form-button.trigger': "Cr\xe9er un formulaire"
    };
});
parcelRegister("8YQ69", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689c56eeda107531$export$2e2bcd8739ae039);
    var $689c56eeda107531$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "Szerkeszt\xe9s",
        'form-system.general.Form': "N\xe9v",
        'jira-common.ListProjectForms.AffectExistingIssues': "Ez nem \xe9rinti azokat a l\xe9tez\u0151 \xfcgyeket, amelyek m\xe1r haszn\xe1lj\xe1k ezt az \u0171rlapot, sem az \u0171rlap m\xe1s projektekben haszn\xe1lt m\xe1solatait.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\xdcgyt\xedpus",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "K\xe9relemt\xedpus",
        'jira-common.ListProjectForms.Cancel': "M\xe9gse",
        'jira-common.ListProjectForms.Copy': "M\xe1sol\xe1s projektbe",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Hiba: Nem siker\xfclt m\xe1solni a k\xf6vetkez\u0151t: \u201E{formName}\u201C",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Az \u0171rlap bem\xe1solva az \xfczleti projektbe} other {Az \u0171rlap bem\xe1solva {numberOfBusinessProjects,number} projektbe}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Az \u0171rlap bem\xe1solva {numberOfProjects,number} projektbe} other {Az \u0171rlap bem\xe1solva {numberOfProjects,number} projektbe}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "A(z) \u201E{formName}\u201C \u0171rlap most m\xe1r haszn\xe1lhat\xf3 ebben a projektben: \u201E{projectName}\u201C.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfServiceProjectsMessage} \xe9s {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfServiceProjectsMessage} \xe9s {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Az \u0171rlap bem\xe1solva az \xfcgyf\xe9lszolg\xe1lati projektbe} other {Az \u0171rlap bem\xe1solva {numberOfServiceProjects,number} \xfcgyf\xe9lszolg\xe1lati projektbe}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} \xe9s {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfSoftwareProjectsMessage} \xe9s {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Az \u0171rlap bem\xe1solva a szoftverprojektbe} other {Az \u0171rlap bem\xe1solva {numberOfSoftwareProjects,number} szoftverprojektbe}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 {numberOfProjects,number} projektben.} other {A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 {numberOfProjects,number} projektben.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Az \u0171rlap bem\xe1solva a projektbe} other {Az \u0171rlap bem\xe1solva {numberOfProjects,number} projektbe}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "M\xe9gse",
        'jira-common.ListProjectForms.CopyModal.Copy': "M\xe1sol\xe1s",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "M\xe1sol\xe1s projekt(ek)be",
        'jira-common.ListProjectForms.CopyModal.Heading': "A(z) \u201E{formName}\u201C \u0171rlap m\xe1sol\xe1sa m\xe1s projektekbe",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Tov\xe1bbi inform\xe1ci\xf3 az \u0171rlapok m\xe1sol\xe1s\xe1r\xf3l",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "Projektek bet\xf6lt\xe9se",
        'jira-common.ListProjectForms.CopyModal.Name': "N\xe9v",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\xd6sszes projekt kijel\xf6l\xe9se",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Az \u0171rlapokon v\xe9grehajtott m\xf3dos\xedt\xe1sok nem jelennek meg a m\xe1s projektekben tal\xe1lhat\xf3 m\xe1solatokban.",
        'jira-common.ListProjectForms.CopyText': "{formName} m\xe1solata",
        'jira-common.ListProjectForms.Delete': "T\xf6rl\xe9s",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u201E{formName}\u201D t\xf6r\xf6lve",
        'jira-common.ListProjectForms.Duplicate': "Duplik\xe1l\xe1s",
        'jira-common.ListProjectForms.EmptyFormName': "C\xedm n\xe9lk\xfcli \u0171rlap",
        'jira-common.ListProjectForms.FilterForms': "\u0170rlapok sz\u0171r\xe9se",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201E{filename}\u201C let\xf6ltve",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Friss\xedtsd az oldalt, majd pr\xf3b\xe1lkozz \xfajra.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201E{filename}\u201C nincs let\xf6ltve",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number} % k\xe9sz} other {{percentCount,number} % k\xe9sz}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u201E{filename}\u201C let\xf6lt\xe9se folyamatban",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "Export\xe1l\xe1s XLSX form\xe1tumban",
        'jira-common.ListProjectForms.FormActions.MoreActions': "Tov\xe1bbi m\u0171veletek",
        'jira-common.ListProjectForms.FutureIssueMessage': "Az ezen \xfcgyt\xedpusok felhaszn\xe1l\xe1s\xe1val l\xe9trehozott, j\xf6v\u0151beni \xfcgyekben m\xe1r nem fog szerepelni ez az \u0171rlap:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Az e k\xe9relemt\xedpusok felhaszn\xe1l\xe1s\xe1val l\xe9trehozott, j\xf6v\u0151beni k\xe9relmekben m\xe1r nem fog szerepelni ez az \u0171rlap.",
        'jira-common.ListProjectForms.Heading': "T\xf6rl\xf6d ezt az \u0171rlapot: \u201E{formName}\u201D?",
        'jira-common.ListProjectForms.IssueType': "\xdcgyt\xedpus",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\xdcgyt\xedpusok keres\xe9se",
        'jira-common.ListProjectForms.LastUpdated': "Utols\xf3 friss\xedt\xe9s",
        'jira-common.ListProjectForms.LearnMoreLink': "Tov\xe1bbi inform\xe1ci\xf3 az \u0171rlapok t\xf6rl\xe9s\xe9r\u0151l.",
        'jira-common.ListProjectForms.RequestType': "K\xe9relemt\xedpus",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "K\xe9relemt\xedpusok keres\xe9se",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Ha t\xf6rl\xf6d ezt az \u0171rlapot, akkor elt\xe1vol\xedtod a k\xf6vetkez\u0151 \xfcgyt\xedpusokb\xf3l:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Ha t\xf6rl\xf6d ezt az \u0171rlapot, akkor elt\xe1vol\xedtod a k\xf6vetkez\u0151 k\xe9relemt\xedpusokb\xf3l:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "K\xf6zvetlen link m\xe1sol\xe1sa",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\xdcgyt\xedpus",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "K\xe9relemt\xedpus",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} \xfczleti projektben} other {{numberOfBusinessProjects,number} \xfczleti projektben}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} \xfcgyf\xe9lszolg\xe1lati projektben} other {{numberOfServiceProjects,number} \xfcgyf\xe9lszolg\xe1lati projektben}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} szoftverprojektben} other {{numberOfSoftwareProjects,number} szoftverprojektben}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \xfcgyt\xedpus",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} k\xe9relemt\xedpus",
        'proforma-project-forms.BusinessForms': "Halad\xf3 \u0171rlapok",
        'proforma-project-forms.CreateForm': "\u0170rlap l\xe9trehoz\xe1sa",
        'proforma-project-forms.Description': "\u0170rlapok l\xe9trehoz\xe1sa, szerkeszt\xe9se, export\xe1l\xe1sa \xe9s t\xf6rl\xe9se. \u0170rlapok m\xe1sol\xe1sa \xe9s felhaszn\xe1l\xe1sa m\xe1s projektekben.",
        'proforma-project-forms.Forms': "\u0170rlapok",
        'proforma-project-forms.LearnMore': "Tov\xe1bbi inform\xe1ci\xf3 az \u0171rlapokr\xf3l.",
        'proforma-project-forms.LoadingForms': "Bet\xf6lt\xe9s\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "Hozz\xe1adhatsz \u0171rlapokat, amelyeket az \xfcgyfelek kit\xf6lthetnek, amikor k\xe9relmet k\xfcldenek be, vagy \u0171rlapokat csatolhatsz a megl\xe9v\u0151 \xfcgyekhez, amelyekr\u0151l szeretn\xe9l tov\xe1bbi inform\xe1ci\xf3t gy\u0171jteni.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Hozz\xe1adhatsz \u0171rlapokat, amelyeket az \xfcgyfelek kit\xf6lthetnek, amikor \xfcgyet hoznak l\xe9tre, vagy \u0171rlapokat csatolhatsz a megl\xe9v\u0151 \xfcgyekhez, amelyekr\u0151l szeretn\xe9l tov\xe1bbi inform\xe1ci\xf3t gy\u0171jteni.",
        'proforma-project-forms.NoFormsDescriptionJwm': "Hozz\xe1adhatsz \u0171rlapokat, amelyeket az \xfcgyfelek kit\xf6lthetnek, amikor l\xe9trehoznak egy t\xe9telt, vagy \u0171rlapokat csatolhatsz a megl\xe9v\u0151 \xfcgyekhez, amelyekr\u0151l szeretn\xe9l tov\xe1bbi inform\xe1ci\xf3t gy\u0171jteni.",
        'proforma-project-forms.NoFormsHeading': "Az \xf6sszes \u0171rlapod itt lesz l\xe1that\xf3",
        'proforma-project-forms.NoFormsHeadingAdvanced': "Az \xf6sszes speci\xe1lis \u0171rlapod itt lesz l\xe1that\xf3",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "L\xe9trehoz\xe1s import\xe1l\xe1sb\xf3l",
        'proforma-project-forms.create-form-button.create-blank': "\xdcres l\xe9trehoz\xe1sa",
        'proforma-project-forms.create-form-button.create-from-blank': "L\xe9trehoz\xe1s \xfcresb\u0151l",
        'proforma-project-forms.create-form-button.create-with-template': "L\xe9trehoz\xe1s sablonb\xf3l",
        'proforma-project-forms.create-form-button.trigger': "\u0170rlap l\xe9trehoz\xe1sa"
    };
});
parcelRegister("lYlPo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fff0221e23db5af7$export$2e2bcd8739ae039);
    var $fff0221e23db5af7$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Modifica',
        'form-system.general.Form': 'Nome',
        'jira-common.ListProjectForms.AffectExistingIssues': "Questa condizione non influisce sui ticket esistenti che gi\xe0 utilizzano questo modulo o su eventuali copie di questo modulo presenti in altri progetti.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Tipo di ticket',
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Tipo di richiesta',
        'jira-common.ListProjectForms.Cancel': 'Annulla',
        'jira-common.ListProjectForms.Copy': 'Copia nel progetto',
        'jira-common.ListProjectForms.CopyFormErrorTitle': 'Errore: impossibile copiare "{formName}" in uno o pi\xf9 progetti',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Modulo copiato nel progetto aziendale} other {Modulo copiato in {numberOfBusinessProjects,number} progetti aziendali}}',
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Modulo copiato in {numberOfProjects,number} progetto} other {Modulo copiato in {numberOfProjects,number} progetti}}',
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" \xe8 ora utilizzabile in "{projectName}".',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfServiceProjectsMessage} e {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfServiceProjectsMessage} e {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Modulo copiato nel progetto del servizio} other {Modulo copiato in {numberOfServiceProjects,number} progetti di service management}}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} e {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfSoftwareProjectsMessage} e {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Modulo copiato nel progetto software} other {Modulo copiato in {numberOfSoftwareProjects,number} progetti software}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" \xe8 ora utilizzabile in {numberOfProjects,number} progetto.} other {"{formName}" \xe8 ora utilizzabile in {numberOfProjects,number} progetti.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Modulo copiato nel progetto} other {Modulo copiato in {numberOfProjects,number} progetti}}',
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Annulla',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Copia',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copia in progetti',
        'jira-common.ListProjectForms.CopyModal.Heading': 'Copia "{formName}" in altri progetti',
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Scopri di pi\xf9 sulla copia dei moduli",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Caricamento di progetti',
        'jira-common.ListProjectForms.CopyModal.Name': 'Nome',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Seleziona tutti i progetti',
        'jira-common.ListProjectForms.CopyModal.SubHeading': 'Le modifiche apportate a un modulo non vengono riportate nelle copie presenti in altri progetti.',
        'jira-common.ListProjectForms.CopyText': 'Copia di {formName}',
        'jira-common.ListProjectForms.Delete': 'Elimina',
        'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" eliminato',
        'jira-common.ListProjectForms.Duplicate': 'Duplica',
        'jira-common.ListProjectForms.EmptyFormName': 'Modulo senza titolo',
        'jira-common.ListProjectForms.FilterForms': 'Filtra moduli',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" scaricato',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Aggiorna la pagina e riprova.',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" non scaricato',
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {{percentCount,number}% completato} other {{percentCount,number}% completati}}',
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': 'Download di "{filename}" in corso',
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Esporta in XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': 'Altre azioni',
        'jira-common.ListProjectForms.FutureIssueMessage': "I ticket futuri creati utilizzando questi tipi di ticket non includeranno pi\xf9 questo modulo:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Le richieste future create utilizzando questi tipi di richiesta non includeranno pi\xf9 questo modulo.",
        'jira-common.ListProjectForms.Heading': 'Vuoi eliminare "{formName}"?',
        'jira-common.ListProjectForms.IssueType': 'Tipo di ticket',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Cerca i tipi di ticket',
        'jira-common.ListProjectForms.LastUpdated': 'Ultimo aggiornamento',
        'jira-common.ListProjectForms.LearnMoreLink': "Scopri di pi\xf9 sull'eliminazione dei moduli.",
        'jira-common.ListProjectForms.RequestType': 'Tipo di richiesta',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Cerca i tipi di richieste',
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "L'eliminazione di questo modulo ne comporter\xe0 la rimozione anche dai seguenti tipi di ticket:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "L'eliminazione di questo modulo ne comporter\xe0 la rimozione anche dai seguenti tipi di richiesta:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copia link diretto',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Tipo di ticket',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Tipo di richiesta',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} progetto aziendale} other {{numberOfBusinessProjects,number} progetti aziendali}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} progetto di servizio} other {{numberOfServiceProjects,number} progetti di servizio}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} progetto software} other {{numberOfSoftwareProjects,number} progetti software}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} tipi di ticket',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} tipi di richiesta',
        'proforma-project-forms.BusinessForms': 'Moduli avanzati',
        'proforma-project-forms.CreateForm': 'Crea modulo',
        'proforma-project-forms.Description': 'Crea, modifica, esporta ed elimina i moduli. Copia i moduli e utilizzali in altri progetti.',
        'proforma-project-forms.Forms': 'Moduli',
        'proforma-project-forms.LearnMore': "Scopri di pi\xf9 sui moduli.",
        'proforma-project-forms.LoadingForms': 'Caricamento in corso...',
        'proforma-project-forms.NoFormsDescriptionJsm': 'Aggiungi moduli che i clienti possono compilare quando inviano una richiesta o allega moduli a ticket esistenti per raccogliere maggiori informazioni.',
        'proforma-project-forms.NoFormsDescriptionJsw': 'Aggiungi moduli che i clienti possono compilare quando creano un ticket o allega moduli a ticket esistenti per raccogliere maggiori informazioni.',
        'proforma-project-forms.NoFormsDescriptionJwm': 'Aggiungi moduli che i clienti possono compilare quando creano un elemento o allega moduli a ticket esistenti per raccogliere maggiori informazioni.',
        'proforma-project-forms.NoFormsHeading': 'Tutti i moduli verranno visualizzati qui',
        'proforma-project-forms.NoFormsHeadingAdvanced': 'Tutti i tuoi moduli avanzati saranno visualizzati qui',
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "Crea dall'importazione",
        'proforma-project-forms.create-form-button.create-blank': 'Crea vuoto',
        'proforma-project-forms.create-form-button.create-from-blank': 'Crea vuoto',
        'proforma-project-forms.create-form-button.create-with-template': 'Crea da modello',
        'proforma-project-forms.create-form-button.trigger': 'Crea modulo'
    };
});
parcelRegister("g1CKL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$baaacce85a1d1012$export$2e2bcd8739ae039);
    var $baaacce85a1d1012$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "\u7DE8\u96C6",
        'form-system.general.Form': "\u540D\u524D",
        'jira-common.ListProjectForms.AffectExistingIssues': "\u3053\u308C\u306F\u3001\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u3059\u3067\u306B\u4F7F\u7528\u3057\u3066\u3044\u308B\u65E2\u5B58\u306E\u8AB2\u984C\u3001\u307E\u305F\u306F\u4ED6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u304A\u3051\u308B\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306E\u30B3\u30D4\u30FC\u306B\u306F\u5F71\u97FF\u3057\u307E\u305B\u3093\u3002",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\u8AB2\u984C\u30BF\u30A4\u30D7",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7",
        'jira-common.ListProjectForms.Cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
        'jira-common.ListProjectForms.Copy': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "\u30A8\u30E9\u30FC:\u300C{formName}\u300D\u3092\u30B3\u30D4\u30FC\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfBusinessProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfBusinessProjects,number} \u4EF6\u306E\u30D3\u30B8\u30CD\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfProjects,number} \u4EF6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u300C{projectName}\u300D\u3067\u300C{formName}\u300D\u3092\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfServiceProjectsMessage} \u3068 {numberOfBusinessProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfServiceProjectsMessage} \u3068 {numberOfSoftwareProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfServiceProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfServiceProjects,number} \u4EF6\u306E\u30B5\u30FC\u30D3\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfServiceProjectsMessage}\u3001{numberOfSoftwareProjectsMessage}\u3001{numberOfBusinessProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfSoftwareProjectsMessage} \u3068 {numberOfBusinessProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfSoftwareProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfSoftwareProjects,number} \u4EF6\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, other {\u300C{formName}\u300D\u3092 {numberOfProjects,number} \u4EF6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfProjects,number} \u4EF6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
        'jira-common.ListProjectForms.CopyModal.Copy': "\u30B3\u30D4\u30FC",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC",
        'jira-common.ListProjectForms.CopyModal.Heading': "\u300C{formName}\u300D\u3092\u4ED6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "\u30D5\u30A9\u30FC\u30E0\u306E\u30B3\u30D4\u30FC\u306B\u95A2\u3059\u308B\u8A73\u7D30",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D",
        'jira-common.ListProjectForms.CopyModal.Name': "\u540D\u524D",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u9078\u629E",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\u30D5\u30A9\u30FC\u30E0\u306B\u52A0\u3048\u305F\u5909\u66F4\u306F\u3001\u4ED6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u3042\u308B\u3059\u3079\u3066\u306E\u3044\u30B3\u30D4\u30FC\u5168\u4F53\u306B\u306F\u53CD\u6620\u3055\u308C\u307E\u305B\u3093\u3002",
        'jira-common.ListProjectForms.CopyText': "{formName} \u306E\u30B3\u30D4\u30FC",
        'jira-common.ListProjectForms.Delete': "\u524A\u9664",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u300C{formName}\u300D\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.Duplicate': "\u8907\u88FD",
        'jira-common.ListProjectForms.EmptyFormName': "\u7121\u984C\u306E\u30D5\u30A9\u30FC\u30E0",
        'jira-common.ListProjectForms.FilterForms': "\u30D5\u30A9\u30FC\u30E0\u3092\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u300C{filename}\u300D\u304C\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u300C{filename}\u300D\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {{percentCount,number} % \u5B8C\u4E86}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u300C{filename}\u300D\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "XLSX \u3067\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
        'jira-common.ListProjectForms.FormActions.MoreActions': "\u305D\u306E\u4ED6\u306E\u64CD\u4F5C",
        'jira-common.ListProjectForms.FutureIssueMessage': "\u4ECA\u5F8C\u3001\u3053\u308C\u3089\u306E\u8AB2\u984C\u30BF\u30A4\u30D7\u3092\u4F7F\u7528\u3057\u3066\u4F5C\u6210\u3057\u305F\u8AB2\u984C\u306B\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306F\u542B\u307E\u308C\u307E\u305B\u3093\u3002",
        'jira-common.ListProjectForms.FutureRequestMessage': "\u4ECA\u5F8C\u3001\u3053\u308C\u3089\u306E\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7\u3092\u4F7F\u7528\u3057\u3066\u4F5C\u6210\u3055\u308C\u305F\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306F\u542B\u307E\u308C\u307E\u305B\u3093\u3002",
        'jira-common.ListProjectForms.Heading': "\u300C{formName}\u300D\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? ",
        'jira-common.ListProjectForms.IssueType': "\u8AB2\u984C\u30BF\u30A4\u30D7",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u8AB2\u984C\u30BF\u30A4\u30D7\u3092\u691C\u7D22",
        'jira-common.ListProjectForms.LastUpdated': "\u6700\u7D42\u66F4\u65B0\u65E5",
        'jira-common.ListProjectForms.LearnMoreLink': "\u30D5\u30A9\u30FC\u30E0\u306E\u524A\u9664\u306B\u95A2\u3059\u308B\u8A73\u7D30\u306B\u3064\u3044\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
        'jira-common.ListProjectForms.RequestType': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7\u3092\u691C\u7D22",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u6B21\u306E\u8AB2\u984C\u30BF\u30A4\u30D7\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u6B21\u306E\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u30C0\u30A4\u30EC\u30AF\u30C8 \u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u8AB2\u984C\u30BF\u30A4\u30D7",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number} \u4EF6\u306E\u30D3\u30B8\u30CD\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\\}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number} \u4EF6\u306E\u30B5\u30FC\u30D3\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number} \u4EF6\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \u500B\u306E\u8AB2\u984C\u30BF\u30A4\u30D7",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} \u500B\u306E\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7",
        'proforma-project-forms.BusinessForms': "\u8A73\u7D30\u306A\u30D5\u30A9\u30FC\u30E0",
        'proforma-project-forms.CreateForm': "\u30D5\u30A9\u30FC\u30E0\u3092\u4F5C\u6210",
        'proforma-project-forms.Description': "\u30D5\u30A9\u30FC\u30E0\u3092\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u3001\u524A\u9664\u3057\u307E\u3059\u3002\u30D5\u30A9\u30FC\u30E0\u3092\u30B3\u30D4\u30FC\u3057\u3066\u3001\u4ED6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u4F7F\u7528\u3057\u307E\u3059\u3002",
        'proforma-project-forms.Forms': "\u30D5\u30A9\u30FC\u30E0",
        'proforma-project-forms.LearnMore': "\u30D5\u30A9\u30FC\u30E0\u306E\u8A73\u7D30\u306B\u3064\u3044\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
        'proforma-project-forms.LoadingForms': "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u767B\u9332\u6642\u306B\u9867\u5BA2\u304C\u8A18\u5165\u3059\u308B\u30D5\u30A9\u30FC\u30E0\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u8AB2\u984C\u306B\u30D5\u30A9\u30FC\u30E0\u3092\u6DFB\u4ED8\u3057\u3066\u8A73\u7D30\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002",
        'proforma-project-forms.NoFormsDescriptionJsw': "\u8AB2\u984C\u306E\u4F5C\u6210\u6642\u306B\u9867\u5BA2\u304C\u8A18\u5165\u3059\u308B\u30D5\u30A9\u30FC\u30E0\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u8AB2\u984C\u306B\u30D5\u30A9\u30FC\u30E0\u3092\u6DFB\u4ED8\u3057\u3066\u8A73\u7D30\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002",
        'proforma-project-forms.NoFormsDescriptionJwm': "\u30A2\u30A4\u30C6\u30E0\u306E\u4F5C\u6210\u6642\u306B\u9867\u5BA2\u304C\u8A18\u5165\u3059\u308B\u30D5\u30A9\u30FC\u30E0\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u8AB2\u984C\u306B\u30D5\u30A9\u30FC\u30E0\u3092\u6DFB\u4ED8\u3057\u3066\u8A73\u7D30\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002",
        'proforma-project-forms.NoFormsHeading': "\u30D5\u30A9\u30FC\u30E0\u306F\u3059\u3079\u3066\u3001\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        'proforma-project-forms.NoFormsHeadingAdvanced': "\u9AD8\u5EA6\u306A\u30D5\u30A9\u30FC\u30E0\u306F\u3059\u3079\u3066\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "\u30A4\u30F3\u30DD\u30FC\u30C8\u304B\u3089\u4F5C\u6210",
        'proforma-project-forms.create-form-button.create-blank': "\u7A7A\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u4F5C\u6210",
        'proforma-project-forms.create-form-button.create-from-blank': "\u767D\u7D19\u304B\u3089\u4F5C\u6210",
        'proforma-project-forms.create-form-button.create-with-template': "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u304B\u3089\u4F5C\u6210",
        'proforma-project-forms.create-form-button.trigger': "\u30D5\u30A9\u30FC\u30E0\u3092\u4F5C\u6210"
    };
});
parcelRegister("7MhDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a9ab1aec4739b55$export$2e2bcd8739ae039);
    var $5a9ab1aec4739b55$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "\uD3B8\uC9D1",
        'form-system.general.Form': "\uC774\uB984",
        'jira-common.ListProjectForms.AffectExistingIssues': "\uC774 \uC591\uC2DD\uC744 \uC774\uBBF8 \uC0AC\uC6A9\uD558\uB294 \uAE30\uC874 \uC774\uC288 \uB610\uB294 \uB2E4\uB978 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC774 \uC591\uC2DD\uC758 \uBCF5\uC0AC\uBCF8\uC5D0\uB294 \uC601\uD5A5\uC744 \uC8FC\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\uC774\uC288 \uC720\uD615",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "\uC694\uCCAD \uC720\uD615",
        'jira-common.ListProjectForms.Cancel': "\uCDE8\uC18C",
        'jira-common.ListProjectForms.Copy': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC",
        'jira-common.ListProjectForms.CopyFormErrorTitle': '\uC624\uB958: "{formName}"\uC744(\uB97C) \uBCF5\uC0AC\uD560 \uC218 \uC5C6\uC74C',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '\uC774\uC81C {numberOfBusinessProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\uC591\uC2DD\uC774 {numberOfBusinessProjects,number}\uAC1C\uC758 \uBE44\uC988\uB2C8\uC2A4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\uC591\uC2DD\uC774 {numberOfProjects,number}\uAC1C\uC758 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '\uC774\uC81C "{projectName}"\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '\uC774\uC81C {numberOfServiceProjectsMessage} \uBC0F {numberOfBusinessProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '\uC774\uC81C {numberOfServiceProjectsMessage} \uBC0F {numberOfSoftwareProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '\uC774\uC81C {numberOfServiceProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\uC591\uC2DD\uC774 {numberOfServiceProjects,number}\uAC1C\uC758 \uC11C\uBE44\uC2A4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '\uC774\uC81C {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} \uBC0F {numberOfBusinessProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '\uC774\uC81C {numberOfSoftwareProjectsMessage} \uBC0F {numberOfBusinessProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '\uC774\uC81C {numberOfSoftwareProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\uC591\uC2DD\uC774 {numberOfSoftwareProjects,number}\uAC1C\uC758 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, other {\uC774\uC81C {numberOfProjects,number}\uAC1C\uC758 \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\uC591\uC2DD\uC774 {numberOfProjects,number}\uAC1C\uC758 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\uCDE8\uC18C",
        'jira-common.ListProjectForms.CopyModal.Copy': "\uBCF5\uC0AC",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC",
        'jira-common.ListProjectForms.CopyModal.Heading': '"{formName}"\uC744(\uB97C) \uB2E4\uB978 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC',
        'jira-common.ListProjectForms.CopyModal.LearnMore': "\uC591\uC2DD \uBCF5\uC0AC\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\uD504\uB85C\uC81D\uD2B8 \uB85C\uB4DC \uC911",
        'jira-common.ListProjectForms.CopyModal.Name': "\uC774\uB984",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\uBAA8\uB4E0 \uD504\uB85C\uC81D\uD2B8 \uC120\uD0DD",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\uC591\uC2DD\uC5D0 \uB300\uD55C \uBCC0\uACBD \uC0AC\uD56D\uC740 \uB2E4\uB978 \uD504\uB85C\uC81D\uD2B8\uC758 \uBCF5\uC0AC\uBCF8\uC5D0 \uBC18\uC601\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
        'jira-common.ListProjectForms.CopyText': "{formName} \uBCF5\uC0AC\uBCF8",
        'jira-common.ListProjectForms.Delete': "\uC0AD\uC81C",
        'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" \uC0AD\uC81C\uB428',
        'jira-common.ListProjectForms.Duplicate': "\uBCF5\uC81C",
        'jira-common.ListProjectForms.EmptyFormName': "\uC81C\uBAA9 \uC5C6\uB294 \uC591\uC2DD",
        'jira-common.ListProjectForms.FilterForms': "\uC591\uC2DD \uD544\uD130\uB9C1",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}"\uC774(\uAC00) \uB2E4\uC6B4\uB85C\uB4DC\uB428',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}"\uC744(\uB97C) \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC9C0 \uBABB\uD568',
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {{percentCount,number}% \uC644\uB8CC}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': '"{filename}" \uB2E4\uC6B4\uB85C\uB4DC \uC911',
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "XLSX\uB85C \uB0B4\uBCF4\uB0B4\uAE30",
        'jira-common.ListProjectForms.FormActions.MoreActions': "\uCD94\uAC00 \uC791\uC5C5",
        'jira-common.ListProjectForms.FutureIssueMessage': "\uC774\uB7EC\uD55C \uC774\uC288 \uC720\uD615\uC744 \uC0AC\uC6A9\uD558\uC5EC \uB9CC\uB4E0 \uD5A5\uD6C4 \uC774\uC288\uC5D0\uB294 \uB354 \uC774\uC0C1 \uC774 \uC591\uC2DD\uC774 \uD3EC\uD568\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
        'jira-common.ListProjectForms.FutureRequestMessage': "\uC774\uB7EC\uD55C \uC694\uCCAD \uC720\uD615\uC744 \uC0AC\uC6A9\uD558\uC5EC \uB9CC\uB4E0 \uD5A5\uD6C4 \uC694\uCCAD\uC5D0\uB294 \uB354 \uC774\uC0C1 \uC774 \uC591\uC2DD\uC774 \uD3EC\uD568\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
        'jira-common.ListProjectForms.Heading': '"{formName}"\uC744(\uB97C) \uC0AD\uC81C\uD558\uACA0\uC2B5\uB2C8\uAE4C?',
        'jira-common.ListProjectForms.IssueType': "\uC774\uC288 \uC720\uD615",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\uC774\uC288 \uC720\uD615 \uAC80\uC0C9",
        'jira-common.ListProjectForms.LastUpdated': "\uCD5C\uADFC \uC5C5\uB370\uC774\uD2B8",
        'jira-common.ListProjectForms.LearnMoreLink': "\uC591\uC2DD \uC0AD\uC81C\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.",
        'jira-common.ListProjectForms.RequestType': "\uC694\uCCAD \uC720\uD615",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "\uC694\uCCAD \uC720\uD615 \uAC80\uC0C9",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\uC774 \uC591\uC2DD\uC744 \uC0AD\uC81C\uD558\uBA74 \uB2E4\uC74C\uACFC \uAC19\uC740 \uC774\uC288 \uC720\uD615\uC5D0\uC11C\uB3C4 \uC81C\uAC70\uB429\uB2C8\uB2E4.",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\uC774 \uC591\uC2DD\uC744 \uC0AD\uC81C\uD558\uBA74 \uB2E4\uC74C\uACFC \uAC19\uC740 \uC694\uCCAD \uC720\uD615\uC5D0\uC11C\uB3C4 \uC81C\uAC70\uB429\uB2C8\uB2E4.",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\uC9C1\uC811 \uB9C1\uD06C \uBCF5\uC0AC",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\uC774\uC288 \uC720\uD615",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\uC694\uCCAD \uC720\uD615",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number}\uAC1C\uC758 \uBE44\uC988\uB2C8\uC2A4 \uD504\uB85C\uC81D\uD2B8}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number}\uAC1C\uC758 \uC11C\uBE44\uC2A4 \uD504\uB85C\uC81D\uD2B8}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number}\uAC1C\uC758 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uD504\uB85C\uC81D\uD2B8}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "\uC774\uC288 \uC720\uD615 {count}\uAC1C",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "\uC694\uCCAD \uC720\uD615 {count}\uAC1C",
        'proforma-project-forms.BusinessForms': "\uACE0\uAE09 \uC591\uC2DD",
        'proforma-project-forms.CreateForm': "\uC591\uC2DD \uB9CC\uB4E4\uAE30",
        'proforma-project-forms.Description': "\uC591\uC2DD\uC744 \uB9CC\uB4E4\uACE0, \uD3B8\uC9D1\uD558\uACE0, \uB0B4\uBCF4\uB0B4\uACE0, \uC0AD\uC81C\uD569\uB2C8\uB2E4. \uC591\uC2DD\uC744 \uBCF5\uC0AC\uD558\uC5EC \uB2E4\uB978 \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C \uC0AC\uC6A9\uD569\uB2C8\uB2E4.",
        'proforma-project-forms.Forms': "\uC591\uC2DD",
        'proforma-project-forms.LearnMore': "\uC591\uC2DD\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.",
        'proforma-project-forms.LoadingForms': "\uB85C\uB4DC \uC911\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "\uC694\uCCAD\uC744 \uC81C\uAE30\uD560 \uB54C \uACE0\uAC1D\uC774 \uC791\uC131\uD560 \uC591\uC2DD\uC744 \uCD94\uAC00\uD558\uAC70\uB098, \uB354 \uB9CE\uC740 \uC815\uBCF4\uB97C \uC218\uC9D1\uD558\uAE30 \uC704\uD574 \uAE30\uC874 \uC774\uC288\uC5D0 \uC591\uC2DD\uC744 \uCCA8\uBD80\uD558\uC138\uC694.",
        'proforma-project-forms.NoFormsDescriptionJsw': "\uC774\uC288\uB97C \uB9CC\uB4E4 \uB54C \uACE0\uAC1D\uC774 \uC791\uC131\uD560 \uC591\uC2DD\uC744 \uCD94\uAC00\uD558\uAC70\uB098, \uB354 \uB9CE\uC740 \uC815\uBCF4\uB97C \uC218\uC9D1\uD558\uAE30 \uC704\uD574 \uAE30\uC874 \uC774\uC288\uC5D0 \uC591\uC2DD\uC744 \uCCA8\uBD80\uD558\uC138\uC694.",
        'proforma-project-forms.NoFormsDescriptionJwm': "\uD56D\uBAA9\uC744 \uB9CC\uB4E4 \uB54C \uACE0\uAC1D\uC774 \uC791\uC131\uD560 \uC591\uC2DD\uC744 \uCD94\uAC00\uD558\uAC70\uB098, \uB354 \uB9CE\uC740 \uC815\uBCF4\uB97C \uC218\uC9D1\uD558\uAE30 \uC704\uD574 \uAE30\uC874 \uC774\uC288\uC5D0 \uC591\uC2DD\uC744 \uCCA8\uBD80\uD558\uC138\uC694.",
        'proforma-project-forms.NoFormsHeading': "\uBAA8\uB4E0 \uC591\uC2DD\uC740 \uC5EC\uAE30\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4",
        'proforma-project-forms.NoFormsHeadingAdvanced': "\uBAA8\uB4E0 \uACE0\uAE09 \uC591\uC2DD\uC740 \uC5EC\uAE30\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "\uAC00\uC838\uC624\uAE30\uC5D0\uC11C \uB9CC\uB4E4\uAE30",
        'proforma-project-forms.create-form-button.create-blank': "\uBE48 \uC591\uC2DD \uB9CC\uB4E4\uAE30",
        'proforma-project-forms.create-form-button.create-from-blank': "\uC0C8\uB85C \uB9CC\uB4E4\uAE30",
        'proforma-project-forms.create-form-button.create-with-template': "\uD15C\uD50C\uB9BF\uC5D0\uC11C \uB9CC\uB4E4\uAE30",
        'proforma-project-forms.create-form-button.trigger': "\uC591\uC2DD \uB9CC\uB4E4\uAE30"
    };
});
parcelRegister("KEmmm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08c39a936abe93a2$export$2e2bcd8739ae039);
    var $08c39a936abe93a2$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Rediger',
        'form-system.general.Form': 'Navn',
        'jira-common.ListProjectForms.AffectExistingIssues': "Dette vil ikke p\xe5virke eksisterende saker som allerede bruker dette skjemaet, eller kopier av dette skjemaet i andre prosjekter.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Sakstype',
        'jira-common.ListProjectForms.AssociatedRequestTypes': "Foresp\xf8rselstype",
        'jira-common.ListProjectForms.Cancel': 'Avbryt',
        'jira-common.ListProjectForms.Copy': 'Kopier til prosjekt',
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Feil: Kan ikke kopiere over \xab{formName}\xbb",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Skjema kopiert til forretningsprosjekt} other {Skjema kopiert til {numberOfBusinessProjects,number} forretningsprosjekter}}',
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Skjema kopiert til {numberOfProjects,number} prosjekt} other {Skjema kopiert til {numberOfProjects,number} prosjekter}}',
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\xab{formName}\xbb kan n\xe5 brukes i \xab{projectName}\xbb.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfServiceProjectsMessage} og {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfServiceProjectsMessage} og {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfServiceProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Skjema kopiert til serviceprosjekt} other {Skjema kopiert til {numberOfServiceProjects,number} serviceprosjekter}}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} og {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfSoftwareProjectsMessage} og {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Skjema kopiert til programvareprosjekt} other {Skjema kopiert til {numberOfSoftwareProjects,number} programvareprosjekter}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\xab{formName}\xbb kan n\xe5 brukes i {numberOfProjects,number} prosjekt.} other {\xab{formName}\xbb kan n\xe5 brukes i {numberOfProjects,number} prosjekter.}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Skjema kopiert til prosjekt} other {Skjema kopiert til {numberOfProjects,number} prosjekter}}',
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Avbryt',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Kopier',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Kopier til prosjekt(er)',
        'jira-common.ListProjectForms.CopyModal.Heading': "Kopier \xab{formName}\xbb til andre prosjekter",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Finn ut mer om \xe5 kopiere skjemaer",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Laster inn prosjekter',
        'jira-common.ListProjectForms.CopyModal.Name': 'Navn',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Velg alle prosjekter',
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Endringer som gj\xf8res i ett skjema, blir ikke reprodusert i skjemaets kopier i andre prosjekter.",
        'jira-common.ListProjectForms.CopyText': 'Kopi av {formName}',
        'jira-common.ListProjectForms.Delete': 'Slett',
        'jira-common.ListProjectForms.DeleteFormSuccess': "\xab{formName}\xbb er slettet",
        'jira-common.ListProjectForms.Duplicate': 'Dupliser',
        'jira-common.ListProjectForms.EmptyFormName': 'Skjema uten tittel',
        'jira-common.ListProjectForms.FilterForms': 'Filtrer skjemaer',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\xab{filename}\xbb er lastet ned",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Oppdater siden og pr\xf8v p\xe5 nytt.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\xab{filename}\xbb ble ikke lastet ned",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% fullf\xf8rt} other {{percentCount,number}\xa0% fullf\xf8rt}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Laster ned \xab{filename}\xbb",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Eksporter til XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': 'Flere handlinger',
        'jira-common.ListProjectForms.FutureIssueMessage': 'Fremtidige saker som blir opprettet med disse sakstypene, vil ikke lenger inkludere dette skjemaet:',
        'jira-common.ListProjectForms.FutureRequestMessage': "Fremtidige foresp\xf8rsler opprettet med disse foresp\xf8rselstypene vil ikke lenger inkludere dette skjemaet.",
        'jira-common.ListProjectForms.Heading': "Vil du slette \xab{formName}\xbb?",
        'jira-common.ListProjectForms.IssueType': 'Sakstype',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "S\xf8k etter sakstyper",
        'jira-common.ListProjectForms.LastUpdated': 'Sist oppdatert',
        'jira-common.ListProjectForms.LearnMoreLink': "Finn ut mer om \xe5 slette skjema.",
        'jira-common.ListProjectForms.RequestType': "Type foresp\xf8rsel",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "S\xf8k etter foresp\xf8rselstyper",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Hvis du sletter dette skjemaet, fjernes det fra f\xf8lgende sakstyper:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Hvis du sletter dette skjemaet, fjernes det fra f\xf8lgende foresp\xf8rselstyper:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Kopier direktekobling',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Sakstype',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Type foresp\xf8rsel",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} forretningsprosjekt} other {{numberOfBusinessProjects,number} forretningsprosjekter}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} serviceprosjekt} other {{numberOfServiceProjects,number} serviceprosjekter}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} programvareprosjekt} other {{numberOfSoftwareProjects,number} programvareprosjekter}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} sakstyper',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} foresp\xf8rselstyper",
        'proforma-project-forms.BusinessForms': 'Avanserte skjemaer',
        'proforma-project-forms.CreateForm': 'Opprett skjema',
        'proforma-project-forms.Description': 'Opprett, rediger, eksporter og slett skjemaer. Kopier skjemaer og bruk dem i andre prosjekter.',
        'proforma-project-forms.Forms': 'Skjemaer',
        'proforma-project-forms.LearnMore': 'Finn ut mer om skjemaer.',
        'proforma-project-forms.LoadingForms': "Laster inn\xa0\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "Legg til skjemaer kunder kan fylle ut n\xe5r de sender inn en foresp\xf8rsel, eller legg til skjemaer i eksisterende saker for \xe5 innhente mer informasjon.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Legg til skjemaer kunder kan fylle ut n\xe5r de oppretter et sak, eller legg til skjemaer i eksisterende saker for \xe5 innhente mer informasjon.",
        'proforma-project-forms.NoFormsDescriptionJwm': "Legg til skjemaer kunder kan fylle ut n\xe5r de oppretter et element, eller legg til skjemaer i eksisterende saker for \xe5 innhente mer informasjon.",
        'proforma-project-forms.NoFormsHeading': 'Alle skjemaene dine vises her',
        'proforma-project-forms.NoFormsHeadingAdvanced': 'Alle de avanserte skjemaene dine vises her',
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': 'Opprett fra import',
        'proforma-project-forms.create-form-button.create-blank': 'Opprett tomt',
        'proforma-project-forms.create-form-button.create-from-blank': 'Opprett fra tomt',
        'proforma-project-forms.create-form-button.create-with-template': 'Opprett fra mal',
        'proforma-project-forms.create-form-button.trigger': 'Opprett skjema'
    };
});
parcelRegister("asac5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79c46d3535969c07$export$2e2bcd8739ae039);
    var $79c46d3535969c07$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Bewerken',
        'form-system.general.Form': 'Naam',
        'jira-common.ListProjectForms.AffectExistingIssues': "Dit heeft geen effect op bestaande issues die al gebruikmaken van dit formulier, of op kopie\xebn van dit formulier in andere projecten.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Issuetype',
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Aanvraagtype',
        'jira-common.ListProjectForms.Cancel': 'Annuleren',
        'jira-common.ListProjectForms.Copy': "Kopi\xebren naar project",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Fout: {formName} kopi\xebren is mislukt",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Formulier gekopieerd naar zakelijk project} other {Formulier gekopieerd naar {numberOfBusinessProjects,number} zakelijke projecten}}',
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Formulier gekopieerd naar {numberOfProjects,number} project} other {Formulier gekopieerd naar {numberOfProjects,number} projecten}}',
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '{formName} kan nu gebruikt worden in {projectName}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfServiceProjectsMessage} en {numberOfBusinessProjectsMessage}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfServiceProjectsMessage} en {numberOfSoftwareProjectsMessage}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfServiceProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Formulier gekopieerd naar serviceproject} other {Formulier gekopieerd naar {numberOfServiceProjects,number} serviceprojecten}}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} en {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfSoftwareProjectsMessage} en {numberOfBusinessProjectsMessage}",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Formulier gekopieerd naar softwareproject} other {Formulier gekopieerd naar {numberOfSoftwareProjects,number} softwareprojecten}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {''{formName}' kan nu gebruikt worden in {numberOfProjects,number} project.} other {''{formName}' kan nu gebruikt worden in {numberOfProjects,number} projecten.}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Formulier gekopieerd naar project} other {Formulier gekopieerd naar {numberOfProjects,number} projecten}}',
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Annuleren',
        'jira-common.ListProjectForms.CopyModal.Copy': "Kopi\xebren",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Naar project(en) kopi\xebren",
        'jira-common.ListProjectForms.CopyModal.Heading': "{formName} naar andere projecten kopi\xebren",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Meer informatie over het kopi\xebren van formulieren",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Bezig met laden van projecten',
        'jira-common.ListProjectForms.CopyModal.Name': 'Naam',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Alle projecten selecteren',
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Wijzigingen aan een formulier worden niet weergegeven in de kopie\xebn ervan in andere projecten.",
        'jira-common.ListProjectForms.CopyText': '{formName} (kopie)',
        'jira-common.ListProjectForms.Delete': 'Verwijderen',
        'jira-common.ListProjectForms.DeleteFormSuccess': '{formName} is verwijderd',
        'jira-common.ListProjectForms.Duplicate': 'Dupliceren',
        'jira-common.ListProjectForms.EmptyFormName': 'Formulier zonder titel',
        'jira-common.ListProjectForms.FilterForms': 'Formulieren filteren',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '{filename} gedownload',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Vernieuw de pagina en probeer het opnieuw.',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '{filename} niet gedownload',
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {{percentCount,number}% voltooid} other {{percentCount,number}% voltooid}}',
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': '{filename} downloaden',
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'In XLSX exporteren',
        'jira-common.ListProjectForms.FormActions.MoreActions': 'Meer acties',
        'jira-common.ListProjectForms.FutureIssueMessage': 'Toekomstige issues die aangemaakt worden met dit issuetype zullen niet langer dit formulier bevatten:',
        'jira-common.ListProjectForms.FutureRequestMessage': 'Toekomstige aanvragen die aangemaakt worden met dit aanvraagtype zullen niet langer dit formulier bevatten.',
        'jira-common.ListProjectForms.Heading': '"{formName}" verwijderen?',
        'jira-common.ListProjectForms.IssueType': 'Issuetype',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Issuetypen zoeken',
        'jira-common.ListProjectForms.LastUpdated': 'Laatst bijgewerkt',
        'jira-common.ListProjectForms.LearnMoreLink': 'Meer informatie over het verwijderen van formulieren.',
        'jira-common.ListProjectForms.RequestType': 'Aanvraagtype',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Aanvraagtypen zoeken',
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': 'Als je dit formulier verwijdert, wordt het verwijderd uit de volgende issuetypen:',
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': 'Als je dit formulier verwijdert, wordt het verwijderd uit de volgende aanvraagtypen:',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Rechtstreekse link kopi\xebren",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Issuetype',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Aanvraagtype',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} zakelijk project} other {{numberOfBusinessProjects,number} zakelijke projecten}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} serviceproject} other {{numberOfServiceProjects,number} serviceprojecten}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} softwareproject} other {{numberOfSoftwareProjects,number} softwareprojecten}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} issuetypen',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} aanvraagtypen',
        'proforma-project-forms.BusinessForms': 'Geavanceerde formulieren',
        'proforma-project-forms.CreateForm': 'Formulier aanmaken',
        'proforma-project-forms.Description': 'Formulieren aanmaken, bewerken, exporteren en verwijderen. Kopieer formulieren en gebruik ze bij andere projecten.',
        'proforma-project-forms.Forms': 'Formulieren',
        'proforma-project-forms.LearnMore': 'Meer informatie over formulieren.',
        'proforma-project-forms.LoadingForms': 'Bezig met laden ...',
        'proforma-project-forms.NoFormsDescriptionJsm': 'Voeg formulieren voor klanten toe bij het aanmaken van een aanvraag, of voeg formulieren toe aan bestaande issues om meer informatie te verkrijgen.',
        'proforma-project-forms.NoFormsDescriptionJsw': 'Voeg formulieren voor klanten toe bij het aanmaken van een issue, of voeg formulieren toe aan bestaande issues om meer informatie te verkrijgen.',
        'proforma-project-forms.NoFormsDescriptionJwm': 'Voeg formulieren voor klanten toe bij het aanmaken van een item, of voeg formulieren toe aan bestaande issues om meer informatie te verkrijgen.',
        'proforma-project-forms.NoFormsHeading': 'Al je formulieren verschijnen hier',
        'proforma-project-forms.NoFormsHeadingAdvanced': 'Al je geavanceerde formulieren verschijnen hier',
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': 'Aanmaken uit import',
        'proforma-project-forms.create-form-button.create-blank': 'Een leeg formulier aanmaken',
        'proforma-project-forms.create-form-button.create-from-blank': 'Aanmaken uit lege',
        'proforma-project-forms.create-form-button.create-with-template': 'Aanmaken op basis van sjabloon',
        'proforma-project-forms.create-form-button.trigger': 'Formulier aanmaken'
    };
});
parcelRegister("fW5Kc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9a0ba7b1896ef31$export$2e2bcd8739ae039);
    var $b9a0ba7b1896ef31$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Edytuj',
        'form-system.general.Form': 'Nazwa',
        'jira-common.ListProjectForms.AffectExistingIssues': "Nie b\u0119dzie to mia\u0142o wp\u0142ywu na istniej\u0105ce zg\u0142oszenia, w kt\xf3rych ju\u017C u\u017Cyto tego formularza, ani na \u017Cadne kopie tego formularza w innych projektach.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "Typ zg\u0142oszenia",
        'jira-common.ListProjectForms.AssociatedRequestTypes': 'Typ wniosku',
        'jira-common.ListProjectForms.Cancel': 'Anuluj',
        'jira-common.ListProjectForms.Copy': 'Kopiuj do projektu',
        'jira-common.ListProjectForms.CopyFormErrorTitle': "B\u0142\u0105d: Nie mo\u017Cna przekopiowa\u0107 formularza \u201E{formName}\u201D",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Skopiowano formularz do projektu biznesowego} few {Skopiowano formularz do {numberOfBusinessProjects,number} projekt\xf3w biznesowych} many {Skopiowano formularz do {numberOfBusinessProjects,number} projekt\xf3w biznesowych} other {Skopiowano formularz do {numberOfBusinessProjects,number} projektu biznesowego}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Skopiowano formularz do {numberOfProjects,number} projektu} few {Skopiowano formularz do {numberOfProjects,number} projekt\xf3w} many {Skopiowano formularz do {numberOfProjects,number} projekt\xf3w} other {Skopiowano formularz do {numberOfProjects,number} projektu}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "Formularza \u201E{formName}\u201D mo\u017Cna teraz u\u017Cywa\u0107 w\xa0projekcie \u201E{projectName}\u201D.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfServiceProjectsMessage} i {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfServiceProjectsMessage} i {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Skopiowano formularz do projektu us\u0142ugowego} few {Skopiowano formularz do {numberOfServiceProjects,number} projekt\xf3w us\u0142ugowych} many {Skopiowano formularz do {numberOfServiceProjects,number} projekt\xf3w us\u0142ugowych} other {Skopiowano formularz do {numberOfServiceProjects,number} projektu us\u0142ugowego}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} i {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfSoftwareProjectsMessage} i {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Skopiowano formularz do projektu oprogramowania} few {Skopiowano formularz do {numberOfSoftwareProjects,number} projekt\xf3w oprogramowania} many {Skopiowano formularz do {numberOfSoftwareProjects,number} projekt\xf3w oprogramowania} other {Skopiowano formularz do {numberOfSoftwareProjects,number} projektu oprogramowania}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfProjects,number} projekcie.} few {Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfProjects,number} projektach.} many {Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfProjects,number} projektach.} other {Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfProjects,number} projektu.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Skopiowano formularz do projektu} few {Skopiowano formularz do {numberOfProjects,number} projekt\xf3w} many {Skopiowano formularz do {numberOfProjects,number} projekt\xf3w} other {Skopiowano formularz do {numberOfProjects,number} projektu}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Anuluj',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Kopiuj',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Kopiuj do projekt\xf3w",
        'jira-common.ListProjectForms.CopyModal.Heading': "Kopiuj formularz \u201E{formName}\u201D do innych projekt\xf3w",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Dowiedz si\u0119 wi\u0119cej o kopiowaniu formularzy",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0141adowanie projekt\xf3w",
        'jira-common.ListProjectForms.CopyModal.Name': 'Nazwa',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Wybierz wszystkie projekty',
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Zmiany wprowadzone w formularzu nie s\u0105 odzwierciedlane w \u017Cadnej z jego kopii w innych projektach.",
        'jira-common.ListProjectForms.CopyText': "{formName} \u2014 kopia",
        'jira-common.ListProjectForms.Delete': "Usu\u0144",
        'jira-common.ListProjectForms.DeleteFormSuccess': "Usuni\u0119to formularz \u201E{formName}\u201D",
        'jira-common.ListProjectForms.Duplicate': 'Duplikuj',
        'jira-common.ListProjectForms.EmptyFormName': 'Formularz bez nazwy',
        'jira-common.ListProjectForms.FilterForms': 'Filtruj formularze',
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "Pobrano plik \u201E{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Od\u015Bwie\u017C stron\u0119 i spr\xf3buj ponownie.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "Nie pobrano pliku \u201E{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {Uko\u0144czono {percentCount,number}%} few {Uko\u0144czono {percentCount,number}%} many {Uko\u0144czono {percentCount,number}%} other {Uko\u0144czono {percentCount,number}%}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Pobieranie pliku \u201E{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Eksportuj do pliku XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': "Wi\u0119cej czynno\u015Bci",
        'jira-common.ListProjectForms.FutureIssueMessage': "Przysz\u0142e zg\u0142oszenia utworzone przy u\u017Cyciu tych typ\xf3w zg\u0142osze\u0144 nie b\u0119d\u0105 ju\u017C zawiera\u0142y tego formularza:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Przysz\u0142e wnioski utworzone przy u\u017Cyciu tych typ\xf3w wniosk\xf3w nie b\u0119d\u0105 ju\u017C uwzgl\u0119dnia\u0107 tego formularza.",
        'jira-common.ListProjectForms.Heading': "Czy usun\u0105\u0107 formularz \u201E{formName}\u201D?",
        'jira-common.ListProjectForms.IssueType': "Typ zg\u0142oszenia",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "Wyszukaj typy zg\u0142osze\u0144",
        'jira-common.ListProjectForms.LastUpdated': 'Ostatnia aktualizacja',
        'jira-common.ListProjectForms.LearnMoreLink': "Dowiedz si\u0119 wi\u0119cej o usuwaniu formularzy.",
        'jira-common.ListProjectForms.RequestType': 'Typ wniosku',
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "Wyszukaj typy wniosk\xf3w",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Usuni\u0119cie tego formularza spowoduje usuni\u0119cie go z nast\u0119puj\u0105cych typ\xf3w zg\u0142osze\u0144:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Usuni\u0119cie tego formularza spowoduje usuni\u0119cie go z nast\u0119puj\u0105cych typ\xf3w wniosk\xf3w:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Kopiuj \u0142\u0105cze bezpo\u015Brednie",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "Typ zg\u0142oszenia",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Typ wniosku',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} projekcie biznesowym} few {{numberOfBusinessProjects,number} projektach biznesowych} many {{numberOfBusinessProjects,number} projektach biznesowych} other {{numberOfBusinessProjects,number} projektu biznesowego}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} projekcie us\u0142ugowym} few {{numberOfServiceProjects,number} projektach us\u0142ugowych} many {{numberOfServiceProjects,number} projektach us\u0142ugowych} other {{numberOfServiceProjects,number} projektu us\u0142ugowego}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} projekcie oprogramowania} few {{numberOfSoftwareProjects,number} projektach oprogramowania} many {{numberOfSoftwareProjects,number} projektach oprogramowania} other {{numberOfSoftwareProjects,number} projektu oprogramowania}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "Typy zg\u0142osze\u0144: {count}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "Typy zapyta\u0144: {count}",
        'proforma-project-forms.BusinessForms': 'Formularze zaawansowane',
        'proforma-project-forms.CreateForm': "Utw\xf3rz formularz",
        'proforma-project-forms.Description': "Tw\xf3rz, edytuj, eksportuj i usuwaj formularze. Kopiuj formularze i u\u017Cywaj ich w innych projektach.",
        'proforma-project-forms.Forms': 'Formularze',
        'proforma-project-forms.LearnMore': "Dowiedz si\u0119 wi\u0119cej na temat formularzy.",
        'proforma-project-forms.LoadingForms': "\u0141adowanie\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "Dodawaj formularze, kt\xf3re klienci mog\u0105 wype\u0142ni\u0107 podczas zg\u0142aszania wniosku, lub do\u0142\u0105czaj formularze do istniej\u0105cych zg\u0142osze\u0144, aby zebra\u0107 wi\u0119cej informacji.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Dodawaj formularze, kt\xf3re klienci mog\u0105 wype\u0142ni\u0107 podczas tworzenia zg\u0142oszenia, lub do\u0142\u0105czaj formularze do istniej\u0105cych zg\u0142osze\u0144, aby zebra\u0107 wi\u0119cej informacji.",
        'proforma-project-forms.NoFormsDescriptionJwm': "Dodawaj formularze, kt\xf3re klienci mog\u0105 wype\u0142ni\u0107 podczas tworzenia elementu, lub do\u0142\u0105czaj formularze do istniej\u0105cych zg\u0142osze\u0144, aby zebra\u0107 wi\u0119cej informacji.",
        'proforma-project-forms.NoFormsHeading': "Wszystkie Twoje formularze b\u0119d\u0105 pojawia\u0107 si\u0119 tutaj",
        'proforma-project-forms.NoFormsHeadingAdvanced': "Wszystkie Twoje zaawansowane formularze b\u0119d\u0105 pojawia\u0107 si\u0119 tutaj",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "Utw\xf3rz z\xa0importu",
        'proforma-project-forms.create-form-button.create-blank': "Utw\xf3rz pusty",
        'proforma-project-forms.create-form-button.create-from-blank': "Utw\xf3rz z\xa0pustego",
        'proforma-project-forms.create-form-button.create-with-template': "Utw\xf3rz z szablonu",
        'proforma-project-forms.create-form-button.trigger': "Utw\xf3rz formularz"
    };
});
parcelRegister("29KrS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$192073c177673809$export$2e2bcd8739ae039);
    var $192073c177673809$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Editar',
        'form-system.general.Form': 'Nome',
        'jira-common.ListProjectForms.AffectExistingIssues': "Itens existentes que j\xe1 usam este formul\xe1rio ou c\xf3pias deste formul\xe1rio em outros projetos n\xe3o v\xe3o ser afetados.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': 'Tipo do item',
        'jira-common.ListProjectForms.AssociatedRequestTypes': "Tipo de solicita\xe7\xe3o",
        'jira-common.ListProjectForms.Cancel': 'Cancelar',
        'jira-common.ListProjectForms.Copy': 'Copiar para projeto',
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Erro: n\xe3o foi poss\xedvel copiar o \u201C{formName}\u201D",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "''{formName}' agora pode ser usado em {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formul\xe1rio copiado para o projeto de neg\xf3cios} other {Formul\xe1rio copiado para {numberOfBusinessProjects,number} projetos de neg\xf3cios}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formul\xe1rio copiado para {numberOfProjects,number} projeto} other {Formul\xe1rio copiado para {numberOfProjects,number} projetos}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "O \u201C{formName}\u201D agora pode ser usado no \u201C{projectName}\u201D.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "''{formName}' agora pode ser usado em {numberOfServiceProjectsMessage} e {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "''{formName}' agora pode ser usado em {numberOfServiceProjectsMessage} e {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "''{formName}' agora pode ser usado em {numberOfServiceProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formul\xe1rio copiado para o projeto de servi\xe7o} other {Formul\xe1rio copiado para {numberOfServiceProjects,number} projetos de servi\xe7o}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "''{formName}' agora pode ser usado em {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} e {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "''{formName}' agora pode ser usado em {numberOfSoftwareProjectsMessage} e {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "''{formName}' agora pode ser usado em {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formul\xe1rio copiado para projeto de software} other {Formul\xe1rio copiado para {numberOfSoftwareProjects,number} projetos de software}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {O ''{formName}' agora pode ser usado em {numberOfProjects,number} projeto.} other {O ''{formName}' agora pode ser usado em {numberOfProjects,number} projetos.}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formul\xe1rio copiado para o projeto} other {Formul\xe1rio copiado para {numberOfProjects,number} projetos}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Cancelar',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Copiar',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copiar para projeto(s)',
        'jira-common.ListProjectForms.CopyModal.Heading': "Copiar \u201C{formName}\u201D para outros projetos",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Saiba mais sobre a c\xf3pia de formul\xe1rios",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Carregando projetos',
        'jira-common.ListProjectForms.CopyModal.Name': 'Nome',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Selecionar todos os projetos',
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Altera\xe7\xf5es feitas no formul\xe1rio n\xe3o s\xe3o refletidas em nenhuma das c\xf3pias em outros projetos.",
        'jira-common.ListProjectForms.CopyText': "C\xf3pia de {formName}",
        'jira-common.ListProjectForms.Delete': 'Excluir',
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u201C{formName}\u201D exclu\xeddo",
        'jira-common.ListProjectForms.Duplicate': 'Duplicar',
        'jira-common.ListProjectForms.EmptyFormName': "Formul\xe1rio sem t\xedtulo",
        'jira-common.ListProjectForms.FilterForms': "Filtrar formul\xe1rios",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "Download de \u201C{filename}\u201D conclu\xeddo",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Atualize a p\xe1gina e tente de novo.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "Falha no download de \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}% conclu\xeddo} other {{percentCount,number}% conclu\xeddos}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Fazendo download de \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Exportar em XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': "Mais a\xe7\xf5es",
        'jira-common.ListProjectForms.FutureIssueMessage': "Itens futuros criados com esses tipos de item n\xe3o v\xe3o mais incluir este formul\xe1rio:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Solicita\xe7\xf5es futuras criadas com esses tipos de solicita\xe7\xe3o n\xe3o v\xe3o mais incluir este formul\xe1rio.",
        'jira-common.ListProjectForms.Heading': "Excluir \u201C{formName}\u201D?",
        'jira-common.ListProjectForms.IssueType': 'Tipo do item',
        'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Pesquisar tipos de item',
        'jira-common.ListProjectForms.LastUpdated': "\xdaltima atualiza\xe7\xe3o",
        'jira-common.ListProjectForms.LearnMoreLink': "Saiba mais sobre a exclus\xe3o de formul\xe1rios.",
        'jira-common.ListProjectForms.RequestType': "Tipo de solicita\xe7\xe3o",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "Pesquisar tipos de solicita\xe7\xe3o",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "A exclus\xe3o vai remover o formul\xe1rio dos seguintes tipos de item:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "A exclus\xe3o vai remover o formul\xe1rio dos seguintes tipos de solicita\xe7\xe3o:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copiar link direto',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Tipo do item',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Tipo de solicita\xe7\xe3o",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} projeto de neg\xf3cios} other {{numberOfBusinessProjects,number} projetos de neg\xf3cios}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} projeto de servi\xe7o} other {{numberOfServiceProjects,number} projetos de servi\xe7o}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} projeto de software} other {{numberOfSoftwareProjects,number} projetos de software}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': 'Tipos de item {count}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "Tipos de solicita\xe7\xe3o {count}",
        'proforma-project-forms.BusinessForms': "Formul\xe1rios avan\xe7ados",
        'proforma-project-forms.CreateForm': "Criar formul\xe1rio",
        'proforma-project-forms.Description': "Crie, edite, exporte e exclua formul\xe1rios. Copie e use formul\xe1rios em outros projetos.",
        'proforma-project-forms.Forms': "Formul\xe1rios",
        'proforma-project-forms.LearnMore': "Saiba mais sobre formul\xe1rios.",
        'proforma-project-forms.LoadingForms': 'Carregando...',
        'proforma-project-forms.NoFormsDescriptionJsm': "Adicione formul\xe1rios para que os clientes preencham quando criarem solicita\xe7\xf5es ou anexe formul\xe1rios aos itens atuais para ter mais informa\xe7\xf5es.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Adicione formul\xe1rios para que os clientes preencham quando criarem itens ou anexe formul\xe1rios aos itens atuais para ter mais informa\xe7\xf5es.",
        'proforma-project-forms.NoFormsDescriptionJwm': "Adicione formul\xe1rios para que os clientes preencham quando criarem itens ou anexe formul\xe1rios aos itens atuais para ter mais informa\xe7\xf5es.",
        'proforma-project-forms.NoFormsHeading': "Todos os seus formul\xe1rios v\xe3o ser exibidos aqui",
        'proforma-project-forms.NoFormsHeadingAdvanced': "Todos os seus formul\xe1rios avan\xe7ados v\xe3o ser exibidos aqui",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "Criar da importa\xe7\xe3o",
        'proforma-project-forms.create-form-button.create-blank': "Criar formul\xe1rio em branco",
        'proforma-project-forms.create-form-button.create-from-blank': 'Criar do item em branco',
        'proforma-project-forms.create-form-button.create-with-template': 'Criar a partir de um template',
        'proforma-project-forms.create-form-button.trigger': "Criar formul\xe1rio"
    };
});
parcelRegister("2lZU4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b6d8fa1fe601719$export$2e2bcd8739ae039);
    var $1b6d8fa1fe601719$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C",
        'form-system.general.Form': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
        'jira-common.ListProjectForms.AffectExistingIssues': "\u042D\u0442\u043E \u043D\u0435 \u0437\u0430\u0442\u0440\u043E\u043D\u0435\u0442 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0443\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442 \u0434\u0430\u043D\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443, \u043B\u0438\u0431\u043E \u043A\u043E\u043F\u0438\u0438 \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447\u0438",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "\u0422\u0438\u043F \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
        'jira-common.ListProjectForms.Cancel': "\u041E\u0442\u043C\u0435\u043D\u0430",
        'jira-common.ListProjectForms.Copy': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u043F\u0440\u043E\u0435\u043A\u0442",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "\u041E\u0448\u0438\u0431\u043A\u0430: \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \xab{projectName}\xbb.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfServiceProjectsMessage} \u0438 {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfServiceProjectsMessage} \u0438 {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfServiceProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} \u0438 {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfSoftwareProjectsMessage} \u0438 {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0435.} few {\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445.} many {\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445.} other {\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430.}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\u041E\u0442\u043C\u0435\u043D\u0430",
        'jira-common.ListProjectForms.CopyModal.Copy': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u044B",
        'jira-common.ListProjectForms.CopyModal.Heading': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u043E\u0440\u043C\u044B \xab{formName}\xbb \u0432 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438 \u0444\u043E\u0440\u043C",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432",
        'jira-common.ListProjectForms.CopyModal.Name': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\u0412\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0435 \u0432 \u0444\u043E\u0440\u043C\u0443 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043D\u0435 \u043E\u0442\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F \u0432 \u0435\u0435 \u043A\u043E\u043F\u0438\u044F\u0445 \u0438\u0437 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432.",
        'jira-common.ListProjectForms.CopyText': "\u041A\u043E\u043F\u0438\u044F \u0444\u043E\u0440\u043C\u044B \xab{formName}\xbb",
        'jira-common.ListProjectForms.Delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u0424\u043E\u0440\u043C\u0430 \xab{formName}\xbb \u0443\u0434\u0430\u043B\u0435\u043D\u0430",
        'jira-common.ListProjectForms.Duplicate': "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        'jira-common.ListProjectForms.EmptyFormName': "\u0424\u043E\u0440\u043C\u0430 \u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F",
        'jira-common.ListProjectForms.FilterForms': "\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u044B",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u0424\u0430\u0439\u043B \xab{filename}\xbb \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u0424\u0430\u0439\u043B \xab{filename}\xbb \u043D\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E: {percentCount,number}\xa0%} few {\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E: {percentCount,number}\xa0%} many {\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E: {percentCount,number}\xa0%} other {\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E: {percentCount,number}\xa0%}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0444\u0430\u0439\u043B\u0430 \xab{filename}\xbb",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u042D\u043A\u0441\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 XLSX",
        'jira-common.ListProjectForms.FormActions.MoreActions': "\u0414\u0440\u0443\u0433\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
        'jira-common.ListProjectForms.FutureIssueMessage': "\u0411\u0443\u0434\u0443\u0449\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u044D\u0442\u0438\u0445 \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u0434\u0430\u0447, \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u0434\u0430\u043D\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443:",
        'jira-common.ListProjectForms.FutureRequestMessage': "\u0411\u0443\u0434\u0443\u0449\u0438\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u044B, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432, \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u044D\u0442\u0443 \u0444\u043E\u0440\u043C\u0443.",
        'jira-common.ListProjectForms.Heading': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb?",
        'jira-common.ListProjectForms.IssueType': "\u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447\u0438",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u041F\u043E\u0438\u0441\u043A \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u0434\u0430\u0447",
        'jira-common.ListProjectForms.LastUpdated': "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435",
        'jira-common.ListProjectForms.LearnMoreLink': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E\u0431 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0438 \u0444\u043E\u0440\u043C.",
        'jira-common.ListProjectForms.RequestType': "\u0422\u0438\u043F \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u041F\u043E\u0438\u0441\u043A \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u043E\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u0434\u0430\u0447:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u043E\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u044F\u043C\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447\u0438",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u0422\u0438\u043F \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442} few {{numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430} many {{numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432} other {{numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} few {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} many {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} other {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} few {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} many {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} other {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "\u0422\u0438\u043F\u043E\u0432 \u0437\u0430\u0434\u0430\u0447: {count}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "\u0422\u0438\u043F\u043E\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432: {count}",
        'proforma-project-forms.BusinessForms': "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B",
        'proforma-project-forms.CreateForm': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0443",
        'proforma-project-forms.Description': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0444\u043E\u0440\u043C. \u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u043E\u0440\u043C \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445.",
        'proforma-project-forms.Forms': "\u0424\u043E\u0440\u043C\u044B",
        'proforma-project-forms.LearnMore': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u0444\u043E\u0440\u043C\u0430\u0445.",
        'proforma-project-forms.LoadingForms': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u044B, \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u0430, \u0438\u043B\u0438 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u044B \u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0430\u043C \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.",
        'proforma-project-forms.NoFormsDescriptionJsw': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u044B, \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438, \u0438\u043B\u0438 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u044B \u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0430\u043C \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.",
        'proforma-project-forms.NoFormsDescriptionJwm': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u044B, \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430, \u0438\u043B\u0438 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u044B \u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0430\u043C \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.",
        'proforma-project-forms.NoFormsHeading': "\u0417\u0434\u0435\u0441\u044C \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u0444\u043E\u0440\u043C\u044B",
        'proforma-project-forms.NoFormsHeadingAdvanced': "\u0417\u0434\u0435\u0441\u044C \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u0437 \u0438\u043C\u043F\u043E\u0440\u0442\u0430",
        'proforma-project-forms.create-form-button.create-blank': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0443\u0441\u0442\u0443\u044E",
        'proforma-project-forms.create-form-button.create-from-blank': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441 \u0447\u0438\u0441\u0442\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430",
        'proforma-project-forms.create-form-button.create-with-template': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0430",
        'proforma-project-forms.create-form-button.trigger': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0443"
    };
});
parcelRegister("lA0ZP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb5dbb932135e0cf$export$2e2bcd8739ae039);
    var $fb5dbb932135e0cf$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': 'Redigera',
        'form-system.general.Form': 'Namn',
        'jira-common.ListProjectForms.AffectExistingIssues': "Detta p\xe5verkar inte befintliga \xe4renden som redan anv\xe4nder det h\xe4r formul\xe4ret, eller kopior av detta formul\xe4r i andra projekt.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\xc4rendetyp",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "F\xf6rfr\xe5gningstyp",
        'jira-common.ListProjectForms.Cancel': 'Avbryt',
        'jira-common.ListProjectForms.Copy': 'Kopiera till projekt',
        'jira-common.ListProjectForms.CopyFormErrorTitle': "Fel: Kunde inte kopiera \xf6ver \u201D{formName}\u201D",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formul\xe4ret har kopierats till aff\xe4rsprojektet} other {Formul\xe4ret har kopierats till {numberOfBusinessProjects,number} aff\xe4rsprojekt}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formul\xe4ret har kopierats till {numberOfProjects,number} projekt} other {Formul\xe4ret har kopierats till {numberOfProjects,number} projekt}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201D{formName}\u201D kan nu anv\xe4ndas i \u201D{projectName}\u201D.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfServiceProjectsMessage} och {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfServiceProjectsMessage} och {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formul\xe4ret har kopierats till serviceprojektet} other {Formul\xe4ret har kopierats till {numberOfServiceProjects,number} serviceprojekt}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} och {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfSoftwareProjectsMessage} och {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formul\xe4ret har kopierats till programvaruprojektet} other {Formul\xe4ret har kopierats till {numberOfSoftwareProjects,number} programvaruprojekt}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" kan nu anv\xe4ndas i {numberOfProjects,number} projekt.} other {"{formName}" kan nu anv\xe4ndas i {numberOfProjects,number} projekt.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formul\xe4ret har kopierats till projektet} other {Formul\xe4ret har kopierats till {numberOfProjects,number} projekt}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': 'Avbryt',
        'jira-common.ListProjectForms.CopyModal.Copy': 'Kopiera',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Kopiera till projekt',
        'jira-common.ListProjectForms.CopyModal.Heading': "Kopiera \u201D{formName}\u201D till andra projekt",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "L\xe4s mer om att kopiera formul\xe4r",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "L\xe4ser in projekt",
        'jira-common.ListProjectForms.CopyModal.Name': 'Namn',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "V\xe4lj alla projekt",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\xc4ndringar som g\xf6rs i ett formul\xe4r \xe5terspeglas inte i n\xe5gon av dess kopior i andra projekt.",
        'jira-common.ListProjectForms.CopyText': 'Kopia av {formName}',
        'jira-common.ListProjectForms.Delete': 'Radera',
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u201D{formName}\u201D har raderats",
        'jira-common.ListProjectForms.Duplicate': 'Duplicera',
        'jira-common.ListProjectForms.EmptyFormName': "Namnl\xf6st formul\xe4r",
        'jira-common.ListProjectForms.FilterForms': "Filtrera formul\xe4r",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201D{filename}\u201D har laddats ner",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Uppdatera sidan och f\xf6rs\xf6k igen.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201D{filename}\u201D har inte laddats ner",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% slutf\xf6rt} other {{percentCount,number}\xa0% slutf\xf6rt}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Laddar ner \u201D{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Exportera i XLSX',
        'jira-common.ListProjectForms.FormActions.MoreActions': "Fler \xe5tg\xe4rder",
        'jira-common.ListProjectForms.FutureIssueMessage': "Framtida \xe4renden som skapas med dessa \xe4rendetyper kommer inte l\xe4ngre att inkludera det h\xe4r formul\xe4ret.",
        'jira-common.ListProjectForms.FutureRequestMessage': "Framtida f\xf6rfr\xe5gningar som skapas med dessa f\xf6rfr\xe5gningstyper kommer inte l\xe4ngre att inkludera det h\xe4r formul\xe4ret.",
        'jira-common.ListProjectForms.Heading': "Vill du radera \u201D{formName}\u201D?",
        'jira-common.ListProjectForms.IssueType': "\xc4rendetyp",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "S\xf6k efter \xe4rendetyper",
        'jira-common.ListProjectForms.LastUpdated': 'Uppdaterades senast',
        'jira-common.ListProjectForms.LearnMoreLink': "L\xe4s mer om att radera formul\xe4r.",
        'jira-common.ListProjectForms.RequestType': "Typ av f\xf6rfr\xe5gan",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "S\xf6k efter f\xf6rfr\xe5gningstyper",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Om formul\xe4ret raderas tas det bort fr\xe5n f\xf6ljande \xe4rendetyper:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Om formul\xe4ret raderas tas det bort fr\xe5n f\xf6ljande f\xf6rfr\xe5gningstyper:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Kopiera direktl\xe4nken",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\xc4rendetyp",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Typ av f\xf6rfr\xe5gan",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} aff\xe4rsprojekt} other {{numberOfBusinessProjects,number} aff\xe4rsprojekt}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} serviceprojekt} other {{numberOfServiceProjects,number} serviceprojekt}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} programvaruprojekt} other {{numberOfSoftwareProjects,number} programvaruprojekt}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \xe4rendetyper",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} f\xf6rfr\xe5gningstyper",
        'proforma-project-forms.BusinessForms': "Avancerade formul\xe4r",
        'proforma-project-forms.CreateForm': "Skapa formul\xe4r",
        'proforma-project-forms.Description': "Skapa, redigera, exportera och radera formul\xe4r. Kopiera formul\xe4r och anv\xe4nd dem i andra projekt.",
        'proforma-project-forms.Forms': "Formul\xe4r",
        'proforma-project-forms.LearnMore': "L\xe4s mer om formul\xe4r.",
        'proforma-project-forms.LoadingForms': "L\xe4ser in\xa0\u2026",
        'proforma-project-forms.NoFormsDescriptionJsm': "L\xe4gg till formul\xe4r som kunder kan fylla i n\xe4r de skapar en f\xf6rfr\xe5gan, eller bifoga formul\xe4r till befintliga \xe4renden f\xf6r att samla in mer information.",
        'proforma-project-forms.NoFormsDescriptionJsw': "L\xe4gg till formul\xe4r som kunder kan fylla i n\xe4r de skapar ett \xe4rende, eller bifoga formul\xe4r till befintliga \xe4renden f\xf6r att samla in mer information.",
        'proforma-project-forms.NoFormsDescriptionJwm': "L\xe4gg till formul\xe4r som kunder kan fylla i n\xe4r de skapar en uppgift, eller bifoga formul\xe4r till befintliga \xe4renden f\xf6r att samla in mer information.",
        'proforma-project-forms.NoFormsHeading': "Alla dina formul\xe4r kommer att visas h\xe4r",
        'proforma-project-forms.NoFormsHeadingAdvanced': "Alla dina avancerade formul\xe4r visas h\xe4r",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "Skapa fr\xe5n import",
        'proforma-project-forms.create-form-button.create-blank': 'Skapa tom',
        'proforma-project-forms.create-form-button.create-from-blank': "Skapa fr\xe5n tom",
        'proforma-project-forms.create-form-button.create-with-template': "Skapa fr\xe5n mall",
        'proforma-project-forms.create-form-button.trigger': "Skapa formul\xe4r"
    };
});
parcelRegister("3Hnao", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b175ba3b27c9779$export$2e2bcd8739ae039);
    var $2b175ba3b27c9779$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "\u0E41\u0E01\u0E49\u0E44\u0E02",
        'form-system.general.Form': "\u0E0A\u0E37\u0E48\u0E2D",
        'jira-common.ListProjectForms.AffectExistingIssues': "\u0E0B\u0E36\u0E48\u0E07\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E43\u0E14 \u0E46 \u0E02\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D",
        'jira-common.ListProjectForms.Cancel': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        'jira-common.ListProjectForms.Copy': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14: \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 {formName} \u0E44\u0E14\u0E49",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfBusinessProjectsMessage}',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E41\u0E25\u0E49\u0E27 {numberOfBusinessProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E41\u0E25\u0E49\u0E27 {numberOfProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201C{formName}\u201D \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 \u201C{projectName}\u201D",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfServiceProjectsMessage} \u0E41\u0E25\u0E30 {numberOfBusinessProjectsMessage}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfServiceProjectsMessage} \u0E41\u0E25\u0E30 {numberOfSoftwareProjectsMessage}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfServiceProjectsMessage}',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27 {numberOfServiceProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} \u0E41\u0E25\u0E30 {numberOfBusinessProjectsMessage}',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfSoftwareProjectsMessage} \u0E41\u0E25\u0E30 {numberOfBusinessProjectsMessage}',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfSoftwareProjectsMessage}',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E41\u0E25\u0E49\u0E27 {numberOfSoftwareProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, other {"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C {numberOfProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E41\u0E25\u0E49\u0E27 {numberOfProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
        'jira-common.ListProjectForms.CopyModal.Copy': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
        'jira-common.ListProjectForms.CopyModal.Heading': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 \u201C{formName}\u201D \u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
        'jira-common.ListProjectForms.CopyModal.Name': "\u0E0A\u0E37\u0E48\u0E2D",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E17\u0E33\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E08\u0E30\u0E44\u0E21\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E43\u0E19\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E02\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E46",
        'jira-common.ListProjectForms.CopyText': "\u0E2A\u0E33\u0E40\u0E19\u0E32 {formName}",
        'jira-common.ListProjectForms.Delete': "\u0E25\u0E1A",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u0E25\u0E1A \u201C{formName}\u201D \u0E41\u0E25\u0E49\u0E27",
        'jira-common.ListProjectForms.Duplicate': "\u0E17\u0E33\u0E2A\u0E33\u0E40\u0E19\u0E32",
        'jira-common.ListProjectForms.EmptyFormName': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D",
        'jira-common.ListProjectForms.FilterForms': "\u0E01\u0E23\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 \u201C{filename}\u201D \u0E41\u0E25\u0E49\u0E27",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27 {percentCount,number}%}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1F\u0E25\u0E4C XLSX",
        'jira-common.ListProjectForms.FormActions.MoreActions': "\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        'jira-common.ListProjectForms.FutureIssueMessage': "\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B:",
        'jira-common.ListProjectForms.FutureRequestMessage': "\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E14\u0E49\u0E27\u0E22\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
        'jira-common.ListProjectForms.Heading': "\u0E25\u0E1A \u201C{formName}\u201D \u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21",
        'jira-common.ListProjectForms.IssueType': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        'jira-common.ListProjectForms.LastUpdated': "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
        'jira-common.ListProjectForms.LearnMoreLink': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
        'jira-common.ListProjectForms.RequestType': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22\u0E40\u0E0A\u0E48\u0E19\u0E01\u0E31\u0E19",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22\u0E40\u0E0A\u0E48\u0E19\u0E01\u0E31\u0E19",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08 {numberOfBusinessProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 {numberOfServiceProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C {numberOfSoftwareProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} \u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D",
        'proforma-project-forms.BusinessForms': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07",
        'proforma-project-forms.CreateForm': "\u0E08\u0E31\u0E14\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
        'proforma-project-forms.Description': "\u0E08\u0E31\u0E14\u0E17\u0E33 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01 \u0E41\u0E25\u0E30\u0E25\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21 \u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E41\u0E25\u0E30\u0E43\u0E0A\u0E49\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E46",
        'proforma-project-forms.Forms': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
        'proforma-project-forms.LearnMore': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
        'proforma-project-forms.LoadingForms': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
        'proforma-project-forms.NoFormsDescriptionJsm': "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E19\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        'proforma-project-forms.NoFormsDescriptionJsw': "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E19\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        'proforma-project-forms.NoFormsDescriptionJwm': "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E19\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        'proforma-project-forms.NoFormsHeading': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E36\u0E49\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
        'proforma-project-forms.NoFormsHeadingAdvanced': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E36\u0E49\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32",
        'proforma-project-forms.create-form-button.create-blank': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E27\u0E48\u0E32\u0E07",
        'proforma-project-forms.create-form-button.create-from-blank': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E08\u0E32\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E27\u0E48\u0E32\u0E07",
        'proforma-project-forms.create-form-button.create-with-template': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E08\u0E32\u0E01\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A",
        'proforma-project-forms.create-form-button.trigger': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21"
    };
});
parcelRegister("lqxIV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9962f80b2083a48$export$2e2bcd8739ae039);
    var $f9962f80b2083a48$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "D\xfczenle",
        'form-system.general.Form': 'Ad',
        'jira-common.ListProjectForms.AffectExistingIssues': "Bu durum, bu formu zaten kullanan mevcut konular\u0131 veya bu formun di\u011Fer projelerdeki kopyalar\u0131n\u0131 etkilemez.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "Konu t\xfcr\xfc",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "Talep t\xfcr\xfc",
        'jira-common.ListProjectForms.Cancel': "\u0130ptal",
        'jira-common.ListProjectForms.Copy': 'Projeye kopyala',
        'jira-common.ListProjectForms.CopyFormErrorTitle': 'Hata: "{formName}" kopyalanam\u0131yor',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" art\u0131k {numberOfBusinessProjectsMessage} i\xe7inde kullan\u0131labilir.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Form i\u015F projesine kopyaland\u0131} other {Form {numberOfBusinessProjects,number} i\u015F projesine kopyaland\u0131}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Form {numberOfProjects,number} projeye kopyaland\u0131} other {Form {numberOfProjects,number} projeye kopyaland\u0131}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" art\u0131k "{projectName}" projesinde kullan\u0131labilir.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" art\u0131k {numberOfServiceProjectsMessage} ve {numberOfBusinessProjectsMessage} i\xe7inde kullan\u0131labilir.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" art\u0131k {numberOfServiceProjectsMessage} ve {numberOfSoftwareProjectsMessage} i\xe7inde kullan\u0131labilir.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" art\u0131k {numberOfServiceProjectsMessage} i\xe7inde kullan\u0131labilir.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Form destek projesine kopyaland\u0131} other {Form {numberOfServiceProjects,number} destek projesine kopyaland\u0131}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" art\u0131k {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} ve {numberOfBusinessProjectsMessage} i\xe7inde kullan\u0131labilir.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" art\u0131k {numberOfSoftwareProjectsMessage} ve {numberOfBusinessProjectsMessage} i\xe7inde kullan\u0131labilir.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" art\u0131k {numberOfSoftwareProjectsMessage} i\xe7inde kullan\u0131labilir.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Form yaz\u0131l\u0131m projesine kopyaland\u0131} other {Form {numberOfSoftwareProjects,number} yaz\u0131l\u0131m projesine kopyaland\u0131}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" art\u0131k {numberOfProjects,number} projede kullan\u0131labilir.} other {"{formName}" art\u0131k {numberOfProjects,number} projede kullan\u0131labilir.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Form projeye kopyaland\u0131} other {Form {numberOfProjects,number} projeye kopyaland\u0131}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\u0130ptal",
        'jira-common.ListProjectForms.CopyModal.Copy': 'Kopyala',
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Projelere kopyala',
        'jira-common.ListProjectForms.CopyModal.Heading': '"{formName}" formunu di\u011Fer projelere kopyalay\u0131n',
        'jira-common.ListProjectForms.CopyModal.LearnMore': "Formlar\u0131 kopyalamak hakk\u0131nda daha fazla bilgi edinin",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "Projeler y\xfckleniyor",
        'jira-common.ListProjectForms.CopyModal.Name': 'Ad',
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "T\xfcm projeleri se\xe7",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "Bir formda yap\u0131lan de\u011Fi\u015Fiklikler, di\u011Fer projelerdeki kopyalar\u0131na yans\u0131t\u0131lmaz.",
        'jira-common.ListProjectForms.CopyText': "{formName} formunun kopyas\u0131",
        'jira-common.ListProjectForms.Delete': 'Sil',
        'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" silindi',
        'jira-common.ListProjectForms.Duplicate': "\xc7o\u011Falt",
        'jira-common.ListProjectForms.EmptyFormName': "Ba\u015Fl\u0131ks\u0131z Form",
        'jira-common.ListProjectForms.FilterForms': "Formlar\u0131 filtreleyin",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" indirildi',
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Sayfay\u0131 yenileyin ve tekrar deneyin.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" indirilemedi',
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {%{percentCount,number} tamamland\u0131} other {%{percentCount,number} tamamland\u0131}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': '"{filename}" indiriliyor',
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "XLSX olarak d\u0131\u015Fa aktar",
        'jira-common.ListProjectForms.FormActions.MoreActions': "Daha fazla i\u015Flem",
        'jira-common.ListProjectForms.FutureIssueMessage': "Bu konu t\xfcrleri kullan\u0131larak olu\u015Fturulacak konular art\u0131k bu formu i\xe7ermeyecek:",
        'jira-common.ListProjectForms.FutureRequestMessage': "Bu talep t\xfcrleri kullan\u0131larak olu\u015Fturulacak talepler art\u0131k bu formu i\xe7ermeyecek.",
        'jira-common.ListProjectForms.Heading': '"{formName}" silinsin mi?',
        'jira-common.ListProjectForms.IssueType': "Konu t\xfcr\xfc",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "Konu t\xfcrlerini aray\u0131n",
        'jira-common.ListProjectForms.LastUpdated': "Son g\xfcncelleme",
        'jira-common.ListProjectForms.LearnMoreLink': "Formlar\u0131 silmek hakk\u0131nda daha fazla bilgi edinin.",
        'jira-common.ListProjectForms.RequestType': "Talep t\xfcr\xfc",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "Talep t\xfcrlerini aray\u0131n",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Bu formu sildi\u011Finizde form a\u015Fa\u011F\u0131daki konu t\xfcrlerinden kald\u0131r\u0131l\u0131r:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Bu formu sildi\u011Finizde form a\u015Fa\u011F\u0131daki talep t\xfcrlerinden kald\u0131r\u0131l\u0131r:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Do\u011Frudan ba\u011Flant\u0131y\u0131 kopyala",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "Konu t\xfcr\xfc",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Talep t\xfcr\xfc",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} i\u015F projesi} other {{numberOfBusinessProjects,number} i\u015F projesi}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} destek projesi} other {{numberOfServiceProjects,number} destek projesi}}',
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} yaz\u0131l\u0131m projesi} other {{numberOfSoftwareProjects,number} yaz\u0131l\u0131m projesi}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} konu t\xfcr\xfc",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} talep t\xfcr\xfc",
        'proforma-project-forms.BusinessForms': "Geli\u015Fmi\u015F Formlar",
        'proforma-project-forms.CreateForm': "Form olu\u015Ftur",
        'proforma-project-forms.Description': "Form olu\u015Fturun, d\xfczenleyin, d\u0131\u015Fa aktar\u0131n veya silin. Formlar\u0131 kopyalay\u0131p di\u011Fer projelerde kullan\u0131n.",
        'proforma-project-forms.Forms': 'Formlar',
        'proforma-project-forms.LearnMore': "Formlar hakk\u0131nda daha fazla bilgi edinin.",
        'proforma-project-forms.LoadingForms': "Y\xfckleniyor...",
        'proforma-project-forms.NoFormsDescriptionJsm': "Talep olu\u015Ftururken m\xfc\u015Fterilerin dolduraca\u011F\u0131 formlar ekleyin veya daha fazla bilgi toplamak i\xe7in formlar\u0131 mevcut konulara ekleyin.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Konu olu\u015Ftururken m\xfc\u015Fterilerin dolduraca\u011F\u0131 formlar ekleyin veya daha fazla bilgi toplamak i\xe7in formlar\u0131 mevcut konulara ekleyin.",
        'proforma-project-forms.NoFormsDescriptionJwm': "\xd6\u011Fe olu\u015Ftururken m\xfc\u015Fterilerin dolduraca\u011F\u0131 formlar ekleyin veya daha fazla bilgi toplamak i\xe7in formlar\u0131 mevcut konulara ekleyin.",
        'proforma-project-forms.NoFormsHeading': "T\xfcm formlar\u0131n\u0131z burada g\xf6r\xfcnecek",
        'proforma-project-forms.NoFormsHeadingAdvanced': "T\xfcm geli\u015Fmi\u015F formlar\u0131n\u0131z burada g\xf6r\xfcn\xfcr",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "\u0130\xe7e aktarmadan olu\u015Ftur",
        'proforma-project-forms.create-form-button.create-blank': "Bo\u015F form olu\u015Ftur",
        'proforma-project-forms.create-form-button.create-from-blank': "Bo\u015F form olu\u015Ftur",
        'proforma-project-forms.create-form-button.create-with-template': "\u015Eablondan olu\u015Ftur",
        'proforma-project-forms.create-form-button.trigger': "Form olu\u015Ftur"
    };
});
parcelRegister("1E54q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$132d75b8d00cf992$export$2e2bcd8739ae039);
    var $132d75b8d00cf992$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
        'form-system.general.Form': "\u041D\u0430\u0437\u0432\u0430",
        'jira-common.ListProjectForms.AffectExistingIssues': "\u0426\u0435 \u043D\u0435 \u0432\u043F\u043B\u0438\u043D\u0435 \u043D\u0430 \u043D\u0430\u044F\u0432\u043D\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F, \u0443 \u044F\u043A\u0438\u0445 \u0443\u0436\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F \u0446\u044F \u0444\u043E\u0440\u043C\u0430, \u0430\u0431\u043E \u043D\u0430 \u0431\u0443\u0434\u044C-\u044F\u043A\u0456 \u043A\u043E\u043F\u0456\u0457 \u0444\u043E\u0440\u043C\u0438 \u0432 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\u0422\u0438\u043F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "\u0422\u0438\u043F \u0437\u0430\u043F\u0438\u0442\u0443",
        'jira-common.ListProjectForms.Cancel': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        'jira-common.ListProjectForms.Copy': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0443} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 \u043F\u0440\u043E\u0454\u043A\u0442\u0456 \xab{projectName}\xbb.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfServiceProjectsMessage} \u0456 {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfServiceProjectsMessage} \u0456 {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfServiceProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0441\u043B\u0443\u0436\u0431\u0438} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0441\u043B\u0443\u0436\u0431\u0438} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0441\u043B\u0443\u0436\u0431\u0438} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0441\u043B\u0443\u0436\u0431\u0438}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfServiceProjectsMessage}), {numberOfSoftwareProjectsMessage} \u0456 {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfSoftwareProjectsMessage} \u0456 {numberOfBusinessProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfSoftwareProjectsMessage}.",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456.} few {\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.} many {\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.} other {\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        'jira-common.ListProjectForms.CopyModal.Copy': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u043D\u043D\u044F \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443(-\u0456\u0432)",
        'jira-common.ListProjectForms.CopyModal.Heading': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u0434\u043E \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u043A\u043E\u043F\u0456\u044E\u0432\u0430\u043D\u043D\u044F \u0444\u043E\u0440\u043C",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432",
        'jira-common.ListProjectForms.CopyModal.Name': "\u041D\u0430\u0437\u0432\u0430",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0456 \u043F\u0440\u043E\u0454\u043A\u0442\u0438",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\u0417\u043C\u0456\u043D\u0438 \u0444\u043E\u0440\u043C\u0438 \u043D\u0435 \u0431\u0443\u0434\u0435 \u043F\u043E\u0448\u0438\u0440\u0435\u043D\u043E \u043D\u0430 \u0457\u0457 \u043A\u043E\u043F\u0456\u0457 \u0432 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.",
        'jira-common.ListProjectForms.CopyText': "\u041A\u043E\u043F\u0456\u044F \u0444\u043E\u0440\u043C\u0438 {formName}",
        'jira-common.ListProjectForms.Delete': "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u0424\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        'jira-common.ListProjectForms.Duplicate': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043A\u043E\u043F\u0456\u044E",
        'jira-common.ListProjectForms.EmptyFormName': "\u0424\u043E\u0440\u043C\u0430 \u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0438",
        'jira-common.ListProjectForms.FilterForms': "\u0424\u0456\u043B\u044C\u0442\u0440 \u0444\u043E\u0440\u043C",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E \u0444\u0430\u0439\u043B \xab{filename}\xbb",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u041E\u043D\u043E\u0432\u0456\u0442\u044C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u0430\u0439\u043B \xab{filename}\xbb",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {percentCount,number}\xa0%} few {\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {percentCount,number}\xa0%} many {\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {percentCount,number}\xa0%} other {\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {percentCount,number}\xa0%}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0443 \xab{filename}\xbb",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 XLSX",
        'jira-common.ListProjectForms.FormActions.MoreActions': "\u0406\u043D\u0448\u0456 \u0434\u0456\u0457",
        'jira-common.ListProjectForms.FutureIssueMessage': "\u0426\u044F \u0444\u043E\u0440\u043C\u0430 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442\u0438\u043C\u0435 \u0434\u043E \u043F\u043E\u0434\u0430\u043B\u044C\u0448\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0445 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0446\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u044C.",
        'jira-common.ListProjectForms.FutureRequestMessage': "\u0426\u044F \u0444\u043E\u0440\u043C\u0430 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442\u0438\u043C\u0435 \u0434\u043E \u043F\u043E\u0434\u0430\u043B\u044C\u0448\u0438\u0445 \u0437\u0430\u043F\u0438\u0442\u0456\u0432, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0445 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0446\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u043F\u0438\u0442\u0456\u0432.",
        'jira-common.ListProjectForms.Heading': "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb?",
        'jira-common.ListProjectForms.IssueType': "\u0422\u0438\u043F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u041F\u043E\u0448\u0443\u043A \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
        'jira-common.ListProjectForms.LastUpdated': "\u0412\u043E\u0441\u0442\u0430\u043D\u043D\u0454 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
        'jira-common.ListProjectForms.LearnMoreLink': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0444\u043E\u0440\u043C.",
        'jira-common.ListProjectForms.RequestType': "\u0422\u0438\u043F \u0437\u0430\u043F\u0438\u0442\u0443",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u041F\u043E\u0448\u0443\u043A \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u043F\u0438\u0442\u0456\u0432",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u0423 \u0440\u0430\u0437\u0456 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0444\u043E\u0440\u043C\u0438 \u0457\u0457 \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0442\u0430\u043A\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u044C:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u0423 \u0440\u0430\u0437\u0456 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0444\u043E\u0440\u043C\u0438 \u0457\u0457 \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0442\u0430\u043A\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u043F\u0438\u0442\u0456\u0432:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u0440\u044F\u043C\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u0422\u0438\u043F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u0422\u0438\u043F \u0437\u0430\u043F\u0438\u0442\u0443",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0456} few {{numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445} many {{numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445} other {{numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0443}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456 \u0441\u043B\u0443\u0436\u0431} few {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445 \u0441\u043B\u0443\u0436\u0431} many {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445 \u0441\u043B\u0443\u0436\u0431} other {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0441\u043B\u0443\u0436\u0431}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} few {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445 \u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} many {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} other {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "\u0422\u0438\u043F\u0456\u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u044C: {count}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "\u0422\u0438\u043F\u0456\u0432 \u0437\u0430\u043F\u0438\u0442\u0456\u0432: {count}",
        'proforma-project-forms.BusinessForms': "\u0420\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u0456 \u0444\u043E\u0440\u043C\u0438",
        'proforma-project-forms.CreateForm': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0443",
        'proforma-project-forms.Description': "\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435, \u0435\u043A\u0441\u043F\u043E\u0440\u0442\u0443\u0439\u0442\u0435 \u0442\u0430 \u0432\u0438\u0434\u0430\u043B\u044F\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438. \u041A\u043E\u043F\u0456\u044E\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438 \u0439 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0457\u0445 \u0432 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.",
        'proforma-project-forms.Forms': "\u0424\u043E\u0440\u043C\u0438",
        'proforma-project-forms.LearnMore': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u0444\u043E\u0440\u043C\u0438",
        'proforma-project-forms.LoadingForms': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
        'proforma-project-forms.NoFormsDescriptionJsm': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438, \u044F\u043A\u0456 \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0438 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0438\u0442\u0456\u0432, \u0430\u0431\u043E \u0432\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0444\u043E\u0440\u043C\u0438 \u0434\u043E \u043D\u0430\u044F\u0432\u043D\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0449\u043E\u0431 \u0437\u0456\u0431\u0440\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457.",
        'proforma-project-forms.NoFormsDescriptionJsw': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438, \u044F\u043A\u0456 \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0438 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0430\u0431\u043E \u0432\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0444\u043E\u0440\u043C\u0438 \u0434\u043E \u043D\u0430\u044F\u0432\u043D\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0449\u043E\u0431 \u0437\u0456\u0431\u0440\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457.",
        'proforma-project-forms.NoFormsDescriptionJwm': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438, \u044F\u043A\u0456 \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0438 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u0443\u043D\u043A\u0442\u0456\u0432, \u0430\u0431\u043E \u0432\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0444\u043E\u0440\u043C\u0438 \u0434\u043E \u043D\u0430\u044F\u0432\u043D\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0449\u043E\u0431 \u0437\u0456\u0431\u0440\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457.",
        'proforma-project-forms.NoFormsHeading': "\u0423\u0441\u0456 \u0432\u0430\u0448\u0456 \u0444\u043E\u0440\u043C\u0438 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043C\u0443\u0442\u044C\u0441\u044F \u0442\u0443\u0442",
        'proforma-project-forms.NoFormsHeadingAdvanced': "\u0423\u0441\u0456 \u0432\u0430\u0448\u0456 \u0440\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u0456 \u0444\u043E\u0440\u043C\u0438 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043C\u0443\u0442\u044C\u0441\u044F \u0442\u0443\u0442",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 \u0456\u043C\u043F\u043E\u0440\u0442\u0443",
        'proforma-project-forms.create-form-button.create-blank': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u043E\u0440\u043E\u0436\u043D\u044E \u0444\u043E\u0440\u043C\u0443",
        'proforma-project-forms.create-form-button.create-from-blank': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 \u043F\u0443\u0441\u0442\u043E\u0457 \u0444\u043E\u0440\u043C\u0438",
        'proforma-project-forms.create-form-button.create-with-template': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0443",
        'proforma-project-forms.create-form-button.trigger': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0443"
    };
});
parcelRegister("bkYAf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84108e9b2bdc4648$export$2e2bcd8739ae039);
    var $84108e9b2bdc4648$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "S\u1EEDa",
        'form-system.general.Form': "T\xean",
        'jira-common.ListProjectForms.AffectExistingIssues': "Vi\u1EC7c n\xe0y s\u1EBD kh\xf4ng \u1EA3nh h\u01B0\u1EDFng \u0111\u1EBFn c\xe1c v\u1EA5n \u0111\u1EC1 hi\u1EC7n c\xf3 \u0111\xe3 s\u1EED d\u1EE5ng bi\u1EC3u m\u1EABu n\xe0y ho\u1EB7c b\u1EA5t k\u1EF3 b\u1EA3n sao n\xe0o c\u1EE7a bi\u1EC3u m\u1EABu n\xe0y trong c\xe1c d\u1EF1 \xe1n kh\xe1c.",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "Lo\u1EA1i v\u1EA5n \u0111\u1EC1",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "Lo\u1EA1i y\xeau c\u1EA7u",
        'jira-common.ListProjectForms.Cancel': "H\u1EE7y",
        'jira-common.ListProjectForms.Copy': "Sao ch\xe9p v\xe0o d\u1EF1 \xe1n",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "L\u1ED7i: Kh\xf4ng th\u1EC3 sao ch\xe9p \u201C{formName}\u201D",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfBusinessProjects,number} d\u1EF1 \xe1n kinh doanh}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfProjects,number} d\u1EF1 \xe1n}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng \u201C{formName}\u201D trong \u201C{projectName}\u201D.",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfServiceProjectsMessage} v\xe0 {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfServiceProjectsMessage} v\xe0 {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfServiceProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfServiceProjects,number} d\u1EF1 \xe1n d\u1ECBch v\u1EE5}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} v\xe0 {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfSoftwareProjectsMessage} v\xe0 {numberOfBusinessProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfSoftwareProjectsMessage}.',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfSoftwareProjects,number} d\u1EF1 \xe1n ph\u1EA7n m\u1EC1m}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, other {Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfProjects,number} d\u1EF1 \xe1n.}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfProjects,number} d\u1EF1 \xe1n}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "H\u1EE7y",
        'jira-common.ListProjectForms.CopyModal.Copy': "Sao ch\xe9p",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Sao ch\xe9p v\xe0o (c\xe1c) d\u1EF1 \xe1n",
        'jira-common.ListProjectForms.CopyModal.Heading': "Sao ch\xe9p \u201C{formName}\u201D v\xe0o c\xe1c d\u1EF1 \xe1n kh\xe1c",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "T\xecm hi\u1EC3u th\xeam v\u1EC1 vi\u1EC7c sao ch\xe9p bi\u1EC3u m\u1EABu",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0110ang t\u1EA3i d\u1EF1 \xe1n",
        'jira-common.ListProjectForms.CopyModal.Name': "T\xean",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "Ch\u1ECDn t\u1EA5t c\u1EA3 c\xe1c d\u1EF1 \xe1n",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "N\u1ED9i dung thay \u0111\u1ED5i c\u1EE7a bi\u1EC3u m\u1EABu kh\xf4ng \u0111\u01B0\u1EE3c ph\u1EA3n \xe1nh tr\xean b\u1EA5t k\u1EF3 b\u1EA3n sao n\xe0o c\u1EE7a bi\u1EC3u m\u1EABu trong c\xe1c d\u1EF1 \xe1n kh\xe1c.",
        'jira-common.ListProjectForms.CopyText': "{formName} b\u1EA3n sao",
        'jira-common.ListProjectForms.Delete': "X\xf3a",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u0110\xe3 x\xf3a \u201C{formName}\u201D",
        'jira-common.ListProjectForms.Duplicate': "B\u1EA3n sao",
        'jira-common.ListProjectForms.EmptyFormName': "Bi\u1EC3u m\u1EABu ch\u01B0a c\xf3 t\xean",
        'jira-common.ListProjectForms.FilterForms': "L\u1ECDc bi\u1EC3u m\u1EABu",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u0110\xe3 t\u1EA3i xu\u1ED1ng \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "L\xe0m m\u1EDBi trang n\xe0y v\xe0 th\u1EED l\u1EA1i.",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "Ch\u01B0a t\u1EA3i xu\u1ED1ng \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {\u0110\xe3 ho\xe0n t\u1EA5t {percentCount,number} %}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u0110ang t\u1EA3i xu\u1ED1ng \u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "Xu\u1EA5t th\xe0nh XLSX",
        'jira-common.ListProjectForms.FormActions.MoreActions': "H\xe0nh \u0111\u1ED9ng kh\xe1c",
        'jira-common.ListProjectForms.FutureIssueMessage': "C\xe1c v\u1EA5n \u0111\u1EC1 t\u01B0\u01A1ng lai \u0111\u01B0\u1EE3c t\u1EA1o b\u1EB1ng nh\u1EEFng lo\u1EA1i v\u1EA5n \u0111\u1EC1 n\xe0y s\u1EBD kh\xf4ng c\xf2n bao g\u1ED3m bi\u1EC3u m\u1EABu n\xe0y.",
        'jira-common.ListProjectForms.FutureRequestMessage': "C\xe1c y\xeau c\u1EA7u t\u01B0\u01A1ng lai \u0111\u01B0\u1EE3c t\u1EA1o b\u1EB1ng nh\u1EEFng lo\u1EA1i y\xeau c\u1EA7u n\xe0y s\u1EBD kh\xf4ng c\xf2n bao g\u1ED3m bi\u1EC3u m\u1EABu n\xe0y.",
        'jira-common.ListProjectForms.Heading': "Xo\xe1 \u201C{formName}\u201D?",
        'jira-common.ListProjectForms.IssueType': "Lo\u1EA1i v\u1EA5n \u0111\u1EC1",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "T\xecm ki\u1EBFm lo\u1EA1i v\u1EA5n \u0111\u1EC1",
        'jira-common.ListProjectForms.LastUpdated': "C\u1EADp nh\u1EADt g\u1EA7n \u0111\xe2y nh\u1EA5t",
        'jira-common.ListProjectForms.LearnMoreLink': "T\xecm hi\u1EC3u th\xeam v\u1EC1 vi\u1EC7c x\xf3a bi\u1EC3u m\u1EABu.",
        'jira-common.ListProjectForms.RequestType': "Lo\u1EA1i y\xeau c\u1EA7u",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "T\xecm ki\u1EBFm lo\u1EA1i y\xeau c\u1EA7u",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "X\xf3a bi\u1EC3u m\u1EABu n\xe0y s\u1EBD lo\u1EA1i b\u1ECF bi\u1EC3u m\u1EABu kh\u1ECFi c\xe1c lo\u1EA1i v\u1EA5n \u0111\u1EC1 sau \u0111\xe2y:",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "X\xf3a bi\u1EC3u m\u1EABu n\xe0y s\u1EBD lo\u1EA1i b\u1ECF bi\u1EC3u m\u1EABu kh\u1ECFi c\xe1c lo\u1EA1i y\xeau c\u1EA7u sau \u0111\xe2y:",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Sao ch\xe9p li\xean k\u1EBFt tr\u1EF1c ti\u1EBFp",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "Lo\u1EA1i v\u1EA5n \u0111\u1EC1",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Lo\u1EA1i y\xeau c\u1EA7u",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number} d\u1EF1 \xe1n kinh doanh}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number} d\u1EF1 \xe1n d\u1ECBch v\u1EE5}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number} d\u1EF1 \xe1n ph\u1EA7n m\u1EC1m}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} lo\u1EA1i v\u1EA5n \u0111\u1EC1",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} lo\u1EA1i y\xeau c\u1EA7u",
        'proforma-project-forms.BusinessForms': "Bi\u1EC3u m\u1EABu n\xe2ng cao",
        'proforma-project-forms.CreateForm': "T\u1EA1o bi\u1EC3u m\u1EABu",
        'proforma-project-forms.Description': "T\u1EA1o, s\u1EEDa, xu\u1EA5t v\xe0 x\xf3a bi\u1EC3u m\u1EABu. Sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0 s\u1EED d\u1EE5ng bi\u1EC3u m\u1EABu trong c\xe1c d\u1EF1 \xe1n kh\xe1c.",
        'proforma-project-forms.Forms': "Bi\u1EC3u m\u1EABu",
        'proforma-project-forms.LearnMore': "T\xecm hi\u1EC3u th\xeam v\u1EC1 bi\u1EC3u m\u1EABu.",
        'proforma-project-forms.LoadingForms': "\u0110ang t\u1EA3i...",
        'proforma-project-forms.NoFormsDescriptionJsm': "Th\xeam bi\u1EC3u m\u1EABu \u0111\u1EC3 kh\xe1ch h\xe0ng \u0111i\u1EC1n v\xe0o khi \u0111\u01B0a ra y\xeau c\u1EA7u ho\u1EB7c \u0111\xednh k\xe8m bi\u1EC3u m\u1EABu v\xe0o c\xe1c v\u1EA5n \u0111\u1EC1 hi\u1EC7n c\xf3 \u0111\u1EC3 thu th\u1EADp th\xeam th\xf4ng tin.",
        'proforma-project-forms.NoFormsDescriptionJsw': "Th\xeam bi\u1EC3u m\u1EABu \u0111\u1EC3 kh\xe1ch h\xe0ng \u0111i\u1EC1n v\xe0o khi t\u1EA1o v\u1EA5n \u0111\u1EC1 ho\u1EB7c \u0111\xednh k\xe8m bi\u1EC3u m\u1EABu v\xe0o c\xe1c v\u1EA5n \u0111\u1EC1 hi\u1EC7n c\xf3 \u0111\u1EC3 thu th\u1EADp th\xeam th\xf4ng tin.",
        'proforma-project-forms.NoFormsDescriptionJwm': "Th\xeam bi\u1EC3u m\u1EABu \u0111\u1EC3 kh\xe1ch h\xe0ng \u0111i\u1EC1n v\xe0o khi t\u1EA1o m\u1EE5c ho\u1EB7c \u0111\xednh k\xe8m bi\u1EC3u m\u1EABu v\xe0o c\xe1c v\u1EA5n \u0111\u1EC1 hi\u1EC7n c\xf3 \u0111\u1EC3 thu th\u1EADp th\xeam th\xf4ng tin.",
        'proforma-project-forms.NoFormsHeading': "T\u1EA5t c\u1EA3 bi\u1EC3u m\u1EABu c\u1EE7a b\u1EA1n s\u1EBD hi\u1EC3n th\u1ECB \u1EDF \u0111\xe2y",
        'proforma-project-forms.NoFormsHeadingAdvanced': "T\u1EA5t c\u1EA3 bi\u1EC3u m\u1EABu n\xe2ng cao c\u1EE7a b\u1EA1n s\u1EBD hi\u1EC3n th\u1ECB \u1EDF \u0111\xe2y",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "T\u1EA1o t\u1EEB d\u1EEF li\u1EC7u nh\u1EADp",
        'proforma-project-forms.create-form-button.create-blank': "T\u1EA1o bi\u1EC3u m\u1EABu tr\u1ED1ng",
        'proforma-project-forms.create-form-button.create-from-blank': "T\u1EA1o bi\u1EC3u m\u1EABu tr\u1ED1ng",
        'proforma-project-forms.create-form-button.create-with-template': "T\u1EA1o t\u1EEB m\u1EABu",
        'proforma-project-forms.create-form-button.trigger': "T\u1EA1o bi\u1EC3u m\u1EABu"
    };
});
parcelRegister("bzQcg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86db73ccb1428bd4$export$2e2bcd8739ae039);
    var $86db73ccb1428bd4$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "\u7F16\u8F91",
        'form-system.general.Form': "\u540D\u79F0",
        'jira-common.ListProjectForms.AffectExistingIssues': "\u8FD9\u4E0D\u4F1A\u5F71\u54CD\u5DF2\u7ECF\u4F7F\u7528\u6B64\u8868\u5355\u7684\u73B0\u6709\u4E8B\u52A1\uFF0C\u4E5F\u4E0D\u4F1A\u5F71\u54CD\u5176\u4ED6\u9879\u76EE\u4E2D\u6B64\u8868\u5355\u7684\u6240\u6709\u526F\u672C\u3002",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\u4E8B\u52A1\u7C7B\u578B",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "\u8BF7\u6C42\u7C7B\u578B",
        'jira-common.ListProjectForms.Cancel': "\u53D6\u6D88",
        'jira-common.ListProjectForms.Copy': "\u590D\u5236\u5230\u9879\u76EE",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "\u9519\u8BEF\uFF1A\u65E0\u6CD5\u590D\u5236\u201C{formName}\u201D",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfBusinessProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfBusinessProjects,number} \u4E2A\u4E1A\u52A1\u9879\u76EE}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfProjects,number} \u4E2A\u9879\u76EE}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201C{formName}\u201D\u73B0\u5728\u53EF\u4EE5\u5728\u201C{projectName}\u201D\u4E2D\u4F7F\u7528\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfServiceProjectsMessage}\u548C {numberOfBusinessProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfServiceProjectsMessage}\u548C {numberOfSoftwareProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfServiceProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfServiceProjects,number} \u4E2A\u670D\u52A1\u9879\u76EE}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfServiceProjectsMessage}\u3001{numberOfSoftwareProjectsMessage}\u548C {numberOfBusinessProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfSoftwareProjectsMessage}\u548C {numberOfBusinessProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfSoftwareProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfSoftwareProjects,number} \u4E2A\u8F6F\u4EF6\u9879\u76EE}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, other {"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfProjects,number} \u4E2A\u9879\u76EE\u4E2D\u4F7F\u7528\u3002}}',
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfProjects,number} \u4E2A\u9879\u76EE}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\u53D6\u6D88",
        'jira-common.ListProjectForms.CopyModal.Copy': "\u590D\u5236",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u590D\u5236\u5230\u9879\u76EE",
        'jira-common.ListProjectForms.CopyModal.Heading': "\u5C06\u201C{formName}\u201D\u590D\u5236\u5230\u5176\u4ED6\u9879\u76EE",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "\u4E86\u89E3\u6709\u5173\u590D\u5236\u8868\u5355\u7684\u66F4\u591A\u4FE1\u606F",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u6B63\u5728\u52A0\u8F7D\u9879\u76EE",
        'jira-common.ListProjectForms.CopyModal.Name': "\u540D\u79F0",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u9009\u62E9\u6240\u6709\u9879\u76EE",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\u5BF9\u8868\u5355\u6240\u505A\u7684\u53D8\u66F4\u4E0D\u4F1A\u53CD\u6620\u5728\u8BE5\u8868\u5355\u5728\u5176\u4ED6\u9879\u76EE\u4E2D\u7684\u526F\u672C\u5185\u3002",
        'jira-common.ListProjectForms.CopyText': "{formName} \u526F\u672C",
        'jira-common.ListProjectForms.Delete': "\u5220\u9664",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u201C{formName}\u201D\u5DF2\u5220\u9664",
        'jira-common.ListProjectForms.Duplicate': "\u590D\u5236",
        'jira-common.ListProjectForms.EmptyFormName': "\u672A\u547D\u540D\u8868\u5355",
        'jira-common.ListProjectForms.FilterForms': "\u7B5B\u9009\u8868\u5355",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201C{filename}\u201D\u5DF2\u4E0B\u8F7D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u8BF7\u5237\u65B0\u9875\u9762\uFF0C\u7136\u540E\u91CD\u8BD5\u3002",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201C{filename}\u201D\u672A\u4E0B\u8F7D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {{percentCount,number}% \u5DF2\u5B8C\u6210}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u6B63\u5728\u4E0B\u8F7D\u201C{filename}\u201D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u4EE5 XLSX \u683C\u5F0F\u5BFC\u51FA",
        'jira-common.ListProjectForms.FormActions.MoreActions': "\u66F4\u591A\u64CD\u4F5C",
        'jira-common.ListProjectForms.FutureIssueMessage': "\u4F7F\u7528\u8FD9\u4E9B\u4E8B\u52A1\u7C7B\u578B\u521B\u5EFA\u7684\u672A\u6765\u8BF7\u6C42\u5C06\u4E0D\u518D\u5305\u542B\u6B64\u8868\u5355\uFF1A",
        'jira-common.ListProjectForms.FutureRequestMessage': "\u4F7F\u7528\u8FD9\u4E9B\u8BF7\u6C42\u7C7B\u578B\u521B\u5EFA\u7684\u672A\u6765\u8BF7\u6C42\u5C06\u4E0D\u518D\u5305\u542B\u6B64\u8868\u5355\u3002",
        'jira-common.ListProjectForms.Heading': "\u5220\u9664\u201C{formName}\u201D\uFF1F",
        'jira-common.ListProjectForms.IssueType': "\u4E8B\u52A1\u7C7B\u578B",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u641C\u7D22\u4E8B\u52A1\u7C7B\u578B",
        'jira-common.ListProjectForms.LastUpdated': "\u4E0A\u6B21\u66F4\u65B0",
        'jira-common.ListProjectForms.LearnMoreLink': "\u4E86\u89E3\u6709\u5173\u5220\u9664\u8868\u5355\u7684\u66F4\u591A\u4FE1\u606F\u3002",
        'jira-common.ListProjectForms.RequestType': "\u8BF7\u6C42\u7C7B\u578B",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u641C\u7D22\u8BF7\u6C42\u7C7B\u578B",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u5220\u9664\u6B64\u8868\u5355\u4F1A\u5C06\u5176\u4ECE\u4EE5\u4E0B\u4E8B\u52A1\u7C7B\u578B\u4E2D\u79FB\u9664\uFF1A",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u5220\u9664\u6B64\u8868\u5355\u4F1A\u5C06\u5176\u4ECE\u4EE5\u4E0B\u8BF7\u6C42\u7C7B\u578B\u4E2D\u79FB\u9664\uFF1A",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u590D\u5236\u76F4\u63A5\u94FE\u63A5",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u4E8B\u52A1\u7C7B\u578B",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u8BF7\u6C42\u7C7B\u578B",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number} \u4E2A\u4E1A\u52A1\u9879\u76EE}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number} \u4E2A\u670D\u52A1\u9879\u76EE}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number} \u4E2A\u8F6F\u4EF6\u9879\u76EE}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \u79CD\u4E8B\u52A1\u7C7B\u578B",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} \u79CD\u8BF7\u6C42\u7C7B\u578B",
        'proforma-project-forms.BusinessForms': "\u9AD8\u7EA7\u8868\u5355",
        'proforma-project-forms.CreateForm': "\u521B\u5EFA\u8868\u5355",
        'proforma-project-forms.Description': "\u521B\u5EFA\u3001\u7F16\u8F91\u3001\u5BFC\u51FA\u548C\u5220\u9664\u8868\u5355\u3002\u590D\u5236\u8868\u5355\u5E76\u5C06\u5176\u7528\u4E8E\u5176\u4ED6\u9879\u76EE\u3002",
        'proforma-project-forms.Forms': "\u8868\u5355",
        'proforma-project-forms.LearnMore': "\u4E86\u89E3\u6709\u5173\u8868\u5355\u7684\u66F4\u591A\u4FE1\u606F\u3002",
        'proforma-project-forms.LoadingForms': "\u6B63\u5728\u52A0\u8F7D...",
        'proforma-project-forms.NoFormsDescriptionJsm': "\u6DFB\u52A0\u8868\u5355\uFF0C\u4F9B\u5BA2\u6237\u63D0\u51FA\u8BF7\u6C42\u65F6\u8FDB\u884C\u586B\u5199\uFF0C\u6216\u5C06\u8868\u5355\u9644\u52A0\u5230\u73B0\u6709\u4E8B\u52A1\u4EE5\u6536\u96C6\u66F4\u591A\u4FE1\u606F\u3002",
        'proforma-project-forms.NoFormsDescriptionJsw': "\u6DFB\u52A0\u8868\u5355\uFF0C\u4F9B\u5BA2\u6237\u521B\u5EFA\u4E8B\u52A1\u65F6\u8FDB\u884C\u586B\u5199\uFF0C\u6216\u5C06\u8868\u5355\u9644\u52A0\u5230\u73B0\u6709\u4E8B\u52A1\u4EE5\u6536\u96C6\u66F4\u591A\u4FE1\u606F\u3002",
        'proforma-project-forms.NoFormsDescriptionJwm': "\u6DFB\u52A0\u8868\u5355\uFF0C\u4F9B\u5BA2\u6237\u521B\u5EFA\u9879\u76EE\u65F6\u8FDB\u884C\u586B\u5199\uFF0C\u6216\u5C06\u8868\u5355\u9644\u52A0\u5230\u73B0\u6709\u4E8B\u52A1\u4EE5\u6536\u96C6\u66F4\u591A\u4FE1\u606F\u3002",
        'proforma-project-forms.NoFormsHeading': "\u60A8\u7684\u6240\u6709\u8868\u5355\u5747\u4F1A\u663E\u793A\u5728\u6B64\u5904",
        'proforma-project-forms.NoFormsHeadingAdvanced': "\u60A8\u7684\u6240\u6709\u9AD8\u7EA7\u8868\u5355\u5747\u4F1A\u663E\u793A\u5728\u6B64\u5904",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "\u4ECE\u5BFC\u5165\u5185\u5BB9\u521B\u5EFA",
        'proforma-project-forms.create-form-button.create-blank': "\u521B\u5EFA\u7A7A\u767D\u8868\u5355",
        'proforma-project-forms.create-form-button.create-from-blank': "\u4ECE\u7A7A\u767D\u8868\u5355\u521B\u5EFA",
        'proforma-project-forms.create-form-button.create-with-template': "\u4ECE\u6A21\u677F\u521B\u5EFA",
        'proforma-project-forms.create-form-button.trigger': "\u521B\u5EFA\u8868\u5355"
    };
});
parcelRegister("fBEDb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5c9d4309ec636d9$export$2e2bcd8739ae039);
    var $b5c9d4309ec636d9$export$2e2bcd8739ae039 = {
        'form-system.general.Edit': "\u7DE8\u8F2F",
        'form-system.general.Form': "\u540D\u7A31",
        'jira-common.ListProjectForms.AffectExistingIssues': "\u9019\u4E0D\u6703\u5F71\u97FF\u5DF2\u7D93\u4F7F\u7528\u6B64\u8868\u55AE (\u6216\u8005\u6B64\u8868\u55AE\u5728\u5176\u4ED6\u5C08\u6848\u4E2D\u7684\u4EFB\u4F55\u8907\u672C) \u7684\u73FE\u6709\u8B70\u984C\u3002",
        'jira-common.ListProjectForms.AssociatedIssueTypes': "\u8B70\u984C\u985E\u578B",
        'jira-common.ListProjectForms.AssociatedRequestTypes': "\u8981\u6C42\u985E\u578B",
        'jira-common.ListProjectForms.Cancel': "\u53D6\u6D88",
        'jira-common.ListProjectForms.Copy': "\u8907\u88FD\u5230\u5C08\u6848",
        'jira-common.ListProjectForms.CopyFormErrorTitle': "\u932F\u8AA4\uFF1A\u7121\u6CD5\u5C07\u300C{formName}\u300D\u8907\u88FD\u904E\u53BB",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfBusinessProjectsMessage}\u300D\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfBusinessProjects,number} \u500B\u696D\u52D9\u5C08\u6848}}",
        'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfProjects,number} \u500B\u5C08\u6848}}",
        'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{projectName}\u300D\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfServiceProjectsMessage}\u300D\u8207\u300C{numberOfBusinessProjectsMessage}\u300D\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfServiceProjectsMessage}\u300D\u8207\u300C{numberOfSoftwareProjectsMessage}\u300D\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfServiceProjectsMessage}\u300D\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfServiceProjects,number} \u500B\u670D\u52D9\u5C08\u6848}}",
        'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfServiceProjectsMessage}\u300D\u3001\u300C{numberOfSoftwareProjectsMessage}\u300D\u8207\u300C{numberOfBusinessProjectsMessage}\u300D\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfSoftwareProjectsMessage}\u300D\u8207\u300C{numberOfBusinessProjectsMessage}\u300D\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfSoftwareProjectsMessage}\u300D\u3002",
        'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfSoftwareProjects,number} \u500B\u8EDF\u9AD4\u5C08\u6848}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, other {\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC {numberOfProjects,number} \u500B\u5C08\u6848\u3002}}",
        'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfProjects,number} \u500B\u5C08\u6848}}",
        'jira-common.ListProjectForms.CopyModal.Cancel': "\u53D6\u6D88",
        'jira-common.ListProjectForms.CopyModal.Copy': "\u8907\u88FD",
        'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u8907\u88FD\u5230\u5C08\u6848",
        'jira-common.ListProjectForms.CopyModal.Heading': "\u5C07\u300C{formName}\u300D\u8907\u88FD\u5230\u5176\u4ED6\u5C08\u6848",
        'jira-common.ListProjectForms.CopyModal.LearnMore': "\u6DF1\u5165\u4E86\u89E3\u5982\u4F55\u8907\u88FD\u8868\u55AE",
        'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u6B63\u5728\u8F09\u5165\u5C08\u6848",
        'jira-common.ListProjectForms.CopyModal.Name': "\u540D\u7A31",
        'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u9078\u53D6\u6240\u6709\u5C08\u6848",
        'jira-common.ListProjectForms.CopyModal.SubHeading': "\u5C0D\u8868\u55AE\u6240\u505A\u7684\u8B8A\u66F4\u4E0D\u6703\u53CD\u6620\u5728\u5176\u4ED6\u5C08\u6848\u7684\u4EFB\u4F55\u526F\u672C\u3002",
        'jira-common.ListProjectForms.CopyText': "\u300C{formName}\u300D\u526F\u672C",
        'jira-common.ListProjectForms.Delete': "\u522A\u9664",
        'jira-common.ListProjectForms.DeleteFormSuccess': "\u300C{formName}\u300D\u5DF2\u522A\u9664",
        'jira-common.ListProjectForms.Duplicate': "\u8907\u88FD",
        'jira-common.ListProjectForms.EmptyFormName': "\u7121\u6A19\u984C\u8868\u55AE",
        'jira-common.ListProjectForms.FilterForms': "\u7BE9\u9078\u8868\u55AE",
        'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u300C{filename}\u300D\u5DF2\u4E0B\u8F09",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
        'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u672A\u4E0B\u8F09\u300C{filename}\u300D",
        'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {\u5B8C\u6210 {percentCount,number}%}}",
        'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u6B63\u5728\u4E0B\u8F09\u300C{filename}\u300D",
        'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u5728 XLSX \u4E2D\u532F\u51FA",
        'jira-common.ListProjectForms.FormActions.MoreActions': "\u66F4\u591A\u52D5\u4F5C",
        'jira-common.ListProjectForms.FutureIssueMessage': "\u4F7F\u7528\u9019\u4E9B\u8B70\u984C\u985E\u578B\u5EFA\u7ACB\u7684\u672A\u4F86\u8B70\u984C\u5C07\u4E0D\u518D\u5305\u542B\u4EE5\u4E0B\u8868\u55AE\uFF1A",
        'jira-common.ListProjectForms.FutureRequestMessage': "\u65E5\u5F8C\u4F7F\u7528\u9019\u4E9B\u8981\u6C42\u985E\u578B\u6240\u5EFA\u7ACB\u7684\u8981\u6C42\u5C07\u4E0D\u6703\u518D\u5305\u542B\u6B64\u8868\u55AE\u3002",
        'jira-common.ListProjectForms.Heading': "\u8981\u522A\u9664\u300C{formName}\u300D\u55CE\uFF1F",
        'jira-common.ListProjectForms.IssueType': "\u8B70\u984C\u985E\u578B",
        'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u641C\u5C0B\u8B70\u984C\u985E\u578B",
        'jira-common.ListProjectForms.LastUpdated': "\u4E0A\u6B21\u66F4\u65B0",
        'jira-common.ListProjectForms.LearnMoreLink': "\u9032\u4E00\u6B65\u4E86\u89E3\u5982\u4F55\u522A\u9664\u8868\u55AE\u3002",
        'jira-common.ListProjectForms.RequestType': "\u8981\u6C42\u985E\u578B",
        'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u641C\u5C0B\u8981\u6C42\u985E\u578B",
        'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u5982\u679C\u522A\u9664\u6B64\u8868\u55AE\uFF0C\u7CFB\u7D71\u6703\u5C07\u5176\u5F9E\u4EE5\u4E0B\u8B70\u984C\u985E\u578B\u4E2D\u79FB\u9664\uFF1A",
        'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u5982\u679C\u522A\u9664\u6B64\u8868\u55AE\uFF0C\u7CFB\u7D71\u6703\u5C07\u5176\u5F9E\u4EE5\u4E0B\u8981\u6C42\u985E\u578B\u4E2D\u79FB\u9664\uFF1A",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u8907\u88FD\u76F4\u63A5\u9023\u7D50",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u8B70\u984C\u985E\u578B",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u8981\u6C42\u985E\u578B",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number} \u500B\u696D\u52D9\u5C08\u6848}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number} \u500B\u670D\u52D9\u5C08\u6848}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number} \u500B\u8EDF\u9AD4\u5C08\u6848}}",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \u500B\u8B70\u984C\u985E\u578B",
        'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} \u500B\u8981\u6C42\u985E\u578B",
        'proforma-project-forms.BusinessForms': "\u9032\u968E\u8868\u55AE",
        'proforma-project-forms.CreateForm': "\u5EFA\u7ACB\u8868\u55AE",
        'proforma-project-forms.Description': "\u5EFA\u7ACB\u3001\u7DE8\u8F2F\u3001\u532F\u51FA\u548C\u522A\u9664\u8868\u55AE\u3002\u8907\u88FD\u8868\u55AE\u4E26\u4E14\u5728\u5176\u4ED6\u5C08\u6848\u4E2D\u4F7F\u7528\u3002",
        'proforma-project-forms.Forms': "\u8868\u55AE",
        'proforma-project-forms.LearnMore': "\u6DF1\u5165\u4E86\u89E3\u8868\u55AE\u3002",
        'proforma-project-forms.LoadingForms': "\u8F09\u5165\u4E2D...",
        'proforma-project-forms.NoFormsDescriptionJsm': "\u65B0\u589E\u8868\u55AE\u4EE5\u4F9B\u5BA2\u6236\u5728\u63D0\u51FA\u8981\u6C42\u6642\u586B\u5BEB\uFF0C\u6216\u5C07\u8868\u55AE\u9644\u52A0\u5230\u73FE\u6709\u8B70\u984C\u4EE5\u6536\u96C6\u66F4\u591A\u8CC7\u8A0A\u3002",
        'proforma-project-forms.NoFormsDescriptionJsw': "\u65B0\u589E\u8868\u55AE\u4EE5\u4F9B\u5BA2\u6236\u5728\u5EFA\u7ACB\u8B70\u984C\u6642\u586B\u5BEB\uFF0C\u6216\u5C07\u8868\u55AE\u9644\u52A0\u5230\u73FE\u6709\u8B70\u984C\u4EE5\u6536\u96C6\u66F4\u591A\u8CC7\u8A0A\u3002",
        'proforma-project-forms.NoFormsDescriptionJwm': "\u65B0\u589E\u8868\u55AE\u4EE5\u4F9B\u5BA2\u6236\u5728\u5EFA\u7ACB\u9805\u76EE\u6642\u586B\u5BEB\uFF0C\u6216\u5C07\u8868\u55AE\u9644\u52A0\u5230\u73FE\u6709\u8B70\u984C\u4EE5\u6536\u96C6\u66F4\u591A\u8CC7\u8A0A\u3002",
        'proforma-project-forms.NoFormsHeading': "\u60A8\u7684\u6240\u6709\u8868\u55AE\u90FD\u6703\u986F\u793A\u5728\u9019\u88E1",
        'proforma-project-forms.NoFormsHeadingAdvanced': "\u60A8\u7684\u6240\u6709\u9032\u968E\u8868\u55AE\u90FD\u6703\u986F\u793A\u5728\u9019\u88E1",
        'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
        'proforma-project-forms.create-form-button.convert-form': "\u5F9E\u532F\u5165\u9805\u76EE\u5EFA\u7ACB",
        'proforma-project-forms.create-form-button.create-blank': "\u5EFA\u7ACB\u7A7A\u767D\u8868\u55AE",
        'proforma-project-forms.create-form-button.create-from-blank': "\u5F9E\u7A7A\u767D\u8868\u55AE\u5EFA\u7ACB",
        'proforma-project-forms.create-form-button.create-with-template': "\u5F9E\u7BC4\u672C\u5EFA\u7ACB",
        'proforma-project-forms.create-form-button.trigger': "\u5EFA\u7ACB\u8868\u55AE"
    };
});
parcelRegister("qE8Ux", function(module, exports) {
    $parcel$export(module.exports, "ProjectFormsContainer", ()=>$05019154d31e63a1$export$bcb823343695b9a8);
    $parcel$export(module.exports, "useProjectFormsController", ()=>$05019154d31e63a1$export$afd20f582dd6fb24);
    $parcel$export(module.exports, "useProjectFormsControllerActions", ()=>$05019154d31e63a1$export$cb8caaed5fbed4c4);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $05019154d31e63a1$var$initialState = {
        forms: [],
        loading: false,
        sortKey: 'Name',
        sortOrder: 'ASC'
    };
    const $05019154d31e63a1$var$actions = {
        load: ()=>({ setState: setState, getState: getState }, { errorUtils: errorUtils, projectFormApi: projectFormApi })=>{
                if (getState().loading) return Promise.resolve();
                setState({
                    loading: true
                });
                return projectFormApi.getForms().then((newForms)=>{
                    setState({
                        forms: newForms,
                        loading: false
                    });
                }).catch((error)=>{
                    errorUtils.reportError(error, {
                        id: 'getForms'
                    });
                    return Promise.reject(error);
                });
            },
        onSort: (sortDetails)=>({ setState: setState })=>{
                setState({
                    sortKey: sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.key,
                    sortOrder: sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.sortOrder
                });
            }
    };
    const $05019154d31e63a1$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $05019154d31e63a1$var$initialState,
        actions: $05019154d31e63a1$var$actions,
        name: 'ProjectFormsStore'
    });
    const $05019154d31e63a1$export$bcb823343695b9a8 = (0, (0, parcelRequire("gg7kZ")).createContainer)($05019154d31e63a1$var$Store, {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($05019154d31e63a1$var$actions.load())
    });
    const $05019154d31e63a1$export$afd20f582dd6fb24 = (0, (0, parcelRequire("3sQ5x")).createHook)($05019154d31e63a1$var$Store);
    const $05019154d31e63a1$export$cb8caaed5fbed4c4 = (0, (0, parcelRequire("3sQ5x")).createHook)($05019154d31e63a1$var$Store, {
        selector: null
    });
});
parcelRegister("3STiV", function(module, exports) {
    $parcel$export(module.exports, "IssueFormsApiProvider", ()=>$2d41508309841bb9$export$cc17409dbbedbd3d);
    $parcel$export(module.exports, "useIssueFormsApi", ()=>$2d41508309841bb9$export$b3af41f49cf1d3c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $eoy38;
    const $2d41508309841bb9$var$IssueFormsApiContext = (0, $5uXOq.createContext)(null);
    const $2d41508309841bb9$export$cc17409dbbedbd3d = ({ issueFormsApi: issueFormsApi, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($2d41508309841bb9$var$IssueFormsApiContext.Provider, {
            value: issueFormsApi
        }, children);
    const $2d41508309841bb9$export$b3af41f49cf1d3c8 = ()=>{
        const issueFormsApi = (0, $5uXOq.useContext)($2d41508309841bb9$var$IssueFormsApiContext);
        if (issueFormsApi === null) throw new Error(`useIssueFormsApi() must be used within a IssueFormsApiProvider. ${(0, (0, parcelRequire("eoy38")).errorMessageDuplicateCommonCore)}`);
        return issueFormsApi;
    };
});
parcelRegister("eoy38", function(module, exports) {
    $parcel$export(module.exports, "errorMessageDuplicateCommonCore", ()=>$a7adb81fe5bce679$export$202e68bc03a230f);
    const $a7adb81fe5bce679$export$202e68bc03a230f = "Please check that the yarn.lock file contains only 1 version of proforma-common-core. You should bump all Proforma packages to their latest version";
});
parcelRegister("7Tgou", function(module, exports) {
    $parcel$export(module.exports, "LiveIssueFormsApi", ()=>$5bea62faa48a7293$export$261c0d1781964c99);
    class $5bea62faa48a7293$export$261c0d1781964c99 {
        constructor(projectId, util){
            this.projectId = projectId;
            this.util = util;
        }
        async getIssueFormsInfo() {
            return this.util.get(`/api/cloud/createissue/project/${this.projectId}/forms`);
        }
    }
});
parcelRegister("1OCFt", function(module, exports) {
    $parcel$export(module.exports, "LiveProjectApi", ()=>$15287497085335eb$export$c5bc9c89db1bda99);
    var $eHiP8 = parcelRequire("eHiP8");
    class $15287497085335eb$export$c5bc9c89db1bda99 {
        constructor(util){
            (0, $eHiP8.default)(this, "convertJiraProjectToProject", (jiraProject)=>({
                    ...jiraProject,
                    id: parseInt(jiraProject.id, 10)
                }));
            this.util = util;
        }
        getAllProjects(isJswEnabled, isJwmEnabled) {
            return this.util.get(`/api/3/projects?isJswEnabled=${isJswEnabled}&isJwmEnabled=${isJwmEnabled}`).then((projects)=>projects.map((project)=>this.convertJiraProjectToProject(project)));
        }
    }
});
parcelRegister("ew6tB", function(module, exports) {
    $parcel$export(module.exports, "ProjectApiProvider", ()=>$02ba35ffac5a6d07$export$d59c1879d9521dec);
    $parcel$export(module.exports, "useProjectApi", ()=>$02ba35ffac5a6d07$export$46e1d0c6200f37f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eoy38;
    const $02ba35ffac5a6d07$var$ProjectApiContext = (0, $5uXOq.createContext)(undefined);
    const $02ba35ffac5a6d07$export$d59c1879d9521dec = ({ projectApi: projectApi, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($02ba35ffac5a6d07$var$ProjectApiContext.Provider, {
            value: projectApi
        }, children);
    const $02ba35ffac5a6d07$export$46e1d0c6200f37f = ()=>{
        const projectApi = (0, $5uXOq.useContext)($02ba35ffac5a6d07$var$ProjectApiContext);
        if (projectApi === undefined) throw new Error(`useProjectApi() must be used within a ProjectApiProvider. ${(0, (0, parcelRequire("eoy38")).errorMessageDuplicateCommonCore)}`);
        return projectApi;
    };
});
parcelRegister("gmf3c", function(module, exports) {
    $parcel$export(module.exports, "LiveProjectFormApi", ()=>$be8a60297d8e6940$export$633a9f556df6b0b0);
    var $a1RLT;
    class $be8a60297d8e6940$export$633a9f556df6b0b0 {
        constructor(projectId, util){
            this.projectId = projectId;
            this.util = util;
        }
        getForms() {
            return this.util.get(`/api/1/projects/${this.projectId}/forms`);
        }
        startXlsxDownload(templateFormId) {
            return this.util.post(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}`, undefined);
        }
        checkXlsxDownload(templateFormId, taskId) {
            return this.util.get(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}/${taskId}`);
        }
        downloadFinishedXlsx(templateFormId, taskId) {
            return this.util.get(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}/${taskId}/ProForma-${this.projectId}-form-${templateFormId}.xlsx`, 'exportDownload', (0, (0, parcelRequire("a1RLT")).AcceptedResponseType).Blob);
        }
        deleteProjectForm(templateFormId) {
            return this.util.delete(`/api/1/projects/${this.projectId}/forms/${templateFormId}`);
        }
    }
});
parcelRegister("2weNo", function(module, exports) {
    $parcel$export(module.exports, "ProjectFormApiProvider", ()=>$1d5a0c0b4a944002$export$1b3e028f1b481fa1);
    $parcel$export(module.exports, "useProjectFormApi", ()=>$1d5a0c0b4a944002$export$c06094384c75f8b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $eoy38;
    const $1d5a0c0b4a944002$var$ProjectFormApiContext = (0, $5uXOq.createContext)(undefined);
    const $1d5a0c0b4a944002$export$1b3e028f1b481fa1 = ({ projectFormApi: projectFormApi, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($1d5a0c0b4a944002$var$ProjectFormApiContext.Provider, {
            value: projectFormApi
        }, children);
    const $1d5a0c0b4a944002$export$c06094384c75f8b4 = ()=>{
        const projectFormApi = (0, $5uXOq.useContext)($1d5a0c0b4a944002$var$ProjectFormApiContext);
        if (projectFormApi === undefined) throw new Error(`useProjectFormApi() must be used within a ProjectFormApiProvider. ${(0, (0, parcelRequire("eoy38")).errorMessageDuplicateCommonCore)}`);
        return projectFormApi;
    };
});
parcelRegister("lLGUB", function(module, exports) {
    $parcel$export(module.exports, "LiveRequestTypeApi", ()=>$fd8f4631ee508adb$export$1705810df2e31f50);
    class $fd8f4631ee508adb$export$1705810df2e31f50 {
        constructor(projectId, util){
            this.projectId = projectId;
            this.util = util;
        }
        async getRequestTypeCategories() {
            return this.util.jiraGet(`/rest/servicedesk/1/servicedesk/${this.projectId}/request-types`);
        }
    }
});
parcelRegister("c92ML", function(module, exports) {
    $parcel$export(module.exports, "RequestTypeApiProvider", ()=>$8d787c6f4b1c9c9b$export$3f33beafacd46d1a);
    $parcel$export(module.exports, "useRequestTypeApi", ()=>$8d787c6f4b1c9c9b$export$812317080a6b942d);
    var $5uXOq = parcelRequire("5uXOq");
    var $eoy38;
    const $8d787c6f4b1c9c9b$var$RequestTypeApiContext = (0, $5uXOq.createContext)(null);
    const $8d787c6f4b1c9c9b$export$3f33beafacd46d1a = ({ requestTypeApi: requestTypeApi, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($8d787c6f4b1c9c9b$var$RequestTypeApiContext.Provider, {
            value: requestTypeApi
        }, children);
    const $8d787c6f4b1c9c9b$export$812317080a6b942d = ()=>{
        const requestTypeApi = (0, $5uXOq.useContext)($8d787c6f4b1c9c9b$var$RequestTypeApiContext);
        if (requestTypeApi === null) throw new Error(`useRequestTypeApi() must be used within a RequestTypeApiProvider. ${(0, (0, parcelRequire("eoy38")).errorMessageDuplicateCommonCore)}`);
        return requestTypeApi;
    };
});
parcelRegister("biT53", function(module, exports) {
    $parcel$export(module.exports, "LiveTemplateFormApi", ()=>$83ac19fe023d9417$export$a54d6a590c20cde6);
    class $83ac19fe023d9417$export$a54d6a590c20cde6 {
        constructor(util){
            this.util = util;
        }
        copyTemplateForm(formId, projectId, copyProjectId, formName) {
            return this.util.post(`/api/2/projects/${projectId}/forms`, {
                name: formName,
                copyProjectId: copyProjectId,
                copyFormId: formId.toString()
            });
        }
        createTemplateFormForProject(projectId, formName) {
            return this.util.post(`/api/2/projects/${projectId}/forms`, {
                name: formName
            });
        }
    }
});
parcelRegister("cyeJM", function(module, exports) {
    $parcel$export(module.exports, "TemplateFormApiProvider", ()=>$9234179345da6f44$export$54424fb733a27080);
    $parcel$export(module.exports, "useTemplateFormApi", ()=>$9234179345da6f44$export$b549592ba5c7b5b);
    var $5uXOq = parcelRequire("5uXOq");
    var $eoy38;
    const $9234179345da6f44$var$TemplateFormApiContext = (0, $5uXOq.createContext)(undefined);
    const $9234179345da6f44$export$54424fb733a27080 = ({ templateFormApi: templateFormApi, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($9234179345da6f44$var$TemplateFormApiContext.Provider, {
            value: templateFormApi
        }, children);
    const $9234179345da6f44$export$b549592ba5c7b5b = ()=>{
        const templateFormApi = (0, $5uXOq.useContext)($9234179345da6f44$var$TemplateFormApiContext);
        if (templateFormApi === undefined) throw new Error(`useTemplateFormApi must be used within a TemplateFormApiProvider. ${(0, (0, parcelRequire("eoy38")).errorMessageDuplicateCommonCore)}`);
        return templateFormApi;
    };
});
parcelRegister("k7zrN", function(module, exports) {
    $parcel$export(module.exports, "ProjectForms", ()=>$ea5ff52e010bbd32$export$fba3a70fd399a62d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $lVJAU;
    var $2NMNM;
    var $ldJSL;
    var $fVnbM;
    var $57MwZ;
    var $VSDnB;
    var $h8yj2;
    var $dFdBd;
    var $eWfcO;
    var $ex6Rw;
    var $aW3TH;
    var $erWXD;
    var $qE8Ux;
    var $cyeJM;
    var $5GADc;
    var $coO0Y;
    var $a065r;
    var $8Ls6i;
    var $cbPCu;
    var $jRtpo;
    const $ea5ff52e010bbd32$export$fba3a70fd399a62d = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, simplifiedProject: simplifiedProject, userIsProjectAdmin: userIsProjectAdmin })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { onOpenInProductHelpArticle: onOpenInProductHelpArticle } = (0, (0, parcelRequire("eWfcO")).useInProductHelp)();
        const { reportError: reportError } = (0, (0, parcelRequire("ex6Rw")).usePfErrorUtils)();
        const [{ forms: forms, loading: loading }] = (0, (0, parcelRequire("qE8Ux")).useProjectFormsController)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const templateFormApi = (0, (0, parcelRequire("cyeJM")).useTemplateFormApi)();
        const { setIsTemplateLibraryOpen: setIsTemplateLibraryOpen } = (0, (0, parcelRequire("aW3TH")).useTemplateLibraryActions)();
        const [isCreatingForm, setIsCreatingForm] = (0, $5uXOq.useState)(false);
        const pageHeadingMessage = (0, (0, parcelRequire("jRtpo")).isSoftwareFormsEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), projectType === 'service_desk' ? (0, (0, parcelRequire("8Ls6i")).messages).pageHeadingNonJwm : (0, (0, parcelRequire("8Ls6i")).messages).pageHeadingJwm) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), projectType === 'business' ? (0, (0, parcelRequire("8Ls6i")).messages).pageHeadingJwm : (0, (0, parcelRequire("8Ls6i")).messages).pageHeadingNonJwm);
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).ProjectFormsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).HeadingContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), null, pageHeadingMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dFdBd")).LoadingSpinner), {
            size: "large"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8Ls6i")).messages).loading)));
        const createForm = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("h8yj2")).fireUIAnalytics)(analyticsEvent, 'createTemplateForm');
            setIsCreatingForm(true);
            templateFormApi.createTemplateFormForProject(projectId, '').then((response)=>{
                (0, (0, parcelRequire("h8yj2")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("erWXD")).ActionSubject).TEMPLATE_FORM} ${(0, (0, parcelRequire("erWXD")).Action).CREATED}`, {
                    templateFormId: response.id
                });
                push(response.nextUrl);
            }).catch((error)=>{
                if ((0, (0, parcelRequire("VSDnB")).fg)('proforma_add_project_form_analytics')) reportError(error, {
                    id: 'addForm'
                });
            }).finally(()=>{
                setIsCreatingForm(false);
            });
        };
        const openTemplateLibrary = ()=>setIsTemplateLibraryOpen(true);
        const learnMoreButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            spacing: "none",
            onClick: ()=>onOpenInProductHelpArticle('5TZElbp1tEXG70CGT0HmT4')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8Ls6i")).messages).learnMoreLinkLabel));
        const headingActions = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coO0Y")).CreateFormDropdown), {
            isLoading: isCreatingForm,
            onCreateBlankForm: createForm,
            onCreateFormFromTemplate: openTemplateLibrary
        }));
        const forkedHeading = projectType === 'service_desk' ? (0, (0, parcelRequire("8Ls6i")).messages).noFormsHeading : (0, (0, parcelRequire("8Ls6i")).messages).noFormsHeadingAdvanced;
        if (forms.length === 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).ProjectFormsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).HeadingContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            actions: headingActions
        }, pageHeadingMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).NoFormsColumn), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5GADc")).CreateFormSvg), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).NoFormsHeading), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jRtpo")).isSoftwareFormsEnabled)() ? forkedHeading : (0, (0, parcelRequire("8Ls6i")).messages).noFormsHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).NoFormsDescription), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), projectType === 'service_desk' ? (0, (0, parcelRequire("8Ls6i")).messages).noFormsDescriptionJsm : projectType === 'software' ? (0, (0, parcelRequire("8Ls6i")).messages).noFormsDescriptionJsw : (0, (0, parcelRequire("8Ls6i")).messages).noFormsDescriptionJwm)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).NoFormsLearnMoreLink), null, learnMoreButton)));
        const bottomBar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).Description), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8Ls6i")).messages).description), "\xA0", learnMoreButton);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).ProjectFormsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbPCu")).HeadingContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            actions: headingActions,
            bottomBar: bottomBar
        }, pageHeadingMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a065r")).ListProjectForms), {
            projectType: projectType,
            projectKey: projectKey,
            simplifiedProject: simplifiedProject,
            userIsProjectAdmin: userIsProjectAdmin
        }));
    };
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("dFdBd", function(module, exports) {
    $parcel$export(module.exports, "LoadingSpinner", ()=>$9f29a73d0e173b34$export$b08b517936747730);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $eZJjh;
    const $9f29a73d0e173b34$export$b08b517936747730 = ({ size: size = 'medium', children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($9f29a73d0e173b34$var$LoadingSpinnerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: size
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($9f29a73d0e173b34$var$LoadingSpinnerMessage, null, children));
    const $9f29a73d0e173b34$var$LoadingSpinnerContainer = (0, $dAHxw.default).div({
        textAlign: 'center'
    });
    const $9f29a73d0e173b34$var$LoadingSpinnerMessage = (0, $dAHxw.default).p({});
});
parcelRegister("aW3TH", function(module, exports) {
    $parcel$export(module.exports, "TemplateLibraryContainer", ()=>$7f62581ee82d6ab6$export$b414c1ae30748492);
    $parcel$export(module.exports, "useTemplateLibraryState", ()=>$7f62581ee82d6ab6$export$47840b12545bcb14);
    $parcel$export(module.exports, "useTemplateLibraryActions", ()=>$7f62581ee82d6ab6$export$8bf462d2c8456f46);
    $parcel$export(module.exports, "useTemplateForm", ()=>$7f62581ee82d6ab6$export$7646fd624e15efcf);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    const $7f62581ee82d6ab6$export$6114e3fefcbff062 = (isOpen)=>({ setState: setState })=>{
            setState({
                isTemplateLibraryOpen: isOpen
            });
        };
    const $7f62581ee82d6ab6$export$b9839c0fc9ebf20a = (selectedTemplate)=>({ setState: setState })=>{
            setState({
                selectedTemplate: selectedTemplate
            });
        };
    const $7f62581ee82d6ab6$export$7679083b8956d369 = (id, template)=>({ setState: setState, getState: getState })=>{
            const currentTemplates = getState().templates;
            if (!currentTemplates[id]) {
                currentTemplates[id] = {
                    ...template
                };
                setState({
                    templates: {
                        ...currentTemplates
                    }
                });
            }
        };
    const $7f62581ee82d6ab6$var$actions = {
        setIsTemplateLibraryOpen: $7f62581ee82d6ab6$export$6114e3fefcbff062,
        setSelectedTemplate: $7f62581ee82d6ab6$export$b9839c0fc9ebf20a,
        setTemplates: $7f62581ee82d6ab6$export$7679083b8956d369
    };
    const $7f62581ee82d6ab6$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isTemplateLibraryOpen: false,
            selectedTemplate: undefined,
            templates: {}
        },
        name: 'proforma-template-library-store',
        actions: $7f62581ee82d6ab6$var$actions
    });
    const $7f62581ee82d6ab6$export$b414c1ae30748492 = (0, (0, parcelRequire("gg7kZ")).createContainer)($7f62581ee82d6ab6$var$Store);
    const $7f62581ee82d6ab6$export$47840b12545bcb14 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($7f62581ee82d6ab6$var$Store);
    const $7f62581ee82d6ab6$export$8bf462d2c8456f46 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($7f62581ee82d6ab6$var$Store);
    const $7f62581ee82d6ab6$export$1a4139ca79fdfefc = (state, id)=>state.templates[id];
    const $7f62581ee82d6ab6$export$7646fd624e15efcf = (0, (0, parcelRequire("3sQ5x")).createStateHook)($7f62581ee82d6ab6$var$Store, {
        selector: $7f62581ee82d6ab6$export$1a4139ca79fdfefc
    });
});
parcelRegister("5GADc", function(module, exports) {
    $parcel$export(module.exports, "CreateFormSvg", ()=>$423d4a35786e0e37$export$b31d126f74eb63db);
    var $5uXOq = parcelRequire("5uXOq");
    const $423d4a35786e0e37$export$b31d126f74eb63db = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            width: "216",
            height: "167",
            viewBox: "0 0 365.22 282.95"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("style", null, `
        .cls-1{isolation:isolate;}
        .cls-2{fill:url(#linear-gradient);}
        .cls-3{opacity:0.07;fill:url(#linear-gradient-2);}
        .cls-4{fill:#4c9aff;}
        .cls-5{fill:url(#linear-gradient-3);}
        .cls-6,.cls-9{fill:#dfe1e5;}
        .cls-15,.cls-16,.cls-6{mix - blend - mode:multiply;}
        .cls-7{fill:#0052cc;}
        .cls-8{fill:#b2d4ff;}
        .cls-10{fill:url(#linear-gradient-4);}
        .cls-11{fill:url(#linear-gradient-5);}
        .cls-12{fill:url(#linear-gradient-6);}
        .cls-13{fill:url(#linear-gradient-7);}
        .cls-14{fill:none;stroke:#2684ff;stroke-miterlimit:10;stroke-width:8px;}
        .cls-15,.cls-16{opacity:0.39;}
        .cls-15{fill:url(#linear-gradient-8);}
        .cls-16{fill:url(#linear-gradient-9);}
        `), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient",
            x1: "43.88",
            y1: "263.33",
            x2: "351.09",
            y2: "-43.88",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0",
            stopColor: "#dfe1e5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#fafbfc"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient-2",
            x1: "135.86",
            y1: "138.06",
            x2: "135.86",
            y2: "235.8",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0",
            stopColor: "#091e42"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#091e42",
            stopOpacity: "0.1"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient-3",
            x1: "10.35",
            y1: "146.56",
            x2: "311.65",
            y2: "146.56",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0",
            stopColor: "#b2d4ff"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.02",
            stopColor: "#b5d6ff"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.13",
            stopColor: "#c8dfff"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.26",
            stopColor: "#d4e6ff"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.43",
            stopColor: "#dceaff"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.79",
            stopColor: "#deebff"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient-4",
            x1: "49.65",
            y1: "180.3",
            x2: "269.79",
            y2: "180.3",
            xlinkHref: "#linear-gradient-3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient-5",
            x1: "37.04",
            y1: "209.41",
            x2: "338.35",
            y2: "209.41",
            xlinkHref: "#linear-gradient-3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient-6",
            x1: "3.07",
            y1: "266.43",
            x2: "303.37",
            y2: "266.43",
            xlinkHref: "#linear-gradient-3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient-7",
            x1: "49.65",
            y1: "236.32",
            x2: "269.79",
            y2: "236.32",
            xlinkHref: "#linear-gradient-3"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient-8",
            x1: "187.7",
            y1: "713.48",
            x2: "187.7",
            y2: "741.99",
            gradientTransform: "matrix(1, 0, 0, -1, 0, 907.97)",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0",
            stopColor: "#b2d4ff"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.87",
            stopColor: "#b2d4ff"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#b2d4ff"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "linear-gradient-9",
            x1: "189.7",
            y1: "659.36",
            x2: "189.7",
            y2: "684.03",
            xlinkHref: "#linear-gradient-8"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            className: "cls-1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "Layer_2",
            "data-name": "Layer 2"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "Layer_1-2",
            "data-name": "Layer 1"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            className: "cls-2",
            width: "365.22",
            height: "249.2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            className: "cls-3",
            d: "M244.35,248.89c-90.8.08-228.87,0-228.87,0L36.94,123.29h219.3Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            className: "cls-4",
            d: "M40.05,90.07H325.34a3,3,0,0,1,3,3v37.05a0,0,0,0,1,0,0H37a0,0,0,0,1,0,0V93.08A3,3,0,0,1,40.05,90.07Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            className: "cls-5",
            points: "338.35 163.52 47.04 163.52 37.04 129.61 328.35 129.61 338.35 163.52"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            className: "cls-6",
            x: "37.35",
            y: "32.72",
            width: "174.7",
            height: "7"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            className: "cls-6",
            x: "37.35",
            y: "49.52",
            width: "127.57",
            height: "7"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            className: "cls-7",
            x: "52.13",
            y: "107.11",
            width: "186.18",
            height: "7"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            className: "cls-8",
            x: "229.2",
            y: "18.12",
            width: "52.93",
            height: "52.93",
            rx: "4.24"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            className: "cls-9",
            x: "297.53",
            y: "30.42",
            width: "28.32",
            height: "28.32",
            rx: "3.56"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            className: "cls-10",
            points: "338.35 163.47 47.04 163.47 37.04 197.12 328.35 197.12 338.35 163.47"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            className: "cls-11",
            points: "338.35 221.8 47.04 221.8 37.04 197.02 328.35 197.02 338.35 221.8"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            className: "cls-12",
            points: "341.35 282.95 50.04 282.95 41.04 249.91 332.35 249.91 341.35 282.95"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            className: "cls-13",
            points: "338.35 221.77 47.04 221.77 41.04 250.88 332.35 250.88 338.35 221.77"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("polyline", {
            className: "cls-14",
            points: "238.44 45.85 250.93 58.54 273.92 29.16"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            className: "cls-15",
            points: "338.35 163.47 47.04 163.47 37.04 197.12 328.35 197.12 338.35 163.47"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("polygon", {
            className: "cls-16",
            points: "338.35 221.77 47.04 221.77 41.04 250.88 332.35 250.88 338.35 221.77"
        })))));
});
parcelRegister("coO0Y", function(module, exports) {
    $parcel$export(module.exports, "CreateFormDropdown", ()=>$906e85cd6e2d3c2f$export$d9c4444e1f762d71);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $2NMNM;
    var $2rqOp;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $6Ingq;
    var $dshNB;
    const $906e85cd6e2d3c2f$export$d9c4444e1f762d71 = ({ isLoading: isLoading, onCreateBlankForm: onCreateBlankForm, onCreateFormFromTemplate: onCreateFormFromTemplate })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleOnCreateBlank = (e)=>{
            onCreateBlankForm(e, createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            placement: "bottom-end",
            shouldRenderToParent: true,
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), (0, $bS32t.default)({}, props, {
                    appearance: "primary",
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    }),
                    ref: triggerRef,
                    isLoading: isLoading
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("dshNB")).messages).createFormTrigger))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onCreateFormFromTemplate
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("dshNB")).messages).createFormTemplate)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: handleOnCreateBlank
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("dshNB")).messages).createFormBlank))));
    };
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("dshNB", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$9cbbb26ba43971fc$export$defe85febe8b728c);
    var $7VHMR;
    const $9cbbb26ba43971fc$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlassianIntelligenceLabel: {
            id: 'proforma-project-forms.create-form-button.atlassian-intelligence-label',
            defaultMessage: 'Atlassian Intelligence',
            description: 'Label for Atlassian Intelligence icon'
        },
        createFromImport: {
            id: 'proforma-project-forms.create-form-button.convert-form',
            defaultMessage: 'Create from import',
            description: 'Option to create a form from import'
        },
        createFormTrigger: {
            id: 'proforma-project-forms.create-form-button.trigger',
            defaultMessage: 'Create form',
            description: 'Trigger for dropdown to create a new form'
        },
        createFormTemplate: {
            id: 'proforma-project-forms.create-form-button.create-with-template',
            defaultMessage: 'Create from template',
            description: 'Option to create a new form from a template'
        },
        createFormBlank: {
            id: 'proforma-project-forms.create-form-button.create-blank',
            defaultMessage: 'Create blank',
            description: 'Option to create a new blank form'
        },
        createFormFromBlank: {
            id: 'proforma-project-forms.create-form-button.create-from-blank',
            defaultMessage: 'Create from blank',
            description: 'Option to create a new blank form'
        }
    });
});
parcelRegister("a065r", function(module, exports) {
    $parcel$export(module.exports, "ListProjectForms", ()=>$747ea02ffda9119d$export$48af72d90bb7288e);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $kY99m;
    var $agcXw;
    var $erWXD;
    var $kyyqC;
    var $qE8Ux;
    var $iy5HD;
    var $ijq0x;
    var $c14E3;
    var $j9VjS;
    const $747ea02ffda9119d$export$48af72d90bb7288e = ({ projectKey: projectKey, projectType: projectType, simplifiedProject: simplifiedProject, userIsProjectAdmin: userIsProjectAdmin })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [{ forms: forms, loading: loading }] = (0, (0, parcelRequire("qE8Ux")).useProjectFormsController)();
        const isServiceProject = projectType === 'service_desk';
        const [searchTextFilter, setSearchTextFilter] = (0, $5uXOq.useState)('');
        const [filteredTypeIds, setFilteredTypeIds] = (0, $5uXOq.useState)([]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kyyqC")).PackageIntlProvider), {
            locale: intl.locale
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijq0x")).ListProjectFormsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijq0x")).TopBar), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijq0x")).TextfieldWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            elemAfterInput: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijq0x")).SmallSearchIcon), {
                label: ""
            }),
            onChange: (e)=>setSearchTextFilter(e.target.value),
            placeholder: intl.formatMessage((0, (0, parcelRequire("iy5HD")).messages).formsFilterPlaceholder),
            isCompact: true,
            "aria-label": intl.formatMessage((0, (0, parcelRequire("iy5HD")).messages).formsFilterPlaceholder)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijq0x")).RequestTypeWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9VjS")).TicketTypeDropdown), {
            isServiceProject: isServiceProject,
            onChange: setFilteredTypeIds
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijq0x")).TableWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c14E3")).Table), {
            projectKey: projectKey,
            projectType: projectType,
            simplifiedProject: simplifiedProject,
            userIsProjectAdmin: userIsProjectAdmin,
            searchTextFilter: searchTextFilter,
            filteredTypeIds: filteredTypeIds
        }), !loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agcXw")).FireUIAnalytics), {
            actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).LIST,
            action: (0, (0, parcelRequire("erWXD")).Action).VIEWED,
            actionSubjectId: "templateFormsList",
            attributes: {
                templateFormsCount: forms.length
            }
        }))));
    };
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("iy5HD", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d80fd36bcaf1c53e$export$defe85febe8b728c);
    var $7VHMR;
    const $d80fd36bcaf1c53e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        formsFilterPlaceholder: {
            id: 'jira-common.ListProjectForms.FilterForms',
            defaultMessage: 'Filter forms',
            description: 'Placeholder for a text field where a user can type to search for a form by name.'
        }
    });
});
parcelRegister("ijq0x", function(module, exports) {
    $parcel$export(module.exports, "ListProjectFormsWrapper", ()=>$d54e2cee958dac1e$export$ab6d0d94aaf980af);
    $parcel$export(module.exports, "RequestTypeWrapper", ()=>$d54e2cee958dac1e$export$c060feb82836da90);
    $parcel$export(module.exports, "SmallSearchIcon", ()=>$d54e2cee958dac1e$export$4f3c3d5b26cd28e4);
    $parcel$export(module.exports, "TableWrapper", ()=>$d54e2cee958dac1e$export$4267411171632d35);
    $parcel$export(module.exports, "TextfieldWrapper", ()=>$d54e2cee958dac1e$export$9700332e73c23bb3);
    $parcel$export(module.exports, "TopBar", ()=>$d54e2cee958dac1e$export$c4e96258f3b6511);
    var $dAHxw = parcelRequire("dAHxw");
    var $77ZoC;
    const $d54e2cee958dac1e$export$ab6d0d94aaf980af = (0, $dAHxw.default).div({
        maxWidth: '1000px'
    });
    const $d54e2cee958dac1e$export$c060feb82836da90 = (0, $dAHxw.default).div({
        marginRight: "var(--ds-space-100, 8px)"
    });
    const $d54e2cee958dac1e$export$4f3c3d5b26cd28e4 = (0, $dAHxw.default)((0, ($parcel$interopDefault((0, parcelRequire("77ZoC"))))))({
        width: '20px',
        height: '20px'
    });
    const $d54e2cee958dac1e$export$4267411171632d35 = (0, $dAHxw.default).div({
        'th:first-child': {
            paddingLeft: "var(--ds-space-150, 12px)"
        },
        'th:nth-child(2)': {
            paddingLeft: "var(--ds-space-200, 16px)"
        },
        'td:nth-child(2)': {
            paddingLeft: "var(--ds-space-200, 16px)"
        },
        'th:nth-child(3)': {
            paddingLeft: "var(--ds-space-200, 16px)"
        },
        'td:nth-child(3)': {
            paddingLeft: "var(--ds-space-200, 16px)"
        }
    });
    const $d54e2cee958dac1e$export$9700332e73c23bb3 = (0, $dAHxw.default).div({
        marginRight: "var(--ds-space-100, 8px)"
    });
    const $d54e2cee958dac1e$export$c4e96258f3b6511 = (0, $dAHxw.default).div({
        paddingBottom: "var(--ds-space-300, 24)",
        display: 'flex'
    });
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("c14E3", function(module, exports) {
    $parcel$export(module.exports, "Table", ()=>$8bf92e70e513bcc9$export$54ec01a60f47d33d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $lVJAU;
    var $fVnbM;
    var $dHbUn;
    var $dC5iT;
    var $8CUq3;
    var $h9kUS;
    var $agcXw;
    var $ex6Rw;
    var $7mkVn;
    var $erWXD;
    var $hnSOb;
    var $qE8Ux;
    var $5pTes;
    var $65aZT;
    var $3STiV;
    var $2weNo;
    var $6KSqW;
    var $2H9en;
    var $cHdmM;
    var $gPg56;
    var $8bf92e70e513bcc9$var$ProjectFormColumns = function(ProjectFormColumns) {
        ProjectFormColumns["Actions"] = "Actions";
        ProjectFormColumns["AssociatedTypes"] = "AssociatedTypes";
        ProjectFormColumns["Name"] = "Name";
        ProjectFormColumns["Updated"] = "Updated";
        return ProjectFormColumns;
    }($8bf92e70e513bcc9$var$ProjectFormColumns || {});
    const $8bf92e70e513bcc9$export$54ec01a60f47d33d = ({ projectKey: projectKey, projectType: projectType, userIsProjectAdmin: userIsProjectAdmin, searchTextFilter: searchTextFilter, simplifiedProject: simplifiedProject, filteredTypeIds: filteredTypeIds })=>{
        const isServiceProject = projectType === 'service_desk';
        const errorUtils = (0, (0, parcelRequire("ex6Rw")).usePfErrorUtils)();
        const projectFormApi = (0, (0, parcelRequire("2weNo")).useProjectFormApi)();
        const issueFormsApi = (0, (0, parcelRequire("3STiV")).useIssueFormsApi)();
        const [{ forms: forms, loading: loading, sortKey: sortKey, sortOrder: sortOrder }, { onSort: onSort }] = (0, (0, parcelRequire("qE8Ux")).useProjectFormsController)();
        const requestTypeCategories = (0, (0, parcelRequire("5pTes")).useRequestTypeCategories)({
            isServiceCMP: isServiceProject && !simplifiedProject
        });
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [issueFormsInfo, setIssueFormsInfo] = (0, $5uXOq.useState)(undefined);
        (0, $5uXOq.useEffect)(()=>{
            issueFormsApi.getIssueFormsInfo().then((res)=>{
                setIssueFormsInfo(res);
            });
        }, [
            issueFormsApi
        ]);
        const headers = [
            {
                key: $8bf92e70e513bcc9$var$ProjectFormColumns.Name,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2H9en")).messages).nameColumnHeader),
                isSortable: false,
                width: 8
            },
            {
                key: $8bf92e70e513bcc9$var$ProjectFormColumns.AssociatedTypes,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), isServiceProject ? (0, (0, parcelRequire("2H9en")).messages).requestTypesColumnHeader : (0, (0, parcelRequire("2H9en")).messages).issueTypesColumnHeader),
                isSortable: false,
                width: 5
            },
            {
                key: $8bf92e70e513bcc9$var$ProjectFormColumns.Updated,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2H9en")).messages).lastUpdatedColumnHeader),
                isSortable: true,
                width: 3
            },
            {
                key: $8bf92e70e513bcc9$var$ProjectFormColumns.Actions,
                content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
                isSortable: false,
                width: 1
            }
        ].filter(Boolean);
        const [rows, setRows] = (0, $5uXOq.useState)([]);
        (0, $5uXOq.useEffect)(()=>{
            const typeFilter = isServiceProject ? (t)=>t.type === (0, (0, parcelRequire("7mkVn")).TicketType).RequestType : (t)=>t.type === (0, (0, parcelRequire("7mkVn")).TicketType).IssueType;
            const formFilter = (form)=>form.name.toLowerCase().includes(searchTextFilter.toLowerCase()) && (filteredTypeIds.length === 0 || form.requesttypes.filter(typeFilter).some((requestType)=>filteredTypeIds.length === 0 || filteredTypeIds.includes((0, (0, parcelRequire("hnSOb")).extractTicketTypeId)(requestType.id))));
            setRows(forms.filter(formFilter).map((form)=>{
                const requestTypes = form.requesttypes.filter(typeFilter);
                return {
                    key: `row-${form.projectId}-${form.id}`,
                    cells: [
                        {
                            key: `${form.name}-${form.id}`,
                            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                                appearance: "subtle-link",
                                onClick: ()=>push(form.editUrl),
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: 'fit-content'
                                }
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPg56")).FormNameWrapper), {
                                id: `${form.name.replace(/\s+/g, '')}-${form.id}`
                            }, form.name || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("2H9en")).messages).emptyFormName)))
                        },
                        {
                            key: $8bf92e70e513bcc9$var$ProjectFormColumns.AssociatedTypes,
                            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHdmM")).RequestTypes), {
                                projectKey: projectKey,
                                simplifiedProject: simplifiedProject,
                                isServiceProject: isServiceProject,
                                requestTypes: requestTypes,
                                requestTypeCategories: requestTypeCategories
                            })
                        },
                        {
                            key: `${$8bf92e70e513bcc9$var$ProjectFormColumns.Updated}-${form.updated.iso8601}-${form.id}`,
                            content: form.updated.friendly
                        },
                        {
                            key: `${$8bf92e70e513bcc9$var$ProjectFormColumns.Actions}-${form.id}`,
                            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KSqW")).FormActions), {
                                projectType: projectType,
                                simplifiedProject: simplifiedProject,
                                userIsProjectAdmin: userIsProjectAdmin,
                                form: form,
                                projectKey: projectKey,
                                issueFormsInfo: issueFormsInfo
                            })
                        }
                    ].filter(Boolean)
                };
            }));
        }, [
            filteredTypeIds,
            forms,
            isServiceProject,
            projectType,
            push,
            searchTextFilter,
            userIsProjectAdmin,
            projectKey,
            simplifiedProject,
            requestTypeCategories,
            issueFormsInfo
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8bf92e70e513bcc9$var$tableWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8bf92e70e513bcc9$var$overflowContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("65aZT")).ExportContainer), {
            errorUtils: errorUtils,
            projectFormApi: projectFormApi
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHbUn")).default), {
            head: {
                cells: headers
            },
            rows: rows,
            loadingSpinnerSize: "large",
            isLoading: loading,
            isFixedSize: true,
            sortKey: sortKey,
            sortOrder: sortOrder,
            onSort: onSort
        })), !loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("agcXw")).FireUIAnalytics), {
            actionSubject: (0, (0, parcelRequire("erWXD")).ActionSubject).TABLE,
            action: (0, (0, parcelRequire("erWXD")).Action).VIEWED,
            actionSubjectId: "proformaDynamicTable",
            attributes: {
                tableRowsCount: rows.length,
                tableSortKey: sortKey,
                tableSortOrder: sortOrder
            }
        })));
    };
    const $8bf92e70e513bcc9$var$tableWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflowX: 'auto'
    });
    const $8bf92e70e513bcc9$var$overflowContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '800',
        [(0, (0, parcelRequire("h9kUS")).media).above.xs]: {
            width: 'auto'
        }
    });
});
parcelRegister("dHbUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb6422faa785b221$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $gS5Cm;
    var $hiWL0;
    var $kF3yx;
    var $fkvnY;
    var $hK8cd;
    var $dDBI6;
    var $dk72m;
    var $50Tma;
    var $jlnvO;
    function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
                return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
            case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
                return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("eGmKJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("eGmKJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("eGmKJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("eGmKJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("gS5Cm")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("gS5Cm")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dk72m")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlnvO")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("50Tma")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDBI6")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $cb6422faa785b221$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("f9SMa")));
    const $cb6422faa785b221$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkvnY")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hK8cd")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;
});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;
parcelRegister("gS5Cm", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$7f55105045703159$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$7f55105045703159$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$7f55105045703159$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$7f55105045703159$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$7f55105045703159$export$c476bbe5da59992d);
    const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("hiWL0", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $3b29b0d00cd7b5c6$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $3b29b0d00cd7b5c6$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`
    });
    const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).highlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverHighlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("54lmm")).row).focusOutline
            },
            css: [
                $3b29b0d00cd7b5c6$var$tableStyles,
                isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
                hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $3b29b0d00cd7b5c6$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $3b29b0d00cd7b5c6$var$captionStyles
        }, children);
    const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("54lmm", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$b728acac6d8ee4bc$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$b728acac6d8ee4bc$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$b728acac6d8ee4bc$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$b728acac6d8ee4bc$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$b728acac6d8ee4bc$export$38d703b73e2cf64d);
    const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
    };
    const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
});
parcelRegister("kF3yx", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$0852c529eaab7231$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$0852c529eaab7231$export$381ea436de119582);
    var $f8Sb3;
    function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0852c529eaab7231$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $0852c529eaab7231$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("fkvnY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32bba7afdbc8736a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7bJDt;
    var $ggqAE;
    class $32bba7afdbc8736a$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ggqAE")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $32bba7afdbc8736a$var$Body = (0, (0, parcelRequire("7bJDt")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;
});
parcelRegister("7bJDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc6eeecb3dc05edd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("gS5Cm")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("ggqAE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$136b57fea50cecd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1g0dL;
    var $d9WgS;
    const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9WgS")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1g0dL")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;
});
parcelRegister("1g0dL", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$11c3ea74eda01ab8$export$948e91fcef170792);
    var $f8Sb3;
    var $9GQPi;
    const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                (0, (0, parcelRequire("9GQPi")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("9GQPi", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$99c9652c1fab2b08$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$99c9652c1fab2b08$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$99c9652c1fab2b08$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$99c9652c1fab2b08$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$99c9652c1fab2b08$export$f7913df521f684e2);
    var $f8Sb3;
    function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $99c9652c1fab2b08$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
    });
    const $99c9652c1fab2b08$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $99c9652c1fab2b08$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("d9WgS", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$ba9cb59faf06ce7f$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hiWL0;
    const $ba9cb59faf06ce7f$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $ba9cb59faf06ce7f$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $ba9cb59faf06ce7f$var$rowStyles,
                isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("hK8cd", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$883137116243a6a0$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $883137116243a6a0$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("dDBI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4b90b361173610$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $lLAKY;
    class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("lLAKY", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$d0e2766ad96d94ad$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$d0e2766ad96d94ad$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$d0e2766ad96d94ad$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
    const $d0e2766ad96d94ad$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $d0e2766ad96d94ad$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $d0e2766ad96d94ad$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("dk72m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba39c903b39a83b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $4xXH4;
    class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args), this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            }, this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            }, this.componentWillUnmount = ()=>{
                this.detachListeners();
            }, this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            }, this.handleResize = ()=>{
                this.updateSpinnerPosition();
            }, this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            }, this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("4xXH4", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$48301faf1109874f$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$48301faf1109874f$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$48301faf1109874f$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48301faf1109874f$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $48301faf1109874f$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $48301faf1109874f$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $48301faf1109874f$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $48301faf1109874f$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("50Tma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21d5ee5c6331aeb9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $xBgAj;
    class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("xBgAj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8aaadfaafd170b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $33etG;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $5HBW9;
    var $15F6T;
    var $lmPue;
    var $fc5SA;
    var $gRWrA;
    const $8aaadfaafd170b3c$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $8aaadfaafd170b3c$var$paginationMenuStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $8aaadfaafd170b3c$var$paginationMenuItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $8aaadfaafd170b3c$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.075'
    });
    function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6s76W")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $8aaadfaafd170b3c$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, (0, parcelRequire("fc5SA")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("fc5SA")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("lmPue")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("33etG")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$8aaadfaafd170b3c$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                as: "li",
                xcss: $8aaadfaafd170b3c$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15F6T")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $8aaadfaafd170b3c$var$paginationMenuStyles
        }, (0, (0, parcelRequire("gRWrA")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $8aaadfaafd170b3c$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
    var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("5HBW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63acbbc2953d9b5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("15F6T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097dd42f19f41562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("lmPue", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d144cd0d91a90ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $jldZL;
    const $3d144cd0d91a90ab$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $3d144cd0d91a90ab$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("fc5SA", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$cbef1c2cfb373aca$export$3f860eba1218f8d3);
    const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};
});
parcelRegister("gRWrA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48fbac64848b775a$export$2e2bcd8739ae039);
    var $8QpSo;
    const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;
});
parcelRegister("jlnvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097ee65829e33b82$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    var $9Ooyy;
    var $a41RA;
    var $dpXLF;
    class $097ee65829e33b82$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("gS5Cm")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("a41RA")).default) : (0, (0, parcelRequire("dpXLF")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;
});
parcelRegister("9Ooyy", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$e002e0403dc403bb$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$e002e0403dc403bb$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    var $9GQPi;
    function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $e002e0403dc403bb$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $e002e0403dc403bb$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $e002e0403dc403bb$var$headStyles,
                isRanking && $e002e0403dc403bb$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $e002e0403dc403bb$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $e002e0403dc403bb$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $e002e0403dc403bb$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("54lmm")).head).textColor
        };
        const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("9GQPi")).cellStyles),
                $e002e0403dc403bb$var$headCellBaseStyles,
                onClick && $e002e0403dc403bb$var$onClickStyles,
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                isSortable && $e002e0403dc403bb$var$baseStyles,
                isASC && $e002e0403dc403bb$var$ascendingStyles,
                isDESC && $e002e0403dc403bb$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("a41RA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$669a06e89a9827f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cVljL;
    var $gS5Cm;
    var $dpXLF;
    class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("gS5Cm")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dpXLF")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $669a06e89a9827f7$var$RankableTableHeadCell = (0, (0, parcelRequire("cVljL")).default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
    var $669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;
});
parcelRegister("cVljL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3e49a9b167764eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    refWidth: 0,
                    refHeight: 0
                }, this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                }, this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("dpXLF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9c80f4a483cfd6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Ooyy;
    const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;
});
parcelRegister("f9SMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bz1jP")
    ]).then(()=>parcelRequire('4THp8'));
});
parcelRegister("7mkVn", function(module, exports) {
    $parcel$export(module.exports, "TicketType", ()=>$55bad19d21b4db02$export$b7a6204b7553fd04);
    let $55bad19d21b4db02$export$b7a6204b7553fd04 = function(TicketType) {
        TicketType["IssueType"] = "issue";
        TicketType["RequestType"] = "request";
        return TicketType;
    }({});
});
parcelRegister("hnSOb", function(module, exports) {
    $parcel$export(module.exports, "extractTicketTypeId", ()=>$ca7f1973018299fc$export$ab6a536ba5209e34);
    $parcel$export(module.exports, "groupRequestTypes", ()=>$ca7f1973018299fc$export$3759ef5bb78a955a);
    const $ca7f1973018299fc$export$ab6a536ba5209e34 = (id)=>id.slice(1);
    const $ca7f1973018299fc$export$3759ef5bb78a955a = (requestTypes)=>requestTypes.reduce((acc, rt)=>{
            const rtId = $ca7f1973018299fc$export$ab6a536ba5209e34(rt.id);
            if (rtId in acc) acc[rtId] = [
                ...acc[rtId],
                rt
            ];
            else acc[rtId] = [
                rt
            ];
            return acc;
        }, {});
});
parcelRegister("5pTes", function(module, exports) {
    $parcel$export(module.exports, "useRequestTypeCategories", ()=>$3f1a2182bee9179a$export$62864a475521b9aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $c92ML;
    const $3f1a2182bee9179a$export$62864a475521b9aa = ({ isServiceCMP: isServiceCMP })=>{
        const requestTypeApi = (0, (0, parcelRequire("c92ML")).useRequestTypeApi)();
        const [requestTypeCategoryMappings, setRequestTypeCategoryMappings] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isServiceCMP) requestTypeApi.getRequestTypeCategories().then((response)=>{
                setRequestTypeCategoryMappings(response.ticketTypes.reduce((prev, curr)=>{
                    var _response$practices$f;
                    return {
                        ...prev,
                        [curr.id]: (_response$practices$f = response.practices.find((category)=>category.ticketTypes.includes(curr.id))) === null || _response$practices$f === void 0 ? void 0 : _response$practices$f.key
                    };
                }, {}));
            });
        }, [
            isServiceCMP,
            requestTypeApi
        ]);
        return requestTypeCategoryMappings;
    };
});
parcelRegister("65aZT", function(module, exports) {
    $parcel$export(module.exports, "ExportContainer", ()=>$46dbbd8345473ab2$export$fb2223a1cd71ec4d);
    $parcel$export(module.exports, "useExportController", ()=>$46dbbd8345473ab2$export$76bdaf6da83e5e48);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $46dbbd8345473ab2$var$spreadsheetPollMaximumDelay = 5000;
    const $46dbbd8345473ab2$var$spreadsheetPollMultiplier = 1.2;
    const $46dbbd8345473ab2$var$initialState = {
        formId: undefined,
        filename: undefined,
        serverProgress: undefined,
        taskId: undefined,
        pollDelay: 500,
        timeoutHandle: undefined,
        downloading: false,
        successful: false,
        error: false
    };
    const $46dbbd8345473ab2$var$actions = {
        start: (form)=>({ setState: setState, getState: getState, dispatch: dispatch }, { errorUtils: errorUtils, projectFormApi: projectFormApi })=>{
                if (getState().filename) return false;
                setState({
                    formId: form.id,
                    filename: `${form.name}.xlsx`
                });
                projectFormApi.startXlsxDownload(form.id).then((xlsxDownloadTask)=>{
                    if (xlsxDownloadTask) setState({
                        serverProgress: 0,
                        taskId: xlsxDownloadTask.id
                    });
                    dispatch($46dbbd8345473ab2$var$processXlsxDownloadResponse(xlsxDownloadTask));
                }).catch(()=>{
                    errorUtils.reportError(new Error('The XLSX download task failed while starting.'));
                    setState({
                        error: true
                    });
                });
                return true;
            },
        clear: ()=>({ setState: setState, getState: getState })=>{
                window.clearTimeout(getState().timeoutHandle);
                setState($46dbbd8345473ab2$var$initialState);
            }
    };
    const $46dbbd8345473ab2$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $46dbbd8345473ab2$var$initialState,
        actions: $46dbbd8345473ab2$var$actions,
        name: 'ExportStore'
    });
    const $46dbbd8345473ab2$export$fb2223a1cd71ec4d = (0, (0, parcelRequire("gg7kZ")).createContainer)($46dbbd8345473ab2$var$Store);
    const $46dbbd8345473ab2$export$76bdaf6da83e5e48 = (0, (0, parcelRequire("3sQ5x")).createHook)($46dbbd8345473ab2$var$Store);
    const $46dbbd8345473ab2$var$processXlsxDownloadResponse = (xlsxDownloadTask)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            if (xlsxDownloadTask.status.failed) setState({
                error: true
            });
            else if (xlsxDownloadTask.status.complete) {
                setState({
                    serverProgress: 100
                });
                dispatch($46dbbd8345473ab2$var$downloadXlsx());
            } else {
                const state = getState();
                setState({
                    serverProgress: xlsxDownloadTask.status.progress,
                    pollDelay: Math.min(state.pollDelay * $46dbbd8345473ab2$var$spreadsheetPollMultiplier, $46dbbd8345473ab2$var$spreadsheetPollMaximumDelay),
                    timeoutHandle: window.setTimeout(()=>dispatch($46dbbd8345473ab2$var$checkXlsxDownload()), state.pollDelay)
                });
            }
        };
    const $46dbbd8345473ab2$var$checkXlsxDownload = ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { errorUtils: errorUtils, projectFormApi: projectFormApi })=>{
            const { formId: formId, taskId: taskId } = getState();
            if (formId === undefined || taskId === undefined) {
                errorUtils.reportError(new Error('Cannot check XLSX download, the download form or task ID is undefined.'));
                setState({
                    error: true
                });
                return;
            }
            projectFormApi.checkXlsxDownload(formId, taskId).then((xlsxDownloadTask)=>dispatch($46dbbd8345473ab2$var$processXlsxDownloadResponse(xlsxDownloadTask))).catch(()=>{
                errorUtils.reportError(new Error('The XLSX download task failed while checking progress.'));
                setState({
                    error: true
                });
            });
        };
    const $46dbbd8345473ab2$var$downloadXlsx = ()=>({ setState: setState, getState: getState }, { errorUtils: errorUtils, projectFormApi: projectFormApi })=>{
            const { formId: formId, filename: filename, taskId: taskId } = getState();
            if (formId === undefined || filename === undefined || taskId === undefined) {
                errorUtils.reportError(new Error('Cannot finish XLSX download, a required property is undefined.'));
                setState({
                    error: true
                });
                return;
            }
            setState({
                downloading: true
            });
            projectFormApi.downloadFinishedXlsx(formId, taskId).then((xlsxBlob)=>{
                const downloadLink = window.document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(xlsxBlob);
                downloadLink.setAttribute('download', filename);
                window.document.body.appendChild(downloadLink);
                downloadLink.click();
                window.document.body.removeChild(downloadLink);
                setState({
                    downloading: false,
                    successful: true
                });
            }).catch(()=>{
                errorUtils.reportError(new Error('The XLSX download task failed while downloading.'));
                setState({
                    error: true
                });
            });
        };
});
parcelRegister("6KSqW", function(module, exports) {
    $parcel$export(module.exports, "FormActions", ()=>$4eb1435126eeaabb$export$9494d5a5e5299081);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $lVJAU;
    var $fVnbM;
    var $6B7KL;
    var $aRoVz;
    var $bKCvK;
    var $7zjHG;
    var $d5Zn3;
    var $3oUqw;
    var $1I7E8;
    var $32MQk;
    var $65aZT;
    var $7UaCT;
    var $aWeh2;
    var $eoVei;
    var $kodsc;
    var $mKi2o;
    var $kdUlD;
    const $4eb1435126eeaabb$export$9494d5a5e5299081 = ({ projectType: projectType, simplifiedProject: simplifiedProject, userIsProjectAdmin: userIsProjectAdmin, form: form, projectKey: projectKey, issueFormsInfo: issueFormsInfo })=>{
        const [{ error: error, filename: filename, formId: formId, serverProgress: serverProgress, successful: successful }, { clear: clear, start: start }] = (0, (0, parcelRequire("65aZT")).useExportController)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("bKCvK")).useFlags)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [showCopyFormModal, setShowCopyFormModal] = (0, $5uXOq.useState)(false);
        const [showDeleteFormModal, setShowDeleteFormModal] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const issueFormInfo = issueFormsInfo === null || issueFormsInfo === void 0 ? void 0 : issueFormsInfo.filter((f)=>f.projectFormId === form.id);
        (0, $5uXOq.useEffect)(()=>{
            let icon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7zjHG"))))), {
                label: ""
            });
            let title;
            let description;
            if (error) {
                icon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
                    label: "",
                    primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
                });
                title = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("mKi2o")).messages).downloadFlagErrorTitle, {
                    values: {
                        filename: filename
                    }
                }));
                description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("mKi2o")).messages).downloadFlagErrorDescription);
                clear();
            } else if (successful) {
                title = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("mKi2o")).messages).downloadFlagCompleteTitle, {
                    values: {
                        filename: filename
                    }
                }));
                clear();
            } else if (serverProgress !== undefined) {
                title = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("mKi2o")).messages).downloadFlagTitle, {
                    values: {
                        filename: filename
                    }
                }));
                description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("32MQk")).default), {
                    value: serverProgress / 100
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kdUlD")).FlagParagraph), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("mKi2o")).messages).downloadFlagPercentComplete, {
                    values: {
                        percentCount: serverProgress
                    }
                }))));
            }
            if (title !== undefined) showFlag({
                id: `export-${formId}`,
                icon: icon,
                title: title,
                description: description
            });
        }, [
            clear,
            error,
            filename,
            formId,
            serverProgress,
            showFlag,
            successful
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-start",
            shouldRenderToParent: true,
            trigger: ({ ...providedProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), (0, $bS32t.default)({}, providedProps, {
                    appearance: "subtle",
                    id: `more_actions${form.id}`,
                    "aria-labelledby": `more_actions${form.id} ${form.name.replace(/\s+/g, '')}-${form.id}`,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                        label: formatMessage((0, (0, parcelRequire("mKi2o")).messages).moreActions)
                    }),
                    onClick: ()=>setIsOpen(!isOpen)
                })),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                    onClick: ()=>push(form.editUrl)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("mKi2o")).messages).edit)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kodsc")).DuplicateFormAction), {
                    form: form
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UaCT")).CopyDirectLink), {
                    projectType: projectType,
                    projectKey: projectKey,
                    simplifiedProject: simplifiedProject,
                    issueFormInfo: issueFormInfo,
                    onCloseParent: ()=>setIsOpen(false)
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                    onClick: ()=>setShowCopyFormModal(true)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("mKi2o")).messages).copyLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                    onClick: ()=>setShowDeleteFormModal(true)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("mKi2o")).messages).deleteLabel)), userIsProjectAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                    isDisabled: formId !== undefined,
                    onClick: ()=>start(form)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("mKi2o")).messages).exportInXlsx)))
        }), showCopyFormModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWeh2")).CopyProjectFormModal), {
            onClose: ()=>setShowCopyFormModal(false),
            formToCopy: form
        }), showDeleteFormModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eoVei")).DeleteProjectFormModal), {
            isServiceProject: projectType === 'service_desk',
            form: form,
            onClose: ()=>setShowDeleteFormModal(false)
        }));
    };
});
parcelRegister("7zjHG", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $582b1603b710ea90$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>$582b1603b710ea90$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
    var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;
});
parcelRegister("d5Zn3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $988b58f36f60a149$var$_react = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $988b58f36f60a149$var$_crossCircle = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $988b58f36f60a149$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $988b58f36f60a149$var$CrossCircleIcon = (props)=>$988b58f36f60a149$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
        }, props, {
            newIcon: $988b58f36f60a149$var$_crossCircle.default
        }));
    $988b58f36f60a149$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $988b58f36f60a149$var$_default = module.exports.default = $988b58f36f60a149$var$CrossCircleIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("32MQk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$baa3bacea9c957c9$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    const $baa3bacea9c957c9$var$MIN_VALUE = 0;
    const $baa3bacea9c957c9$var$MAX_VALUE = 1;
    const $baa3bacea9c957c9$var$increasingBarAnimation = null;
    const $baa3bacea9c957c9$var$decreasingBarAnimation = null;
    const $baa3bacea9c957c9$var$containerStyles = null;
    const $baa3bacea9c957c9$var$containerAppearance = {
        default: "_11q71t45",
        success: "_11q71t45",
        inverse: "_11q7lgn7"
    };
    const $baa3bacea9c957c9$var$barAppearance = {
        default: "_11q71wby",
        success: "_11q71bh5",
        inverse: "_11q7vuon"
    };
    const $baa3bacea9c957c9$var$barStyles = null;
    const $baa3bacea9c957c9$var$determinateBarStyles = null;
    const $baa3bacea9c957c9$var$increasingBarStyles = null;
    const $baa3bacea9c957c9$var$decreasingBarStyles = null;
    const $baa3bacea9c957c9$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
        const valueParsed = isIndeterminate ? $baa3bacea9c957c9$var$MIN_VALUE : Math.max($baa3bacea9c957c9$var$MIN_VALUE, Math.min(value, $baa3bacea9c957c9$var$MAX_VALUE));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "progressbar",
            "aria-label": ariaLabel,
            "aria-valuemin": $baa3bacea9c957c9$var$MIN_VALUE,
            "aria-valuenow": valueParsed,
            "aria-valuemax": $baa3bacea9c957c9$var$MAX_VALUE,
            tabIndex: 0,
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3ii2wt _kqswh2mm _11q71t45 _2rko1sit _1reo15vq _18m915vq",
                $baa3bacea9c957c9$var$containerAppearance[appearance]
            ])
        }, isIndeterminate ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _4t3ii2wt _kqswstnw _2rko1sit",
                $baa3bacea9c957c9$var$barAppearance[appearance],
                "_y44v1ud3"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _4t3ii2wt _kqswstnw _2rko1sit",
                $baa3bacea9c957c9$var$barAppearance[appearance],
                "_y44voiec"
            ])
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _4t3ii2wt _kqswstnw _2rko1sit",
                $baa3bacea9c957c9$var$barAppearance[appearance],
                "_v564calv"
            ])
        }));
    };
    var $baa3bacea9c957c9$export$2e2bcd8739ae039 = $baa3bacea9c957c9$var$ProgressBar;
});
parcelRegister("7UaCT", function(module, exports) {
    $parcel$export(module.exports, "CopyDirectLink", ()=>$5c160184f006bcfb$export$849f21ba228a66a);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $ebd3R;
    var $kJpBP;
    var $4CTmx;
    var $hQUdm;
    const $5c160184f006bcfb$export$849f21ba228a66a = ({ projectType: projectType, projectKey: projectKey, simplifiedProject: simplifiedProject, issueFormInfo: issueFormInfo, onCloseParent: onCloseParent })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        if (!issueFormInfo || (issueFormInfo === null || issueFormInfo === void 0 ? void 0 : issueFormInfo.length) === 0) return null;
        const handleClick = (info)=>()=>{
                const url = `${window.location.origin}/jira/${(0, (0, parcelRequire("hQUdm")).getProjectTypeURLString)(projectType, simplifiedProject)}/projects/${projectKey}/forms/form/direct/${info.projectFormId}/${info.issueType.id}${info.requestType ? `?requestTypeId=${info.requestType.id}` : ''}`;
                (0, (0, parcelRequire("hQUdm")).copyToClipboard)(url);
                onCloseParent();
            };
        if (issueFormInfo.length === 1) {
            const rt = issueFormInfo[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                onClick: handleClick(rt)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("4CTmx")).messages).copyDirectLinkLabel));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            placement: "right-start",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), (0, $bS32t.default)({}, triggerProps, {
                    ref: triggerRef,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
                        label: ""
                    })
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("4CTmx")).messages).copyDirectLinkLabel))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            title: intl.formatMessage(projectType === 'service_desk' ? (0, (0, parcelRequire("4CTmx")).messages).requestTypesHeader : (0, (0, parcelRequire("4CTmx")).messages).issueTypesHeader)
        }, issueFormInfo.map((info)=>{
            var _info$requestType;
            const rt = (_info$requestType = info.requestType) !== null && _info$requestType !== void 0 ? _info$requestType : info.issueType;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: rt.id,
                elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                    src: rt.icon,
                    alt: ""
                }),
                onClick: handleClick(info)
            }, rt.name);
        })));
    };
});
parcelRegister("4CTmx", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$35e5a7de60fb5f55$export$defe85febe8b728c);
    var $7VHMR;
    const $35e5a7de60fb5f55$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyDirectLinkLabel: {
            id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel',
            defaultMessage: 'Copy direct link',
            description: 'Label for a menu item that copies a link to issue forms direct for the selected form to the clipboard.'
        },
        requestTypesHeader: {
            id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader',
            defaultMessage: 'Request type',
            description: 'Header for the submenu containing a list of request types to select, in JSM projects.'
        },
        issueTypesHeader: {
            id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader',
            defaultMessage: 'Issue type',
            description: 'Header for the submenu containing a list of request types to select, in non-JSM projects.'
        }
    });
});
parcelRegister("hQUdm", function(module, exports) {
    $parcel$export(module.exports, "copyToClipboard", ()=>$cff2e60a62e1ac6f$export$2cdf1b96a9f86d16);
    $parcel$export(module.exports, "getProjectTypeURLString", ()=>$cff2e60a62e1ac6f$export$1671a9efc8e29ec4);
    const $cff2e60a62e1ac6f$export$2cdf1b96a9f86d16 = (text)=>{
        if (window.navigator.clipboard) return window.navigator.clipboard.writeText(text);
        return new Promise((resolve)=>{
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            resolve();
        });
    };
    const $cff2e60a62e1ac6f$export$1671a9efc8e29ec4 = (projectType, simplifiedProject)=>{
        switch(projectType){
            case 'business':
                return 'core';
            case 'service_desk':
                return 'servicedesk';
            case 'software':
                return simplifiedProject ? 'software' : 'software/c';
            default:
                return '';
        }
    };
});
parcelRegister("aWeh2", function(module, exports) {
    $parcel$export(module.exports, "CopyProjectFormModal", ()=>$7f6a64ab3109d817$export$c47b7672f932f38a);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $ousew;
    var $2NMNM;
    var $ujWmd;
    var $fVnbM;
    var $kkJfY;
    var $bKCvK;
    var $8RBk4;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $VSDnB;
    var $dFdBd;
    var $eWfcO;
    var $ex6Rw;
    var $qE8Ux;
    var $ew6tB;
    var $cyeJM;
    var $lcoP4;
    var $ld230;
    var $3KYpa;
    const $7f6a64ab3109d817$export$c47b7672f932f38a = ({ onClose: onClose, formToCopy: formToCopy })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("bKCvK")).useFlags)();
        const { simplifiedProject: simplifiedProject, onOpenInProductHelpArticle: onOpenInProductHelpArticle } = (0, (0, parcelRequire("eWfcO")).useInProductHelp)();
        const { reportError: reportError } = (0, (0, parcelRequire("ex6Rw")).usePfErrorUtils)();
        const projectApi = (0, (0, parcelRequire("ew6tB")).useProjectApi)();
        const [, { load: load }] = (0, (0, parcelRequire("qE8Ux")).useProjectFormsControllerActions)();
        const templateFormApi = (0, (0, parcelRequire("cyeJM")).useTemplateFormApi)();
        const [projects, setProjects] = (0, $5uXOq.useState)([]);
        const [isLoadingProjects, setIsLoadingProjects] = (0, $5uXOq.useState)(true);
        const handleCopy = ()=>(0, (0, parcelRequire("3KYpa")).onCopyClick)(formToCopy, projects, templateFormApi, showFlag, load, onClose, reportError, createAnalyticsEvent);
        (0, $5uXOq.useEffect)(()=>{
            projectApi.getAllProjects((0, (0, parcelRequire("VSDnB")).fg)('proforma_mvp_jsw_project_settings'), (0, (0, parcelRequire("VSDnB")).fg)('proforma_mvp_jwm_project_settings')).then((newProjects)=>{
                const projectsWithSelectedState = newProjects.sort((projectA, projectB)=>projectA.id === formToCopy.projectId ? -1 : projectB.id === formToCopy.projectId ? 1 : projectA.name.localeCompare(projectB.name)).map((project)=>({
                        ...project,
                        selected: false
                    }));
                setProjects(projectsWithSelectedState);
                setIsLoadingProjects(false);
            });
        }, [
            formToCopy.projectId,
            projectApi
        ]);
        const handleSelectProject = (projectId)=>{
            const newProjects = [
                ...projects
            ];
            const projectIndex = newProjects.findIndex((project)=>project.id === projectId);
            if (projectIndex !== -1) newProjects[projectIndex].selected = !newProjects[projectIndex].selected;
            setProjects(newProjects);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            width: "large"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).ModalTitleContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).heading, {
            values: {
                formName: formToCopy.name
            }
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lcoP4")).messages).subHeading), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            spacing: "none",
            onClick: ()=>onOpenInProductHelpArticle(simplifiedProject ? '2UpZYTmtNjy287pvVmqg8Z' : '4lpdE2uEWCBRuduqNGgLLs')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lcoP4")).messages).learnMore))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).Divider), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).PanelContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).LeftPanel), null, (0, ($parcel$interopDefault($5uXOq))).createElement($7f6a64ab3109d817$var$PanelTitle, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lcoP4")).messages).name)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).FormNameContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, formToCopy.name), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: "Right arrow icon"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).RightPanel), null, (0, ($parcel$interopDefault($5uXOq))).createElement("fieldset", null, (0, ($parcel$interopDefault($5uXOq))).createElement("legend", null, (0, ($parcel$interopDefault($5uXOq))).createElement($7f6a64ab3109d817$var$PanelTitle, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lcoP4")).messages).copyToProjectsTitle))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).ProjectsContainer), null, isLoadingProjects ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dFdBd")).LoadingSpinner), {
            size: "large"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lcoP4")).messages).loadingProjects)) : projects.map((project)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
                value: project.id,
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).ProjectLabelContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    appearance: "square",
                    size: "small",
                    src: project.smallAvatarUrl,
                    name: project.name
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).ProjectNameContainer), null, project.name)),
                isChecked: project.selected,
                onChange: ()=>handleSelectProject(project.id),
                name: project.name
            }))))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ld230")).Divider), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lcoP4")).messages).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            onClick: handleCopy
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lcoP4")).messages).copy))));
    };
    const $7f6a64ab3109d817$var$PanelTitle = (0, $dAHxw.default).h2({
        fontSize: "var(--ds-font-body, 14px)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: '-0.003em',
        paddingTop: "var(--ds-space-200, 16px)"
    });
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    var $VSDnB;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
                fill: "inherit",
                x: "8",
                y: "11",
                width: "8",
                height: "2",
                rx: "1"
            });
        }
        if (isChecked) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
                fill: "inherit"
            });
        }
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5"
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("lcoP4", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f6edf93e037d0e5e$export$defe85febe8b728c);
    var $7VHMR;
    const $f6edf93e037d0e5e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cancel: {
            id: 'jira-common.ListProjectForms.CopyModal.Cancel',
            defaultMessage: 'Cancel',
            description: 'Title of a Modal button for cancellation an action to copy a form between projects'
        },
        copy: {
            id: 'jira-common.ListProjectForms.CopyModal.Copy',
            defaultMessage: 'Copy',
            description: 'Title of a Modal button for starting the copy of a form between projects'
        },
        copyErrorTitle: {
            id: 'jira-common.ListProjectForms.CopyFormErrorTitle',
            defaultMessage: "Error: Could not copy \u201C{formName}\u201D over",
            description: 'Title displayed when an error occurred when trying to copy a form over to one or more projects.'
        },
        copySuccessBusinessProjectsDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfBusinessProjectsMessage}.",
            description: 'Flag description displayed when a form has been successfully copied to business projects.'
        },
        copySuccessBusinessProjectsTitle: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle',
            defaultMessage: 'Form copied to {numberOfBusinessProjects, plural, one {business project} other {# business projects}}',
            description: 'Flag title displayed when a form has been successfully copied to business projects.'
        },
        copySuccessMultipleProjectTypesTitle: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle',
            defaultMessage: 'Form copied to {numberOfProjects, plural, one {# project} other {# projects}}',
            description: 'Flag title displayed when a form has been successfully copied to multiple project types.'
        },
        copySuccessOneProjectDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in \u201C{projectName}\u201D.",
            description: 'Flag description displayed when a form has been successfully copied to one project.'
        },
        copySuccessServiceAndBusinessProjectsDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.",
            description: 'Flag description displayed when a form has been successfully copied to service and business projects.'
        },
        copySuccessServiceAndSoftwareProjectsDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.",
            description: 'Flag description displayed when a form has been successfully copied to service and software projects.'
        },
        copySuccessServiceProjectsDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}.",
            description: 'Flag description displayed when a form has been successfully copied to service projects.'
        },
        copySuccessServiceProjectsTitle: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle',
            defaultMessage: 'Form copied to {numberOfServiceProjects, plural, one {service project} other {# service projects}}',
            description: 'Flag title displayed when a form has been successfully copied to service projects.'
        },
        copySuccessServiceSoftwareAndBusinessProjectsDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
            description: 'Flag description displayed when a form has been successfully copied to service, software and business projects.'
        },
        copySuccessSoftwareAndBusinessProjectsDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
            description: 'Flag description displayed when a form has been successfully copied to software and business projects.'
        },
        copySuccessSoftwareProjectsDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage}.",
            description: 'Flag description displayed when a form has been successfully copied to software projects.'
        },
        copySuccessSoftwareProjectsTitle: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle',
            defaultMessage: 'Form copied to {numberOfSoftwareProjects, plural, one {software project} other {# software projects}}',
            description: 'Flag title displayed when a form has been successfully copied to software projects.'
        },
        copySuccessUnrecognisedProjectsDescription: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription',
            defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfProjects, plural, one {# project} other {# projects}}.",
            description: 'Flag description displayed when a form has been successfully copied to projects, and at least one project type was not recognised.'
        },
        copySuccessUnrecognisedProjectsTitle: {
            id: 'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle',
            defaultMessage: 'Form copied to {numberOfProjects, plural, one {project} other {# projects}}',
            description: 'Flag title displayed when a form has been successfully copied to projects, and at least one project type was not recognised.'
        },
        copyToProjectsTitle: {
            id: 'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle',
            defaultMessage: 'Copy to project(s)',
            description: 'Title of a heading above the name of the projects where the form can be copied to'
        },
        heading: {
            id: 'jira-common.ListProjectForms.CopyModal.Heading',
            defaultMessage: "Copy \u201C{formName}\u201D to other projects",
            description: 'Heading for a modal to copy a form between projects'
        },
        learnMore: {
            id: 'jira-common.ListProjectForms.CopyModal.LearnMore',
            defaultMessage: 'Learn more about copying forms',
            description: 'Title of a link button to trigger in app help about copying forms'
        },
        loadingProjects: {
            id: 'jira-common.ListProjectForms.CopyModal.LoadingProjects',
            defaultMessage: 'Loading projects',
            description: 'Message to display while the list of projects are being loaded'
        },
        name: {
            id: 'jira-common.ListProjectForms.CopyModal.Name',
            defaultMessage: 'Name',
            description: 'Title of a heading above the name of the form chosen to be copied between projects'
        },
        numberOfBusinessProjects: {
            id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects',
            defaultMessage: '{numberOfBusinessProjects, plural, one {# business project} other {# business projects}}',
            description: 'The number of business projects copied to. Only concatenated within forms copied to projects messages.'
        },
        numberOfServiceProjects: {
            id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects',
            defaultMessage: '{numberOfServiceProjects, plural, one {# service project} other {# service projects}}',
            description: 'The number of service projects copied to. Only concatenated within forms copied to projects messages.'
        },
        numberOfSoftwareProjects: {
            id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects',
            defaultMessage: '{numberOfSoftwareProjects, plural, one {# software project} other {# software projects}}',
            description: 'The number of software projects copied to. Only concatenated within forms copied to projects messages.'
        },
        selectAllProjects: {
            id: 'jira-common.ListProjectForms.CopyModal.SelectAllProjects',
            defaultMessage: 'Select all projects',
            description: 'Description for a checkbox to allow all projects in a list to be selected'
        },
        subHeading: {
            id: 'jira-common.ListProjectForms.CopyModal.SubHeading',
            defaultMessage: 'Changes made to a form are not reflected across any of its copies in other projects.',
            description: 'Subheading for a modal for copying a form between projects'
        }
    });
});
parcelRegister("ld230", function(module, exports) {
    $parcel$export(module.exports, "Divider", ()=>$f70c667774649591$export$2e0a83ec2e27ecbb);
    $parcel$export(module.exports, "FormNameContainer", ()=>$f70c667774649591$export$8da3ed372522c458);
    $parcel$export(module.exports, "LeftPanel", ()=>$f70c667774649591$export$110709f040143804);
    $parcel$export(module.exports, "ModalTitleContainer", ()=>$f70c667774649591$export$8bbe98d958a85a9d);
    $parcel$export(module.exports, "PanelContainer", ()=>$f70c667774649591$export$7c4d2b536147788a);
    $parcel$export(module.exports, "RightPanel", ()=>$f70c667774649591$export$364a989a35814102);
    $parcel$export(module.exports, "ProjectLabelContainer", ()=>$f70c667774649591$export$ab41bd356b0897d4);
    $parcel$export(module.exports, "ProjectNameContainer", ()=>$f70c667774649591$export$3244ac263792ccd);
    $parcel$export(module.exports, "ProjectsContainer", ()=>$f70c667774649591$export$99e3a663fb5d4ea4);
    var $dAHxw = parcelRequire("dAHxw");
    const $f70c667774649591$export$2e0a83ec2e27ecbb = (0, $dAHxw.default).hr({
        borderStyle: 'none',
        backgroundColor: `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        margin: 0
    });
    const $f70c667774649591$export$8da3ed372522c458 = (0, $dAHxw.default).div({
        marginTop: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-200, 16px)",
        display: 'flex',
        justifyContent: 'space-between'
    });
    const $f70c667774649591$export$110709f040143804 = (0, $dAHxw.default).div({
        flexBasis: '100%'
    });
    const $f70c667774649591$export$8bbe98d958a85a9d = (0, $dAHxw.default).span({
        'h1, h1 > span': {
            fontSize: "var(--ds-font-heading-small, 20px)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            lineHeight: 1
        }
    });
    const $f70c667774649591$export$7c4d2b536147788a = (0, $dAHxw.default).div({
        display: 'flex',
        margin: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-0, 0px)"}`
    });
    const $f70c667774649591$export$364a989a35814102 = (0, $dAHxw.default).div({
        flexBasis: '100%'
    });
    const $f70c667774649591$export$ab41bd356b0897d4 = (0, $dAHxw.default).div({
        display: 'flex',
        alignItems: 'center'
    });
    const $f70c667774649591$export$3244ac263792ccd = (0, $dAHxw.default).div({
        marginLeft: "var(--ds-space-100, 8px)"
    });
    const $f70c667774649591$export$99e3a663fb5d4ea4 = (0, $dAHxw.default).div({
        marginTop: "var(--ds-space-100, 8px)"
    });
});
parcelRegister("3KYpa", function(module, exports) {
    $parcel$export(module.exports, "onCopyClick", ()=>$2bc4861eb2a9ed6b$export$fc213dc576da1b1c);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $dAHxw = parcelRequire("dAHxw");
    var $ousew;
    var $btivG;
    var $7nnPp;
    var $VSDnB;
    var $h8yj2;
    var $erWXD;
    var $lcoP4;
    const $2bc4861eb2a9ed6b$export$fc213dc576da1b1c = (formToCopy, projects, templateFormApi, showFlag, reloadProjectForms, onClose, reportError, createAnalyticsEvent)=>{
        const projectsToCopyTo = projects.filter((project)=>project.selected);
        const promises = [];
        const projectsSucceeded = [];
        const projectsFailed = [];
        projectsToCopyTo.forEach((project)=>{
            promises.push(templateFormApi.copyTemplateForm(formToCopy.id, project.id, formToCopy.projectId, formToCopy.name).then(()=>{
                projectsSucceeded.push(project);
                if ((0, (0, parcelRequire("VSDnB")).fg)('proforma_add_project_form_analytics')) (0, (0, parcelRequire("h8yj2")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("erWXD")).ActionSubject).FORM} ${(0, (0, parcelRequire("erWXD")).Action).COPIED}`, {
                    templateFormId: formToCopy.id,
                    projectCopiedFromId: formToCopy.projectId,
                    projectCopiedToId: project.id
                });
            }).catch((error)=>{
                projectsFailed.push(project);
                if ((0, (0, parcelRequire("VSDnB")).fg)('proforma_add_project_form_analytics')) reportError(error, {
                    id: 'copyForm'
                });
            }));
        });
        Promise.all(promises).finally(()=>{
            const formName = formToCopy.name;
            if (projectsFailed.length > 0) showFlag({
                appearance: 'error',
                id: 'copy-form-error-flag',
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                    label: "error",
                    secondaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                }),
                title: (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4861eb2a9ed6b$var$FlagHeading, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).copyErrorTitle, {
                    values: {
                        formName: formName
                    }
                }))),
                isAutoDismiss: true
            });
            if (projectsSucceeded.length > 0) {
                const numberOfProjects = projectsSucceeded.length;
                if (numberOfProjects < 1) return;
                const serviceProjects = projectsSucceeded.filter((project)=>project.projectTypeKey === 'service_desk');
                const numberOfServiceProjects = serviceProjects.length;
                const softwareProjects = projectsSucceeded.filter((project)=>project.projectTypeKey === 'software');
                const numberOfSoftwareProjects = softwareProjects.length;
                const businessProjects = projectsSucceeded.filter((project)=>project.projectTypeKey === 'business');
                const numberOfBusinessProjects = businessProjects.length;
                let titleMessage;
                let titleValues;
                let descriptionMessage;
                let descriptionValues;
                if (numberOfProjects !== numberOfServiceProjects + numberOfSoftwareProjects + numberOfBusinessProjects) {
                    if (numberOfProjects > 1) {
                        titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessUnrecognisedProjectsTitle;
                        titleValues = {
                            numberOfProjects: numberOfProjects
                        };
                        descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessUnrecognisedProjectsDescription;
                        descriptionValues = {
                            formName: formName,
                            numberOfProjects: numberOfProjects
                        };
                    } else {
                        titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessUnrecognisedProjectsTitle;
                        titleValues = {
                            numberOfProjects: numberOfProjects
                        };
                        descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessOneProjectDescription;
                        descriptionValues = {
                            formName: formName,
                            projectName: projectsSucceeded[0].name
                        };
                    }
                } else if (numberOfServiceProjects > 0) {
                    if (numberOfSoftwareProjects > 0) {
                        if (numberOfBusinessProjects > 0) {
                            titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessMultipleProjectTypesTitle;
                            titleValues = {
                                numberOfProjects: numberOfProjects
                            };
                            descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessServiceSoftwareAndBusinessProjectsDescription;
                            descriptionValues = {
                                formName: formName,
                                numberOfServiceProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfServiceProjects, {
                                    values: {
                                        numberOfServiceProjects: numberOfServiceProjects
                                    }
                                })),
                                numberOfSoftwareProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfSoftwareProjects, {
                                    values: {
                                        numberOfSoftwareProjects: numberOfSoftwareProjects
                                    }
                                })),
                                numberOfBusinessProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfBusinessProjects, {
                                    values: {
                                        numberOfBusinessProjects: numberOfBusinessProjects
                                    }
                                }))
                            };
                        } else {
                            titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessMultipleProjectTypesTitle;
                            titleValues = {
                                numberOfProjects: numberOfProjects
                            };
                            descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessServiceAndSoftwareProjectsDescription;
                            descriptionValues = {
                                formName: formName,
                                numberOfServiceProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfServiceProjects, {
                                    values: {
                                        numberOfServiceProjects: numberOfServiceProjects
                                    }
                                })),
                                numberOfSoftwareProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfSoftwareProjects, {
                                    values: {
                                        numberOfSoftwareProjects: numberOfSoftwareProjects
                                    }
                                }))
                            };
                        }
                    } else if (numberOfBusinessProjects > 0) {
                        titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessMultipleProjectTypesTitle;
                        titleValues = {
                            numberOfProjects: numberOfProjects
                        };
                        descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessServiceAndBusinessProjectsDescription;
                        descriptionValues = {
                            formName: formName,
                            numberOfServiceProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfServiceProjects, {
                                values: {
                                    numberOfServiceProjects: numberOfServiceProjects
                                }
                            })),
                            numberOfBusinessProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfBusinessProjects, {
                                values: {
                                    numberOfBusinessProjects: numberOfBusinessProjects
                                }
                            }))
                        };
                    } else if (numberOfServiceProjects > 1) {
                        titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessServiceProjectsTitle;
                        titleValues = {
                            numberOfServiceProjects: numberOfServiceProjects
                        };
                        descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessServiceProjectsDescription;
                        descriptionValues = {
                            formName: formName,
                            numberOfServiceProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfServiceProjects, {
                                values: {
                                    numberOfServiceProjects: numberOfServiceProjects
                                }
                            }))
                        };
                    } else {
                        titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessServiceProjectsTitle;
                        titleValues = {
                            numberOfServiceProjects: numberOfServiceProjects
                        };
                        descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessOneProjectDescription;
                        descriptionValues = {
                            formName: formName,
                            projectName: serviceProjects[0].name
                        };
                    }
                } else if (numberOfSoftwareProjects > 0) {
                    if (numberOfBusinessProjects > 0) {
                        titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessMultipleProjectTypesTitle;
                        titleValues = {
                            numberOfProjects: numberOfProjects
                        };
                        descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessSoftwareAndBusinessProjectsDescription;
                        descriptionValues = {
                            formName: formName,
                            numberOfSoftwareProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfSoftwareProjects, {
                                values: {
                                    numberOfSoftwareProjects: numberOfSoftwareProjects
                                }
                            })),
                            numberOfBusinessProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfBusinessProjects, {
                                values: {
                                    numberOfBusinessProjects: numberOfBusinessProjects
                                }
                            }))
                        };
                    } else if (numberOfSoftwareProjects > 1) {
                        titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessSoftwareProjectsTitle;
                        titleValues = {
                            numberOfSoftwareProjects: numberOfSoftwareProjects
                        };
                        descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessSoftwareProjectsDescription;
                        descriptionValues = {
                            formName: formName,
                            numberOfSoftwareProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfSoftwareProjects, {
                                values: {
                                    numberOfSoftwareProjects: numberOfSoftwareProjects
                                }
                            }))
                        };
                    } else {
                        titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessSoftwareProjectsTitle;
                        titleValues = {
                            numberOfSoftwareProjects: numberOfSoftwareProjects
                        };
                        descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessOneProjectDescription;
                        descriptionValues = {
                            formName: formName,
                            projectName: softwareProjects[0].name
                        };
                    }
                } else if (numberOfBusinessProjects > 1) {
                    titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessBusinessProjectsTitle;
                    titleValues = {
                        numberOfBusinessProjects: numberOfBusinessProjects
                    };
                    descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessBusinessProjectsDescription;
                    descriptionValues = {
                        formName: formName,
                        numberOfBusinessProjectsMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("lcoP4")).messages).numberOfBusinessProjects, {
                            values: {
                                numberOfBusinessProjects: numberOfBusinessProjects
                            }
                        }))
                    };
                } else {
                    titleMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessBusinessProjectsTitle;
                    titleValues = {
                        numberOfBusinessProjects: numberOfBusinessProjects
                    };
                    descriptionMessage = (0, (0, parcelRequire("lcoP4")).messages).copySuccessOneProjectDescription;
                    descriptionValues = {
                        formName: formName,
                        projectName: businessProjects[0].name
                    };
                }
                showFlag({
                    id: 'copy-form-success-flag',
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
                        label: "Success",
                        primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
                    }),
                    title: (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4861eb2a9ed6b$var$FlagHeading, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, titleMessage, {
                        values: titleValues
                    }))),
                    description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, descriptionMessage, {
                        values: descriptionValues
                    })),
                    isAutoDismiss: true
                });
                if (projectsSucceeded.some((project)=>project.id === formToCopy.projectId)) reloadProjectForms();
            }
            onClose();
        });
    };
    const $2bc4861eb2a9ed6b$var$FlagHeading = (0, $dAHxw.default).h2({
        color: "var(--ds-text-subtle, #42526E)",
        fontSize: "var(--ds-font-body, 14px)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        lineHeight: "var(--ds-space-250, 20px)",
        letterSpacing: 'normal'
    });
});
parcelRegister("eoVei", function(module, exports) {
    $parcel$export(module.exports, "DeleteProjectFormModal", ()=>$a7bfb3337c093c88$export$c0729566c6762eb2);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $2NMNM;
    var $fVnbM;
    var $bKCvK;
    var $btivG;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $VSDnB;
    var $cgL5K;
    var $h8yj2;
    var $eWfcO;
    var $ex6Rw;
    var $7mkVn;
    var $erWXD;
    var $hnSOb;
    var $qE8Ux;
    var $2weNo;
    var $fCmO1;
    var $kPe1Y;
    const $a7bfb3337c093c88$export$c0729566c6762eb2 = ({ isServiceProject: isServiceProject, form: form, onClose: onClose })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("bKCvK")).useFlags)();
        const { onOpenInProductHelpArticle: onOpenInProductHelpArticle } = (0, (0, parcelRequire("eWfcO")).useInProductHelp)();
        const { reportError: reportError } = (0, (0, parcelRequire("ex6Rw")).usePfErrorUtils)();
        const [, { load: load }] = (0, (0, parcelRequire("qE8Ux")).useProjectFormsControllerActions)();
        const projectFormApi = (0, (0, parcelRequire("2weNo")).useProjectFormApi)();
        const uniqueRequestTypes = Object.values((0, (0, parcelRequire("hnSOb")).groupRequestTypes)(form.requesttypes)).map(([firstRequestType])=>firstRequestType);
        const typeFilter = isServiceProject ? (t)=>t.type === (0, (0, parcelRequire("7mkVn")).TicketType).RequestType : (t)=>t.type === (0, (0, parcelRequire("7mkVn")).TicketType).IssueType;
        const types = uniqueRequestTypes.filter(typeFilter);
        const handleDeleteForm = ()=>{
            projectFormApi.deleteProjectForm(form.id).then(()=>{
                showFlag({
                    id: 'delete-form-success-flag',
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
                        label: "Success",
                        primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`
                    }),
                    title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("fCmO1")).messages).deleteFormSuccessFlagTitle, {
                        values: {
                            formName: form.name
                        }
                    })),
                    isAutoDismiss: true
                });
                if ((0, (0, parcelRequire("VSDnB")).fg)('proforma_add_project_form_analytics')) (0, (0, parcelRequire("h8yj2")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("erWXD")).ActionSubject).FORM} ${(0, (0, parcelRequire("erWXD")).Action).DELETED}`, {
                    templateFormId: form.id,
                    projectId: form.projectId
                });
                load();
                onClose();
            }).catch((error)=>{
                if ((0, (0, parcelRequire("VSDnB")).fg)('proforma_add_project_form_analytics')) reportError(error, {
                    id: 'deleteForm'
                });
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kPe1Y")).ModalTitleContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, (0, (0, parcelRequire("fCmO1")).messages).heading, {
            values: {
                formName: form.name
            }
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, uniqueRequestTypes.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), isServiceProject ? (0, (0, parcelRequire("fCmO1")).messages).willRemoveRequestTypesMsg : (0, (0, parcelRequire("fCmO1")).messages).willRemoveIssueTypesMsg)), (0, ($parcel$interopDefault($5uXOq))).createElement("ul", null, types.map((requestType)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: requestType.id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kPe1Y")).RequestTypeSpan), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kPe1Y")).RequestTypeIcon), {
                src: requestType.iconUrl
            }), requestType.name)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), isServiceProject ? (0, (0, parcelRequire("fCmO1")).messages).futureRequestMessage : (0, (0, parcelRequire("fCmO1")).messages).futureIssueMessage))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("fCmO1")).messages).affectExistingIssues), "\xA0", (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            spacing: "none",
            onClick: ()=>onOpenInProductHelpArticle('2WUi6sHHMAhNDpaw0seJlj')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("fCmO1")).messages).learnMoreLink)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "default",
            onClick: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("fCmO1")).messages).cancel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "warning",
            onClick: handleDeleteForm
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("fCmO1")).messages).delete))));
    };
});
parcelRegister("fCmO1", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b5ec1866e8637a57$export$defe85febe8b728c);
    var $7VHMR;
    const $b5ec1866e8637a57$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            id: 'jira-common.ListProjectForms.Heading',
            defaultMessage: "Delete \u201C{formName}\u201D?"
        },
        cancel: {
            id: 'jira-common.ListProjectForms.Cancel',
            defaultMessage: 'Cancel'
        },
        delete: {
            id: 'jira-common.ListProjectForms.Delete',
            defaultMessage: 'Delete'
        },
        deleteFormSuccessFlagTitle: {
            id: 'jira-common.ListProjectForms.DeleteFormSuccess',
            defaultMessage: "\u201C{formName}\u201D deleted",
            description: 'The title for the flag shown on successful deletion of a form.'
        },
        willRemoveRequestTypesMsg: {
            id: 'jira-common.ListProjectForms.WillRemoveRequestTypesMsg',
            defaultMessage: 'Deleting this form will remove it from the following request types: '
        },
        willRemoveIssueTypesMsg: {
            id: 'jira-common.ListProjectForms.WillRemoveIssueTypesMsg',
            defaultMessage: 'Deleting this form will remove it from the following issue types: '
        },
        futureIssueMessage: {
            id: 'jira-common.ListProjectForms.FutureIssueMessage',
            defaultMessage: 'Future issues created using these issue types will no longer include this form:'
        },
        futureRequestMessage: {
            id: 'jira-common.ListProjectForms.FutureRequestMessage',
            defaultMessage: 'Future requests created using these request types will no longer include this form.'
        },
        affectExistingIssues: {
            id: 'jira-common.ListProjectForms.AffectExistingIssues',
            defaultMessage: "This won\u2019t affect existing issues that already use this form, or any copies of this form in other projects."
        },
        learnMoreLink: {
            id: 'jira-common.ListProjectForms.LearnMoreLink',
            defaultMessage: 'Learn more about deleting forms.'
        }
    });
});
parcelRegister("kPe1Y", function(module, exports) {
    $parcel$export(module.exports, "ModalTitleContainer", ()=>$f293744ee76a8316$export$8bbe98d958a85a9d);
    $parcel$export(module.exports, "RequestTypeIcon", ()=>$f293744ee76a8316$export$92ecfe5a3fa8d686);
    $parcel$export(module.exports, "RequestTypeSpan", ()=>$f293744ee76a8316$export$f22353c96e1f6af6);
    var $dAHxw = parcelRequire("dAHxw");
    const $f293744ee76a8316$export$8bbe98d958a85a9d = (0, $dAHxw.default).span({
        'h1, h1 > span': {
            fontSize: "var(--ds-font-heading-medium, 20px)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            lineHeight: 1
        }
    });
    const $f293744ee76a8316$export$92ecfe5a3fa8d686 = (0, $dAHxw.default).img({
        width: "var(--ds-space-200, 16px)",
        marginRight: "var(--ds-space-100, 8px)"
    });
    const $f293744ee76a8316$export$f22353c96e1f6af6 = (0, $dAHxw.default).span({
        display: 'flex',
        alignItems: 'center'
    });
});
parcelRegister("kodsc", function(module, exports) {
    $parcel$export(module.exports, "DuplicateFormAction", ()=>$ed807c2a964c7c4e$export$3b7b2efb9ac38f5d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $lVJAU;
    var $2NMNM;
    var $6B7KL;
    var $VSDnB;
    var $h8yj2;
    var $ex6Rw;
    var $erWXD;
    var $cyeJM;
    var $kcP6E;
    const $ed807c2a964c7c4e$export$3b7b2efb9ac38f5d = ({ form: form })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { reportError: reportError } = (0, (0, parcelRequire("ex6Rw")).usePfErrorUtils)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const templateFormApi = (0, (0, parcelRequire("cyeJM")).useTemplateFormApi)();
        const handleDuplicateForm = (formToCopy)=>{
            templateFormApi.copyTemplateForm(formToCopy.id, form.projectId, form.projectId, intl.formatMessage((0, (0, parcelRequire("kcP6E")).messages).copyNewFormName, {
                formName: formToCopy.name
            })).then((response)=>{
                if ((0, (0, parcelRequire("VSDnB")).fg)('proforma_add_project_form_analytics')) (0, (0, parcelRequire("h8yj2")).fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, (0, parcelRequire("erWXD")).ActionSubject).FORM} ${(0, (0, parcelRequire("erWXD")).Action).COPIED}`, {
                    templateFormId: formToCopy.id,
                    projectCopiedFromId: form.projectId,
                    projectCopiedToId: form.projectId
                });
                push(response.nextUrl);
            }).catch((error)=>{
                if ((0, (0, parcelRequire("VSDnB")).fg)('proforma_add_project_form_analytics')) reportError(error, {
                    id: 'copyForm'
                });
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: ()=>handleDuplicateForm(form)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kcP6E")).messages).duplicateLabel));
    };
});
parcelRegister("kcP6E", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$eb5c924ade7ab105$export$defe85febe8b728c);
    var $7VHMR;
    const $eb5c924ade7ab105$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyNewFormName: {
            id: 'jira-common.ListProjectForms.CopyText',
            defaultMessage: '{formName} copy',
            description: 'Adds the word copy to a duplicated form title'
        },
        duplicateLabel: {
            id: 'jira-common.ListProjectForms.Duplicate',
            defaultMessage: 'Duplicate',
            description: 'Label for the dropdown menu item, which duplicates a form'
        }
    });
});
parcelRegister("mKi2o", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0445f6676d34c6ae$export$defe85febe8b728c);
    var $7VHMR;
    const $0445f6676d34c6ae$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyLabel: {
            id: 'jira-common.ListProjectForms.Copy',
            defaultMessage: 'Copy to project',
            description: 'Label for a dropdown item, which pops a modal to copy a form between projects.'
        },
        deleteLabel: {
            id: 'jira-common.ListProjectForms.Delete',
            defaultMessage: 'Delete',
            description: 'Text for a modal dialog title when prompting the user to delete a form'
        },
        downloadFlagCompleteTitle: {
            id: 'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle',
            defaultMessage: "\u201C{filename}\u201D downloaded"
        },
        downloadFlagErrorDescription: {
            id: 'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription',
            defaultMessage: 'Refresh the page and try again.'
        },
        downloadFlagErrorTitle: {
            id: 'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle',
            defaultMessage: "\u201C{filename}\u201D not downloaded"
        },
        downloadFlagPercentComplete: {
            id: 'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete',
            defaultMessage: '{percentCount, plural, one {# % complete} other {# % complete}}'
        },
        downloadFlagTitle: {
            id: 'jira-common.ListProjectForms.FormActions.DownloadFlagTitle',
            defaultMessage: "Downloading \u201C{filename}\u201D"
        },
        edit: {
            id: 'form-system.general.Edit',
            defaultMessage: 'Edit',
            description: 'Text for a button that links to an editor for project forms'
        },
        exportInXlsx: {
            id: 'jira-common.ListProjectForms.FormActions.ExportInXlsx',
            defaultMessage: 'Export in XLSX',
            description: 'Label for a link to export forms into an Excel spreadsheet'
        },
        moreActions: {
            id: 'jira-common.ListProjectForms.FormActions.MoreActions',
            defaultMessage: 'More actions',
            description: 'Label for the dropdown menu that contains additional actions for a form'
        }
    });
});
parcelRegister("kdUlD", function(module, exports) {
    $parcel$export(module.exports, "FlagParagraph", ()=>$eb90bb101668c268$export$5d9bee1f7be2adf6);
    var $dAHxw = parcelRequire("dAHxw");
    const $eb90bb101668c268$export$5d9bee1f7be2adf6 = (0, $dAHxw.default).p({
        margin: '0.5em 0'
    });
});
parcelRegister("2H9en", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1f66c1fe441a1ca2$export$defe85febe8b728c);
    var $7VHMR;
    const $1f66c1fe441a1ca2$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTypesColumnHeader: {
            id: 'jira-common.ListProjectForms.AssociatedIssueTypes',
            defaultMessage: 'Issue type',
            description: 'A table column heading showing issue types associated with a project form.'
        },
        lastUpdatedColumnHeader: {
            id: 'jira-common.ListProjectForms.LastUpdated',
            defaultMessage: 'Last updated',
            description: 'A table column heading for the timestamp for the last update of a project form.'
        },
        nameColumnHeader: {
            id: 'form-system.general.Form',
            defaultMessage: 'Name',
            description: 'The Name column header in the Project Forms list.'
        },
        requestTypesColumnHeader: {
            id: 'jira-common.ListProjectForms.AssociatedRequestTypes',
            defaultMessage: 'Request type',
            description: 'A table column heading showing request types associated with a project form.'
        },
        emptyFormName: {
            id: 'jira-common.ListProjectForms.EmptyFormName',
            defaultMessage: 'Untitled Form',
            description: 'A placeholder for a form with an empty name.'
        }
    });
});
parcelRegister("cHdmM", function(module, exports) {
    $parcel$export(module.exports, "RequestTypes", ()=>$93e3de78bfb9b8e0$export$e849aec7fe4f0a48);
    var $bS32t = parcelRequire("bS32t");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $1I7E8;
    var $c8oLN;
    var $hnSOb;
    var $2nqev;
    var $bseDC;
    var $6fXsM;
    const $93e3de78bfb9b8e0$export$e849aec7fe4f0a48 = ({ isServiceProject: isServiceProject, projectKey: projectKey, requestTypes: requestTypes, requestTypeCategories: requestTypeCategories, simplifiedProject: simplifiedProject })=>{
        const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
        const groupedRequestTypes = (0, (0, parcelRequire("hnSOb")).groupRequestTypes)(requestTypes);
        const ids = Object.keys(groupedRequestTypes);
        if (ids.length === 0) return null;
        if (ids.length === 1) {
            const rt = groupedRequestTypes[ids[0]][0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bseDC")).RequestTypeLink), {
                requestType: rt,
                isServiceProject: isServiceProject,
                projectKey: projectKey,
                requestTypeCategories: requestTypeCategories,
                simplifiedProject: simplifiedProject
            });
        }
        const uniqueRequestTypes = Object.values(groupedRequestTypes).map((rts)=>rts[0]);
        const buttonLabel = isServiceProject ? (0, (0, parcelRequire("2nqev")).messages).multipleRequestTypesLabel : (0, (0, parcelRequire("2nqev")).messages).multipleIssueTypesLabel;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).Popup), {
            isOpen: isPopupOpen,
            onClose: ()=>setIsPopupOpen(false),
            placement: "bottom-start",
            shouldRenderToParent: true,
            content: ()=>uniqueRequestTypes.map((rt)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6fXsM")).PopupItem), {
                        key: rt.id
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bseDC")).RequestTypeLink), {
                        requestType: rt,
                        isServiceProject: isServiceProject,
                        projectKey: projectKey,
                        requestTypeCategories: requestTypeCategories,
                        simplifiedProject: simplifiedProject
                    }))),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8oLN")).default), {
                    inline: "space.150"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), (0, $bS32t.default)({}, triggerProps, {
                    appearance: "link",
                    spacing: "compact",
                    style: {
                        borderRadius: '12px'
                    },
                    isSelected: isPopupOpen,
                    onClick: ()=>setIsPopupOpen(!isPopupOpen)
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $bS32t.default)({}, buttonLabel, {
                    values: {
                        count: uniqueRequestTypes.length
                    }
                }))))
        });
    };
});
parcelRegister("c8oLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e401c8401021557f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8CUq3;
    function $e401c8401021557f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e401c8401021557f$var$baseStyles = {
        name: "1khn195",
        styles: "box-sizing:border-box"
    };
    const $e401c8401021557f$var$blockBleedMap = {
        'space.025': {
            name: "9w2fxh",
            styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "1qhe0y6",
            styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "s0o2nz",
            styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "151e4o3",
            styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "16sn062",
            styles: "margin-block:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$inlineBleedMap = {
        'space.025': {
            name: "16oxh68",
            styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "tdc6fz",
            styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "crujrn",
            styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "y28d58",
            styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "1vfkteg",
            styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$Bleed = (0, ($parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: resolvedStyles.static,
            css: [
                $e401c8401021557f$var$baseStyles,
                (inline || all) && $e401c8401021557f$var$inlineBleedMap[inline || all],
                (block || all) && $e401c8401021557f$var$blockBleedMap[block || all],
                resolvedStyles.emotion
            ],
            "data-testid": testId
        }, children);
    });
    $e401c8401021557f$var$Bleed.displayName = 'Bleed';
    var $e401c8401021557f$export$2e2bcd8739ae039 = $e401c8401021557f$var$Bleed;
});
parcelRegister("2nqev", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1bb2140e00a7c563$export$defe85febe8b728c);
    var $7VHMR;
    const $1bb2140e00a7c563$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        multipleIssueTypesLabel: {
            id: 'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel',
            defaultMessage: '{count} issue types',
            description: 'The text displayed on the issue type label when there are multiple issue types in non-JSM projects.'
        },
        multipleRequestTypesLabel: {
            id: 'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel',
            defaultMessage: '{count} request types',
            description: 'The text displayed on the request type label when there are multiple request types in JSM projects.'
        }
    });
});
parcelRegister("bseDC", function(module, exports) {
    $parcel$export(module.exports, "RequestTypeLink", ()=>$856daa0c409f074c$export$93f2486fb3c795c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $hDzhb;
    var $fVnbM;
    var $f5TWP;
    var $hnSOb;
    var $fYEpp;
    const $856daa0c409f074c$export$93f2486fb3c795c6 = ({ requestTypeCategories: requestTypeCategories, simplifiedProject: simplifiedProject, projectKey: projectKey, requestType: requestType, isServiceProject: isServiceProject })=>{
        if (isServiceProject) {
            const id = (0, (0, parcelRequire("hnSOb")).extractTicketTypeId)(requestType.id);
            const category = requestTypeCategories === null || requestTypeCategories === void 0 ? void 0 : requestTypeCategories[parseInt(id, 10)];
            const requestTypeUrl = simplifiedProject ? `/jira/servicedesk/projects/${projectKey}/settings/issuetypes/${id}` : `/jira/servicedesk/projects/${projectKey}/settings/request-types/category/${category}/request-type/${id}/request-form`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "link",
                spacing: "none",
                href: requestTypeUrl,
                component: (0, (0, parcelRequire("hDzhb")).default),
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fYEpp")).RequestTypeIcon), {
                    src: requestType.iconUrl,
                    alt: ""
                })
            }, requestType.name);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fYEpp")).RequestTypeIcon), {
            src: requestType.iconUrl,
            alt: ""
        }), requestType.name);
    };
});
parcelRegister("fYEpp", function(module, exports) {
    $parcel$export(module.exports, "RequestTypeIcon", ()=>$ba1bcdf34762d77d$export$92ecfe5a3fa8d686);
    var $dAHxw = parcelRequire("dAHxw");
    const $ba1bcdf34762d77d$export$92ecfe5a3fa8d686 = (0, $dAHxw.default).img({
        width: '16px',
        height: '16px',
        marginRight: "var(--ds-space-100, 8px)"
    });
});
parcelRegister("6fXsM", function(module, exports) {
    $parcel$export(module.exports, "PopupItem", ()=>$48e244ee711f6790$export$497d69bbe7e2cd54);
    var $dAHxw = parcelRequire("dAHxw");
    const $48e244ee711f6790$export$497d69bbe7e2cd54 = (0, $dAHxw.default).div({
        padding: "var(--ds-space-200, 16px)",
        '& + &': {
            borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`
        }
    });
});
parcelRegister("gPg56", function(module, exports) {
    $parcel$export(module.exports, "FormNameWrapper", ()=>$c3fde22f7b8dee56$export$f21e68efbab8f6ed);
    var $dAHxw = parcelRequire("dAHxw");
    const $c3fde22f7b8dee56$export$f21e68efbab8f6ed = (0, $dAHxw.default).div({
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontSize: "var(--ds-font-body, 14px)",
        lineHeight: '24px',
        display: 'flex',
        alignItems: 'center',
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
        whiteSpace: 'pre-wrap',
        textAlign: 'left'
    });
});
parcelRegister("j9VjS", function(module, exports) {
    $parcel$export(module.exports, "TicketTypeDropdown", ()=>$df2b52126a7a4710$export$13957c5df7f24d1c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $ieDtd;
    var $8Ro77;
    var $6WrhC;
    var $7C0BI;
    var $3t6TE;
    var $7mkVn;
    var $hnSOb;
    var $qE8Ux;
    var $9Na2D;
    const $df2b52126a7a4710$var$byFormNameAndId = (a, b)=>a.name.localeCompare(b.name) || a.id.localeCompare(b.id);
    const $df2b52126a7a4710$export$13957c5df7f24d1c = ({ isServiceProject: isServiceProject, onChange: onChange })=>{
        const [{ forms: forms, loading: loading }] = (0, (0, parcelRequire("qE8Ux")).useProjectFormsController)();
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [typeIds] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('typeIds');
        const [typeOptions, setTypeOptions] = (0, $5uXOq.useState)([]);
        (0, $5uXOq.useEffect)(()=>{
            if (!loading) {
                const typeFilter = isServiceProject ? (t)=>t.type === (0, (0, parcelRequire("7mkVn")).TicketType).RequestType : (t)=>t.type === (0, (0, parcelRequire("7mkVn")).TicketType).IssueType;
                const formTicketTypes = {};
                forms.forEach((item)=>item.requesttypes.filter(typeFilter).forEach((type)=>{
                        const ticketTypeId = (0, (0, parcelRequire("hnSOb")).extractTicketTypeId)(type.id);
                        formTicketTypes[ticketTypeId] = {
                            ...type,
                            id: ticketTypeId
                        };
                    }));
                const sortedTicketTypes = Object.values(formTicketTypes).sort($df2b52126a7a4710$var$byFormNameAndId).map((item)=>({
                        optionType: 'avatar',
                        label: item.name,
                        value: item.id,
                        avatar: item.iconUrl
                    }));
                setTypeOptions(sortedTicketTypes);
            }
        }, [
            forms,
            isServiceProject,
            loading
        ]);
        const [selectedTypeOptions, setSelectedTypeOptions] = (0, $5uXOq.useState)([]);
        const updateSelectedTypeOptions = (0, $5uXOq.useCallback)((newTypeOptions)=>{
            setSelectedTypeOptions(newTypeOptions);
            onChange(newTypeOptions.map((option)=>option.value));
        }, [
            onChange
        ]);
        const onLoadOptions = (search, a, b, c, d, callback)=>{
            let optionsToDisplay = typeOptions;
            if (search) {
                const lowercaseSearch = search.toLocaleLowerCase();
                optionsToDisplay = typeOptions.filter((option)=>{
                    var _option$label;
                    return (_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.toLocaleLowerCase().includes(lowercaseSearch);
                });
            }
            callback({
                totalCount: (0, (0, parcelRequire("8Ro77")).countSingleOptions)(optionsToDisplay),
                options: optionsToDisplay
            });
        };
        (0, $5uXOq.useEffect)(()=>{
            if (typeOptions !== null && typeOptions !== void 0 && typeOptions.length && typeIds) {
                const typeIdsArray = typeIds.split(',');
                const preSelectedTypeOptions = typeOptions.filter((option)=>'value' in option && typeIdsArray.includes(option.value));
                if (preSelectedTypeOptions.length > 0) updateSelectedTypeOptions(preSelectedTypeOptions);
            }
        }, [
            typeOptions,
            typeIds,
            updateSelectedTypeOptions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6WrhC")).Picker), {
            isOpen: isOpen,
            onOpen: (0, ($parcel$interopDefault($8Rkzz))),
            onClose: ()=>setIsOpen(false),
            value: selectedTypeOptions,
            fieldId: "proforma-ticket-type-dropdown",
            onChange: updateSelectedTypeOptions,
            onLoadOptions: onLoadOptions,
            onTrigger: ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3t6TE")).default), {
                    hasValues: selectedTypeOptions.length > 0,
                    onClick: ()=>setIsOpen(!isOpen),
                    isSelected: isOpen,
                    isInvalid: false,
                    ref: ref
                }, (0, (0, parcelRequire("7C0BI")).formatLabel)(intl.formatMessage(isServiceProject ? (0, (0, parcelRequire("9Na2D")).messages).requestType : (0, (0, parcelRequire("9Na2D")).messages).issueType), selectedTypeOptions)),
            onClearValues: ()=>updateSelectedTypeOptions([]),
            pagination: {
                enableFullList: false
            },
            ariaLabel: intl.formatMessage(isServiceProject ? (0, (0, parcelRequire("9Na2D")).messages).requestTypeAriaLabel : (0, (0, parcelRequire("9Na2D")).messages).issueTypeAriaLabel)
        });
    };
});
parcelRegister("8Ro77", function(module, exports) {
    $parcel$export(module.exports, "countSingleOptions", ()=>$0b10c9e74585c28e$export$54319cf8344f1691);
    $parcel$export(module.exports, "default", ()=>$0b10c9e74585c28e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fW7cr = parcelRequire("fW7cr");
    var $hIkqU = parcelRequire("hIkqU");
    parcelRequire("eAthk");
    var $iaInK;
    var $jWxNP;
    var $1rp1K;
    var $ctN3E;
    var $4MzeA;
    var $9XIzC;
    var $i1gGd;
    const $0b10c9e74585c28e$var$MAX_TOTAL_COUNT = 1000;
    const $0b10c9e74585c28e$var$paginatedComponents = {
        ...(0, (0, parcelRequire("4MzeA")).selectComponents),
        MenuList: (0, parcelRequire("1rp1K")).MenuList
    };
    const $0b10c9e74585c28e$var$ProxyBaseSelect = ({ selectOptions: selectOptions, ...props })=>{
        return selectOptions ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4MzeA")).LocalBaseSelect), {
            ...props,
            options: selectOptions
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4MzeA")).LocalBaseSelect), props);
    };
    const $0b10c9e74585c28e$var$AsyncSelect = (props)=>{
        const baseSelectProps = (0, (0, parcelRequire("iaInK")).default)(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0b10c9e74585c28e$var$ProxyBaseSelect, {
            ...props,
            ...baseSelectProps
        });
    };
    const $0b10c9e74585c28e$var$addUniqueOptions = (keys, options, option)=>{
        if (option.optionType === 'group') {
            const groupOptions = [];
            option.options.forEach((groupOption)=>{
                $0b10c9e74585c28e$var$addUniqueOptions(keys, groupOptions, groupOption);
            });
            options.push({
                ...option,
                options: groupOptions
            });
            return;
        }
        if (!keys.has(option.value)) {
            keys.add(option.value);
            options.push(option);
        }
    };
    const $0b10c9e74585c28e$var$generateOptions = (selectedValues, newOptions, addSelectedFirst, previousOptions)=>{
        const optionKeys = new Set();
        const options = [];
        if (addSelectedFirst) selectedValues.forEach((option)=>{
            $0b10c9e74585c28e$var$addUniqueOptions(optionKeys, options, option);
        });
        previousOptions?.forEach((option)=>{
            $0b10c9e74585c28e$var$addUniqueOptions(optionKeys, options, option);
        });
        newOptions.forEach((option)=>{
            $0b10c9e74585c28e$var$addUniqueOptions(optionKeys, options, option);
        });
        return options;
    };
    const $0b10c9e74585c28e$var$getLastCursorOption = (options)=>(0, ($parcel$interopDefault($hIkqU)))(options, (option)=>'cursor' in option && !!option.cursor);
    const $0b10c9e74585c28e$var$noFilterOptions = ()=>true;
    const $0b10c9e74585c28e$var$noLoadOptions = ()=>Promise.resolve();
    const $0b10c9e74585c28e$export$54319cf8344f1691 = (options)=>options.map((option)=>option.optionType === 'group' ? option.options.length : 1).reduce((sumSoFar, count)=>sumSoFar + count, 0);
    const $0b10c9e74585c28e$export$fccf54b4cac6e0b3 = ({ ariaLabel: ariaLabel, field: field, value: value, onChange: onChange, onClear: onClear, initiallyAddSelectedFirst: initiallyAddSelectedFirst, showFooter: showFooter, ...restProps })=>{
        const [page, setPage] = (0, $5uXOq.useState)(0);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const [isPaginationLoading, setIsPaginationLoading] = (0, $5uXOq.useState)(false);
        const [inputValue, setInputValue] = (0, $5uXOq.useState)('');
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [enableFullList, setEnableFullList] = (0, $5uXOq.useState)(field.pagination?.enableFullList ?? false);
        const [totalCount, setTotalCount] = (0, $5uXOq.useState)(null);
        const [error, setError] = (0, $5uXOq.useState)({
            isError: false,
            error: null,
            onRetry: null
        });
        const getTotalCountWithFunctions = (0, $5uXOq.useCallback)((newTotalCount)=>{
            if (newTotalCount === null || !field.pagination?.keywordValues?.length) return newTotalCount;
            const { pagination: { keywordValues: keywordValues } } = field;
            const newTotalCountWithKeywords = newTotalCount + value.filter((option)=>keywordValues.includes(option.value)).length;
            return newTotalCountWithKeywords < $0b10c9e74585c28e$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $0b10c9e74585c28e$var$MAX_TOTAL_COUNT;
        }, [
            field,
            value
        ]);
        const checkIfError = (0, $5uXOq.useCallback)((search, options, onRetry)=>{
            if (options.some((option)=>option.optionType === 'error')) {
                setError({
                    isError: true,
                    error: null,
                    onRetry: onRetry
                });
                setIsLoading(false);
                return true;
            }
            setError({
                isError: false,
                error: null,
                onRetry: null
            });
            return false;
        }, []);
        const handleLoadOptions = (0, $5uXOq.useCallback)((search)=>{
            const { loadOptions: loadOptions } = field;
            if (!loadOptions) return;
            setIsLoading(true);
            loadOptions(search, enableFullList, false, false, undefined, ({ options: options, totalCount: newTotalCount })=>{
                if (checkIfError(search, options, ()=>handleLoadOptions(search))) return;
                setLoadedOptions($0b10c9e74585c28e$var$generateOptions(value, options, initiallyAddSelectedFirst));
                setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
                setIsLoading(false);
            });
        }, [
            field,
            enableFullList,
            checkIfError,
            value,
            initiallyAddSelectedFirst,
            getTotalCountWithFunctions
        ]);
        const handleShowMore = (0, $5uXOq.useCallback)((showFullList = false, isRetry = false)=>{
            const { loadOptions: loadOptions } = field;
            if (!loadOptions) return;
            let originalLoadedOptions;
            if (showFullList) {
                originalLoadedOptions = [];
                setIsLoading(true);
            } else {
                originalLoadedOptions = loadedOptions;
                if (isRetry) setIsLoading(true);
                else setIsPaginationLoading(true);
            }
            loadOptions(inputValue, false, showFullList, true, $0b10c9e74585c28e$var$getLastCursorOption(loadedOptions), ({ options: options, totalCount: newTotalCount })=>{
                if (checkIfError(inputValue, options, ()=>{
                    handleShowMore(showFullList, true);
                })) return;
                setPage(page + 1);
                setEnableFullList(false);
                setLoadedOptions($0b10c9e74585c28e$var$generateOptions(value, options, showFullList, originalLoadedOptions));
                setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
                setIsPaginationLoading(false);
                setIsLoading(false);
            });
        }, [
            field,
            loadedOptions,
            inputValue,
            checkIfError,
            value,
            page,
            getTotalCountWithFunctions
        ]);
        const handleShowFullList = (0, $5uXOq.useCallback)(()=>{
            handleShowMore(true, false);
        }, [
            handleShowMore
        ]);
        const handleInputChange = (0, $5uXOq.useCallback)((newInputValue)=>{
            const { onInputChange: onInputChange } = field;
            setEnableFullList(false);
            setPage(0);
            setInputValue(newInputValue);
            setTotalCount(null);
            setLoadedOptions([]);
            handleLoadOptions(newInputValue);
            onInputChange && onInputChange();
        }, [
            field,
            handleLoadOptions
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)((options, action)=>{
            let selectData;
            if ('option' in action) {
                const actionOption = action.option;
                if (actionOption && 'value' in actionOption) selectData = {
                    selectedIndex: (0, ($parcel$interopDefault($fW7cr)))(loadedOptions, (option)=>'value' in option && option.value === actionOption.value)
                };
            }
            onChange?.(options, action, selectData);
        }, [
            onChange,
            loadedOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            handleLoadOptions('');
        }, []);
        const loadedOptionsCount = totalCount === null ? 0 : $0b10c9e74585c28e$export$54319cf8344f1691(loadedOptions);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($0b10c9e74585c28e$var$AsyncSelect, {
            ariaLabel: ariaLabel,
            cacheOptions: field.cacheOptions,
            components: $0b10c9e74585c28e$var$paginatedComponents,
            defaultOptions: field.defaultOptions,
            defaultOptionsLabel: field.defaultOptionsLabel,
            inputValue: inputValue,
            loadOptions: $0b10c9e74585c28e$var$noLoadOptions,
            onInputChange: handleInputChange,
            onMenuScrollToBottom: field.onMenuScrollToBottom,
            onMenuScrollToTop: field.onMenuScrollToTop,
            placeholder: field.placeholder,
            fieldKey: field.key,
            fieldLabel: field.label,
            fieldInvalidLabel: field.invalidLabel,
            selectOptions: loadedOptions,
            onFilterOption: $0b10c9e74585c28e$var$noFilterOptions,
            menuListProps: {
                error: error,
                type: field.key,
                handleShowMore: handleShowMore,
                isLoading: isLoading,
                isPaginationLoading: isPaginationLoading,
                showShowMoreButton: totalCount !== null && loadedOptionsCount < totalCount
            },
            onChange: handleOnChange,
            value: value,
            ...restProps
        }), (showFooter || !showFooter && !!value.length) && field.pagination && !isLoading && !!loadedOptions?.length && !error.isError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i1gGd")).Footer), null, !value.length && enableFullList && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9XIzC")).ShowFullListButton), {
            type: field.key,
            onShowFullList: handleShowFullList
        }), !!value.length && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWxNP")).ClearSelectedItemsButton), {
            onClear: onClear,
            type: field.key
        }), showFooter && !enableFullList && totalCount !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctN3E")).PaginationDetails), {
            itemsCount: loadedOptionsCount,
            totalCount: totalCount
        })));
    };
    var $0b10c9e74585c28e$export$2e2bcd8739ae039 = $0b10c9e74585c28e$export$fccf54b4cac6e0b3;
});
parcelRegister("fW7cr", function(module, exports) {
    var $b5dwA = parcelRequire("b5dwA");
    var $bxDef = parcelRequire("bxDef");
    var $kPZpS = parcelRequire("kPZpS");
    var $b9a1db7d7901532f$var$nativeMax = Math.max;
    function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) return -1;
        var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
        if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
        return $b5dwA(array, $bxDef(predicate, 3), index);
    }
    module.exports = $b9a1db7d7901532f$var$findIndex;
});
parcelRegister("hIkqU", function(module, exports) {
    var $bptzf = parcelRequire("bptzf");
    var $apUNl = parcelRequire("apUNl");
    var $0353f9604956038c$var$findLast = $bptzf($apUNl);
    module.exports = $0353f9604956038c$var$findLast;
});
parcelRegister("bptzf", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $hTJwX = parcelRequire("hTJwX");
    var $66FNL = parcelRequire("66FNL");
    function $84e8f705a13e859f$var$createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
            var iterable = Object(collection);
            if (!$hTJwX(collection)) {
                var iteratee = $bxDef(predicate, 3);
                collection = $66FNL(collection);
                predicate = function(key) {
                    return iteratee(iterable[key], key, iterable);
                };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
        };
    }
    module.exports = $84e8f705a13e859f$var$createFind;
});
parcelRegister("apUNl", function(module, exports) {
    var $b5dwA = parcelRequire("b5dwA");
    var $bxDef = parcelRequire("bxDef");
    var $kPZpS = parcelRequire("kPZpS");
    var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
    function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) return -1;
        var index = length - 1;
        if (fromIndex !== undefined) {
            index = $kPZpS(fromIndex);
            index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
        }
        return $b5dwA(array, $bxDef(predicate, 3), index, true);
    }
    module.exports = $79584b713e0c6354$var$findLastIndex;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props), this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            }, this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)(), this.controlRef = null, this.getControlRef = (ref)=>{
                this.controlRef = ref;
            }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            }, this.inputRef = null, this.getInputRef = (ref)=>{
                this.inputRef = ref;
            }, this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            }, this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            }, this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            }, this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            }, this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            }, this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            }, this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            }, this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            }, this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            }, this.getStyles = (key, props)=>{
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            }, this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            }, this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            }, this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            }, this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            }, this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            }, this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            }, this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            }, this.onCompositionStart = ()=>{
                this.isComposing = true;
            }, this.onCompositionEnd = ()=>{
                this.isComposing = false;
            }, this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            }, this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            }, this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            }, this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            }, this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            }, this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            }, this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            }, this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            }, this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            }, this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            }, this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            }, this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            }, this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } })=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } })=>({
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        });
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } })=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } })=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } })=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } })=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } })=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            textAlign: 'center',
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } })=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis })=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused })=>({
            alignItems: 'center',
            display: 'flex',
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } })=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } })=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } })=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("jWxNP", function(module, exports) {
    $parcel$export(module.exports, "ClearSelectedItemsButton", ()=>$26859c8a6389fb85$export$1d4b7cda9e589b53);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $guSWU;
    const $26859c8a6389fb85$export$1d4b7cda9e589b53 = ({ onClear: onClear })=>{
        const onClearSelectedItems = (0, $5uXOq.useCallback)(()=>{
            onClear && onClear();
        }, [
            onClear
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClearSelectedItems,
            appearance: "subtle-link",
            testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("guSWU")).default).clearAllSelectedItemsButtonText));
    };
    var $26859c8a6389fb85$export$2e2bcd8739ae039 = $26859c8a6389fb85$export$1d4b7cda9e589b53;
});
parcelRegister("guSWU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eaf4d9971ba0e623$export$2e2bcd8739ae039);
    var $7VHMR;
    var $eaf4d9971ba0e623$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clearAllSelectedItemsButtonText: {
            id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
            defaultMessage: 'Clear selection',
            description: 'Clicking this button will unselect all the selected items in the dropdown'
        }
    });
});
parcelRegister("1rp1K", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$17ee91a906e30656$export$d4c4e98c5044dc8);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    var $eZJjh;
    var $2VrhZ;
    var $2JKHM;
    var $lONhA;
    var $jbEhG;
    const $17ee91a906e30656$export$d4c4e98c5044dc8 = (props)=>{
        const [clickCount, setClickCount] = (0, $5uXOq.useState)(1);
        const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, showShowMoreButton: showShowMoreButton } } } = props;
        const handleOnShowMore = (0, $5uXOq.useCallback)(()=>{
            setClickCount(clickCount + 1);
            handleShowMore();
        }, [
            clickCount,
            handleShowMore
        ]);
        if (isLoading && clickCount > 1) setClickCount(1);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MenuList, props, isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKHM")).LoadingMessage), null) : isError ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2VrhZ")).default), {
            onRetry: onRetry
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children, isPaginationLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jbEhG")).LoadingWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null)) : showShowMoreButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lONhA")).default), {
            onShowMore: handleOnShowMore
        })));
    };
    var $17ee91a906e30656$export$2e2bcd8739ae039 = $17ee91a906e30656$export$d4c4e98c5044dc8;
});
parcelRegister("2VrhZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12a5701321ada406$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $dD7Zc;
    var $5EtQl;
    var $lYkz0;
    const $12a5701321ada406$var$ErrorMessage = ({ onRetry: onRetry })=>{
        const onClick = (0, $5uXOq.useCallback)(()=>{
            onRetry?.();
        }, [
            onRetry
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).StyledBox), {
            height: 144
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).StyledBox), {
            height: 72,
            iconSize: 72
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
            spacing: "spacious",
            color: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            label: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).StyledText), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lYkz0")).default).errorMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClick,
            appearance: "link"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("lYkz0")).default).retryMessage)));
    };
    var $12a5701321ada406$export$2e2bcd8739ae039 = $12a5701321ada406$var$ErrorMessage;
});
parcelRegister("5EtQl", function(module, exports) {
    $parcel$export(module.exports, "DropdownIndicatorWrapper", ()=>$1f3e39b09bd697db$export$30c615a45297e297);
    $parcel$export(module.exports, "StyledBox", ()=>$1f3e39b09bd697db$export$d675f139b342d51a);
    $parcel$export(module.exports, "StyledText", ()=>$1f3e39b09bd697db$export$31ea92f3997410dd);
    $parcel$export(module.exports, "StyledControl", ()=>$1f3e39b09bd697db$export$5c7b7f0e517b89f8);
    $parcel$export(module.exports, "CloseIconWrapper", ()=>$1f3e39b09bd697db$export$94756becb802e330);
    $parcel$export(module.exports, "DisplayWrapper", ()=>$1f3e39b09bd697db$export$6833d6d22987ee7f);
    $parcel$export(module.exports, "StyledInvalidCheckboxOption", ()=>$1f3e39b09bd697db$export$e786733cafde97b9);
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    const $1f3e39b09bd697db$export$30c615a45297e297 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12oo4m7-0"
    })({
        marginRight: "var(--ds-space-025, 2px)",
        textAlign: 'center',
        width: '32px'
    });
    const $1f3e39b09bd697db$export$d675f139b342d51a = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12oo4m7-1"
    })((props)=>({
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: `${props.height || 128}px`,
            justifyContent: 'center'
        }), ({ iconSize: iconSize })=>iconSize ? `svg {
          width: ${iconSize}px;
          height: ${iconSize}px;
        }` : '');
    const $1f3e39b09bd697db$export$31ea92f3997410dd = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12oo4m7-2"
    })((0, (0, parcelRequire("3RZIb")).h400), {
        marginTop: "var(--ds-space-100, 8px)"
    });
    const $1f3e39b09bd697db$export$5c7b7f0e517b89f8 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12oo4m7-3"
    })({
        boxShadow: `var(--ds-shadow-overlay, ${`0 2px 0 ${(0, $829f609a65d26a98$export$920c0d5c49070351)}`})`,
        display: 'flex',
        padding: "var(--ds-space-050, 4px)"
    });
    const $1f3e39b09bd697db$export$94756becb802e330 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12oo4m7-4"
    })({
        cursor: 'pointer',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`,
        '&:hover, &:focus': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        }
    });
    const $1f3e39b09bd697db$export$6833d6d22987ee7f = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12oo4m7-5"
    })((props)=>({
            display: props.displayFlag ? 'block' : 'none'
        }));
    const $1f3e39b09bd697db$export$e786733cafde97b9 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-12oo4m7-6"
    })({
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: "var(--ds-space-100, 8px)",
        '& > *': {
            backgroundColor: 'inherit !important'
        }
    });
});
parcelRegister("lYkz0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8eb3c5b787fac9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6c8eb3c5b787fac9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorMessage: {
            id: 'paginated-picker.async-select.menu-list.error-message.error-message',
            defaultMessage: "Couldn't retrieve data",
            description: 'The text for when an error occurs when loading options'
        },
        retryMessage: {
            id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
            defaultMessage: 'Click to retry',
            description: 'The text for button to reload options'
        }
    });
});
parcelRegister("2JKHM", function(module, exports) {
    $parcel$export(module.exports, "LoadingMessage", ()=>$e4c11b29dd890812$export$e928a71d039d3102);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $eZJjh;
    var $5EtQl;
    var $3cbW5;
    const $e4c11b29dd890812$export$e928a71d039d3102 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).StyledBox), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).StyledBox), {
            height: 72
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).StyledText), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("3cbW5")).default).loadingMessage)));
});
parcelRegister("3cbW5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f883dac371012333$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f883dac371012333$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadingMessage: {
            id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
            defaultMessage: 'Loading...',
            description: 'The text for when options are being loaded in dropdown'
        }
    });
});
parcelRegister("lONhA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ffe92d710765e8c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $iJj6Y;
    const $0ffe92d710765e8c$var$ShowMoreButton = ({ onShowMore: onShowMore })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onShowMore,
            appearance: "link",
            testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("iJj6Y")).default).showMoreButtonText));
    var $0ffe92d710765e8c$export$2e2bcd8739ae039 = $0ffe92d710765e8c$var$ShowMoreButton;
});
parcelRegister("iJj6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$705f8d04ffa234cf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $705f8d04ffa234cf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showMoreButtonText: {
            id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
            defaultMessage: 'Show more',
            description: 'Clicking this button will load more items into the dropdown'
        }
    });
});
parcelRegister("jbEhG", function(module, exports) {
    $parcel$export(module.exports, "LoadingWrapper", ()=>$518a2412e4e23e08$export$43a792a870d28db2);
    var $47bDC = parcelRequire("47bDC");
    const $518a2412e4e23e08$export$43a792a870d28db2 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-8ouqtd-0"
    })({
        display: 'flex',
        justifyContent: 'center',
        margin: `${"var(--ds-space-050, 4px)"} 0`
    });
});
parcelRegister("ctN3E", function(module, exports) {
    $parcel$export(module.exports, "PaginationDetails", ()=>$4832fdbefabb9e15$export$33eb0288c0936a84);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8Wgg0;
    var $2QOHk;
    const $4832fdbefabb9e15$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QOHk")).PaginationDetailsStyled), {
            "data-testid": "paginated-picker.ui.async-select.pagination-details"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("8Wgg0")).default).ofTotalCount,
            values: {
                itemsCount: itemsCount,
                totalCount: totalCount
            }
        }));
    var $4832fdbefabb9e15$export$2e2bcd8739ae039 = $4832fdbefabb9e15$export$33eb0288c0936a84;
});
parcelRegister("8Wgg0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f615b01124eda6a0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f615b01124eda6a0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        ofTotalCount: {
            id: 'paginated-picker.async-select.pagination-details.of-total-count',
            defaultMessage: '{itemsCount} of {totalCount}',
            description: 'Total count of items.'
        }
    });
});
parcelRegister("2QOHk", function(module, exports) {
    $parcel$export(module.exports, "PaginationDetailsStyled", ()=>$2d3fff10619f4d5a$export$fff9218028c24180);
    var $47bDC = parcelRequire("47bDC");
    const $2d3fff10619f4d5a$export$fff9218028c24180 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-2jljtl-0"
    })({
        flex: 1,
        textAlign: 'right',
        margin: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtlest, #979797)"
    });
});
parcelRegister("4MzeA", function(module, exports) {
    $parcel$export(module.exports, "selectComponents", ()=>$917465e04260de1e$export$c34d65c0f5a1c617);
    $parcel$export(module.exports, "LocalBaseSelect", ()=>$917465e04260de1e$export$51cc13ac81e51592);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $7K5PP;
    var $7XoEL;
    var $dIElv;
    var $3U0Cd;
    var $Jb7gv;
    var $aGGEB;
    var $ihi9a;
    const $917465e04260de1e$export$c34d65c0f5a1c617 = {
        Control: (0, parcelRequire("dIElv")).Control,
        DropdownIndicator: (0, parcelRequire("3U0Cd")).DropdownIndicator,
        IndicatorSeparator: null,
        LoadingIndicator: null,
        Menu: (0, parcelRequire("Jb7gv")).Menu,
        Option: (0, parcelRequire("ihi9a")).Option
    };
    const $917465e04260de1e$var$onIsOptionDisabled = (option)=>'error' in option ? !!option.error : false;
    const $917465e04260de1e$export$51cc13ac81e51592 = ({ onFilterOption: onFilterOption, placeholder: placeholder, ...restProps })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { ariaLabel: ariaLabelProp, onInputChange: onInputChangeProp, inputValue: inputValueProp } = restProps;
        const [inputValue, setInputValue] = (0, $5uXOq.useState)(inputValueProp || '');
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if ([
                (0, (0, parcelRequire("7XoEL")).MetaActions).setValue,
                (0, (0, parcelRequire("7XoEL")).MetaActions).inputBlur,
                (0, (0, parcelRequire("7XoEL")).MetaActions).menuClose
            ].includes(actionMeta.action) && !newValue.length) return;
            onInputChangeProp?.(newValue, actionMeta);
            setInputValue(newValue);
        }, [
            onInputChangeProp
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            ...restProps,
            "aria-label": ariaLabelProp || intl.formatMessage((0, (0, parcelRequire("aGGEB")).default).searchPlaceholder),
            autoFocus: true,
            backspaceRemovesValue: false,
            blurInputOnSelect: false,
            closeMenuOnSelect: false,
            controlShouldRenderValue: false,
            hideSelectedOptions: false,
            isClearable: false,
            isMulti: true,
            inputValue: inputValue,
            menuIsOpen: true,
            menuShouldScrollIntoView: false,
            tabSelectsValue: false,
            noOptionsMessage: ()=>intl.formatMessage((0, (0, parcelRequire("aGGEB")).default).noOptionsMessage),
            onInputChange: onInputChange,
            isOptionDisabled: $917465e04260de1e$var$onIsOptionDisabled,
            filterOption: onFilterOption,
            placeholder: placeholder ?? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("aGGEB")).default).searchPlaceholder)
        });
    };
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("7XoEL", function(module, exports) {
    $parcel$export(module.exports, "MetaActions", ()=>$3e4db3dc9fd385e4$export$50531cf3046c5956);
    const $3e4db3dc9fd385e4$export$50531cf3046c5956 = {
        setValue: 'set-value',
        inputChange: 'input-change',
        inputBlur: 'input-blur',
        menuClose: 'menu-close',
        selectOption: 'select-option',
        deselectOption: 'deselect-option',
        removeValue: 'remove-value',
        popValue: 'pop-value',
        clear: 'clear',
        createOption: 'create-option',
        clearOptions: 'clear-options',
        add: 'add',
        remove: 'remove',
        update: 'update'
    };
});
parcelRegister("dIElv", function(module, exports) {
    $parcel$export(module.exports, "Control", ()=>$0f30c6b2ed3f462b$export$7a7fa4424cb20976);
    var $5uXOq = parcelRequire("5uXOq");
    var $5EtQl;
    const $0f30c6b2ed3f462b$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).StyledControl), {
            ...innerProps,
            ref: innerRef
        }, children);
    };
});
parcelRegister("3U0Cd", function(module, exports) {
    $parcel$export(module.exports, "DropdownIndicator", ()=>$7a876697965cf434$export$ec98719d3db7f2e4);
    var $5uXOq = parcelRequire("5uXOq");
    var $26g7Y;
    var $d5Zn3;
    var $47etd;
    var $bChGW;
    var $5EtQl;
    const $7a876697965cf434$export$ec98719d3db7f2e4 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).DropdownIndicatorWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).DisplayWrapper), {
            displayFlag: !!props.selectProps.inputValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).CloseIconWrapper), {
            onClick: (event)=>{
                event.preventDefault();
                props.selectProps.onInputChange?.('', {
                    action: 'input-change',
                    prevInputValue: props.selectProps.inputValue
                });
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("47etd"))))), {
            color: "currentColor",
            LEGACY_size: "small",
            label: "",
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("d5Zn3")))))
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).DisplayWrapper), {
            displayFlag: !props.selectProps.inputValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            color: "currentColor",
            LEGACY_size: "small",
            label: ""
        }))));
});
parcelRegister("Jb7gv", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$895639da1382c815$export$d9b273488cd8ce6f);
    var $5uXOq = parcelRequire("5uXOq");
    const $895639da1382c815$export$d9b273488cd8ce6f = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "refinement-bar.common.ui.select.menu",
            ref: innerRef,
            ...innerProps
        }, children);
});
parcelRegister("aGGEB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2afe38cf99f591e2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2afe38cf99f591e2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOptionsMessage: {
            id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
            defaultMessage: 'No matches found',
            description: 'The text for when no matches are found in dropdown'
        },
        searchPlaceholder: {
            id: 'paginated-picker.async-select.select.search-placeholder',
            defaultMessage: 'Search',
            description: 'Placeholder text in search input indicating that the user can search'
        }
    });
});
parcelRegister("ihi9a", function(module, exports) {
    $parcel$export(module.exports, "Option", ()=>$4b24cabb024ced55$export$36d18380658d5d20);
    var $5uXOq = parcelRequire("5uXOq");
    var $dD7Zc;
    var $itpgN;
    var $3bDjY;
    var $5EtQl;
    const $4b24cabb024ced55$export$36d18380658d5d20 = (props)=>{
        if (props.data?.invalid) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5EtQl")).StyledInvalidCheckboxOption), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itpgN")).CheckboxOption), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: props.selectProps.fieldInvalidLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
            label: "Test",
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itpgN")).CheckboxOption), props);
    };
});
parcelRegister("itpgN", function(module, exports) {
    $parcel$export(module.exports, "CheckboxOption", ()=>$f5875245cd0ad0c1$export$d40cc97ecda916f9);
    $parcel$export(module.exports, "RadioOption", ()=>$f5875245cd0ad0c1$export$82ab7168879267a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6aY6N;
    var $iQHJo;
    var $dV6Te;
    var $VSDnB;
    function $f5875245cd0ad0c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f5875245cd0ad0c1$var$getPrimitiveStyles = (props)=>{
        const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
        const baseStyles = {
            alignItems: 'center',
            backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : 'transparent',
            color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
            display: 'flex ',
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-050, 4px)",
            boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}` : 'none',
            ':active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: isFocused ? '2px solid transparent' : ''
            }
        };
        const augmentedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            ...getStyles('option', props),
            ...baseStyles
        });
        const bemClasses = {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        };
        return [
            augmentedStyles,
            cx(bemClasses, className)
        ];
    };
    const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isActive) return `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        else if (isFocused) return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
        else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (!isSelected) return 'transparent';
        return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isActive) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused) return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    };
    const $f5875245cd0ad0c1$var$baseIconStyles = {
        name: "35x0q3",
        styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
    };
    const $f5875245cd0ad0c1$var$baseOptionStyles = {
        name: "16e0ede",
        styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    class $f5875245cd0ad0c1$var$ControlOption extends (0, $5uXOq.Component) {
        render() {
            const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
            const props = {
                ...innerProps,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            const [styles, classes] = $f5875245cd0ad0c1$var$getPrimitiveStyles({
                getStyles: getStyles,
                ...rest
            });
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: styles,
                className: classes,
                ref: innerRef,
                ...props
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f5875245cd0ad0c1$var$baseIconStyles,
                    {
                        '& svg rect, & svg circle:first-of-type': {
                            stroke: $f5875245cd0ad0c1$var$getBorderColor({
                                ...this.props,
                                ...this.state
                            })
                        }
                    }
                ]
            }, !!Icon ? (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                label: "",
                primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                    ...this.props,
                    ...this.state
                }),
                secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                    ...this.props,
                    ...this.state
                }),
                isFacadeDisabled: true
            }) : null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $f5875245cd0ad0c1$var$baseOptionStyles
            }, children)));
        }
        constructor(...args){
            super(...args), this.state = {
                isActive: false
            }, this.onMouseDown = ()=>this.setState({
                    isActive: true
                }), this.onMouseUp = ()=>this.setState({
                    isActive: false
                }), this.onMouseLeave = ()=>this.setState({
                    isActive: false
                });
        }
    }
    const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "6.75",
            fill: "currentColor",
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "3",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : (0, ($parcel$interopDefault((0, parcelRequire("6aY6N"))))),
            ...props
        });
    const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewRadioIcon : (0, ($parcel$interopDefault((0, parcelRequire("iQHJo"))))),
            ...props
        });
});
parcelRegister("6aY6N", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
    function $47f24d9003b82760$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47f24d9003b82760$var$CheckboxIcon = (props)=>$47f24d9003b82760$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $47f24d9003b82760$var$_checkboxChecked.default
        }));
    $47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;
});
parcelRegister("aoKYM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79209663d32c0c44$var$_UNSAFE_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79209663d32c0c44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>$79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;
});
parcelRegister("iQHJo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
    function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $db8f016a0af5fda9$var$RadioIcon = (props)=>$db8f016a0af5fda9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $db8f016a0af5fda9$var$_radioChecked.default
        }));
    $db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
    var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;
});
parcelRegister("kqGQn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $edf7783e719984ba$var$_UNSAFE_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $edf7783e719984ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>$edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;
});
parcelRegister("9XIzC", function(module, exports) {
    $parcel$export(module.exports, "ShowFullListButton", ()=>$403fd92019edd6cd$export$bf0956d66cd7566b);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $fVnbM;
    var $7516N;
    const $403fd92019edd6cd$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList })=>{
        const handleShowFullList = (0, $5uXOq.useCallback)(()=>{
            onShowFullList();
        }, [
            onShowFullList
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: handleShowFullList,
            appearance: "subtle-link",
            testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7516N")).default).showFullListButtonText));
    };
    var $403fd92019edd6cd$export$2e2bcd8739ae039 = $403fd92019edd6cd$export$bf0956d66cd7566b;
});
parcelRegister("7516N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95dd599663baf990$export$2e2bcd8739ae039);
    var $7VHMR;
    var $95dd599663baf990$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showFullListButtonText: {
            id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
            defaultMessage: 'Show full list',
            description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
        }
    });
});
parcelRegister("i1gGd", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$0e9aac8377abfc52$export$a06f1c675e846f6f);
    var $47bDC = parcelRequire("47bDC");
    const $0e9aac8377abfc52$export$a06f1c675e846f6f = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1bj6bqn-0"
    })({
        borderTop: `${"var(--ds-border, #ebedf0)"} solid 2px`,
        paddingTop: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    });
});
parcelRegister("6WrhC", function(module, exports) {
    $parcel$export(module.exports, "Picker", ()=>$1a7900e25e8bc90a$export$ba25329847403e11);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $i7Pgv;
    var $8Ro77;
    var $eOSw1;
    var $1ZIOB;
    const $1a7900e25e8bc90a$export$ba25329847403e11 = ({ ariaLabel: ariaLabel, isOpen: isOpen, value: value, onClose: onClose, onClearValues: onClearValues, fieldId: fieldId, fieldLabel: fieldLabel, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, formatOptionLabel: formatOptionLabel = (0, (0, parcelRequire("eOSw1")).default), onLoadOptions: onLoadOptions, pagination: pagination, PopupComponent: PopupComponent, onTrigger: onTrigger, initiallyAddSelectedFirst: initiallyAddSelectedFirst = true, showFooter: showFooter = true, popupProps: popupProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i7Pgv")).PaginatedPickerIntlProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            key: fieldId,
            placement: "bottom-start",
            isOpen: isOpen,
            onClose: onClose,
            popupComponent: PopupComponent,
            shouldRenderToParent: true,
            trigger: onTrigger,
            autoFocus: false,
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ZIOB")).DialogInner), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Ro77")).default), {
                    field: {
                        isRemovable: false,
                        label: fieldLabel || '',
                        invalidLabel: fieldInvalidLabel,
                        type: 'Filter',
                        key: fieldId,
                        defaultOptionsLabel: 'defaultOptionsLabel',
                        defaultOptions: true,
                        cacheOptions: false,
                        inputValue: 'string',
                        enableShowMore: true,
                        pagination: pagination,
                        loadOptions: onLoadOptions
                    },
                    onChange: onChange,
                    value: value,
                    formatOptionLabel: formatOptionLabel,
                    onClear: onClearValues,
                    initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                    showFooter: showFooter,
                    ariaLabel: ariaLabel
                })),
            ...popupProps
        }));
});
parcelRegister("i7Pgv", function(module, exports) {
    $parcel$export(module.exports, "PaginatedPickerIntlProvider", ()=>$1bd0be420ad404e3$export$b61655080b0a1f32);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $7OSbv;
    const $1bd0be420ad404e3$var$i18n = (0, parcelRequire("7OSbv"));
    const $1bd0be420ad404e3$var$getCodesFromLocale = (locale)=>{
        const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
        if (!match) throw Error('Unable to get language and country from invalid Locale');
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country.toUpperCase()
        };
    };
    const $1bd0be420ad404e3$export$b61655080b0a1f32 = ({ children: children })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { language: language, country: country } = $1bd0be420ad404e3$var$getCodesFromLocale(intl.locale.toString());
        const messages = $1bd0be420ad404e3$var$i18n[`${language}_${country}`] || $1bd0be420ad404e3$var$i18n[language] || $1bd0be420ad404e3$var$i18n.en;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            messages: messages,
            locale: intl.locale
        }, children);
    };
});
parcelRegister("7OSbv", function(module, exports) {
    $parcel$export(module.exports, "cs", ()=>(parcelRequire("8oaET")).default);
    $parcel$export(module.exports, "da", ()=>(parcelRequire("SwWKo")).default);
    $parcel$export(module.exports, "de", ()=>(parcelRequire("aSNkn")).default);
    $parcel$export(module.exports, "en", ()=>(parcelRequire("7wjd9")).default);
    $parcel$export(module.exports, "en_GB", ()=>(parcelRequire("k7lX5")).default);
    $parcel$export(module.exports, "en_ZZ", ()=>(parcelRequire("9gS9O")).default);
    $parcel$export(module.exports, "es", ()=>(parcelRequire("57ePL")).default);
    $parcel$export(module.exports, "fi", ()=>(parcelRequire("kIWZm")).default);
    $parcel$export(module.exports, "fr", ()=>(parcelRequire("9eF14")).default);
    $parcel$export(module.exports, "hu", ()=>(parcelRequire("g5wS3")).default);
    $parcel$export(module.exports, "it", ()=>(parcelRequire("d41Rh")).default);
    $parcel$export(module.exports, "ja", ()=>(parcelRequire("euZEp")).default);
    $parcel$export(module.exports, "ko", ()=>(parcelRequire("gQ7cM")).default);
    $parcel$export(module.exports, "nb", ()=>(parcelRequire("8jIt1")).default);
    $parcel$export(module.exports, "nl", ()=>(parcelRequire("9xh2O")).default);
    $parcel$export(module.exports, "pl", ()=>(parcelRequire("iRC8S")).default);
    $parcel$export(module.exports, "pt_BR", ()=>(parcelRequire("1RIUY")).default);
    $parcel$export(module.exports, "ru", ()=>(parcelRequire("cv3lW")).default);
    $parcel$export(module.exports, "sv", ()=>(parcelRequire("4OMkS")).default);
    $parcel$export(module.exports, "th", ()=>(parcelRequire("2lfQd")).default);
    $parcel$export(module.exports, "tr", ()=>(parcelRequire("61LkR")).default);
    $parcel$export(module.exports, "uk", ()=>(parcelRequire("5qDIG")).default);
    $parcel$export(module.exports, "vi", ()=>(parcelRequire("azy9G")).default);
    $parcel$export(module.exports, "zh", ()=>(parcelRequire("iJkie")).default);
    $parcel$export(module.exports, "zh_TW", ()=>(parcelRequire("5Pj4T")).default);
    var $8oaET;
    var $SwWKo;
    var $aSNkn;
    var $7wjd9;
    var $k7lX5;
    var $9gS9O;
    var $57ePL;
    var $kIWZm;
    var $9eF14;
    var $g5wS3;
    var $d41Rh;
    var $euZEp;
    var $gQ7cM;
    var $8jIt1;
    var $9xh2O;
    var $iRC8S;
    var $1RIUY;
    var $cv3lW;
    var $4OMkS;
    var $2lfQd;
    var $61LkR;
    var $5qDIG;
    var $azy9G;
    var $iJkie;
    var $5Pj4T;
});
parcelRegister("8oaET", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3258cc801167bc18$export$2e2bcd8739ae039);
    var $3258cc801167bc18$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Zru\u0161it v\xfdb\u011Br",
        'paginated-picker.async-select.menu-list.error-message.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknut\xedm opakovat",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "Na\u010D\xedt\xe1n\xed\u2026",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Zobrazit v\xedce",
        'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} z\xa0{totalCount}",
        'paginated-picker.async-select.select.no-options-message.no-options-message': "Nebyly nalezeny \u017E\xe1dn\xe9 shody",
        'paginated-picker.async-select.select.option.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
        'paginated-picker.async-select.select.option.retry-message': "Kliknut\xedm opakovat",
        'paginated-picker.async-select.select.search-placeholder': 'Vyhledat',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Zobrazit \xfapln\xfd seznam"
    };
});
parcelRegister("SwWKo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be992e6a08942848$export$2e2bcd8739ae039);
    var $be992e6a08942848$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Ryd valgte',
        'paginated-picker.async-select.menu-list.error-message.error-message': 'Data kunne ikke hentes',
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Klik for at pr\xf8ve igen",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "Indl\xe6ser ...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mere',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} af {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ingen match fundet',
        'paginated-picker.async-select.select.option.error-message': 'Data kunne ikke hentes',
        'paginated-picker.async-select.select.option.retry-message': "Klik for at pr\xf8ve igen",
        'paginated-picker.async-select.select.search-placeholder': "S\xf8g",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis hele listen'
    };
});
parcelRegister("aSNkn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e435ca9a4e0c3d1$export$2e2bcd8739ae039);
    var $7e435ca9a4e0c3d1$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Auswahl l\xf6schen",
        'paginated-picker.async-select.menu-list.error-message.error-message': 'Daten konnten nicht abgerufen werden.',
        'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klicken, um es erneut zu versuchen',
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4dt\xa0...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mehr anzeigen',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} von {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'Keine Treffer gefunden',
        'paginated-picker.async-select.select.option.error-message': 'Daten konnten nicht abgerufen werden.',
        'paginated-picker.async-select.select.option.retry-message': 'Klicken, um es erneut zu versuchen',
        'paginated-picker.async-select.select.search-placeholder': 'Suchen',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Vollst\xe4ndige Liste anzeigen"
    };
});
parcelRegister("7wjd9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba3dd913870f67dc$export$2e2bcd8739ae039);
    var $ba3dd913870f67dc$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
        'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
        'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
        'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
        'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
        'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
        'paginated-picker.async-select.select.search-placeholder': 'Search',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
    };
});
parcelRegister("k7lX5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eae28e4999fae8f5$export$2e2bcd8739ae039);
    var $eae28e4999fae8f5$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
        'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
        'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
        'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
        'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
        'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
        'paginated-picker.async-select.select.search-placeholder': 'Search',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
    };
});
parcelRegister("9gS9O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc31e335350d7b12$export$2e2bcd8739ae039);
    var $cc31e335350d7b12$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u2063\u2062Clear selection\u206E\x9d\u206B\u2060\u206D\x8f\u206B\u200C\u200D\u206C\x9d\u206E\u200C\u206B\u206D\u200C\u206C\u206F\u206F\u206B\u206E\x81\u2060\u206F\u206A\u200D\x8d\u206D\u200C\x8d\u2060\u061C\u2063\u2064",
        'paginated-picker.async-select.menu-list.error-message.error-message': "\u2063\u2062Couldn't retrieve data\x81\u206A\u206D\u2060\u2061\u206F\x8d\u206E\u2060\x8d\u2060\u206C\u206E\u2061\u206E\x90\u206E\u200C\u200D\x81\u200D\u206F\u206C\u206D\x8d\u206B\x81\u206A\x8d\u200D\u206A\u200C\u2063\u2064",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "\u2063\u2062Click to retry\u206A\u200C\u206C\x8d\x9d\u206D\u2060\u200C\u206C\u206F\u206A\u206B\u206D\u206B\x8f\u206F\u206F\u206D\u206F\x8f\u206B\u206C\u2061\u061C\u206F\u061C\x8f\u206F\u200D\u2060\u206D\u206D\u2063\u2064",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u2063\u2062Loading...\u200D\u206C\u206E\x8f\u061C\u206D\u206D\u206B\u206D\x9d\u200D\x9d\u2061\x8f\u061C\u200C\x9d\u2060\x90\u2060\x90\u200C\u2061\u2061\x8d\x8f\x81\x8f\u2060\u206E\u206C\u200C\u2063\u2064",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u2063\u2062Show more\u206E\x81\x8f\u2060\x8d\u206A\u2061\u2060\x8d\x8d\x90\x8f\x8f\u200C\x90\u061C\x8f\u206A\x9d\u206C\u206F\x8d\u206D\u206D\u206F\u061C\x8d\x9d\u206C\u206B\u200D\u206D\u2063\u2064",
        'paginated-picker.async-select.pagination-details.of-total-count': "\u2063\u2062{itemsCount} of {totalCount}\u206D\u206B\u061C\u206C\x8f\u206F\u206F\x8d\x90\u061C\u2060\u061C\u206D\u206C\x8f\u200D\x9d\u2060\u206E\x8f\u200D\u200C\u200D\u206F\u206D\u206A\x8d\x8d\u206C\u2060\x81\x8d\u2063\u2064",
        'paginated-picker.async-select.select.no-options-message.no-options-message': "\u2063\u2062No matches found\u061C\x9d\x81\u2060\u206E\u200C\u200D\u206E\u206F\x9d\x8f\u206F\u206A\u200C\u2061\u206A\u2060\u200C\u2060\x9d\u206E\x90\x8d\u206C\x8d\u206E\x9d\u200C\u206A\x81\x9d\u206C\u2063\u2064",
        'paginated-picker.async-select.select.option.error-message': "\u2063\u2062Couldn't retrieve data\u206C\u206E\x90\u2060\x8d\u200C\u061C\u2061\u2061\x90\u206F\u206B\u200D\u200D\x9d\u206C\u206E\u206D\u200D\x9d\u206B\u206D\u206B\u206D\u206E\u206F\x90\x81\u200C\u206A\u206C\u206D\u2063\u2064",
        'paginated-picker.async-select.select.option.retry-message': "\u2063\u2062Click to retry\x8f\u206C\u200C\x81\u061C\u206E\u061C\u206B\u206C\x9d\u206D\u206C\u206F\u206F\u206C\u206E\x8d\u200C\u200D\x90\u206D\x8d\u206F\u206B\x81\u2060\u206F\x8d\u206E\u206A\x90\u206A\u2063\u2064",
        'paginated-picker.async-select.select.search-placeholder': "\u2063\u2062Search\u200D\u206D\x90\u061C\u200D\u206A\u206E\x90\u206A\u206C\u206F\u061C\u200C\u206A\x90\u206D\x81\u206C\x9d\u061C\u200D\u200D\x8f\u206D\u206D\x8d\x8f\u206E\x9d\u2060\u206F\u2060\u2063\u2064",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u2063\u2062Show full list\x90\u206D\u2061\u206E\u206A\u206B\u061C\u206C\u206B\u206E\u206A\u206E\u206D\x9d\u2061\x8f\x9d\u206B\u2060\u200D\x9d\u2061\u206B\u206B\u206A\x90\x81\u206C\x81\u200C\u206D\u200D\u2063\u2064"
    };
});
parcelRegister("57ePL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e96093f9b37b630$export$2e2bcd8739ae039);
    var $1e96093f9b37b630$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Borrar selecci\xf3n",
        'paginated-picker.async-select.menu-list.error-message.error-message': 'No se han podido recuperar los datos',
        'paginated-picker.async-select.menu-list.error-message.retry-message': 'Haz clic para intentarlo de nuevo',
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "Cargando\u2026",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Mostrar m\xe1s",
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'No se han encontrado coincidencias',
        'paginated-picker.async-select.select.option.error-message': 'No se han podido recuperar los datos',
        'paginated-picker.async-select.select.option.retry-message': 'Haz clic para intentarlo de nuevo',
        'paginated-picker.async-select.select.search-placeholder': 'Buscar',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
    };
});
parcelRegister("kIWZm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb2db60f1b16e7e2$export$2e2bcd8739ae039);
    var $fb2db60f1b16e7e2$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Tyhjenn\xe4 valinta",
        'paginated-picker.async-select.menu-list.error-message.error-message': 'Tietoja ei voitu noutaa',
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Ladataan...',
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "N\xe4yt\xe4 lis\xe4\xe4",
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ei hakutuloksia',
        'paginated-picker.async-select.select.option.error-message': 'Tietoja ei voitu noutaa',
        'paginated-picker.async-select.select.option.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
        'paginated-picker.async-select.select.search-placeholder': 'Hae',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "N\xe4yt\xe4 koko luettelo"
    };
});
parcelRegister("9eF14", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58c1b5b28e83f8f7$export$2e2bcd8739ae039);
    var $58c1b5b28e83f8f7$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Effacer la s\xe9lection",
        'paginated-picker.async-select.menu-list.error-message.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Cliquez pour r\xe9essayer",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "Chargement en cours\u2026",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Afficher plus',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} sur {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "R\xe9sultats introuvables",
        'paginated-picker.async-select.select.option.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
        'paginated-picker.async-select.select.option.retry-message': "Cliquez pour r\xe9essayer",
        'paginated-picker.async-select.select.search-placeholder': 'Rechercher',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Afficher toute la liste'
    };
});
parcelRegister("g5wS3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcfe8eaa5a424d59$export$2e2bcd8739ae039);
    var $bcfe8eaa5a424d59$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Kijel\xf6l\xe9s megsz\xfcntet\xe9se",
        'paginated-picker.async-select.menu-list.error-message.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "Bet\xf6lt\xe9s\u2026",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "T\xf6bb",
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "Nincs egyez\xe9s",
        'paginated-picker.async-select.select.option.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
        'paginated-picker.async-select.select.option.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
        'paginated-picker.async-select.select.search-placeholder': "Keres\xe9s",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Teljes lista megjelen\xedt\xe9se"
    };
});
parcelRegister("d41Rh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$104355f2db8708eb$export$2e2bcd8739ae039);
    var $104355f2db8708eb$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Cancella selezione',
        'paginated-picker.async-select.menu-list.error-message.error-message': 'Impossibile recuperare i dati',
        'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clicca per riprovare',
        'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Caricamento in corso...',
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mostra altro',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} di {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nessuna corrispondenza trovata',
        'paginated-picker.async-select.select.option.error-message': 'Impossibile recuperare i dati',
        'paginated-picker.async-select.select.option.retry-message': 'Clicca per riprovare',
        'paginated-picker.async-select.select.search-placeholder': 'Ricerca',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Mostra l'elenco completo"
    };
});
parcelRegister("euZEp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c86c54b42f8c58b$export$2e2bcd8739ae039);
    var $4c86c54b42f8c58b$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u9078\u629E\u3092\u89E3\u9664",
        'paginated-picker.async-select.menu-list.error-message.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u8868\u793A\u3092\u5897\u3084\u3059",
        'paginated-picker.async-select.pagination-details.of-total-count': "{totalCount} \u4EF6\u4E2D {itemsCount} \u4EF6",
        'paginated-picker.async-select.select.no-options-message.no-options-message': "\u4E00\u81F4\u3059\u308B\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
        'paginated-picker.async-select.select.option.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
        'paginated-picker.async-select.select.option.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
        'paginated-picker.async-select.select.search-placeholder': "\u691C\u7D22",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u30EA\u30B9\u30C8\u5168\u4F53\u3092\u8868\u793A"
    };
});
parcelRegister("gQ7cM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61eaf753f1c028a4$export$2e2bcd8739ae039);
    var $61eaf753f1c028a4$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\uC120\uD0DD \uD56D\uBAA9 \uC9C0\uC6B0\uAE30",
        'paginated-picker.async-select.menu-list.error-message.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\uB85C\uB4DC \uC911...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\uB354 \uBCF4\uAE30",
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "\uC77C\uCE58\uD558\uB294 \uD56D\uBAA9 \uC5C6\uC74C",
        'paginated-picker.async-select.select.option.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
        'paginated-picker.async-select.select.option.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
        'paginated-picker.async-select.select.search-placeholder': "\uAC80\uC0C9",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\uC804\uCCB4 \uBAA9\uB85D \uD45C\uC2DC"
    };
});
parcelRegister("8jIt1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c0d7e58edd6336e$export$2e2bcd8739ae039);
    var $5c0d7e58edd6336e$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Fjern valg',
        'paginated-picker.async-select.menu-list.error-message.error-message': 'Kan ikke hente data',
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "Laster\xa0\u2026",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mer',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'Finner ingen treff',
        'paginated-picker.async-select.select.option.error-message': 'Kan ikke hente data',
        'paginated-picker.async-select.select.option.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
        'paginated-picker.async-select.select.search-placeholder': "S\xf8k",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis fullstendig liste'
    };
});
parcelRegister("9xh2O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$073977698fca3650$export$2e2bcd8739ae039);
    var $073977698fca3650$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Selectie wissen',
        'paginated-picker.async-select.menu-list.error-message.error-message': 'Gegevens konden niet worden opgehaald',
        'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klik om het opnieuw te proberen',
        'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Laden...',
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Meer tonen',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} van {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': 'Geen overeenkomsten gevonden',
        'paginated-picker.async-select.select.option.error-message': 'Gegevens konden niet worden opgehaald',
        'paginated-picker.async-select.select.option.retry-message': 'Klik om het opnieuw te proberen',
        'paginated-picker.async-select.select.search-placeholder': 'Zoeken',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Volledige lijst weergeven'
    };
});
parcelRegister("iRC8S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7b7e7e7513428e4$export$2e2bcd8739ae039);
    var $a7b7e7e7513428e4$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Wyczy\u015B\u0107 wyb\xf3r",
        'paginated-picker.async-select.menu-list.error-message.error-message': "Nie mo\u017Cna pobra\u0107 danych",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0141adowanie...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Poka\u017C wi\u0119cej",
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} z {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "Nie znaleziono dopasowa\u0144",
        'paginated-picker.async-select.select.option.error-message': "Nie mo\u017Cna pobra\u0107 danych",
        'paginated-picker.async-select.select.option.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
        'paginated-picker.async-select.select.search-placeholder': 'Szukaj',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Poka\u017C pe\u0142n\u0105 list\u0119"
    };
});
parcelRegister("1RIUY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7e710a9cbd028aa$export$2e2bcd8739ae039);
    var $a7e710a9cbd028aa$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Limpar sele\xe7\xe3o",
        'paginated-picker.async-select.menu-list.error-message.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
        'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clique para tentar de novo',
        'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Carregando...',
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Ver mais',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "Nenhuma correspond\xeancia encontrada",
        'paginated-picker.async-select.select.option.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
        'paginated-picker.async-select.select.option.retry-message': 'Clique para tentar de novo',
        'paginated-picker.async-select.select.search-placeholder': 'Pesquisar',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
    };
});
parcelRegister("cv3lW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35dacc9806ad08d6$export$2e2bcd8739ae039);
    var $35dacc9806ad08d6$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435",
        'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
        'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0438\u0437 {totalCount}",
        'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
        'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
        'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
        'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0438\u0441\u043A",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
    };
});
parcelRegister("4OMkS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c22d26bb6ba2fd7$export$2e2bcd8739ae039);
    var $1c22d26bb6ba2fd7$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Rensa urval',
        'paginated-picker.async-select.menu-list.error-message.error-message': "Det gick inte att h\xe4mta data",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4ser in ...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Visa mer',
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "Inga tr\xe4ffar hittades",
        'paginated-picker.async-select.select.option.error-message': "Det gick inte att h\xe4mta data",
        'paginated-picker.async-select.select.option.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
        'paginated-picker.async-select.select.search-placeholder': "S\xf6k",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Visa fullst\xe4ndig lista"
    };
});
parcelRegister("2lfQd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21bd720fd44512e9$export$2e2bcd8739ae039);
    var $21bd720fd44512e9$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0E25\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
        'paginated-picker.async-select.menu-list.error-message.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
        'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0E08\u0E32\u0E01 {totalCount}",
        'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
        'paginated-picker.async-select.select.option.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
        'paginated-picker.async-select.select.option.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
        'paginated-picker.async-select.select.search-placeholder': "\u0E04\u0E49\u0E19\u0E2B\u0E32",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
    };
});
parcelRegister("61LkR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0b83f17e8540266$export$2e2bcd8739ae039);
    var $f0b83f17e8540266$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Se\xe7imi temizle",
        'paginated-picker.async-select.menu-list.error-message.error-message': "Veriler al\u0131namad\u0131",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "Y\xfckleniyor...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Daha fazla g\xf6ster",
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "E\u015Fle\u015Fme bulunamad\u0131",
        'paginated-picker.async-select.select.option.error-message': "Veriler al\u0131namad\u0131",
        'paginated-picker.async-select.select.option.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
        'paginated-picker.async-select.select.search-placeholder': 'Ara',
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Tam listeyi g\xf6ster"
    };
});
parcelRegister("5qDIG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$519e8e0fe8d93334$export$2e2bcd8739ae039);
    var $519e8e0fe8d93334$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
        'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
        'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0437 {totalCount}",
        'paginated-picker.async-select.select.no-options-message.no-options-message': "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
        'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
        'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0448\u0443\u043A",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
    };
});
parcelRegister("azy9G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abf5f3bfc9432b22$export$2e2bcd8739ae039);
    var $abf5f3bfc9432b22$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "X\xf3a m\u1EE5c \u0111\xe3 ch\u1ECDn",
        'paginated-picker.async-select.menu-list.error-message.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0110ang t\u1EA3i...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Hi\u1EC3n th\u1ECB th\xeam",
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xf9 h\u1EE3p n\xe0o",
        'paginated-picker.async-select.select.option.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
        'paginated-picker.async-select.select.option.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
        'paginated-picker.async-select.select.search-placeholder': "T\xecm ki\u1EBFm",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Hi\u1EC3n th\u1ECB danh s\xe1ch \u0111\u1EA7y \u0111\u1EE7"
    };
});
parcelRegister("iJkie", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d6800f8feb53cfc$export$2e2bcd8739ae039);
    var $1d6800f8feb53cfc$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u7A7A\u9009\u62E9",
        'paginated-picker.async-select.menu-list.error-message.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u52A0\u8F7D...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u663E\u793A\u66F4\u591A",
        'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
        'paginated-picker.async-select.select.no-options-message.no-options-message': "\u672A\u627E\u5230\u5339\u914D\u9879",
        'paginated-picker.async-select.select.option.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
        'paginated-picker.async-select.select.option.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
        'paginated-picker.async-select.select.search-placeholder': "\u641C\u7D22",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u663E\u793A\u5B8C\u6574\u5217\u8868"
    };
});
parcelRegister("5Pj4T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3374cd11ea2b5edc$export$2e2bcd8739ae039);
    var $3374cd11ea2b5edc$export$2e2bcd8739ae039 = {
        'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u9664\u9078\u53D6\u5167\u5BB9",
        'paginated-picker.async-select.menu-list.error-message.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
        'paginated-picker.async-select.menu-list.error-message.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
        'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u8F09\u5165...",
        'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u986F\u793A\u8F03\u591A",
        'paginated-picker.async-select.pagination-details.of-total-count': "\u7B2C {itemsCount} \u500B\uFF0C\u5171 {totalCount} \u500B",
        'paginated-picker.async-select.select.no-options-message.no-options-message': "\u627E\u4E0D\u5230\u76F8\u7B26\u9805\u76EE",
        'paginated-picker.async-select.select.option.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
        'paginated-picker.async-select.select.option.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
        'paginated-picker.async-select.select.search-placeholder': "\u641C\u5C0B",
        'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u986F\u793A\u5B8C\u6574\u6E05\u55AE"
    };
});
parcelRegister("eOSw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$304ac89284934ce2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7d4ZW;
    var $decHf;
    var $4ZTIH;
    const $304ac89284934ce2$var$formatOptionLabel = (option)=>{
        if (option.optionType === 'option') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("decHf")).IconOptionLabel), {
            option: option
        });
        if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7d4ZW")).AvatarOptionLabel), {
            avatarOption: option
        });
        if (option.optionType === 'lozenge') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ZTIH")).LozengeOptionLabel), {
            lozengeOption: option
        });
        console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
    var $304ac89284934ce2$export$2e2bcd8739ae039 = $304ac89284934ce2$var$formatOptionLabel;
});
parcelRegister("7d4ZW", function(module, exports) {
    $parcel$export(module.exports, "AvatarOptionLabel", ()=>$63b4938407953058$export$fe00f602c942368a);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $iBdWF;
    const $63b4938407953058$export$fe00f602c942368a = ({ avatarOption: avatarOption })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledOption), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
            size: "xsmall",
            appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledChild), null, avatarOption.label));
});
parcelRegister("iBdWF", function(module, exports) {
    $parcel$export(module.exports, "StyledChild", ()=>$d57c37c2f7d7a568$export$8133811dea85f484);
    $parcel$export(module.exports, "StyledOption", ()=>$d57c37c2f7d7a568$export$844bee7de236d7ec);
    $parcel$export(module.exports, "StyledItem", ()=>$d57c37c2f7d7a568$export$7c16ae7705e422c4);
    $parcel$export(module.exports, "StyledChildIcon", ()=>$d57c37c2f7d7a568$export$c23e66fb1706d7dd);
    $parcel$export(module.exports, "StyledOptionIcon", ()=>$d57c37c2f7d7a568$export$20da797b837461ca);
    var $47bDC = parcelRequire("47bDC");
    const $d57c37c2f7d7a568$export$8133811dea85f484 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-3nijrx-0"
    })({
        margin: "var(--ds-space-050, 4px)",
        minWidth: 0
    });
    const $d57c37c2f7d7a568$export$844bee7de236d7ec = (0, $47bDC.default).div.withConfig({
        componentId: "sc-3nijrx-1"
    })({
        alignItems: 'center',
        display: 'flex'
    });
    const $d57c37c2f7d7a568$export$7c16ae7705e422c4 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-3nijrx-2"
    })({
        display: 'flex'
    });
    const $d57c37c2f7d7a568$export$c23e66fb1706d7dd = (0, $47bDC.default).div.withConfig({
        componentId: "sc-3nijrx-3"
    })({
        marginLeft: "var(--ds-space-100, 8px)"
    });
    const $d57c37c2f7d7a568$export$20da797b837461ca = (0, $47bDC.default).img.withConfig({
        componentId: "sc-3nijrx-4"
    })({
        borderRadius: '50%',
        height: '16px',
        width: '16px',
        display: 'flex',
        margin: "var(--ds-space-025, 2px)"
    });
});
parcelRegister("decHf", function(module, exports) {
    $parcel$export(module.exports, "IconOptionLabel", ()=>$b50063f39de22b0a$export$914fa095fc1e0a45);
    var $5uXOq = parcelRequire("5uXOq");
    var $iBdWF;
    const $b50063f39de22b0a$export$914fa095fc1e0a45 = ({ option: option })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledOption), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledItem), null, option.icon !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledOptionIcon), {
            src: option.icon,
            alt: option.label
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledChildIcon), null, option.label)));
});
parcelRegister("4ZTIH", function(module, exports) {
    $parcel$export(module.exports, "LozengeOptionLabel", ()=>$46cf944f2c72c496$export$5f70fe304106fcb1);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $iBdWF;
    const $46cf944f2c72c496$export$5f70fe304106fcb1 = ({ lozengeOption: lozengeOption })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledOption), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledChild), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iBdWF")).StyledItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: lozengeOption.appearance,
            isBold: lozengeOption.isBold,
            maxWidth: lozengeOption.maxWidth
        }, lozengeOption.label))));
});
parcelRegister("1ZIOB", function(module, exports) {
    $parcel$export(module.exports, "DialogInner", ()=>$4cf7df0777825fba$export$999ca5bf223f627);
    var $47bDC = parcelRequire("47bDC");
    const $4cf7df0777825fba$export$999ca5bf223f627 = (0, $47bDC.default).div.withConfig({
        componentId: "mzm5tv-0"
    })({
        minWidth: '220px'
    });
});
parcelRegister("7C0BI", function(module, exports) {
    $parcel$export(module.exports, "formatLabel", ()=>$b41b62f87754b346$export$957d7daebd899f12);
    var $5uXOq = parcelRequire("5uXOq");
    var $16T6Y;
    var $cgL5K;
    var $jrKyY;
    const $b41b62f87754b346$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : !!value;
    const $b41b62f87754b346$export$957d7daebd899f12 = (label = '', value)=>{
        if (!value || !$b41b62f87754b346$export$96bdbc84526f3739(value)) return label;
        const [firstValue, ...otherValues] = value.map((v)=>v.label ?? '');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jrKyY")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "strong",
            color: "inherit"
        }, label, ":"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jrKyY")).LabelValueWrapper), null, firstValue, otherValues.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jrKyY")).BadgeWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), null, `+${otherValues.length}`))));
    };
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("jrKyY", function(module, exports) {
    $parcel$export(module.exports, "BadgeWrapper", ()=>$949986fd5d9897c4$export$1a37a8b7ddf809ac);
    $parcel$export(module.exports, "Container", ()=>$949986fd5d9897c4$export$42a852a2b6b56249);
    $parcel$export(module.exports, "LabelValueWrapper", ()=>$949986fd5d9897c4$export$8f3477ca2c4ba51a);
    var $47bDC = parcelRequire("47bDC");
    const $949986fd5d9897c4$export$1a37a8b7ddf809ac = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1abwl2h-0"
    })({
        display: 'inline-flex',
        marginLeft: "var(--ds-space-050, 4px)",
        opacity: 0.5
    });
    const $949986fd5d9897c4$export$42a852a2b6b56249 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1abwl2h-1"
    })({
        display: 'inline-flex',
        alignItems: 'center'
    });
    const $949986fd5d9897c4$export$8f3477ca2c4ba51a = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1abwl2h-2"
    })({
        marginLeft: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        alignItems: 'center'
    });
});
parcelRegister("3t6TE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a77ed45d000d3127$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $c8Oei;
    var $i7Pgv;
    var $84gfX;
    var $d2vip;
    var $gUQZ8;
    const $a77ed45d000d3127$var$PickerTrigger = (0, $5uXOq.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId }, ref)=>{
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i7Pgv")).PaginatedPickerIntlProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d2vip")).LoadingStateAnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            isSelected: true,
            testId: testId
        }, children, ":")));
        const iconAfter = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("84gfX")).ClearButton), {
            onClick: (e)=>{
                e.stopPropagation();
                onClear?.();
            },
            label: "Remove criteria"
        });
        const Content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUQZ8")).ChildrenWrapper), null, children), onClear ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUQZ8")).StyledClose), null, iconAfter) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUQZ8")).StyledChevron), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "",
            LEGACY_margin: "-5px 0 0 0"
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i7Pgv")).PaginatedPickerIntlProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUQZ8")).ButtonWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: isInvalid ? 'danger' : 'default',
            isSelected: isSelected || hasValues,
            onClick: onClick,
            ref: ref,
            testId: testId,
            "aria-expanded": isSelected
        }, Content)));
    });
    var $a77ed45d000d3127$export$2e2bcd8739ae039 = $a77ed45d000d3127$var$PickerTrigger;
});
parcelRegister("84gfX", function(module, exports) {
    $parcel$export(module.exports, "ClearButton", ()=>$743eb357cffd5cdc$export$13ec83e50bf04290);
    var $5uXOq = parcelRequire("5uXOq");
    var $2C7j9;
    var $bjGSs;
    var $eVIB8;
    const $743eb357cffd5cdc$export$13ec83e50bf04290 = ({ label: label, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eVIB8")).StyledClearButton), {
            ...props,
            "data-testid": "paginated-picker.ui.clear-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
            color: "currentColor",
            label: label,
            LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("2C7j9"))))),
            LEGACY_margin: "0 0 0 -6px"
        }));
    $743eb357cffd5cdc$export$13ec83e50bf04290.defaultProps = {
        isSelected: false,
        type: 'button'
    };
    var $743eb357cffd5cdc$export$2e2bcd8739ae039 = $743eb357cffd5cdc$export$13ec83e50bf04290;
});
parcelRegister("eVIB8", function(module, exports) {
    $parcel$export(module.exports, "StyledClearButton", ()=>$41112036947e369a$export$969a0501aa28855a);
    var $47bDC = parcelRequire("47bDC");
    var $k5uoT;
    const $41112036947e369a$export$969a0501aa28855a = (0, $47bDC.default).div.withConfig({
        componentId: "m9cwqf-0"
    })({
        background: 0,
        border: 0,
        borderRadius: `${(0, (0, parcelRequire("k5uoT")).borderRadius)() / 2}px`,
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`,
        cursor: 'pointer',
        height: "var(--ds-space-300, 24px)",
        lineHeight: 1,
        outline: 0,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)",
        transition: 'background-color 200ms opacity 200ms',
        width: "var(--ds-space-300, 24px)",
        '&:hover, &:focus': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        }
    });
});
parcelRegister("d2vip", function(module, exports) {
    $parcel$export(module.exports, "LoadingStateAnimationWrapper", ()=>$3ee68ee71b88b53c$export$c7a90a9f6120efb7);
    var $47bDC = parcelRequire("47bDC");
    const $3ee68ee71b88b53c$export$c7a90a9f6120efb7 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-13besx7-0"
    })({
        position: 'relative',
        animation: 'flickerAnimation 2s infinite',
        '@keyframes flickerAnimation': {
            '0%': {
                opacity: 1
            },
            '50%': {
                opacity: 0.5
            },
            '100%': {
                opacity: 1
            }
        }
    });
});
parcelRegister("gUQZ8", function(module, exports) {
    $parcel$export(module.exports, "ButtonWrapper", ()=>$d54a7677c5ddf5c9$export$d53c836cccbb0d90);
    $parcel$export(module.exports, "ChildrenWrapper", ()=>$d54a7677c5ddf5c9$export$d9eb77d8aa91d4c8);
    $parcel$export(module.exports, "StyledChevron", ()=>$d54a7677c5ddf5c9$export$d2e6432fd8e55c4f);
    $parcel$export(module.exports, "StyledClose", ()=>$d54a7677c5ddf5c9$export$cd8104a6ec6bb897);
    var $47bDC = parcelRequire("47bDC");
    const $d54a7677c5ddf5c9$export$d53c836cccbb0d90 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1bg0ktc-0"
    })({
        position: 'relative'
    });
    const $d54a7677c5ddf5c9$export$d9eb77d8aa91d4c8 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1bg0ktc-1"
    })({
        paddingRight: "var(--ds-space-200, 16px)"
    });
    const $d54a7677c5ddf5c9$export$d2e6432fd8e55c4f = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1bg0ktc-2"
    })({
        background: 0,
        border: 0,
        height: "var(--ds-space-300, 24px)",
        lineHeight: 1,
        outline: 0,
        padding: 0,
        position: 'absolute',
        right: '0px',
        top: '50%',
        marginTop: "var(--ds-space-negative-150, -7px)",
        width: "var(--ds-space-300, 24px)"
    });
    const $d54a7677c5ddf5c9$export$cd8104a6ec6bb897 = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1bg0ktc-3"
    })({
        background: 0,
        border: 0,
        height: "var(--ds-space-300, 24px)",
        lineHeight: 1,
        outline: 0,
        padding: 0,
        position: 'absolute',
        right: "var(--ds-space-negative-050, -4px)",
        top: '50%',
        marginTop: "var(--ds-space-negative-150, -12px)",
        width: "var(--ds-space-300, 24px)"
    });
});
parcelRegister("9Na2D", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$72107aaf33cf7039$export$defe85febe8b728c);
    var $7VHMR;
    const $72107aaf33cf7039$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueType: {
            id: 'jira-common.ListProjectForms.IssueType',
            defaultMessage: 'Issue type',
            description: 'A button label for a dropdown listing issue types used for forms.'
        },
        requestType: {
            id: 'jira-common.ListProjectForms.RequestType',
            defaultMessage: 'Request type',
            description: 'A button label for a dropdown listing request types used for forms.'
        },
        issueTypeAriaLabel: {
            id: 'jira-common.ListProjectForms.IssueTypeAriaLabel',
            defaultMessage: 'Search issue types',
            description: 'Aria label for issue types picker'
        },
        requestTypeAriaLabel: {
            id: 'jira-common.ListProjectForms.RequestTypeAriaLabel',
            defaultMessage: 'Search request types',
            description: 'Aria label for request types picker'
        }
    });
});
parcelRegister("8Ls6i", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$661882b747d0e567$export$defe85febe8b728c);
    var $7VHMR;
    const $661882b747d0e567$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createFormLabel: {
            id: 'proforma-project-forms.CreateForm',
            defaultMessage: 'Create form',
            description: 'Label for a button for creating a new Jira form.'
        },
        description: {
            id: 'proforma-project-forms.Description',
            defaultMessage: 'Create, edit, export, and delete forms. Copy forms and use them in other projects.',
            description: 'A description of the actions available on the Jira project forms page.'
        },
        learnMoreLinkLabel: {
            id: 'proforma-project-forms.LearnMore',
            defaultMessage: 'Learn more about forms.',
            description: 'Label for a button with more information about Jira forms.'
        },
        loading: {
            id: 'proforma-project-forms.LoadingForms',
            defaultMessage: 'Loading...',
            description: 'The message for the primary loading spinner on the Jira project forms page.'
        },
        noFormsDescriptionJsm: {
            id: 'proforma-project-forms.NoFormsDescriptionJsm',
            defaultMessage: 'Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.',
            description: 'The description when there are no forms on the Jira project forms page in a JSM project.'
        },
        noFormsDescriptionJsw: {
            id: 'proforma-project-forms.NoFormsDescriptionJsw',
            defaultMessage: 'Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.',
            description: 'The description when there are no forms on the Jira project forms page in a JSW project.'
        },
        noFormsDescriptionJwm: {
            id: 'proforma-project-forms.NoFormsDescriptionJwm',
            defaultMessage: 'Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.',
            description: 'The description when there are no forms on the Jira project forms page in a JWM project.'
        },
        noFormsHeading: {
            id: 'proforma-project-forms.NoFormsHeading',
            defaultMessage: 'All of your forms will show up here',
            description: 'The heading when there are no forms on the Jira project forms page.'
        },
        noFormsHeadingAdvanced: {
            id: 'proforma-project-forms.NoFormsHeadingAdvanced',
            defaultMessage: 'All of your advanced forms will show up here',
            description: 'The heading when there are no forms on the Jira project proforma forms page.'
        },
        pageHeadingJwm: {
            id: 'proforma-project-forms.BusinessForms',
            defaultMessage: 'Advanced Forms',
            description: 'The heading of the Jira project forms (list) page for JWM projects.'
        },
        pageHeadingNonJwm: {
            id: 'proforma-project-forms.Forms',
            defaultMessage: 'Forms',
            description: 'The heading of the Jira project forms (list) page for non-JWM projects.'
        }
    });
});
parcelRegister("cbPCu", function(module, exports) {
    $parcel$export(module.exports, "Description", ()=>$8dfe8db9774aaace$export$393edc798c47379d);
    $parcel$export(module.exports, "HeadingContainer", ()=>$8dfe8db9774aaace$export$9204afa15bdaec56);
    $parcel$export(module.exports, "NoFormsColumn", ()=>$8dfe8db9774aaace$export$ef6be50c6b1bf75d);
    $parcel$export(module.exports, "NoFormsDescription", ()=>$8dfe8db9774aaace$export$c4b08a3b2c9bb79b);
    $parcel$export(module.exports, "NoFormsLearnMoreLink", ()=>$8dfe8db9774aaace$export$2d4dc85665f08d27);
    $parcel$export(module.exports, "NoFormsHeading", ()=>$8dfe8db9774aaace$export$cab51723f6d096b6);
    $parcel$export(module.exports, "ProjectFormsWrapper", ()=>$8dfe8db9774aaace$export$e2eec2297409c511);
    var $dAHxw = parcelRequire("dAHxw");
    const $8dfe8db9774aaace$export$393edc798c47379d = (0, $dAHxw.default).div({
        display: 'flex',
        alignItems: 'center',
        marginBottom: "var(--ds-space-400, 32px)"
    });
    const $8dfe8db9774aaace$export$9204afa15bdaec56 = (0, $dAHxw.default).span({
        'h1, h1 > span': {
            fontSize: "var(--ds-font-heading-large, 24px)",
            fontWeight: "var(--ds-font-weight-medium, 500)"
        }
    });
    const $8dfe8db9774aaace$export$ef6be50c6b1bf75d = (0, $dAHxw.default).div({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
    });
    const $8dfe8db9774aaace$export$c4b08a3b2c9bb79b = (0, $dAHxw.default).div({
        textAlign: 'center',
        width: '425px'
    });
    const $8dfe8db9774aaace$export$2d4dc85665f08d27 = (0, $dAHxw.default).div({
        marginBottom: "var(--ds-space-400, 32px)",
        textAlign: 'center'
    });
    const $8dfe8db9774aaace$export$cab51723f6d096b6 = (0, $dAHxw.default).h3({
        paddingBottom: "var(--ds-space-100, 8px)"
    });
    const $8dfe8db9774aaace$export$e2eec2297409c511 = (0, $dAHxw.default).div({
        maxWidth: '1000px'
    });
});
parcelRegister("jRtpo", function(module, exports) {
    $parcel$export(module.exports, "isSoftwareFormsEnabled", ()=>$e759c7763be0c3bd$export$a8d0a5edf6fb0c31);
    var $5IPCv;
    const $e759c7763be0c3bd$export$a8d0a5edf6fb0c31 = ()=>{
        if ((0, (0, parcelRequire("5IPCv")).default).initializeCalled()) return (0, (0, parcelRequire("5IPCv")).default).getExperimentValue('forms_for_jsw_experiment', 'isEnabled', false, {
            fireExperimentExposure: false
        });
        return false;
    };
});
parcelRegister("2N1wE", function(module, exports) {
    $parcel$export(module.exports, "AsyncBenefitModal", ()=>$c18ab5df97bfb7a3$export$efc5bc86e2f54c1c);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $c18ab5df97bfb7a3$var$LazyBenefitModal = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("3iN4w")), {
        moduleId: "./src/packages/proforma/project-forms-settings/src/ui/benefit-modal/main.tsx"
    });
    const $c18ab5df97bfb7a3$var$BenefitModal = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "proforma-forms-settings-benefit-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c18ab5df97bfb7a3$var$LazyBenefitModal, null));
    const $c18ab5df97bfb7a3$export$efc5bc86e2f54c1c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "ProformaFormsSettings",
            packageName: "jiraProformaFormSettingsBenefitModal",
            teamName: "jsm-request-intake"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c18ab5df97bfb7a3$var$BenefitModal, null));
});
parcelRegister("3iN4w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eFJP1").then(()=>parcelRequire('2UKyL'));
});
parcelRegister("hiwyX", function(module, exports) {
    $parcel$export(module.exports, "FormSettingsTemplateLibrary", ()=>$a73ed3fd5ae18cf2$export$830400ba49ddf12b);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $kIbMP;
    var $dKzS9;
    var $doZTA;
    var $acB4m;
    function $a73ed3fd5ae18cf2$export$830400ba49ddf12b({ projectId: projectId }) {
        const { callCreateForm: callCreateForm } = (0, (0, parcelRequire("acB4m")).useCreateForm)(projectId);
        const [{ location: location }, { push: push }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const handleTemplateSelectedOld = (0, $5uXOq.useCallback)(async (templateId, template)=>{
            const result = await callCreateForm({
                templateId: templateId,
                template: template
            });
            if (result) push(`${location.pathname}/form/${result.form.id}/edit`);
        }, [
            push,
            callCreateForm,
            location.pathname
        ]);
        const handleTemplateSelected = (0, $5uXOq.useCallback)(async (templateId, template, templateGroup)=>{
            const formTemplateKey = (0, (0, parcelRequire("dKzS9")).generateFormTemplateKey)(templateGroup, template.design.settings.name);
            const result = await callCreateForm({
                templateId: templateId,
                template: template,
                formTemplateKey: formTemplateKey
            });
            if (result) push(`${location.pathname}/form/${result.form.id}/edit`);
        }, [
            push,
            callCreateForm,
            location.pathname
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kIbMP")).ProformaTemplateLibraryInDrawer), {
            onTemplateSelected: (0, (0, parcelRequire("4R6GH")).fg)('start-1993_change_granular_template_events') ? handleTemplateSelected : handleTemplateSelectedOld
        });
    }
});
parcelRegister("kIbMP", function(module, exports) {
    $parcel$export(module.exports, "ProformaTemplateLibraryInDrawer", ()=>$4719d7c7b70415ac$export$8c06e3ce3a085ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $9kPzn;
    var $aW3TH;
    var $kxZPA;
    var $7hSN4;
    var $dnjeJ;
    var $6mTto;
    const $4719d7c7b70415ac$var$LazyProformaTemplateLibrary = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("h0fx4")).then(({ ProformaTemplateLibraryWithAnalytics: ProformaTemplateLibraryWithAnalytics })=>ProformaTemplateLibraryWithAnalytics), {
        moduleId: "./src/packages/proforma/proforma-template-library/src/ui/main.tsx"
    });
    const $4719d7c7b70415ac$var$LazyProformaTemplateLibraryWithUFO = (props)=>{
        (0, (0, parcelRequire("dnjeJ")).useUFOComponentExperience)((0, (0, parcelRequire("6mTto")).proformaTemplateLibraryExperience));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4719d7c7b70415ac$var$LazyProformaTemplateLibrary, props);
    };
    const $4719d7c7b70415ac$export$8c06e3ce3a085ee = (props)=>{
        const { isTemplateLibraryOpen: isTemplateLibraryOpen } = (0, (0, parcelRequire("aW3TH")).useTemplateLibraryState)();
        const { setIsTemplateLibraryOpen: setIsTemplateLibraryOpen } = (0, (0, parcelRequire("aW3TH")).useTemplateLibraryActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9kPzn")).default), {
            testId: "proforma-template-library.ui.proforma-template-library-drawer",
            isOpen: isTemplateLibraryOpen,
            onClose: ()=>setIsTemplateLibraryOpen(false),
            width: "full",
            overrides: {
                Content: {
                    cssFn: (defaultStyles)=>({
                            ...defaultStyles,
                            marginTop: 0
                        })
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7hSN4")).LazySuspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4719d7c7b70415ac$var$LazyProformaTemplateLibraryWithUFO, props)));
    };
});
parcelRegister("dnjeJ", function(module, exports) {
    $parcel$export(module.exports, "useUFOComponentExperience", ()=>$44448c24118cb590$export$30ab340faaed55d4);
    var $5uXOq = parcelRequire("5uXOq");
    const $44448c24118cb590$var$useConstructor = (callback)=>{
        const hasBeenFired = (0, $5uXOq.useRef)(false);
        if (!hasBeenFired.current) {
            callback();
            hasBeenFired.current = true;
        }
        return null;
    };
    const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                experience.abort();
            };
        }, []);
        $44448c24118cb590$var$useConstructor(()=>experience.start());
        return null;
    };
});
parcelRegister("6mTto", function(module, exports) {
    $parcel$export(module.exports, "proformaTemplateLibraryExperience", ()=>$2bd834e24110f976$export$451a0e8b519ffce);
    var $atdLB;
    var $duUGa;
    const $2bd834e24110f976$export$451a0e8b519ffce = new (0, (0, parcelRequire("duUGa")).UFOExperience)('proforma.template-library', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
});
parcelRegister("h0fx4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("kWrFZ"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8ubmg")
    ]).then(()=>parcelRequire('4KwNP'));
});
parcelRegister("dKzS9", function(module, exports) {
    $parcel$export(module.exports, "generateFormTemplateKey", ()=>$9bab6b14e5323602$export$d56ade9f6d05d67a);
    const $9bab6b14e5323602$export$d56ade9f6d05d67a = (formTemplateGroup, formTemplateName)=>{
        const processedGroup = formTemplateGroup?.trim().toLowerCase().replaceAll(' ', '-');
        const processedName = formTemplateName.trim().toLowerCase().replaceAll(' ', '-');
        return !processedGroup ? processedName : processedGroup?.concat('.', processedName);
    };
});
parcelRegister("acB4m", function(module, exports) {
    $parcel$export(module.exports, "useCreateForm", ()=>$c7068502a38273e2$export$a78b09186b83ef5f);
    var $5uXOq = parcelRequire("5uXOq");
    var $ld2hZ;
    var $jcw0u;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $dTob9;
    var $1C4SM;
    var $koeKL;
    var $57t1Y;
    const $c7068502a38273e2$export$a78b09186b83ef5f = (projectId)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFormSelectFailFlag: showFormSelectFailFlag } = (0, (0, parcelRequire("dTob9")).useFormSelectedErrorFlag)();
        const requestOld = (0, $5uXOq.useCallback)(async ({ templateId: templateId, template: template })=>{
            const isBlankTemplate = templateId === (0, (0, parcelRequire("1C4SM")).BLANK_TEMPLATE).id;
            try {
                const createdFormResponse = await (0, (0, parcelRequire("57t1Y")).createForm)(cloudId, projectId, template);
                if (isBlankTemplate) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'blankTemplateForm created', {
                    projectId: projectId,
                    templateFormId: createdFormResponse.form.id
                });
                else (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'templateFormFromTemplate created', {
                    projectId: projectId,
                    templateId: templateId,
                    templateFormId: createdFormResponse.form.id
                });
                return createdFormResponse;
            } catch (error) {
                if (isBlankTemplate) (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'createBlankTemplateForm',
                        packageName: 'jiraProformaProjectFormsSettings',
                        teamName: 'jsm-request-intake'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId
                    }
                });
                else (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'createFormFromTemplate',
                        packageName: 'jiraProformaProjectFormsSettings',
                        teamName: 'jsm-request-intake'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId,
                        templateId: templateId
                    }
                });
                showFormSelectFailFlag();
                throw error;
            }
        }, [
            cloudId,
            createAnalyticsEvent,
            projectId,
            showFormSelectFailFlag
        ]);
        const request = (0, $5uXOq.useCallback)(async ({ templateId: templateId, template: template, formTemplateKey: formTemplateKey })=>{
            const isBlankTemplate = templateId === (0, (0, parcelRequire("1C4SM")).BLANK_TEMPLATE).id;
            try {
                const createdFormResponse = await (0, (0, parcelRequire("57t1Y")).createForm)(cloudId, projectId, template);
                if (isBlankTemplate) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'blankTemplateForm created', {
                    projectId: projectId,
                    templateFormId: createdFormResponse.form.id
                });
                else (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'templateFormFromTemplate created', {
                    projectId: projectId,
                    templateFormId: createdFormResponse.form.id,
                    formTemplateId: templateId,
                    formTemplateKey: formTemplateKey
                });
                return createdFormResponse;
            } catch (error) {
                if (isBlankTemplate) (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'createBlankTemplateForm',
                        packageName: 'jiraProformaProjectFormsSettings',
                        teamName: 'jsm-request-intake'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId
                    }
                });
                else (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'createFormFromTemplate',
                        packageName: 'jiraProformaProjectFormsSettings',
                        teamName: 'jsm-request-intake'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: {
                        projectId: projectId,
                        templateId: templateId
                    }
                });
                showFormSelectFailFlag();
                throw error;
            }
        }, [
            cloudId,
            createAnalyticsEvent,
            projectId,
            showFormSelectFailFlag
        ]);
        const { loading: loading, data: data, error: error, fetch: fetch } = (0, (0, parcelRequire("ld2hZ")).useService)((0, (0, parcelRequire("4R6GH")).fg)('start-1993_change_granular_template_events') ? request : requestOld, {
            loading: true
        });
        return {
            loading: loading,
            data: data,
            error: error,
            callCreateForm: fetch
        };
    };
});
parcelRegister("dTob9", function(module, exports) {
    $parcel$export(module.exports, "useFormSelectedErrorFlag", ()=>$7c5d144ea28a8ffe$export$2fbea2fdae1f5e83);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $koVbs;
    var $ARTjQ;
    const $7c5d144ea28a8ffe$export$2fbea2fdae1f5e83 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const showFormSelectFailFlag = (0, $5uXOq.useCallback)(()=>{
            showFlag({
                id: 'proforma-template-library.ui.library.form-selected-error',
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("ARTjQ")).messages).title),
                isAutoDismiss: true
            });
        }, [
            showFlag,
            formatMessage
        ]);
        return {
            showFormSelectFailFlag: showFormSelectFailFlag
        };
    };
});
parcelRegister("ARTjQ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$5f207aabf3549d28$export$defe85febe8b728c);
    var $7VHMR;
    const $5f207aabf3549d28$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "proforma-template-library.common.utils.form-selected-failed-flag.title",
            "defaultMessage": "We couldn't open this form template. Select template to try again."
        }
    });
});
parcelRegister("1C4SM", function(module, exports) {
    $parcel$export(module.exports, "BLANK_TEMPLATE", ()=>$5a38854c7f8ac2d1$export$6e9e11a7a8d6a7f3);
    $parcel$export(module.exports, "BLANK_TEMPLATE_FORM", ()=>$5a38854c7f8ac2d1$export$35b609282db432c6);
    const $5a38854c7f8ac2d1$export$6e9e11a7a8d6a7f3 = {
        group: null,
        subGroup: [],
        name: '',
        lang: null,
        faIcon: {
            faKey: ''
        },
        id: (0, $b78ca21461af1579$export$32ab81f39b57ddd2)
    };
    const $5a38854c7f8ac2d1$export$35b609282db432c6 = {
        id: 0,
        updated: '',
        design: {
            settings: {
                templateId: 0,
                name: '',
                submit: {
                    lock: false,
                    pdf: false
                }
            },
            layout: [
                {
                    version: 1,
                    type: 'doc',
                    content: []
                }
            ],
            conditions: {},
            sections: {},
            questions: {}
        },
        state: undefined
    };
});
const $b78ca21461af1579$export$6109b18ad728eb9b = 'All';
const $b78ca21461af1579$export$e3b2d903e6c086dc = 'ADDED';
const $b78ca21461af1579$export$32ab81f39b57ddd2 = 'PROFORMA_BLANK_FORM_TEMPLATE';
parcelRegister("57t1Y", function(module, exports) {
    $parcel$export(module.exports, "createForm", ()=>$401ca192a4298de6$export$f681a8129d2e9d28);
    var $eusud;
    function $401ca192a4298de6$export$f681a8129d2e9d28(cloudId, projectId, template) {
        return (0, (0, parcelRequire("eusud")).performPostRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/cloud/project/${projectId}/form`, {
            body: JSON.stringify(template)
        });
    }
});
parcelRegister("63MBm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97cfc99e6031092f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bJcWY;
    var $aZdfU;
    var $e0Brz;
    var $jS4lj;
    var $e0tCO;
    var $gEFwt;
    var $dAfqg;
    const $97cfc99e6031092f$var$AppContainer = ({ children: children, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dAfqg")).ProjectContextProvider), null, ({ data: projectData })=>(0, ($parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$ConditionalGrid, {
                gridLayout: gridLayout,
                fullSize: fullSize
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$BreadcrumbsWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
                baseUrl: "",
                projectKey: projectKey,
                projectName: projectData ? projectData.projectName : projectKey
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0tCO")).default), {
                baseUrl: "",
                projectKey: projectKey,
                projectType: projectData ? projectData.projectType : undefined,
                isSimplified: projectData ? projectData.simplified : false
            }, children)))));
    var $97cfc99e6031092f$export$2e2bcd8739ae039 = $97cfc99e6031092f$var$AppContainer;
    const $97cfc99e6031092f$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
        if (fullSize) return (0, ($parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$FullHeightWrapper, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($97cfc99e6031092f$var$NormalWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJcWY")).default), {
            layout: gridLayout
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZdfU")).default), null, children)));
    };
    const $97cfc99e6031092f$var$NormalWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1yt45gjp",
                __cmplp.className
            ])
        });
    });
    const $97cfc99e6031092f$var$FullHeightWrapper = (0, $5uXOq.forwardRef)(({ as: C = $97cfc99e6031092f$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4 _zulp1ejb",
                __cmplp.className
            ])
        });
    });
    const $97cfc99e6031092f$var$BreadcrumbsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bJcWY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08fe944bdcd177c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1WIN;
    var $itnZ9;
    var $aZdfU;
    var $ephoW;
    const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
        const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        const { medium: medium } = (0, $5uXOq.useContext)((0, (0, parcelRequire("aZdfU")).GridColumnContext));
        const defaultColumns = medium > 0 ? medium : (0, (0, parcelRequire("f1WIN")).defaultGridColumns);
        const spacing = spacingProp ?? theme?.spacing ?? (0, (0, parcelRequire("f1WIN")).defaultSpacing);
        const columns = columnsProp ?? theme?.columns ?? defaultColumns;
        const isNested = theme?.isNestedGrid ?? !isRoot;
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                isRoot: false,
                isNested: isNested,
                spacing: spacing,
                columns: columns
            }), [
            spacing,
            columns,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ephoW")).GridContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itnZ9")).Grid), {
            layout: layout,
            testId: testId
        }, children));
    };
    var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;
});
parcelRegister("f1WIN", function(module, exports) {
    $parcel$export(module.exports, "defaultGridColumns", ()=>$196a11a7b8c2fbef$export$74797698e12f8baa);
    $parcel$export(module.exports, "defaultGridColumnWidth", ()=>$196a11a7b8c2fbef$export$b8241a1616ab1b96);
    $parcel$export(module.exports, "spacingMapping", ()=>$196a11a7b8c2fbef$export$2a89a65a43bab52d);
    $parcel$export(module.exports, "defaultSpacing", ()=>$196a11a7b8c2fbef$export$8ec7372efd74b753);
    $parcel$export(module.exports, "defaultBannerHeight", ()=>$196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
    $parcel$export(module.exports, "defaultMedium", ()=>$196a11a7b8c2fbef$export$f8725d21f81f3e01);
    $parcel$export(module.exports, "defaultLayout", ()=>$196a11a7b8c2fbef$export$2303d2bd9eeff99a);
    $parcel$export(module.exports, "varColumnsNum", ()=>$196a11a7b8c2fbef$export$9ddc3632bbfb8966);
    $parcel$export(module.exports, "varColumnSpan", ()=>$196a11a7b8c2fbef$export$8b7e31f391e6e681);
    $parcel$export(module.exports, "varGridSpacing", ()=>$196a11a7b8c2fbef$export$936829b4511db3e4);
    const $196a11a7b8c2fbef$export$3aaf3a78c909ea56 = 8;
    const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
    const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 10;
    const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
        comfortable: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 5,
        cosy: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 2,
        compact: $196a11a7b8c2fbef$export$3aaf3a78c909ea56 * 0.5
    };
    const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
    const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
    const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
    const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
    const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
    const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
    const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';
});
parcelRegister("itnZ9", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$92e4fcbfc398e3a4$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f1WIN;
    var $ephoW;
    function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $92e4fcbfc398e3a4$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: '0 auto',
        padding: `0 calc(var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}) / 2)`,
        position: 'relative',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    });
    const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
        fixed: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(var(${(0, (0, parcelRequire("f1WIN")).varColumnsNum)}) * ${(0, (0, parcelRequire("f1WIN")).defaultGridColumnWidth)}px)`
        }),
        fluid: {
            name: "qhxz92",
            styles: "max-width:100%"
        }
    };
    const $92e4fcbfc398e3a4$var$nestedGridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 calc(-1 * var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`
    });
    const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, (0, parcelRequire("f1WIN")).defaultLayout), testId: testId, children: children })=>{
        const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $92e4fcbfc398e3a4$var$gridStyles,
                $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
                isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
            ],
            style: {
                [(0, (0, parcelRequire("f1WIN")).varColumnsNum)]: columns,
                [(0, (0, parcelRequire("f1WIN")).varGridSpacing)]: `${(0, (0, parcelRequire("f1WIN")).spacingMapping)[spacing]}px`
            },
            "data-testid": testId
        }, children);
    };
});
parcelRegister("ephoW", function(module, exports) {
    $parcel$export(module.exports, "GridContext", ()=>$529bf77650fbff0f$export$11cae3e04ab99fae);
    var $5uXOq = parcelRequire("5uXOq");
    var $f1WIN;
    const $529bf77650fbff0f$export$11cae3e04ab99fae = (0, $5uXOq.createContext)({
        isRoot: true,
        isNested: false,
        spacing: (0, (0, parcelRequire("f1WIN")).defaultSpacing),
        columns: (0, (0, parcelRequire("f1WIN")).defaultGridColumns)
    });
});
parcelRegister("aZdfU", function(module, exports) {
    $parcel$export(module.exports, "GridColumnContext", ()=>$11b791725219e059$export$1229ad7112b989f5);
    $parcel$export(module.exports, "default", ()=>$11b791725219e059$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $f1WIN;
    var $ephoW;
    var $11b791725219e059$var$ColumnVariant;
    (function(ColumnVariant) {
        ColumnVariant["Auto"] = "auto";
        ColumnVariant["Bounded"] = "bounded";
        ColumnVariant["FullWidth"] = "fullWidth";
    })($11b791725219e059$var$ColumnVariant || ($11b791725219e059$var$ColumnVariant = {}));
    const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
        if (medium === (0, (0, parcelRequire("f1WIN")).defaultMedium)) return "auto";
        else if (medium < columns) return "bounded";
        return "fullWidth";
    };
    const $11b791725219e059$var$availableWidth = '99.9999%';
    const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, (0, parcelRequire("f1WIN")).varColumnsNum)}))`;
    const $11b791725219e059$var$gridColumnStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
        margin: `0 calc(var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}) / 2)`,
        flexGrow: 1,
        flexShrink: 0,
        wordWrap: 'break-word'
    });
    const $11b791725219e059$var$gridColumnWidthStyles = {
        ["auto"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `auto`
        }),
        ["bounded"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, (0, parcelRequire("f1WIN")).varColumnSpan)}) - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `100%`
        }),
        ["fullWidth"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("f1WIN")).varGridSpacing)}))`,
            flexBasis: `100%`
        })
    };
    const $11b791725219e059$export$1229ad7112b989f5 = (0, $5uXOq.createContext)({
        medium: (0, (0, parcelRequire("f1WIN")).defaultMedium)
    });
    const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, (0, parcelRequire("f1WIN")).defaultMedium), children: children, testId: testId })=>{
        const { columns: columns } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ephoW")).GridContext));
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                medium: medium
            }), [
            medium
        ]);
        const colSpan = Math.max(1, Math.min(medium, columns));
        const variant = $11b791725219e059$var$getVariant({
            medium: medium,
            columns: columns
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $11b791725219e059$var$gridColumnStyles,
                $11b791725219e059$var$gridColumnWidthStyles[variant]
            ],
            style: {
                [(0, (0, parcelRequire("f1WIN")).varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId
        }, children));
    };
    var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;
});
parcelRegister("e0tCO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67a65658db3ebd27$export$2e2bcd8739ae039);
    var $az4zD;
    var $7Xr7M;
    var $67a65658db3ebd27$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("7Xr7M")).default));
});
parcelRegister("7Xr7M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14c779f1fa7b01b6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $c2D8L;
    var $81ps3;
    var $9zgyl;
    const $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && (projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                href: (0, (0, parcelRequire("81ps3")).createProjectSettingsUrl)(projectKey, projectType, isSimplified),
                text: formatMessage((0, (0, parcelRequire("9zgyl")).default).projectSettingsTitle),
                type: 'projectSettings'
            }
        }, children) : children;
    var $14c779f1fa7b01b6$export$2e2bcd8739ae039 = $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb;
});
parcelRegister("9zgyl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e487ef6161e77fc4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e487ef6161e77fc4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectSettingsTitle: {
            "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
            "defaultMessage": "Project settings"
        }
    });
});
parcelRegister("joVu9", function(module, exports) {
    $parcel$export(module.exports, "SharedSettingsDocumentTitle", ()=>$2c438104557218de$export$846e5bb7ce3ba3ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $9sGI6;
    var $ew1Lk;
    var $az4zD;
    var $e33py;
    var $bB78Z;
    const $2c438104557218de$export$155581e8dc02007a = (props)=>{
        const { DocumentTitle: DocumentTitle, section: section, action: action, intl: { formatMessage: formatMessage }, projectName: projectName, projectType: projectType } = props;
        if (projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e33py")).PageTitle), {
            DocumentTitle: DocumentTitle,
            section: section,
            projectName: projectName
        });
        const actionTitle = action && formatMessage((0, (0, parcelRequire("bB78Z")).default)[action]);
        const sectionTitle = formatMessage((0, (0, parcelRequire("bB78Z")).default)[section]);
        const title = actionTitle ? `${actionTitle} - ${projectName} - ${sectionTitle}` : `${projectName} - ${sectionTitle}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
            title: title
        });
    };
    const $2c438104557218de$var$InjectedPage = (0, (0, parcelRequire("9sGI6")).default)($2c438104557218de$export$155581e8dc02007a, {
        DocumentTitle: (0, (0, parcelRequire("ew1Lk")).DocumentTitle)
    });
    const $2c438104557218de$export$846e5bb7ce3ba3ec = (0, (0, parcelRequire("az4zD")).injectIntlV2)($2c438104557218de$var$InjectedPage);
    var $2c438104557218de$export$2e2bcd8739ae039 = $2c438104557218de$export$846e5bb7ce3ba3ec;
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("e33py", function(module, exports) {
    $parcel$export(module.exports, "PageTitle", ()=>$ae40b537a934bf9c$export$155581e8dc02007a);
    $parcel$export(module.exports, "ServiceDeskDocumentTitle", ()=>$ae40b537a934bf9c$export$c7841d2c1c13065e);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $ew1Lk;
    var $koVbs;
    var $2BHCj;
    const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
        const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = subsection ? `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${subsection} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}` : `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
            title: title
        });
    };
    const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, (0, parcelRequire("9sGI6")).default)($ae40b537a934bf9c$export$155581e8dc02007a, {
        DocumentTitle: (0, (0, parcelRequire("ew1Lk")).DocumentTitle)
    });
    var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;
});
parcelRegister("2BHCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d7eb5ce3479323e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlassianAnalytics: {
            "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
            "defaultMessage": "Atlassian Analytics"
        },
        serviceProject: {
            "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
            "defaultMessage": "Service project"
        },
        knowledge: {
            "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
            "defaultMessage": "Knowledge base"
        },
        itsmFeatures: {
            "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
            "defaultMessage": "Features"
        },
        queues: {
            "id": "servicedesk-spa-commons.common.utils.document-title.queues",
            "defaultMessage": "Queues"
        },
        customers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customers",
            "defaultMessage": "Customers"
        },
        organizations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
            "defaultMessage": "Organizations"
        },
        customerServiceEscalations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
            "defaultMessage": "Developer escalations"
        },
        reports: {
            "id": "servicedesk-spa-commons.common.utils.document-title.reports",
            "defaultMessage": "Reports"
        },
        services: {
            "id": "servicedesk-spa-commons.common.utils.document-title.services",
            "defaultMessage": "Services"
        },
        oncall: {
            "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
            "defaultMessage": "On-call"
        },
        email: {
            "id": "servicedesk-spa-commons.common.utils.document-title.email",
            "defaultMessage": "Email request"
        },
        sla: {
            "id": "servicedesk-spa-commons.common.utils.document-title.sla",
            "defaultMessage": "Service level agreements"
        },
        csat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.csat",
            "defaultMessage": "Customer satisfaction"
        },
        details: {
            "id": "servicedesk-spa-commons.common.utils.document-title.details",
            "defaultMessage": "Details"
        },
        portal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal",
            "defaultMessage": "Customer portal"
        },
        externalLinks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
            "defaultMessage": "External resources"
        },
        portalSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
            "defaultMessage": "Portal settings"
        },
        automation: {
            "id": "servicedesk-spa-commons.common.utils.document-title.automation",
            "defaultMessage": "Automation"
        },
        advanced: {
            "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
            "defaultMessage": "Advanced"
        },
        languageSupport: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
            "defaultMessage": "Language support"
        },
        languageTranslations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
            "defaultMessage": "Language translations"
        },
        notificationEmail: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
            "defaultMessage": "Notification email"
        },
        notifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
            "defaultMessage": "Notifications"
        },
        internalNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
            "defaultMessage": "Internal notifications"
        },
        customerNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
            "defaultMessage": "Customer notifications"
        },
        widget: {
            "id": "servicedesk-spa-commons.common.utils.document-title.widget",
            "defaultMessage": "Widget"
        },
        customerPermissions: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
            "defaultMessage": "Customer permissions"
        },
        people: {
            "id": "servicedesk-spa-commons.common.utils.document-title.people",
            "defaultMessage": "Internal access"
        },
        issueType: {
            "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
            "defaultMessage": "Request types"
        },
        connectAppControls: {
            "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
            "defaultMessage": "Apps"
        },
        features: {
            "id": "servicedesk-spa-commons.common.utils.document-title.features",
            "defaultMessage": "Features"
        },
        calendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
            "defaultMessage": "Calendar"
        },
        projectSummary: {
            "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
            "defaultMessage": "Summary"
        },
        changeCalendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
            "defaultMessage": "Change calendar"
        },
        changeManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
            "defaultMessage": "Change management"
        },
        incidentManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
            "defaultMessage": "Incident management"
        },
        virtualAgentConversations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
            "defaultMessage": "Conversations"
        },
        virtualAgentIntents: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
            "defaultMessage": "Intents"
        },
        virtualAgentStandardFlows: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
            "defaultMessage": "Standard flows"
        },
        virtualAgentSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
            "defaultMessage": "Settings"
        },
        virtualAgentLanding: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
            "defaultMessage": "Virtual agent"
        },
        chat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.chat",
            "defaultMessage": "Chat"
        },
        proformaForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
            "defaultMessage": "Forms"
        },
        playbooks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
            "defaultMessage": "Playbooks"
        },
        dataClassifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
            "defaultMessage": "Data classification"
        },
        fieldsNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
            "defaultMessage": "Fields"
        },
        workflowScheme: {
            "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
            "defaultMessage": "Workflows"
        },
        journeysNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
            "defaultMessage": "Journeys"
        },
        journeyConfigNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
            "defaultMessage": "Journey configuration"
        },
        helpCenterForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
            "defaultMessage": "Forms"
        },
        virtualAgentAiAnswers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
            "defaultMessage": "Atlassian Intelligence answers"
        },
        virtualAgentPerformance: {
            "id": "servicedesk-spa-commons.common.utils.document-title.performance",
            "defaultMessage": "Performance"
        }
    });
});
parcelRegister("bB78Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b39f56024efd46d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9b39f56024efd46d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        details: {
            "id": "spa-apps.project-settings.common.shared-document-title.details",
            "defaultMessage": "Details"
        },
        people: {
            "id": "spa-apps.project-settings.common.shared-document-title.people",
            "defaultMessage": "Access"
        },
        issueType: {
            "id": "spa-apps.project-settings.common.shared-document-title.issue-type",
            "defaultMessage": "Issue types"
        },
        configureIssue: {
            "id": "spa-apps.project-settings.common.shared-document-title.configure-issue",
            "defaultMessage": "Configure issue"
        },
        notifications: {
            "id": "spa-apps.project-settings.common.shared-document-title.notifications",
            "defaultMessage": "Notifications"
        },
        notificationEmail: {
            "id": "spa-apps.project-settings.common.shared-document-title.notification-email",
            "defaultMessage": "Notification email"
        },
        features: {
            "id": "spa-apps.project-settings.common.shared-document-title.features",
            "defaultMessage": "Features"
        },
        connectAppControls: {
            "id": "spa-apps.project-settings.common.shared-document-title.connect-app-controls",
            "defaultMessage": "Apps"
        },
        proformaForms: {
            "id": "spa-apps.project-settings.common.shared-document-title.proforma-forms",
            "defaultMessage": "Forms"
        },
        connections: {
            "id": "spa-apps.project-settings.common.shared-document-title.connections",
            "defaultMessage": "Connections"
        },
        toolchain: {
            "id": "spa-apps.project-settings.common.shared-document-title.toolchain",
            "defaultMessage": "Toolchain"
        },
        dataClassifications: {
            "id": "spa-apps.project-settings.common.shared-document-title.data-classifications",
            "defaultMessage": "Data classifications"
        },
        fieldsNonFinal: {
            "id": "spa-apps.project-settings.common.shared-document-title.fields-non-final",
            "defaultMessage": "Fields"
        }
    });
});
